/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(46);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(3);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactHotLoader = __webpack_require__(98);
	
	var _Main = __webpack_require__(39);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Render the main component into the dom
	_reactDom2.default.render(_react2.default.createElement(
	  _reactHotLoader.AppContainer,
	  null,
	  _react2.default.createElement(_Main2.default, null)
	), document.getElementById('app'));
	
	// Hot Module Replacement API
	if (false) {
	  module.hot.accept('./components/main/Main', function () {
	    var NextApp = require('./components/main/Main').default;
	    _reactDom2.default.render(_react2.default.createElement(
	      _reactHotLoader.AppContainer,
	      null,
	      _react2.default.createElement(NextApp, null)
	    ), document.getElementById('app'));
	  });
	}
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/*!
	 * react-lite.js v0.15.38
	 * (c) 2017 Jade Gu
	 * Released under the MIT License.
	 */
	'use strict';
	
	var HTML_KEY = 'dangerouslySetInnerHTML';
	var SVGNamespaceURI = 'http://www.w3.org/2000/svg';
	var COMPONENT_ID = 'liteid';
	var VELEMENT = 2;
	var VSTATELESS = 3;
	var VCOMPONENT = 4;
	var VCOMMENT = 5;
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * current stateful component's refs property
	 * will attach to every vnode created by calling component.render method
	 */
	var refs = null;
	
	function createVnode(vtype, type, props, key, ref) {
	    var vnode = {
	        vtype: vtype,
	        type: type,
	        props: props,
	        refs: refs,
	        key: key,
	        ref: ref
	    };
	    if (vtype === VSTATELESS || vtype === VCOMPONENT) {
	        vnode.uid = getUid();
	    }
	    return vnode;
	}
	
	function initVnode(vnode, parentContext, namespaceURI) {
	    var vtype = vnode.vtype;
	
	    var node = null;
	    if (!vtype) {
	        // init text
	        node = document.createTextNode(vnode);
	    } else if (vtype === VELEMENT) {
	        // init element
	        node = initVelem(vnode, parentContext, namespaceURI);
	    } else if (vtype === VCOMPONENT) {
	        // init stateful component
	        node = initVcomponent(vnode, parentContext, namespaceURI);
	    } else if (vtype === VSTATELESS) {
	        // init stateless component
	        node = initVstateless(vnode, parentContext, namespaceURI);
	    } else if (vtype === VCOMMENT) {
	        // init comment
	        node = document.createComment('react-text: ' + (vnode.uid || getUid()));
	    }
	    return node;
	}
	
	function updateVnode(vnode, newVnode, node, parentContext) {
	    var vtype = vnode.vtype;
	
	    if (vtype === VCOMPONENT) {
	        return updateVcomponent(vnode, newVnode, node, parentContext);
	    }
	
	    if (vtype === VSTATELESS) {
	        return updateVstateless(vnode, newVnode, node, parentContext);
	    }
	
	    // ignore VCOMMENT and other vtypes
	    if (vtype !== VELEMENT) {
	        return node;
	    }
	
	    var oldHtml = vnode.props[HTML_KEY] && vnode.props[HTML_KEY].__html;
	    if (oldHtml != null) {
	        updateVelem(vnode, newVnode, node, parentContext);
	        initVchildren(newVnode, node, parentContext);
	    } else {
	        updateVChildren(vnode, newVnode, node, parentContext);
	        updateVelem(vnode, newVnode, node, parentContext);
	    }
	    return node;
	}
	
	function updateVChildren(vnode, newVnode, node, parentContext) {
	    var patches = {
	        removes: [],
	        updates: [],
	        creates: []
	    };
	    diffVchildren(patches, vnode, newVnode, node, parentContext);
	    flatEach(patches.removes, applyDestroy);
	    flatEach(patches.updates, applyUpdate);
	    flatEach(patches.creates, applyCreate);
	}
	
	function applyUpdate(data) {
	    if (!data) {
	        return;
	    }
	    var vnode = data.vnode;
	    var newNode = data.node;
	
	    // update
	    if (!data.shouldIgnore) {
	        if (!vnode.vtype) {
	            newNode.replaceData(0, newNode.length, data.newVnode);
	        } else if (vnode.vtype === VELEMENT) {
	            updateVelem(vnode, data.newVnode, newNode, data.parentContext);
	        } else if (vnode.vtype === VSTATELESS) {
	            newNode = updateVstateless(vnode, data.newVnode, newNode, data.parentContext);
	        } else if (vnode.vtype === VCOMPONENT) {
	            newNode = updateVcomponent(vnode, data.newVnode, newNode, data.parentContext);
	        }
	    }
	
	    // re-order
	    var currentNode = newNode.parentNode.childNodes[data.index];
	    if (currentNode !== newNode) {
	        newNode.parentNode.insertBefore(newNode, currentNode);
	    }
	    return newNode;
	}
	
	function applyDestroy(data) {
	    destroyVnode(data.vnode, data.node);
	    data.node.parentNode.removeChild(data.node);
	}
	
	function applyCreate(data) {
	    var node = initVnode(data.vnode, data.parentContext, data.parentNode.namespaceURI);
	    data.parentNode.insertBefore(node, data.parentNode.childNodes[data.index]);
	}
	
	/**
	 * Only vnode which has props.children need to call destroy function
	 * to check whether subTree has component that need to call lify-cycle method and release cache.
	 */
	
	function destroyVnode(vnode, node) {
	    var vtype = vnode.vtype;
	
	    if (vtype === VELEMENT) {
	        // destroy element
	        destroyVelem(vnode, node);
	    } else if (vtype === VCOMPONENT) {
	        // destroy state component
	        destroyVcomponent(vnode, node);
	    } else if (vtype === VSTATELESS) {
	        // destroy stateless component
	        destroyVstateless(vnode, node);
	    }
	}
	
	function initVelem(velem, parentContext, namespaceURI) {
	    var type = velem.type;
	    var props = velem.props;
	
	    var node = null;
	
	    if (type === 'svg' || namespaceURI === SVGNamespaceURI) {
	        node = document.createElementNS(SVGNamespaceURI, type);
	        namespaceURI = SVGNamespaceURI;
	    } else {
	        node = document.createElement(type);
	    }
	
	    initVchildren(velem, node, parentContext);
	
	    var isCustomComponent = type.indexOf('-') >= 0 || props.is != null;
	    setProps(node, props, isCustomComponent);
	
	    if (velem.ref != null) {
	        addItem(pendingRefs, velem);
	        addItem(pendingRefs, node);
	    }
	
	    return node;
	}
	
	function initVchildren(velem, node, parentContext) {
	    var vchildren = node.vchildren = getFlattenChildren(velem);
	    var namespaceURI = node.namespaceURI;
	    for (var i = 0, len = vchildren.length; i < len; i++) {
	        node.appendChild(initVnode(vchildren[i], parentContext, namespaceURI));
	    }
	}
	
	function getFlattenChildren(vnode) {
	    var children = vnode.props.children;
	
	    var vchildren = [];
	    if (isArr(children)) {
	        flatEach(children, collectChild, vchildren);
	    } else {
	        collectChild(children, vchildren);
	    }
	    return vchildren;
	}
	
	function collectChild(child, children) {
	    if (child != null && typeof child !== 'boolean') {
	        if (!child.vtype) {
	            // convert immutablejs data
	            if (child.toJS) {
	                child = child.toJS();
	                if (isArr(child)) {
	                    flatEach(child, collectChild, children);
	                } else {
	                    collectChild(child, children);
	                }
	                return;
	            }
	            child = '' + child;
	        }
	        children[children.length] = child;
	    }
	}
	
	function diffVchildren(patches, vnode, newVnode, node, parentContext) {
	    if (!node.vchildren) return; // react-lite hasn't seen this DOM node before
	
	    var childNodes = node.childNodes;
	    var vchildren = node.vchildren;
	
	    var newVchildren = node.vchildren = getFlattenChildren(newVnode);
	    var vchildrenLen = vchildren.length;
	    var newVchildrenLen = newVchildren.length;
	
	    if (vchildrenLen === 0) {
	        if (newVchildrenLen > 0) {
	            for (var i = 0; i < newVchildrenLen; i++) {
	                addItem(patches.creates, {
	                    vnode: newVchildren[i],
	                    parentNode: node,
	                    parentContext: parentContext,
	                    index: i
	                });
	            }
	        }
	        return;
	    } else if (newVchildrenLen === 0) {
	        for (var i = 0; i < vchildrenLen; i++) {
	            addItem(patches.removes, {
	                vnode: vchildren[i],
	                node: childNodes[i]
	            });
	        }
	        return;
	    }
	
	    var updates = Array(newVchildrenLen);
	    var removes = null;
	    var creates = null;
	
	    // isEqual
	    for (var i = 0; i < vchildrenLen; i++) {
	        var _vnode = vchildren[i];
	        for (var j = 0; j < newVchildrenLen; j++) {
	            if (updates[j]) {
	                continue;
	            }
	            var _newVnode = newVchildren[j];
	            if (_vnode === _newVnode) {
	                updates[j] = {
	                    shouldIgnore: shouldIgnoreUpdate(node),
	                    vnode: _vnode,
	                    newVnode: _newVnode,
	                    node: childNodes[i],
	                    parentContext: parentContext,
	                    index: j
	                };
	                vchildren[i] = null;
	                break;
	            }
	        }
	    }
	
	    // isSimilar
	    for (var i = 0; i < vchildrenLen; i++) {
	        var _vnode2 = vchildren[i];
	        if (_vnode2 === null) {
	            continue;
	        }
	        var shouldRemove = true;
	        for (var j = 0; j < newVchildrenLen; j++) {
	            if (updates[j]) {
	                continue;
	            }
	            var _newVnode2 = newVchildren[j];
	            if (_newVnode2.type === _vnode2.type && _newVnode2.key === _vnode2.key && _newVnode2.refs === _vnode2.refs) {
	                updates[j] = {
	                    vnode: _vnode2,
	                    newVnode: _newVnode2,
	                    node: childNodes[i],
	                    parentContext: parentContext,
	                    index: j
	                };
	                shouldRemove = false;
	                break;
	            }
	        }
	        if (shouldRemove) {
	            if (!removes) {
	                removes = [];
	            }
	            addItem(removes, {
	                vnode: _vnode2,
	                node: childNodes[i]
	            });
	        }
	    }
	
	    for (var i = 0; i < newVchildrenLen; i++) {
	        var item = updates[i];
	        if (!item) {
	            if (!creates) {
	                creates = [];
	            }
	            addItem(creates, {
	                vnode: newVchildren[i],
	                parentNode: node,
	                parentContext: parentContext,
	                index: i
	            });
	        } else if (item.vnode.vtype === VELEMENT) {
	            diffVchildren(patches, item.vnode, item.newVnode, item.node, item.parentContext);
	        }
	    }
	
	    if (removes) {
	        addItem(patches.removes, removes);
	    }
	    if (creates) {
	        addItem(patches.creates, creates);
	    }
	    addItem(patches.updates, updates);
	}
	
	function updateVelem(velem, newVelem, node) {
	    var isCustomComponent = velem.type.indexOf('-') >= 0 || velem.props.is != null;
	    patchProps(node, velem.props, newVelem.props, isCustomComponent);
	    if (velem.ref !== newVelem.ref) {
	        detachRef(velem.refs, velem.ref, node);
	        attachRef(newVelem.refs, newVelem.ref, node);
	    }
	    return node;
	}
	
	function destroyVelem(velem, node) {
	    var props = velem.props;
	    var vchildren = node.vchildren;
	    var childNodes = node.childNodes;
	
	    if (vchildren) {
	        for (var i = 0, len = vchildren.length; i < len; i++) {
	            destroyVnode(vchildren[i], childNodes[i]);
	        }
	    }
	    detachRef(velem.refs, velem.ref, node);
	    node.eventStore = node.vchildren = null;
	}
	
	function initVstateless(vstateless, parentContext, namespaceURI) {
	    var vnode = renderVstateless(vstateless, parentContext);
	    var node = initVnode(vnode, parentContext, namespaceURI);
	    node.cache = node.cache || {};
	    node.cache[vstateless.uid] = vnode;
	    return node;
	}
	
	function updateVstateless(vstateless, newVstateless, node, parentContext) {
	    var uid = vstateless.uid;
	    var vnode = node.cache[uid];
	    delete node.cache[uid];
	    var newVnode = renderVstateless(newVstateless, parentContext);
	    var newNode = compareTwoVnodes(vnode, newVnode, node, parentContext);
	    newNode.cache = newNode.cache || {};
	    newNode.cache[newVstateless.uid] = newVnode;
	    if (newNode !== node) {
	        syncCache(newNode.cache, node.cache, newNode);
	    }
	    return newNode;
	}
	
	function destroyVstateless(vstateless, node) {
	    var uid = vstateless.uid;
	    var vnode = node.cache[uid];
	    delete node.cache[uid];
	    destroyVnode(vnode, node);
	}
	
	function renderVstateless(vstateless, parentContext) {
	    var factory = vstateless.type;
	    var props = vstateless.props;
	
	    var componentContext = getContextByTypes(parentContext, factory.contextTypes);
	    var vnode = factory(props, componentContext);
	    if (vnode && vnode.render) {
	        vnode = vnode.render();
	    }
	    if (vnode === null || vnode === false) {
	        vnode = createVnode(VCOMMENT);
	    } else if (!vnode || !vnode.vtype) {
	        throw new Error('@' + factory.name + '#render:You may have returned undefined, an array or some other invalid object');
	    }
	    return vnode;
	}
	
	function initVcomponent(vcomponent, parentContext, namespaceURI) {
	    var Component = vcomponent.type;
	    var props = vcomponent.props;
	    var uid = vcomponent.uid;
	
	    var componentContext = getContextByTypes(parentContext, Component.contextTypes);
	    var component = new Component(props, componentContext);
	    var updater = component.$updater;
	    var cache = component.$cache;
	
	    cache.parentContext = parentContext;
	    updater.isPending = true;
	    component.props = component.props || props;
	    component.context = component.context || componentContext;
	    if (component.componentWillMount) {
	        component.componentWillMount();
	        component.state = updater.getState();
	    }
	    var vnode = renderComponent(component);
	    var node = initVnode(vnode, getChildContext(component, parentContext), namespaceURI);
	    node.cache = node.cache || {};
	    node.cache[uid] = component;
	    cache.vnode = vnode;
	    cache.node = node;
	    cache.isMounted = true;
	    addItem(pendingComponents, component);
	
	    if (vcomponent.ref != null) {
	        addItem(pendingRefs, vcomponent);
	        addItem(pendingRefs, component);
	    }
	
	    return node;
	}
	
	function updateVcomponent(vcomponent, newVcomponent, node, parentContext) {
	    var uid = vcomponent.uid;
	    var component = node.cache[uid];
	    var updater = component.$updater;
	    var cache = component.$cache;
	    var Component = newVcomponent.type;
	    var nextProps = newVcomponent.props;
	
	    var componentContext = getContextByTypes(parentContext, Component.contextTypes);
	    delete node.cache[uid];
	    node.cache[newVcomponent.uid] = component;
	    cache.parentContext = parentContext;
	    if (component.componentWillReceiveProps) {
	        var needToggleIsPending = !updater.isPending;
	        if (needToggleIsPending) updater.isPending = true;
	        component.componentWillReceiveProps(nextProps, componentContext);
	        if (needToggleIsPending) updater.isPending = false;
	    }
	
	    if (vcomponent.ref !== newVcomponent.ref) {
	        detachRef(vcomponent.refs, vcomponent.ref, component);
	        attachRef(newVcomponent.refs, newVcomponent.ref, component);
	    }
	
	    updater.emitUpdate(nextProps, componentContext);
	
	    return cache.node;
	}
	
	function destroyVcomponent(vcomponent, node) {
	    var uid = vcomponent.uid;
	    var component = node.cache[uid];
	    var cache = component.$cache;
	    delete node.cache[uid];
	    detachRef(vcomponent.refs, vcomponent.ref, component);
	    component.setState = component.forceUpdate = noop;
	    if (component.componentWillUnmount) {
	        component.componentWillUnmount();
	    }
	    destroyVnode(cache.vnode, node);
	    delete component.setState;
	    cache.isMounted = false;
	    cache.node = cache.parentContext = cache.vnode = component.refs = component.context = null;
	}
	
	function getContextByTypes(curContext, contextTypes) {
	    var context = {};
	    if (!contextTypes || !curContext) {
	        return context;
	    }
	    for (var key in contextTypes) {
	        if (contextTypes.hasOwnProperty(key)) {
	            context[key] = curContext[key];
	        }
	    }
	    return context;
	}
	
	function renderComponent(component, parentContext) {
	    refs = component.refs;
	    var vnode = component.render();
	    if (vnode === null || vnode === false) {
	        vnode = createVnode(VCOMMENT);
	    } else if (!vnode || !vnode.vtype) {
	        throw new Error('@' + component.constructor.name + '#render:You may have returned undefined, an array or some other invalid object');
	    }
	    refs = null;
	    return vnode;
	}
	
	function getChildContext(component, parentContext) {
	    if (component.getChildContext) {
	        var curContext = component.getChildContext();
	        if (curContext) {
	            parentContext = extend(extend({}, parentContext), curContext);
	        }
	    }
	    return parentContext;
	}
	
	var pendingComponents = [];
	function clearPendingComponents() {
	    var len = pendingComponents.length;
	    if (!len) {
	        return;
	    }
	    var components = pendingComponents;
	    pendingComponents = [];
	    var i = -1;
	    while (len--) {
	        var component = components[++i];
	        var updater = component.$updater;
	        if (component.componentDidMount) {
	            component.componentDidMount();
	        }
	        updater.isPending = false;
	        updater.emitUpdate();
	    }
	}
	
	var pendingRefs = [];
	function clearPendingRefs() {
	    var len = pendingRefs.length;
	    if (!len) {
	        return;
	    }
	    var list = pendingRefs;
	    pendingRefs = [];
	    for (var i = 0; i < len; i += 2) {
	        var vnode = list[i];
	        var refValue = list[i + 1];
	        attachRef(vnode.refs, vnode.ref, refValue);
	    }
	}
	
	function clearPending() {
	    clearPendingRefs();
	    clearPendingComponents();
	}
	
	function compareTwoVnodes(vnode, newVnode, node, parentContext) {
	    var newNode = node;
	    if (newVnode == null) {
	        // remove
	        destroyVnode(vnode, node);
	        node.parentNode.removeChild(node);
	    } else if (vnode.type !== newVnode.type || vnode.key !== newVnode.key) {
	        // replace
	        destroyVnode(vnode, node);
	        newNode = initVnode(newVnode, parentContext, node.namespaceURI);
	        node.parentNode.replaceChild(newNode, node);
	    } else if (vnode !== newVnode || parentContext) {
	        // same type and same key -> update
	        newNode = updateVnode(vnode, newVnode, node, parentContext);
	    }
	    return newNode;
	}
	
	function getDOMNode() {
	    return this;
	}
	
	function attachRef(refs, refKey, refValue) {
	    if (refKey == null || !refValue) {
	        return;
	    }
	    if (refValue.nodeName && !refValue.getDOMNode) {
	        // support react v0.13 style: this.refs.myInput.getDOMNode()
	        refValue.getDOMNode = getDOMNode;
	    }
	    if (isFn(refKey)) {
	        refKey(refValue);
	    } else if (refs) {
	        refs[refKey] = refValue;
	    }
	}
	
	function detachRef(refs, refKey, refValue) {
	    if (refKey == null) {
	        return;
	    }
	    if (isFn(refKey)) {
	        refKey(null);
	    } else if (refs && refs[refKey] === refValue) {
	        delete refs[refKey];
	    }
	}
	
	function syncCache(cache, oldCache, node) {
	    for (var key in oldCache) {
	        if (!oldCache.hasOwnProperty(key)) {
	            continue;
	        }
	        var value = oldCache[key];
	        cache[key] = value;
	
	        // is component, update component.$cache.node
	        if (value.forceUpdate) {
	            value.$cache.node = node;
	        }
	    }
	}
	
	function shouldIgnoreUpdate(node) {
	    var vchildren = node.vchildren;
	    var children = node.children;
	
	    if (vchildren) {
	        for (var i = 0; i < vchildren.length; i++) {
	            var vchild = vchildren[i];
	            if (vchild.vtype === VCOMPONENT || vchild.vtype === VSTATELESS) {
	                if (vchild.type.contextTypes) {
	                    return false;
	                }
	            }
	        }
	    }
	
	    if (children) {
	        for (var i = 0; i < children.length; i++) {
	            if (!shouldIgnoreUpdate(children[i])) {
	                return false;
	            }
	        }
	    }
	
	    return true;
	}
	
	var updateQueue = {
		updaters: [],
		isPending: false,
		add: function add(updater) {
			addItem(this.updaters, updater);
		},
		batchUpdate: function batchUpdate() {
			if (this.isPending) {
				return;
			}
			this.isPending = true;
			/*
	   each updater.update may add new updater to updateQueue
	   clear them with a loop
	   event bubbles from bottom-level to top-level
	   reverse the updater order can merge some props and state and reduce the refresh times
	   see Updater.update method below to know why
	  */
			var updaters = this.updaters;
	
			var updater = undefined;
			while (updater = updaters.pop()) {
				updater.updateComponent();
			}
			this.isPending = false;
		}
	};
	
	function Updater(instance) {
		this.instance = instance;
		this.pendingStates = [];
		this.pendingCallbacks = [];
		this.isPending = false;
		this.nextProps = this.nextContext = null;
		this.clearCallbacks = this.clearCallbacks.bind(this);
	}
	
	Updater.prototype = {
		emitUpdate: function emitUpdate(nextProps, nextContext) {
			this.nextProps = nextProps;
			this.nextContext = nextContext;
			// receive nextProps!! should update immediately
			nextProps || !updateQueue.isPending ? this.updateComponent() : updateQueue.add(this);
		},
		updateComponent: function updateComponent() {
			var instance = this.instance;
			var pendingStates = this.pendingStates;
			var nextProps = this.nextProps;
			var nextContext = this.nextContext;
	
			if (nextProps || pendingStates.length > 0) {
				nextProps = nextProps || instance.props;
				nextContext = nextContext || instance.context;
				this.nextProps = this.nextContext = null;
				// merge the nextProps and nextState and update by one time
				shouldUpdate(instance, nextProps, this.getState(), nextContext, this.clearCallbacks);
			}
		},
		addState: function addState(nextState) {
			if (nextState) {
				addItem(this.pendingStates, nextState);
				if (!this.isPending) {
					this.emitUpdate();
				}
			}
		},
		replaceState: function replaceState(nextState) {
			var pendingStates = this.pendingStates;
	
			pendingStates.pop();
			// push special params to point out should replace state
			addItem(pendingStates, [nextState]);
		},
		getState: function getState() {
			var instance = this.instance;
			var pendingStates = this.pendingStates;
			var state = instance.state;
			var props = instance.props;
	
			if (pendingStates.length) {
				state = extend({}, state);
				pendingStates.forEach(function (nextState) {
					var isReplace = isArr(nextState);
					if (isReplace) {
						nextState = nextState[0];
					}
					if (isFn(nextState)) {
						nextState = nextState.call(instance, state, props);
					}
					// replace state
					if (isReplace) {
						state = extend({}, nextState);
					} else {
						extend(state, nextState);
					}
				});
				pendingStates.length = 0;
			}
			return state;
		},
		clearCallbacks: function clearCallbacks() {
			var pendingCallbacks = this.pendingCallbacks;
			var instance = this.instance;
	
			if (pendingCallbacks.length > 0) {
				this.pendingCallbacks = [];
				pendingCallbacks.forEach(function (callback) {
					return callback.call(instance);
				});
			}
		},
		addCallback: function addCallback(callback) {
			if (isFn(callback)) {
				addItem(this.pendingCallbacks, callback);
			}
		}
	};
	function Component(props, context) {
		this.$updater = new Updater(this);
		this.$cache = { isMounted: false };
		this.props = props;
		this.state = {};
		this.refs = {};
		this.context = context;
	}
	
	var ReactComponentSymbol = {};
	
	Component.prototype = {
		constructor: Component,
		isReactComponent: ReactComponentSymbol,
		// getChildContext: _.noop,
		// componentWillUpdate: _.noop,
		// componentDidUpdate: _.noop,
		// componentWillReceiveProps: _.noop,
		// componentWillMount: _.noop,
		// componentDidMount: _.noop,
		// componentWillUnmount: _.noop,
		// shouldComponentUpdate(nextProps, nextState) {
		// 	return true
		// },
		forceUpdate: function forceUpdate(callback) {
			var $updater = this.$updater;
			var $cache = this.$cache;
			var props = this.props;
			var state = this.state;
			var context = this.context;
	
			if (!$cache.isMounted) {
				return;
			}
			// if updater is pending, add state to trigger nexttick update
			if ($updater.isPending) {
				$updater.addState(state);
				return;
			}
			var nextProps = $cache.props || props;
			var nextState = $cache.state || state;
			var nextContext = $cache.context || context;
			var parentContext = $cache.parentContext;
			var node = $cache.node;
			var vnode = $cache.vnode;
			$cache.props = $cache.state = $cache.context = null;
			$updater.isPending = true;
			if (this.componentWillUpdate) {
				this.componentWillUpdate(nextProps, nextState, nextContext);
			}
			this.state = nextState;
			this.props = nextProps;
			this.context = nextContext;
			var newVnode = renderComponent(this);
			var newNode = compareTwoVnodes(vnode, newVnode, node, getChildContext(this, parentContext));
			if (newNode !== node) {
				newNode.cache = newNode.cache || {};
				syncCache(newNode.cache, node.cache, newNode);
			}
			$cache.vnode = newVnode;
			$cache.node = newNode;
			clearPending();
			if (this.componentDidUpdate) {
				this.componentDidUpdate(props, state, context);
			}
			if (callback) {
				callback.call(this);
			}
			$updater.isPending = false;
			$updater.emitUpdate();
		},
		setState: function setState(nextState, callback) {
			var $updater = this.$updater;
	
			$updater.addCallback(callback);
			$updater.addState(nextState);
		},
		replaceState: function replaceState(nextState, callback) {
			var $updater = this.$updater;
	
			$updater.addCallback(callback);
			$updater.replaceState(nextState);
		},
		getDOMNode: function getDOMNode() {
			var node = this.$cache.node;
			return node && node.nodeName === '#comment' ? null : node;
		},
		isMounted: function isMounted() {
			return this.$cache.isMounted;
		}
	};
	
	function shouldUpdate(component, nextProps, nextState, nextContext, callback) {
		var shouldComponentUpdate = true;
		if (component.shouldComponentUpdate) {
			shouldComponentUpdate = component.shouldComponentUpdate(nextProps, nextState, nextContext);
		}
		if (shouldComponentUpdate === false) {
			component.props = nextProps;
			component.state = nextState;
			component.context = nextContext || {};
			return;
		}
		var cache = component.$cache;
		cache.props = nextProps;
		cache.state = nextState;
		cache.context = nextContext || {};
		component.forceUpdate(callback);
	}
	
	// event config
	var unbubbleEvents = {
	    /**
	     * should not bind mousemove in document scope
	     * even though mousemove event can bubble
	     */
	    onmousemove: 1,
	    ontouchmove: 1,
	    onmouseleave: 1,
	    onmouseenter: 1,
	    onload: 1,
	    onunload: 1,
	    onscroll: 1,
	    onfocus: 1,
	    onblur: 1,
	    onrowexit: 1,
	    onbeforeunload: 1,
	    onstop: 1,
	    ondragdrop: 1,
	    ondragenter: 1,
	    ondragexit: 1,
	    ondraggesture: 1,
	    ondragover: 1,
	    oncontextmenu: 1,
	    onerror: 1,
	
	    // media event
	    onabort: 1,
	    oncanplay: 1,
	    oncanplaythrough: 1,
	    ondurationchange: 1,
	    onemptied: 1,
	    onended: 1,
	    onloadeddata: 1,
	    onloadedmetadata: 1,
	    onloadstart: 1,
	    onencrypted: 1,
	    onpause: 1,
	    onplay: 1,
	    onplaying: 1,
	    onprogress: 1,
	    onratechange: 1,
	    onseeking: 1,
	    onseeked: 1,
	    onstalled: 1,
	    onsuspend: 1,
	    ontimeupdate: 1,
	    onvolumechange: 1,
	    onwaiting: 1
	};
	
	function getEventName(key) {
	    if (key === 'onDoubleClick') {
	        key = 'ondblclick';
	    } else if (key === 'onTouchTap') {
	        key = 'onclick';
	    }
	
	    return key.toLowerCase();
	}
	
	// Mobile Safari does not fire properly bubble click events on
	// non-interactive elements, which means delegated click listeners do not
	// fire. The workaround for this bug involves attaching an empty click
	// listener on the target node.
	var inMobile = ('ontouchstart' in document);
	var emptyFunction = function emptyFunction() {};
	var ON_CLICK_KEY = 'onclick';
	
	var eventTypes = {};
	
	function addEvent(elem, eventType, listener) {
	    eventType = getEventName(eventType);
	
	    var eventStore = elem.eventStore || (elem.eventStore = {});
	    eventStore[eventType] = listener;
	
	    if (unbubbleEvents[eventType] === 1) {
	        elem[eventType] = dispatchUnbubbleEvent;
	        return;
	    } else if (!eventTypes[eventType]) {
	        // onclick -> click
	        document.addEventListener(eventType.substr(2), dispatchEvent, false);
	        eventTypes[eventType] = true;
	    }
	
	    if (inMobile && eventType === ON_CLICK_KEY) {
	        elem.addEventListener('click', emptyFunction, false);
	        return;
	    }
	
	    var nodeName = elem.nodeName;
	
	    if (eventType === 'onchange' && supportInputEvent(elem)) {
	        addEvent(elem, 'oninput', listener);
	    }
	}
	
	function removeEvent(elem, eventType) {
	    eventType = getEventName(eventType);
	
	    var eventStore = elem.eventStore || (elem.eventStore = {});
	    delete eventStore[eventType];
	
	    if (unbubbleEvents[eventType] === 1) {
	        elem[eventType] = null;
	        return;
	    } else if (inMobile && eventType === ON_CLICK_KEY) {
	        elem.removeEventListener('click', emptyFunction, false);
	        return;
	    }
	
	    var nodeName = elem.nodeName;
	
	    if (eventType === 'onchange' && supportInputEvent(elem)) {
	        delete eventStore['oninput'];
	    }
	}
	
	function dispatchEvent(event) {
	    var target = event.target;
	    var type = event.type;
	
	    var eventType = 'on' + type;
	    var syntheticEvent = undefined;
	
	    updateQueue.isPending = true;
	    while (target) {
	        var _target = target;
	        var eventStore = _target.eventStore;
	
	        var listener = eventStore && eventStore[eventType];
	        if (!listener) {
	            target = target.parentNode;
	            continue;
	        }
	        if (!syntheticEvent) {
	            syntheticEvent = createSyntheticEvent(event);
	        }
	        syntheticEvent.currentTarget = target;
	        listener.call(target, syntheticEvent);
	        if (syntheticEvent.$cancelBubble) {
	            break;
	        }
	        target = target.parentNode;
	    }
	    updateQueue.isPending = false;
	    updateQueue.batchUpdate();
	}
	
	function dispatchUnbubbleEvent(event) {
	    var target = event.currentTarget || event.target;
	    var eventType = 'on' + event.type;
	    var syntheticEvent = createSyntheticEvent(event);
	
	    syntheticEvent.currentTarget = target;
	    updateQueue.isPending = true;
	
	    var eventStore = target.eventStore;
	
	    var listener = eventStore && eventStore[eventType];
	    if (listener) {
	        listener.call(target, syntheticEvent);
	    }
	
	    updateQueue.isPending = false;
	    updateQueue.batchUpdate();
	}
	
	function createSyntheticEvent(nativeEvent) {
	    var syntheticEvent = {};
	    var cancelBubble = function cancelBubble() {
	        return syntheticEvent.$cancelBubble = true;
	    };
	    syntheticEvent.nativeEvent = nativeEvent;
	    syntheticEvent.persist = noop;
	    for (var key in nativeEvent) {
	        if (typeof nativeEvent[key] !== 'function') {
	            syntheticEvent[key] = nativeEvent[key];
	        } else if (key === 'stopPropagation' || key === 'stopImmediatePropagation') {
	            syntheticEvent[key] = cancelBubble;
	        } else {
	            syntheticEvent[key] = nativeEvent[key].bind(nativeEvent);
	        }
	    }
	    return syntheticEvent;
	}
	
	function supportInputEvent(elem) {
	    var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName !== 'select' && !(nodeName === 'input' && elem.type === 'file');
	}
	
	function setStyle(elemStyle, styles) {
	    for (var styleName in styles) {
	        if (styles.hasOwnProperty(styleName)) {
	            setStyleValue(elemStyle, styleName, styles[styleName]);
	        }
	    }
	}
	
	function removeStyle(elemStyle, styles) {
	    for (var styleName in styles) {
	        if (styles.hasOwnProperty(styleName)) {
	            elemStyle[styleName] = '';
	        }
	    }
	}
	
	function patchStyle(elemStyle, style, newStyle) {
	    if (style === newStyle) {
	        return;
	    }
	    if (!newStyle && style) {
	        removeStyle(elemStyle, style);
	        return;
	    } else if (newStyle && !style) {
	        setStyle(elemStyle, newStyle);
	        return;
	    }
	
	    for (var key in style) {
	        if (newStyle.hasOwnProperty(key)) {
	            if (newStyle[key] !== style[key]) {
	                setStyleValue(elemStyle, key, newStyle[key]);
	            }
	        } else {
	            elemStyle[key] = '';
	        }
	    }
	    for (var key in newStyle) {
	        if (!style.hasOwnProperty(key)) {
	            setStyleValue(elemStyle, key, newStyle[key]);
	        }
	    }
	}
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	    animationIterationCount: 1,
	    borderImageOutset: 1,
	    borderImageSlice: 1,
	    borderImageWidth: 1,
	    boxFlex: 1,
	    boxFlexGroup: 1,
	    boxOrdinalGroup: 1,
	    columnCount: 1,
	    flex: 1,
	    flexGrow: 1,
	    flexPositive: 1,
	    flexShrink: 1,
	    flexNegative: 1,
	    flexOrder: 1,
	    gridRow: 1,
	    gridColumn: 1,
	    fontWeight: 1,
	    lineClamp: 1,
	    lineHeight: 1,
	    opacity: 1,
	    order: 1,
	    orphans: 1,
	    tabSize: 1,
	    widows: 1,
	    zIndex: 1,
	    zoom: 1,
	
	    // SVG-related properties
	    fillOpacity: 1,
	    floodOpacity: 1,
	    stopOpacity: 1,
	    strokeDasharray: 1,
	    strokeDashoffset: 1,
	    strokeMiterlimit: 1,
	    strokeOpacity: 1,
	    strokeWidth: 1
	};
	
	function prefixKey(prefix, key) {
	    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	    prefixes.forEach(function (prefix) {
	        isUnitlessNumber[prefixKey(prefix, prop)] = 1;
	    });
	});
	
	var RE_NUMBER = /^-?\d+(\.\d+)?$/;
	function setStyleValue(elemStyle, styleName, styleValue) {
	
	    if (!isUnitlessNumber[styleName] && RE_NUMBER.test(styleValue)) {
	        elemStyle[styleName] = styleValue + 'px';
	        return;
	    }
	
	    if (styleName === 'float') {
	        styleName = 'cssFloat';
	    }
	
	    if (styleValue == null || typeof styleValue === 'boolean') {
	        styleValue = '';
	    }
	
	    elemStyle[styleName] = styleValue;
	}
	
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\uB7\\u0300-\\u036F\\u203F-\\u2040';
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
	
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	// will merge some data in properties below
	var properties = {};
	
	/**
	 * Mapping from normalized, camelcased property names to a configuration that
	 * specifies how the associated DOM property should be accessed or rendered.
	 */
	var MUST_USE_PROPERTY = 0x1;
	var HAS_BOOLEAN_VALUE = 0x4;
	var HAS_NUMERIC_VALUE = 0x8;
	var HAS_POSITIVE_NUMERIC_VALUE = 0x10 | 0x8;
	var HAS_OVERLOADED_BOOLEAN_VALUE = 0x20;
	
	// html config
	var HTMLDOMPropertyConfig = {
	    props: {
	        /**
	         * Standard Properties
	         */
	        accept: 0,
	        acceptCharset: 0,
	        accessKey: 0,
	        action: 0,
	        allowFullScreen: HAS_BOOLEAN_VALUE,
	        allowTransparency: 0,
	        alt: 0,
	        async: HAS_BOOLEAN_VALUE,
	        autoComplete: 0,
	        autoFocus: HAS_BOOLEAN_VALUE,
	        autoPlay: HAS_BOOLEAN_VALUE,
	        capture: HAS_BOOLEAN_VALUE,
	        cellPadding: 0,
	        cellSpacing: 0,
	        charSet: 0,
	        challenge: 0,
	        checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	        cite: 0,
	        classID: 0,
	        className: 0,
	        cols: HAS_POSITIVE_NUMERIC_VALUE,
	        colSpan: 0,
	        content: 0,
	        contentEditable: 0,
	        contextMenu: 0,
	        controls: HAS_BOOLEAN_VALUE,
	        coords: 0,
	        crossOrigin: 0,
	        data: 0, // For `<object />` acts as `src`.
	        dateTime: 0,
	        'default': HAS_BOOLEAN_VALUE,
	        // not in regular react, they did it in other way
	        defaultValue: MUST_USE_PROPERTY,
	        // not in regular react, they did it in other way
	        defaultChecked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	        defer: HAS_BOOLEAN_VALUE,
	        dir: 0,
	        disabled: HAS_BOOLEAN_VALUE,
	        download: HAS_OVERLOADED_BOOLEAN_VALUE,
	        draggable: 0,
	        encType: 0,
	        form: 0,
	        formAction: 0,
	        formEncType: 0,
	        formMethod: 0,
	        formNoValidate: HAS_BOOLEAN_VALUE,
	        formTarget: 0,
	        frameBorder: 0,
	        headers: 0,
	        height: 0,
	        hidden: HAS_BOOLEAN_VALUE,
	        high: 0,
	        href: 0,
	        hrefLang: 0,
	        htmlFor: 0,
	        httpEquiv: 0,
	        icon: 0,
	        id: 0,
	        inputMode: 0,
	        integrity: 0,
	        is: 0,
	        keyParams: 0,
	        keyType: 0,
	        kind: 0,
	        label: 0,
	        lang: 0,
	        list: 0,
	        loop: HAS_BOOLEAN_VALUE,
	        low: 0,
	        manifest: 0,
	        marginHeight: 0,
	        marginWidth: 0,
	        max: 0,
	        maxLength: 0,
	        media: 0,
	        mediaGroup: 0,
	        method: 0,
	        min: 0,
	        minLength: 0,
	        // Caution; `option.selected` is not updated if `select.multiple` is
	        // disabled with `removeAttribute`.
	        multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	        muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	        name: 0,
	        nonce: 0,
	        noValidate: HAS_BOOLEAN_VALUE,
	        open: HAS_BOOLEAN_VALUE,
	        optimum: 0,
	        pattern: 0,
	        placeholder: 0,
	        poster: 0,
	        preload: 0,
	        profile: 0,
	        radioGroup: 0,
	        readOnly: HAS_BOOLEAN_VALUE,
	        referrerPolicy: 0,
	        rel: 0,
	        required: HAS_BOOLEAN_VALUE,
	        reversed: HAS_BOOLEAN_VALUE,
	        role: 0,
	        rows: HAS_POSITIVE_NUMERIC_VALUE,
	        rowSpan: HAS_NUMERIC_VALUE,
	        sandbox: 0,
	        scope: 0,
	        scoped: HAS_BOOLEAN_VALUE,
	        scrolling: 0,
	        seamless: HAS_BOOLEAN_VALUE,
	        selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	        shape: 0,
	        size: HAS_POSITIVE_NUMERIC_VALUE,
	        sizes: 0,
	        span: HAS_POSITIVE_NUMERIC_VALUE,
	        spellCheck: 0,
	        src: 0,
	        srcDoc: 0,
	        srcLang: 0,
	        srcSet: 0,
	        start: HAS_NUMERIC_VALUE,
	        step: 0,
	        style: 0,
	        summary: 0,
	        tabIndex: 0,
	        target: 0,
	        title: 0,
	        // Setting .type throws on non-<input> tags
	        type: 0,
	        useMap: 0,
	        value: MUST_USE_PROPERTY,
	        width: 0,
	        wmode: 0,
	        wrap: 0,
	
	        /**
	         * RDFa Properties
	         */
	        about: 0,
	        datatype: 0,
	        inlist: 0,
	        prefix: 0,
	        // property is also supported for OpenGraph in meta tags.
	        property: 0,
	        playsInline: HAS_BOOLEAN_VALUE,
	        resource: 0,
	        'typeof': 0,
	        vocab: 0,
	
	        /**
	         * Non-standard Properties
	         */
	        // autoCapitalize and autoCorrect are supported in Mobile Safari for
	        // keyboard hints.
	        autoCapitalize: 0,
	        autoCorrect: 0,
	        // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	        autoSave: 0,
	        // color is for Safari mask-icon link
	        color: 0,
	        // itemProp, itemScope, itemType are for
	        // Microdata support. See http://schema.org/docs/gs.html
	        itemProp: 0,
	        itemScope: HAS_BOOLEAN_VALUE,
	        itemType: 0,
	        // itemID and itemRef are for Microdata support as well but
	        // only specified in the WHATWG spec document. See
	        // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	        itemID: 0,
	        itemRef: 0,
	        // results show looking glass icon and recent searches on input
	        // search fields in WebKit/Blink
	        results: 0,
	        // IE-only attribute that specifies security restrictions on an iframe
	        // as an alternative to the sandbox attribute on IE<10
	        security: 0,
	        // IE-only attribute that controls focus behavior
	        unselectable: 0
	    },
	    attrNS: {},
	    domAttrs: {
	        acceptCharset: 'accept-charset',
	        className: 'class',
	        htmlFor: 'for',
	        httpEquiv: 'http-equiv'
	    },
	    domProps: {}
	};
	
	// svg config
	var xlink = 'http://www.w3.org/1999/xlink';
	var xml = 'http://www.w3.org/XML/1998/namespace';
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	    accentHeight: 'accent-height',
	    accumulate: 0,
	    additive: 0,
	    alignmentBaseline: 'alignment-baseline',
	    allowReorder: 'allowReorder',
	    alphabetic: 0,
	    amplitude: 0,
	    arabicForm: 'arabic-form',
	    ascent: 0,
	    attributeName: 'attributeName',
	    attributeType: 'attributeType',
	    autoReverse: 'autoReverse',
	    azimuth: 0,
	    baseFrequency: 'baseFrequency',
	    baseProfile: 'baseProfile',
	    baselineShift: 'baseline-shift',
	    bbox: 0,
	    begin: 0,
	    bias: 0,
	    by: 0,
	    calcMode: 'calcMode',
	    capHeight: 'cap-height',
	    clip: 0,
	    clipPath: 'clip-path',
	    clipRule: 'clip-rule',
	    clipPathUnits: 'clipPathUnits',
	    colorInterpolation: 'color-interpolation',
	    colorInterpolationFilters: 'color-interpolation-filters',
	    colorProfile: 'color-profile',
	    colorRendering: 'color-rendering',
	    contentScriptType: 'contentScriptType',
	    contentStyleType: 'contentStyleType',
	    cursor: 0,
	    cx: 0,
	    cy: 0,
	    d: 0,
	    decelerate: 0,
	    descent: 0,
	    diffuseConstant: 'diffuseConstant',
	    direction: 0,
	    display: 0,
	    divisor: 0,
	    dominantBaseline: 'dominant-baseline',
	    dur: 0,
	    dx: 0,
	    dy: 0,
	    edgeMode: 'edgeMode',
	    elevation: 0,
	    enableBackground: 'enable-background',
	    end: 0,
	    exponent: 0,
	    externalResourcesRequired: 'externalResourcesRequired',
	    fill: 0,
	    fillOpacity: 'fill-opacity',
	    fillRule: 'fill-rule',
	    filter: 0,
	    filterRes: 'filterRes',
	    filterUnits: 'filterUnits',
	    floodColor: 'flood-color',
	    floodOpacity: 'flood-opacity',
	    focusable: 0,
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontSizeAdjust: 'font-size-adjust',
	    fontStretch: 'font-stretch',
	    fontStyle: 'font-style',
	    fontVariant: 'font-variant',
	    fontWeight: 'font-weight',
	    format: 0,
	    from: 0,
	    fx: 0,
	    fy: 0,
	    g1: 0,
	    g2: 0,
	    glyphName: 'glyph-name',
	    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	    glyphOrientationVertical: 'glyph-orientation-vertical',
	    glyphRef: 'glyphRef',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    hanging: 0,
	    horizAdvX: 'horiz-adv-x',
	    horizOriginX: 'horiz-origin-x',
	    ideographic: 0,
	    imageRendering: 'image-rendering',
	    'in': 0,
	    in2: 0,
	    intercept: 0,
	    k: 0,
	    k1: 0,
	    k2: 0,
	    k3: 0,
	    k4: 0,
	    kernelMatrix: 'kernelMatrix',
	    kernelUnitLength: 'kernelUnitLength',
	    kerning: 0,
	    keyPoints: 'keyPoints',
	    keySplines: 'keySplines',
	    keyTimes: 'keyTimes',
	    lengthAdjust: 'lengthAdjust',
	    letterSpacing: 'letter-spacing',
	    lightingColor: 'lighting-color',
	    limitingConeAngle: 'limitingConeAngle',
	    local: 0,
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    markerHeight: 'markerHeight',
	    markerUnits: 'markerUnits',
	    markerWidth: 'markerWidth',
	    mask: 0,
	    maskContentUnits: 'maskContentUnits',
	    maskUnits: 'maskUnits',
	    mathematical: 0,
	    mode: 0,
	    numOctaves: 'numOctaves',
	    offset: 0,
	    opacity: 0,
	    operator: 0,
	    order: 0,
	    orient: 0,
	    orientation: 0,
	    origin: 0,
	    overflow: 0,
	    overlinePosition: 'overline-position',
	    overlineThickness: 'overline-thickness',
	    paintOrder: 'paint-order',
	    panose1: 'panose-1',
	    pathLength: 'pathLength',
	    patternContentUnits: 'patternContentUnits',
	    patternTransform: 'patternTransform',
	    patternUnits: 'patternUnits',
	    pointerEvents: 'pointer-events',
	    points: 0,
	    pointsAtX: 'pointsAtX',
	    pointsAtY: 'pointsAtY',
	    pointsAtZ: 'pointsAtZ',
	    preserveAlpha: 'preserveAlpha',
	    preserveAspectRatio: 'preserveAspectRatio',
	    primitiveUnits: 'primitiveUnits',
	    r: 0,
	    radius: 0,
	    refX: 'refX',
	    refY: 'refY',
	    renderingIntent: 'rendering-intent',
	    repeatCount: 'repeatCount',
	    repeatDur: 'repeatDur',
	    requiredExtensions: 'requiredExtensions',
	    requiredFeatures: 'requiredFeatures',
	    restart: 0,
	    result: 0,
	    rotate: 0,
	    rx: 0,
	    ry: 0,
	    scale: 0,
	    seed: 0,
	    shapeRendering: 'shape-rendering',
	    slope: 0,
	    spacing: 0,
	    specularConstant: 'specularConstant',
	    specularExponent: 'specularExponent',
	    speed: 0,
	    spreadMethod: 'spreadMethod',
	    startOffset: 'startOffset',
	    stdDeviation: 'stdDeviation',
	    stemh: 0,
	    stemv: 0,
	    stitchTiles: 'stitchTiles',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strikethroughPosition: 'strikethrough-position',
	    strikethroughThickness: 'strikethrough-thickness',
	    string: 0,
	    stroke: 0,
	    strokeDasharray: 'stroke-dasharray',
	    strokeDashoffset: 'stroke-dashoffset',
	    strokeLinecap: 'stroke-linecap',
	    strokeLinejoin: 'stroke-linejoin',
	    strokeMiterlimit: 'stroke-miterlimit',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    surfaceScale: 'surfaceScale',
	    systemLanguage: 'systemLanguage',
	    tableValues: 'tableValues',
	    targetX: 'targetX',
	    targetY: 'targetY',
	    textAnchor: 'text-anchor',
	    textDecoration: 'text-decoration',
	    textRendering: 'text-rendering',
	    textLength: 'textLength',
	    to: 0,
	    transform: 0,
	    u1: 0,
	    u2: 0,
	    underlinePosition: 'underline-position',
	    underlineThickness: 'underline-thickness',
	    unicode: 0,
	    unicodeBidi: 'unicode-bidi',
	    unicodeRange: 'unicode-range',
	    unitsPerEm: 'units-per-em',
	    vAlphabetic: 'v-alphabetic',
	    vHanging: 'v-hanging',
	    vIdeographic: 'v-ideographic',
	    vMathematical: 'v-mathematical',
	    values: 0,
	    vectorEffect: 'vector-effect',
	    version: 0,
	    vertAdvY: 'vert-adv-y',
	    vertOriginX: 'vert-origin-x',
	    vertOriginY: 'vert-origin-y',
	    viewBox: 'viewBox',
	    viewTarget: 'viewTarget',
	    visibility: 0,
	    widths: 0,
	    wordSpacing: 'word-spacing',
	    writingMode: 'writing-mode',
	    x: 0,
	    xHeight: 'x-height',
	    x1: 0,
	    x2: 0,
	    xChannelSelector: 'xChannelSelector',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlns: 0,
	    xmlnsXlink: 'xmlns:xlink',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space',
	    y: 0,
	    y1: 0,
	    y2: 0,
	    yChannelSelector: 'yChannelSelector',
	    z: 0,
	    zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	    props: {},
	    attrNS: {
	        xlinkActuate: xlink,
	        xlinkArcrole: xlink,
	        xlinkHref: xlink,
	        xlinkRole: xlink,
	        xlinkShow: xlink,
	        xlinkTitle: xlink,
	        xlinkType: xlink,
	        xmlBase: xml,
	        xmlLang: xml,
	        xmlSpace: xml
	    },
	    domAttrs: {},
	    domProps: {}
	};
	
	Object.keys(ATTRS).map(function (key) {
	    SVGDOMPropertyConfig.props[key] = 0;
	    if (ATTRS[key]) {
	        SVGDOMPropertyConfig.domAttrs[key] = ATTRS[key];
	    }
	});
	
	// merge html and svg config into properties
	mergeConfigToProperties(HTMLDOMPropertyConfig);
	mergeConfigToProperties(SVGDOMPropertyConfig);
	
	function mergeConfigToProperties(config) {
	    var
	    // all react/react-lite supporting property names in here
	    props = config.props;
	    var
	    // attributes namespace in here
	    attrNS = config.attrNS;
	    var
	    // propName in props which should use to be dom-attribute in here
	    domAttrs = config.domAttrs;
	    var
	    // propName in props which should use to be dom-property in here
	    domProps = config.domProps;
	
	    for (var propName in props) {
	        if (!props.hasOwnProperty(propName)) {
	            continue;
	        }
	        var propConfig = props[propName];
	        properties[propName] = {
	            attributeName: domAttrs.hasOwnProperty(propName) ? domAttrs[propName] : propName.toLowerCase(),
	            propertyName: domProps.hasOwnProperty(propName) ? domProps[propName] : propName,
	            attributeNamespace: attrNS.hasOwnProperty(propName) ? attrNS[propName] : null,
	            mustUseProperty: checkMask(propConfig, MUST_USE_PROPERTY),
	            hasBooleanValue: checkMask(propConfig, HAS_BOOLEAN_VALUE),
	            hasNumericValue: checkMask(propConfig, HAS_NUMERIC_VALUE),
	            hasPositiveNumericValue: checkMask(propConfig, HAS_POSITIVE_NUMERIC_VALUE),
	            hasOverloadedBooleanValue: checkMask(propConfig, HAS_OVERLOADED_BOOLEAN_VALUE)
	        };
	    }
	}
	
	function checkMask(value, bitmask) {
	    return (value & bitmask) === bitmask;
	}
	
	/**
	 * Sets the value for a property on a node.
	 *
	 * @param {DOMElement} node
	 * @param {string} name
	 * @param {*} value
	 */
	
	function setPropValue(node, name, value) {
	    var propInfo = properties.hasOwnProperty(name) && properties[name];
	    if (propInfo) {
	        // should delete value from dom
	        if (value == null || propInfo.hasBooleanValue && !value || propInfo.hasNumericValue && isNaN(value) || propInfo.hasPositiveNumericValue && value < 1 || propInfo.hasOverloadedBooleanValue && value === false) {
	            removePropValue(node, name);
	        } else if (propInfo.mustUseProperty) {
	            var propName = propInfo.propertyName;
	            // dom.value has side effect
	            if (propName !== 'value' || '' + node[propName] !== '' + value) {
	                node[propName] = value;
	            }
	        } else {
	            var attributeName = propInfo.attributeName;
	            var namespace = propInfo.attributeNamespace;
	
	            // `setAttribute` with objects becomes only `[object]` in IE8/9,
	            // ('' + value) makes it output the correct toString()-value.
	            if (namespace) {
	                node.setAttributeNS(namespace, attributeName, '' + value);
	            } else if (propInfo.hasBooleanValue || propInfo.hasOverloadedBooleanValue && value === true) {
	                node.setAttribute(attributeName, '');
	            } else {
	                node.setAttribute(attributeName, '' + value);
	            }
	        }
	    } else if (isCustomAttribute(name) && VALID_ATTRIBUTE_NAME_REGEX.test(name)) {
	        if (value == null) {
	            node.removeAttribute(name);
	        } else {
	            node.setAttribute(name, '' + value);
	        }
	    }
	}
	
	/**
	 * Deletes the value for a property on a node.
	 *
	 * @param {DOMElement} node
	 * @param {string} name
	 */
	
	function removePropValue(node, name) {
	    var propInfo = properties.hasOwnProperty(name) && properties[name];
	    if (propInfo) {
	        if (propInfo.mustUseProperty) {
	            var propName = propInfo.propertyName;
	            if (propInfo.hasBooleanValue) {
	                node[propName] = false;
	            } else {
	                // dom.value accept string value has side effect
	                if (propName !== 'value' || '' + node[propName] !== '') {
	                    node[propName] = '';
	                }
	            }
	        } else {
	            node.removeAttribute(propInfo.attributeName);
	        }
	    } else if (isCustomAttribute(name)) {
	        node.removeAttribute(name);
	    }
	}
	
	function isFn(obj) {
	    return typeof obj === 'function';
	}
	
	var isArr = Array.isArray;
	
	function noop() {}
	
	function identity(obj) {
	    return obj;
	}
	
	function pipe(fn1, fn2) {
	    return function () {
	        fn1.apply(this, arguments);
	        return fn2.apply(this, arguments);
	    };
	}
	
	function addItem(list, item) {
	    list[list.length] = item;
	}
	
	function flatEach(list, iteratee, a) {
	    var len = list.length;
	    var i = -1;
	
	    while (len--) {
	        var item = list[++i];
	        if (isArr(item)) {
	            flatEach(item, iteratee, a);
	        } else {
	            iteratee(item, a);
	        }
	    }
	}
	
	function extend(to, from) {
	    if (!from) {
	        return to;
	    }
	    var keys = Object.keys(from);
	    var i = keys.length;
	    while (i--) {
	        to[keys[i]] = from[keys[i]];
	    }
	    return to;
	}
	
	var uid = 0;
	
	function getUid() {
	    return ++uid;
	}
	
	var EVENT_KEYS = /^on/i;
	
	function setProp(elem, key, value, isCustomComponent) {
	    if (EVENT_KEYS.test(key)) {
	        addEvent(elem, key, value);
	    } else if (key === 'style') {
	        setStyle(elem.style, value);
	    } else if (key === HTML_KEY) {
	        if (value && value.__html != null) {
	            elem.innerHTML = value.__html;
	        }
	    } else if (isCustomComponent) {
	        if (value == null) {
	            elem.removeAttribute(key);
	        } else {
	            elem.setAttribute(key, '' + value);
	        }
	    } else {
	        setPropValue(elem, key, value);
	    }
	}
	
	function removeProp(elem, key, oldValue, isCustomComponent) {
	    if (EVENT_KEYS.test(key)) {
	        removeEvent(elem, key);
	    } else if (key === 'style') {
	        removeStyle(elem.style, oldValue);
	    } else if (key === HTML_KEY) {
	        elem.innerHTML = '';
	    } else if (isCustomComponent) {
	        elem.removeAttribute(key);
	    } else {
	        removePropValue(elem, key);
	    }
	}
	
	function patchProp(elem, key, value, oldValue, isCustomComponent) {
	    if (key === 'value' || key === 'checked') {
	        oldValue = elem[key];
	    }
	    if (value === oldValue) {
	        return;
	    }
	    if (value === undefined) {
	        removeProp(elem, key, oldValue, isCustomComponent);
	        return;
	    }
	    if (key === 'style') {
	        patchStyle(elem.style, oldValue, value);
	    } else {
	        setProp(elem, key, value, isCustomComponent);
	    }
	}
	
	function setProps(elem, props, isCustomComponent) {
	    for (var key in props) {
	        if (key !== 'children') {
	            setProp(elem, key, props[key], isCustomComponent);
	        }
	    }
	}
	
	function patchProps(elem, props, newProps, isCustomComponent) {
	    for (var key in props) {
	        if (key !== 'children') {
	            if (newProps.hasOwnProperty(key)) {
	                patchProp(elem, key, newProps[key], props[key], isCustomComponent);
	            } else {
	                removeProp(elem, key, props[key], isCustomComponent);
	            }
	        }
	    }
	    for (var key in newProps) {
	        if (key !== 'children' && !props.hasOwnProperty(key)) {
	            setProp(elem, key, newProps[key], isCustomComponent);
	        }
	    }
	}
	
	if (!Object.freeze) {
	    Object.freeze = identity;
	}
	
	function isValidContainer(node) {
		return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	var pendingRendering = {};
	var vnodeStore = {};
	function renderTreeIntoContainer(vnode, container, callback, parentContext) {
		if (!vnode.vtype) {
			throw new Error('cannot render ' + vnode + ' to container');
		}
		if (!isValidContainer(container)) {
			throw new Error('container ' + container + ' is not a DOM element');
		}
		var id = container[COMPONENT_ID] || (container[COMPONENT_ID] = getUid());
		var argsCache = pendingRendering[id];
	
		// component lify cycle method maybe call root rendering
		// should bundle them and render by only one time
		if (argsCache) {
			if (argsCache === true) {
				pendingRendering[id] = argsCache = { vnode: vnode, callback: callback, parentContext: parentContext };
			} else {
				argsCache.vnode = vnode;
				argsCache.parentContext = parentContext;
				argsCache.callback = argsCache.callback ? pipe(argsCache.callback, callback) : callback;
			}
			return;
		}
	
		pendingRendering[id] = true;
		var oldVnode = null;
		var rootNode = null;
		if (oldVnode = vnodeStore[id]) {
			rootNode = compareTwoVnodes(oldVnode, vnode, container.firstChild, parentContext);
		} else {
			rootNode = initVnode(vnode, parentContext, container.namespaceURI);
			var childNode = null;
			while (childNode = container.lastChild) {
				container.removeChild(childNode);
			}
			container.appendChild(rootNode);
		}
		vnodeStore[id] = vnode;
		var isPending = updateQueue.isPending;
		updateQueue.isPending = true;
		clearPending();
		argsCache = pendingRendering[id];
		delete pendingRendering[id];
	
		var result = null;
		if (typeof argsCache === 'object') {
			result = renderTreeIntoContainer(argsCache.vnode, container, argsCache.callback, argsCache.parentContext);
		} else if (vnode.vtype === VELEMENT) {
			result = rootNode;
		} else if (vnode.vtype === VCOMPONENT) {
			result = rootNode.cache[vnode.uid];
		}
	
		if (!isPending) {
			updateQueue.isPending = false;
			updateQueue.batchUpdate();
		}
	
		if (callback) {
			callback.call(result);
		}
	
		return result;
	}
	
	function render(vnode, container, callback) {
		return renderTreeIntoContainer(vnode, container, callback);
	}
	
	function unstable_renderSubtreeIntoContainer(parentComponent, subVnode, container, callback) {
		var context = parentComponent.$cache.parentContext;
		return renderTreeIntoContainer(subVnode, container, callback, context);
	}
	
	function unmountComponentAtNode(container) {
		if (!container.nodeName) {
			throw new Error('expect node');
		}
		var id = container[COMPONENT_ID];
		var vnode = null;
		if (vnode = vnodeStore[id]) {
			destroyVnode(vnode, container.firstChild);
			container.removeChild(container.firstChild);
			delete vnodeStore[id];
			return true;
		}
		return false;
	}
	
	function findDOMNode(node) {
		if (node == null) {
			return null;
		}
		if (node.nodeName) {
			return node;
		}
		var component = node;
		// if component.node equal to false, component must be unmounted
		if (component.getDOMNode && component.$cache.isMounted) {
			return component.getDOMNode();
		}
		throw new Error('findDOMNode can not find Node');
	}
	
	var ReactDOM = Object.freeze({
		render: render,
		unstable_renderSubtreeIntoContainer: unstable_renderSubtreeIntoContainer,
		unmountComponentAtNode: unmountComponentAtNode,
		findDOMNode: findDOMNode
	});
	
	function createElement(type, props, children) {
		var vtype = null;
		if (typeof type === 'string') {
			vtype = VELEMENT;
		} else if (typeof type === 'function') {
			if (type.prototype && type.prototype.isReactComponent) {
				vtype = VCOMPONENT;
			} else {
				vtype = VSTATELESS;
			}
		} else {
			throw new Error('React.createElement: unexpect type [ ' + type + ' ]');
		}
	
		var key = null;
		var ref = null;
		var finalProps = {};
		if (props != null) {
			for (var propKey in props) {
				if (!props.hasOwnProperty(propKey)) {
					continue;
				}
				if (propKey === 'key') {
					if (props.key !== undefined) {
						key = '' + props.key;
					}
				} else if (propKey === 'ref') {
					if (props.ref !== undefined) {
						ref = props.ref;
					}
				} else {
					finalProps[propKey] = props[propKey];
				}
			}
		}
	
		var defaultProps = type.defaultProps;
	
		if (defaultProps) {
			for (var propKey in defaultProps) {
				if (finalProps[propKey] === undefined) {
					finalProps[propKey] = defaultProps[propKey];
				}
			}
		}
	
		var argsLen = arguments.length;
		var finalChildren = children;
	
		if (argsLen > 3) {
			finalChildren = Array(argsLen - 2);
			for (var i = 2; i < argsLen; i++) {
				finalChildren[i - 2] = arguments[i];
			}
		}
	
		if (finalChildren !== undefined) {
			finalProps.children = finalChildren;
		}
	
		return createVnode(vtype, type, finalProps, key, ref);
	}
	
	function isValidElement(obj) {
		return obj != null && !!obj.vtype;
	}
	
	function cloneElement(originElem, props) {
		var type = originElem.type;
		var key = originElem.key;
		var ref = originElem.ref;
	
		var newProps = extend(extend({ key: key, ref: ref }, originElem.props), props);
	
		for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
			children[_key - 2] = arguments[_key];
		}
	
		var vnode = createElement.apply(undefined, [type, newProps].concat(children));
		if (vnode.ref === originElem.ref) {
			vnode.refs = originElem.refs;
		}
		return vnode;
	}
	
	function createFactory(type) {
		var factory = function factory() {
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return createElement.apply(undefined, [type].concat(args));
		};
		factory.type = type;
		return factory;
	}
	
	var tagNames = 'a|abbr|address|area|article|aside|audio|b|base|bdi|bdo|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|data|datalist|dd|del|details|dfn|dialog|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|main|map|mark|menu|menuitem|meta|meter|nav|noscript|object|ol|optgroup|option|output|p|param|picture|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|span|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|u|ul|var|video|wbr|circle|clipPath|defs|ellipse|g|image|line|linearGradient|mask|path|pattern|polygon|polyline|radialGradient|rect|stop|svg|text|tspan';
	var DOM = {};
	tagNames.split('|').forEach(function (tagName) {
		DOM[tagName] = createFactory(tagName);
	});
	
	var check = function check() {
	    return check;
	};
	check.isRequired = check;
	var PropTypes = {
	    "array": check,
	    "bool": check,
	    "func": check,
	    "number": check,
	    "object": check,
	    "string": check,
	    "any": check,
	    "arrayOf": check,
	    "element": check,
	    "instanceOf": check,
	    "node": check,
	    "objectOf": check,
	    "oneOf": check,
	    "oneOfType": check,
	    "shape": check
	};
	
	function only(children) {
		if (isValidElement(children)) {
			return children;
		}
		throw new Error('expect only one child');
	}
	
	function forEach(children, iteratee, context) {
		if (children == null) {
			return children;
		}
		var index = 0;
		if (isArr(children)) {
			flatEach(children, function (child) {
				// from traverseAllChildrenImpl in react
				var type = typeof child;
				if (type === 'undefined' || type === 'boolean') {
					// All of the above are perceived as null.
					child = null;
				}
	
				iteratee.call(context, child, index++);
			});
		} else {
			// from traverseAllChildrenImpl in react
			var type = typeof children;
			if (type === 'undefined' || type === 'boolean') {
				// All of the above are perceived as null.
				children = null;
			}
			iteratee.call(context, children, index);
		}
	}
	
	function map(children, iteratee, context) {
		if (children == null) {
			return children;
		}
		var store = [];
		var keyMap = {};
		forEach(children, function (child, index) {
			var data = {};
			data.child = iteratee.call(context, child, index) || child;
			data.isEqual = data.child === child;
			var key = data.key = getKey(child, index);
			if (keyMap.hasOwnProperty(key)) {
				keyMap[key] += 1;
			} else {
				keyMap[key] = 0;
			}
			data.index = keyMap[key];
			addItem(store, data);
		});
		var result = [];
		store.forEach(function (_ref) {
			var child = _ref.child;
			var key = _ref.key;
			var index = _ref.index;
			var isEqual = _ref.isEqual;
	
			if (child == null || typeof child === 'boolean') {
				return;
			}
			if (!isValidElement(child) || key == null) {
				addItem(result, child);
				return;
			}
			if (keyMap[key] !== 0) {
				key += ':' + index;
			}
			if (!isEqual) {
				key = escapeUserProvidedKey(child.key || '') + '/' + key;
			}
			child = cloneElement(child, { key: key });
			addItem(result, child);
		});
		return result;
	}
	
	function count(children) {
		var count = 0;
		forEach(children, function () {
			count++;
		});
		return count;
	}
	
	function toArray(children) {
		return map(children, identity) || [];
	}
	
	function getKey(child, index) {
		var key = undefined;
		if (isValidElement(child) && typeof child.key === 'string') {
			key = '.$' + child.key;
		} else {
			key = '.' + index.toString(36);
		}
		return key;
	}
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
		return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	var Children = Object.freeze({
		only: only,
		forEach: forEach,
		map: map,
		count: count,
		toArray: toArray
	});
	
	function eachMixin(mixins, iteratee) {
		mixins.forEach(function (mixin) {
			if (mixin) {
				if (isArr(mixin.mixins)) {
					eachMixin(mixin.mixins, iteratee);
				}
				iteratee(mixin);
			}
		});
	}
	
	function combineMixinToProto(proto, mixin) {
		for (var key in mixin) {
			if (!mixin.hasOwnProperty(key)) {
				continue;
			}
			var value = mixin[key];
			if (key === 'getInitialState') {
				addItem(proto.$getInitialStates, value);
				continue;
			}
			var curValue = proto[key];
			if (isFn(curValue) && isFn(value)) {
				proto[key] = pipe(curValue, value);
			} else {
				proto[key] = value;
			}
		}
	}
	
	function combineMixinToClass(Component, mixin) {
		if (mixin.propTypes) {
			Component.propTypes = Component.propTypes || {};
			extend(Component.propTypes, mixin.propTypes);
		}
		if (mixin.contextTypes) {
			Component.contextTypes = Component.contextTypes || {};
			extend(Component.contextTypes, mixin.contextTypes);
		}
		extend(Component, mixin.statics);
		if (isFn(mixin.getDefaultProps)) {
			Component.defaultProps = Component.defaultProps || {};
			extend(Component.defaultProps, mixin.getDefaultProps());
		}
	}
	
	function bindContext(obj, source) {
		for (var key in source) {
			if (source.hasOwnProperty(key)) {
				if (isFn(source[key])) {
					obj[key] = source[key].bind(obj);
				}
			}
		}
	}
	
	var Facade = function Facade() {};
	Facade.prototype = Component.prototype;
	
	function getInitialState() {
		var _this = this;
	
		var state = {};
		var setState = this.setState;
		this.setState = Facade;
		this.$getInitialStates.forEach(function (getInitialState) {
			if (isFn(getInitialState)) {
				extend(state, getInitialState.call(_this));
			}
		});
		this.setState = setState;
		return state;
	}
	function createClass(spec) {
		if (!isFn(spec.render)) {
			throw new Error('createClass: spec.render is not function');
		}
		var specMixins = spec.mixins || [];
		var mixins = specMixins.concat(spec);
		spec.mixins = null;
		function Klass(props, context) {
			Component.call(this, props, context);
			this.constructor = Klass;
			spec.autobind !== false && bindContext(this, Klass.prototype);
			this.state = this.getInitialState() || this.state;
		}
		Klass.displayName = spec.displayName;
		var proto = Klass.prototype = new Facade();
		proto.$getInitialStates = [];
		eachMixin(mixins, function (mixin) {
			combineMixinToProto(proto, mixin);
			combineMixinToClass(Klass, mixin);
		});
		proto.getInitialState = getInitialState;
		spec.mixins = specMixins;
		return Klass;
	}
	
	function shallowEqual(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	
	    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    // Test for A's keys different from B.
	    for (var i = 0; i < keysA.length; i++) {
	        if (!objB.hasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function PureComponent(props, context) {
		Component.call(this, props, context);
	}
	
	PureComponent.prototype = Object.create(Component.prototype);
	PureComponent.prototype.constructor = PureComponent;
	PureComponent.prototype.isPureReactComponent = true;
	PureComponent.prototype.shouldComponentUpdate = shallowCompare;
	
	function shallowCompare(nextProps, nextState) {
		return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
	}
	
	var React = extend({
	    version: '0.15.1',
	    cloneElement: cloneElement,
	    isValidElement: isValidElement,
	    createElement: createElement,
	    createFactory: createFactory,
	    Component: Component,
	    PureComponent: PureComponent,
	    createClass: createClass,
	    Children: Children,
	    PropTypes: PropTypes,
	    DOM: DOM
	}, ReactDOM);
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	
	module.exports = React;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-request/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(12), __webpack_require__(91), __webpack_require__(92)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-collection', 'd3-dispatch', 'd3-dsv'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Collection,d3Dispatch,d3Dsv) { 'use strict';
	
	var request = function(url, callback) {
	  var request,
	      event = d3Dispatch.dispatch("beforesend", "progress", "load", "error"),
	      mimeType,
	      headers = d3Collection.map(),
	      xhr = new XMLHttpRequest,
	      user = null,
	      password = null,
	      response,
	      responseType,
	      timeout = 0;
	
	  // If IE does not support CORS, use XDomainRequest.
	  if (typeof XDomainRequest !== "undefined"
	      && !("withCredentials" in xhr)
	      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;
	
	  "onload" in xhr
	      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
	      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };
	
	  function respond(o) {
	    var status = xhr.status, result;
	    if (!status && hasResponse(xhr)
	        || status >= 200 && status < 300
	        || status === 304) {
	      if (response) {
	        try {
	          result = response.call(request, xhr);
	        } catch (e) {
	          event.call("error", request, e);
	          return;
	        }
	      } else {
	        result = xhr;
	      }
	      event.call("load", request, result);
	    } else {
	      event.call("error", request, o);
	    }
	  }
	
	  xhr.onprogress = function(e) {
	    event.call("progress", request, e);
	  };
	
	  request = {
	    header: function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers.get(name);
	      if (value == null) headers.remove(name);
	      else headers.set(name, value + "");
	      return request;
	    },
	
	    // If mimeType is non-null and no Accept header is set, a default is used.
	    mimeType: function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return request;
	    },
	
	    // Specifies what type the response value should take;
	    // for instance, arraybuffer, blob, document, or text.
	    responseType: function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return request;
	    },
	
	    timeout: function(value) {
	      if (!arguments.length) return timeout;
	      timeout = +value;
	      return request;
	    },
	
	    user: function(value) {
	      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
	    },
	
	    password: function(value) {
	      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
	    },
	
	    // Specify how to convert the response content to a specific type;
	    // changes the callback value on "load" events.
	    response: function(value) {
	      response = value;
	      return request;
	    },
	
	    // Alias for send("GET", …).
	    get: function(data, callback) {
	      return request.send("GET", data, callback);
	    },
	
	    // Alias for send("POST", …).
	    post: function(data, callback) {
	      return request.send("POST", data, callback);
	    },
	
	    // If callback is non-null, it will be used for error and load events.
	    send: function(method, data, callback) {
	      xhr.open(method, url, true, user, password);
	      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
	      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
	      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
	      if (responseType != null) xhr.responseType = responseType;
	      if (timeout > 0) xhr.timeout = timeout;
	      if (callback == null && typeof data === "function") callback = data, data = null;
	      if (callback != null && callback.length === 1) callback = fixCallback(callback);
	      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
	      event.call("beforesend", request, xhr);
	      xhr.send(data == null ? null : data);
	      return request;
	    },
	
	    abort: function() {
	      xhr.abort();
	      return request;
	    },
	
	    on: function() {
	      var value = event.on.apply(event, arguments);
	      return value === event ? request : value;
	    }
	  };
	
	  if (callback != null) {
	    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    return request.get(callback);
	  }
	
	  return request;
	};
	
	function fixCallback(callback) {
	  return function(error, xhr) {
	    callback(error == null ? xhr : null);
	  };
	}
	
	function hasResponse(xhr) {
	  var type = xhr.responseType;
	  return type && type !== "text"
	      ? xhr.response // null on error
	      : xhr.responseText; // "" on error
	}
	
	var type = function(defaultMimeType, response) {
	  return function(url, callback) {
	    var r = request(url).mimeType(defaultMimeType).response(response);
	    if (callback != null) {
	      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	      return r.get(callback);
	    }
	    return r;
	  };
	};
	
	var html = type("text/html", function(xhr) {
	  return document.createRange().createContextualFragment(xhr.responseText);
	});
	
	var json = type("application/json", function(xhr) {
	  return JSON.parse(xhr.responseText);
	});
	
	var text = type("text/plain", function(xhr) {
	  return xhr.responseText;
	});
	
	var xml = type("application/xml", function(xhr) {
	  var xml = xhr.responseXML;
	  if (!xml) throw new Error("parse error");
	  return xml;
	});
	
	var dsv = function(defaultMimeType, parse) {
	  return function(url, row, callback) {
	    if (arguments.length < 3) callback = row, row = null;
	    var r = request(url).mimeType(defaultMimeType);
	    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
	    r.row(row);
	    return callback ? r.get(callback) : r;
	  };
	};
	
	function responseOf(parse, row) {
	  return function(request$$1) {
	    return parse(request$$1.responseText, row);
	  };
	}
	
	var csv = dsv("text/csv", d3Dsv.csvParse);
	
	var tsv = dsv("text/tab-separated-values", d3Dsv.tsvParse);
	
	exports.request = request;
	exports.html = html;
	exports.json = json;
	exports.text = text;
	exports.xml = xml;
	exports.csv = csv;
	exports.tsv = tsv;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parseHostname = __webpack_require__(29);
	
	Object.defineProperty(exports, 'parseHostname', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_parseHostname).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * Virtual enums – used to define the different forms a sharing button/icon
	 * can take when being shown.
	 * @module displayTypes
	 * @enum {string}
	 * @property {string} HORIZONTAL_ICONS - Share buttons displayed as horizontally aligned icons.
	 * @property {string} VERTICAL_BUTTONS - Share buttons displayed as vertically stacked buttons.
	 * @property {string} HORIZONTAL_BUTTONS – Share buttons displayed as
	 * horizontal small grouped icons
	 * @readonly
	 */
	exports.default = {
	  HORIZONTAL_ICONS: 'horizontal icons',
	  VERTICAL_BUTTONS: 'vertical buttons',
	  HORIZONTAL_BUTTONS: 'horizontal buttons'
	};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.0' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(10)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(84);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./image.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./image.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ArticleCard;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Renders a single teaser card.
	 * @param {object} props
	 * @param {string} props.url The (article) URL to link to.
	 * @param {string} props.imageSrc The source URL of the teaser image.
	 * @param {string} props.title The title of the article.
	 * @param {string} props.authors A string with the author information
	 * @param {string} props.lead The lead of the article
	 * @returns {XML}
	 */
	function ArticleCard(_ref) {
	  var url = _ref.url,
	      imageSrc = _ref.imageSrc,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? '░░░ ░░░░░░░' + ' ░░░░░░' : _ref$title,
	      _ref$authors = _ref.authors,
	      authors = _ref$authors === undefined ? '░░░ ░░░, ░░░░░░' : _ref$authors,
	      _ref$lead = _ref.lead,
	      lead = _ref$lead === undefined ? '<p>░░░░░░ ░░░░░ ░░░░░░░░░░' + ' ░░░ ░░░░░░░░ ░░░░░░░░░░░░░ ░░░░░ ░░░ ░░░░░░░░░. ░░░░░░░░░░░░░ ░░░░ ░░ ░░░' + ' ░░░ ░░░░░░░░░░ ░░░░░░░░.</p>' : _ref$lead;
	
	  return _react2.default.createElement(
	    'a',
	    { href: url,
	      target: '_top',
	      className: 'ui article-teaser card' },
	    _react2.default.createElement(
	      'div',
	      { className: 'image' },
	      _react2.default.createElement('img', { src: imageSrc })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        title
	      ),
	      _react2.default.createElement('div', { className: 'description', dangerouslySetInnerHTML: { __html: lead } }),
	      _react2.default.createElement(
	        'div',
	        null,
	        'Mehr\u2009\u2026'
	      )
	    ),
	    authors !== '' && _react2.default.createElement(
	      'div',
	      { className: 'extra content' },
	      authors
	    )
	  );
	}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Helper object in case you don't use flow – the string values as an object
	 * of the various {@link SortMode}s
	 * @module sortMode
	 * @enum {string}
	 * @see SortMode
	 * @readonly
	 * @property {'none'} NONE No sorting applied, teaser will be listed in the
	 *   order their data has been downloaded.
	 * @property {'manual'} MANUAL Use the same order as passed into the props.
	 * @property {'chronologically by creation date'} CHRONOLOGICALLY_BY_CREATION_DATE Order teasers in
	 *   chronological order using their `first_published_at` timestamp.
	 * @property {'reverse chronologically by creation date'} REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE Order teasers in
	 *   reverse chronological order using their `first_published_at` timestamp.
	 * @property {'chronologically by update date'} CHRONOLOGICALLY_BY_UPDATE_DATE Order teasers in
	 *   chronological order using their `timestamp_updated_at` timestamp.
	 * @property {'reverse chronologically by update date'} REVERSE_CHRONOLOGICALLY_BY_UPDATE_DATE Order teasers in
	 *   reverse chronological order using their `timestamp_updated_at` timestamp.
	 */
	var sortMode = exports.sortMode = {
	  NONE: 'none',
	  MANUAL: 'manual',
	  CHRONOLOGICALLY_BY_CREATION_DATE: 'chronologically by creation date',
	  REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE: 'reverse chronologically by creation date',
	  CHRONOLOGICALLY_BY_UPDATE_DATE: 'chronologically by update date',
	  REVERSE_CHRONOLOGICALLY_BY_UPDATE_DATE: 'reverse chronologically by update date'
	};
	
	/**
	 * The possible string values that can be used to sort the articles.
	 */
	exports.default = sortMode;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _shareButtons = __webpack_require__(35);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _shareButtons.ShareButtons;
	  }
	});
	Object.defineProperty(exports, 'ShareButtons', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shareButtons).default;
	  }
	});
	
	var _displayTypes = __webpack_require__(7);
	
	Object.defineProperty(exports, 'displayTypes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_displayTypes).default;
	  }
	});
	
	var _supportedCommunities = __webpack_require__(17);
	
	Object.defineProperty(exports, 'supportedCommunities', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_supportedCommunities).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * The communities this setup currently supports (i.e. with icons or the
	 * shareActionFactory.
	 * Currently supports `twitter`, `facebook`, `whatsapp` and `share`.
	 * @module supportedCommunities
	 */
	exports.default = ['twitter', 'facebook', 'whatsapp', 'share'];

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(57);
	var createDesc = __webpack_require__(62);
	module.exports = __webpack_require__(9) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(50);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(21);
	var defined = __webpack_require__(18);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(96)();
	}


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  above: 'above',
	  inside: 'inside',
	  below: 'below',
	  invisible: 'invisible'
	};
	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(77);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./button.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./button.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(78);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./card.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./card.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseHostname;
	/**
	 * @module parseHostname
	 * @desc Parses the hostname (`window.location.hostname` or your own supplied
	 *   string) and returns an object with the hostname (kinda redundant), the
	 *   simple domain and the media name. Used to find the correct API endpoint or
	 *   to find the correct logo for the masthead.
	 * @version 1.0
	 *
	 * @example
	 * import {parseHostname} from '@ta-interaktiv/parse-hostname';
	 *
	 * let parsedHost = parseHostname();
	 * // Returns on http://interaktiv.tagesanzeiger.ch/2016/example-project
	 * // {
	 * //    projectDomain: interaktiv.tagesanzeiger.ch,
	 * //    publicationDomain: tagesanzeiger.ch,
	 * //    publicationName: tagesanzeiger
	 * // }
	 */
	
	/**
	 * @typedef {Object} Hostname
	 * @property {string} projectDomain Full host name, like
	 * "interaktiv.tagesanzeiger.ch".
	 * @property {string} publicationDomain Last two parts of the project
	 * domain, like "tagesanzeiger.ch".
	 * @property {string} publicationName Just the media name, like "tagesanzeiger".
	 */
	
	/**
	 * @param {string} [host=window.location.hostname] A
	 * host name like `interaktiv.tagesanzeiger.ch`, in case it differs
	 * from the current location.
	 *
	 * @returns {Hostname}
	 */
	function parseHostname() {
	  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
	
	  // get the full host name. Replace with 'interaktiv.tagesanzeiger.ch' if
	  // developing on localhost.
	  var projectDomain = /localhost/.test(host) ? 'interaktiv.tagesanzeiger.ch' : host;
	
	  /** Create an array with the projectDomain parts */
	  var hostnameArray = projectDomain.split('.');
	
	  /**
	   * Domain without any sub domains = last two parts of the projectDomain
	   */
	  var publicationDomain = hostnameArray.slice(-2).join('.');
	
	  /**
	   * Media Name: Domain without top level domain.
	   */
	  var publicationName = hostnameArray[hostnameArray.length - 2];
	
	  return {
	    projectDomain: projectDomain,
	    publicationDomain: publicationDomain,
	    publicationName: publicationName
	  };
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Request = __webpack_require__(4);
	
	var _parseHostname = __webpack_require__(5);
	
	__webpack_require__(28);
	
	var _articleCard = __webpack_require__(14);
	
	var _articleCard2 = _interopRequireDefault(_articleCard);
	
	__webpack_require__(112);
	
	var _sortMode = __webpack_require__(15);
	
	var _sortMode2 = _interopRequireDefault(_sortMode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Article Teaser component: downloads the teaser information and stores the
	 * downloaded data in its state.
	 *
	 * @version 1.1
	 * @example
	 * import ArticleTeasers, {sortMode} from
	 * '@ta-interaktiv/react-article-teasers';
	 *
	 * // more code ...
	 *
	 * class YourComponent extends React.Component {
	 *  render() {
	 *
	 *    return (
	 *      <ArticleTeasers
	 *        sorting={sortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE}
	 *        articleIds={['16008934', '21426105', '17814575']}/>
	 *    )
	 *  }
	 *}
	 *
	 * @param props
	 * @param {string[]} props.articleIds An array of CD article IDs, as strings.
	 * @param {string} [props.numberOfCards=two] How many article teaser
	 * should
	 * be shown in a row on desktop devices. As a number word. ('one', 'two',
	 * 'three', etc.)
	 * @param {SortMode} [props.sorting=manual] The sorting mode. Choose from
	 * one of the options from {@link sortMode}.
	 * @param {string} [props.additionalClasses=] Additional classes to be
	 * passed to the cards element. As defined in the
	 * {@link http://semantic-docs.xeophin.com/views/card.html|Card
	   *   documentation}.
	 */
	var ArticleTeasers = function (_React$Component) {
	  _inherits(ArticleTeasers, _React$Component);
	
	  function ArticleTeasers() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ArticleTeasers);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ArticleTeasers.__proto__ || Object.getPrototypeOf(ArticleTeasers)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      downloadedArticles: new Map()
	    }, _this.hostdomain = (0, _parseHostname.parseHostname)().publicationDomain, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ArticleTeasers, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // Render nothing when there are no articles
	      if (this.props.articleIds.length === 0 || this.state.downloadedArticles.length === 0) {
	        return null;
	      }
	
	      // region Sorting
	      var sortedArticleList = [];
	
	      // Push article data into the sorted list, based on the order of the
	      // prop articleId list
	      this.props.articleIds.map(function (id) {
	        var article = _this2.state.downloadedArticles.get(id);
	        if (article !== undefined) {
	          sortedArticleList.push(article);
	        }
	      });
	
	      if (sortedArticleList.length <= 0) {
	        return null;
	      }
	
	      switch (this.props.sorting) {
	        case _sortMode2.default.CHRONOLOGICALLY_BY_CREATION_DATE:
	          sortedArticleList.sort(function (a, b) {
	            return a.first_published_at - b.first_published_at;
	          });
	          break;
	
	        case _sortMode2.default.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE:
	          sortedArticleList.sort(function (a, b) {
	            return b.first_published_at - a.first_published_at;
	          });
	          break;
	
	        case _sortMode2.default.CHRONOLOGICALLY_BY_UPDATE_DATE:
	          sortedArticleList.sort(function (a, b) {
	            return a.timestamp_updated_at - b.timestamp_updated_at;
	          });
	          break;
	
	        case _sortMode2.default.REVERSE_CHRONOLOGICALLY_BY_UPDATE_DATE:
	          sortedArticleList.sort(function (a, b) {
	            return b.timestamp_updated_at - a.timestamp_updated_at;
	          });
	          break;
	
	        case _sortMode2.default.NONE:
	        case _sortMode2.default.MANUAL:
	        default:
	          break;
	      }
	
	      // endregion
	
	      // HACK maxWidth should be solved by Semantic UI
	      return _react2.default.createElement(
	        'div',
	        { className: 'article-teasers ui stackable ' + this.props.numberOfCards + ' ' + this.props.additionalClasses + ' text cards',
	          style: { maxWidth: '100vw' } },
	        sortedArticleList.map(function (article, index) {
	          if (typeof article.title === 'undefined') {
	            return false;
	          }
	
	          // Prepare author list
	          var authorNames = [];
	          var authorsString = '';
	          article.authors.map(function (author) {
	            authorNames.push(author.name);
	          });
	
	          // If we have a nice list of authors that is longer than zero
	          // elements, join them with a comma.
	          if (authorNames.length > 0) {
	            authorsString += authorNames.join(', ');
	          }
	
	          return _react2.default.createElement(_articleCard2.default, { key: article.legacy_id,
	            url: '//www.' + _this2.hostdomain + '/' + article.legacy_id,
	            imageSrc: article.picture_medium_url,
	            title: article.title,
	            authors: authorsString,
	            lead: article.lead });
	        })
	      );
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      // Component did just mount. We will assume that so far, no article data
	      // has been downloaded and it is safe to download all requested data.
	      this.props.articleIds.map(function (id) {
	        _this3.downloadNewArticle(id);
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this4 = this;
	
	      // Check if any article data has been downloaded before and download new
	      // ones
	      nextProps.articleIds.map(function (id) {
	        if (_this4.state.downloadedArticles.has(id)) {
	          // Data has been downloaded before, don't do anything
	          return;
	        }
	
	        // Download new article data
	        _this4.downloadNewArticle(id);
	      });
	    }
	
	    /**
	     * Loads new, previously not downloaded articles.
	     * Updates the component state.
	     */
	
	  }, {
	    key: 'downloadNewArticle',
	    value: function downloadNewArticle(articleID) {
	      var _this5 = this;
	
	      (0, _d3Request.json)('//mobile2.' + this.hostdomain + '/api/articles/' + articleID, function (error, articleData) {
	        if (error) {
	          console.group('Article Teasers');
	          console.warn('Article with ID ' + articleID + ' could not be loaded. It might not be published yet or is not available on this website.');
	          console.groupEnd();
	          return;
	        }
	
	        _this5.setState(function (previousState) {
	          var articleList = previousState.downloadedArticles;
	          articleList.set(articleID, articleData.article);
	          return {
	            downloadedArticles: articleList
	          };
	        });
	      });
	    }
	  }]);
	
	  return ArticleTeasers;
	}(_react2.default.Component);
	
	ArticleTeasers.defaultProps = {
	  numberOfCards: 'two',
	  additionalClasses: '',
	  sorting: _sortMode2.default.MANUAL
	};
	exports.default = ArticleTeasers;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _articleTeasers = __webpack_require__(30);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_articleTeasers).default;
	  }
	});
	
	var _sortMode = __webpack_require__(15);
	
	Object.defineProperty(exports, 'sortMode', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sortMode).default;
	  }
	});
	
	var _articleCard = __webpack_require__(14);
	
	Object.defineProperty(exports, 'ArticleCard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_articleCard).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// region import React
	
	// endregion
	// region import components
	
	// endregion
	// region import CSS
	// Semantic UI
	
	// Specific CSS
	
	
	exports.default = Masthead;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactShareButtons = __webpack_require__(16);
	
	var _reactShareButtons2 = _interopRequireDefault(_reactShareButtons);
	
	__webpack_require__(120);
	
	__webpack_require__(118);
	
	__webpack_require__(13);
	
	__webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Renders the masthead component.
	 * @param {mastheadProps} props
	 * @param {string} [props.mediaName=tagesanzeiger] The media domain name whose
	 * logo should be shown.
	 * @param {string} [props.fullMediaName=Tages-Anzeiger] The outwards facing
	 *   media name.
	 * @param {string} [props.homepage=http://www.tagesanzeiger.ch] The home page
	 *   of the medium to link to.
	 * @param {string} [props.url=window.location.href] The URL to share. Will be
	 * overridden by URLs in the {@link communities} array. Passed along to share
	 *   buttons component.
	 * @param {boolean} [props.inverted=false] Whether the masthead should be
	 * displayed inverted, for use on dark backgrounds.
	 * @param {string[]} [props.hashtags] Hashtags as an array of strings. Facebook
	 *   will only use the first one.
	 * @param {communityObject[]} [props.communities] Community objects, as
	 * provided by
	 *   the External Services API service by Newsnet.
	 * @param {function} [props.clickHandler=noop] The action that should be
	 * executed when the user clicks the link.
	 */
	
	// endregion
	
	/**
	 * @module Masthead
	 * @version 2.2
	 * @example
	 * import Masthead from '@ta-interaktiv/react-masthead';
	 *
	 *  // ...
	 *
	 *  class YourComponent extends React.Component {
	 *   render() {
	 *
	 *     return (
	 *       <Masthead
	 *          mediaName='tagesanzeiger'
	 *          homepage='//www.tagesanzeiger.ch'
	 *          fullMediaName='Tages-Anzeiger'
	 *          hashtags={['TAGrafik', 'DDJ']} />
	 *     )
	 *   }
	 * }
	 *
	 */
	
	/**
	 * The community object as provided by the Newsnet API.
	 *
	 * @property {string} type The identifier of the community (i.e. 'facebook'
	 *   or 'twitter')
	 * @property {number} count The number of shares of this type.
	 * @property {string} share_type_id A GUID that links article and community
	 *   type.
	 * @property {string} url The canonical URL of the article that should be
	 *   used for sharing this article.
	 * @property {string} [name] The front facing name of the community.
	 * @property {string} [title] The title of the article for sharing.
	 * @property {string} [description] The call to action for the community.
	 * @property {string} [facebook_id] The Facebook App ID.
	 * @property {string} [via] The via account name to use on Twitter.
	 */
	function Masthead(props) {
	  var _props$mediaName = props.mediaName,
	      mediaName = _props$mediaName === undefined ? 'tagesanzeiger' : _props$mediaName,
	      _props$inverted = props.inverted,
	      inverted = _props$inverted === undefined ? false : _props$inverted,
	      _props$clickHandler = props.clickHandler,
	      clickHandler = _props$clickHandler === undefined ? function () {} : _props$clickHandler,
	      _props$homepage = props.homepage,
	      homepage = _props$homepage === undefined ? '//www.tagesanzeiger.ch' : _props$homepage,
	      _props$fullMediaName = props.fullMediaName,
	      fullMediaName = _props$fullMediaName === undefined ? 'Tages-Anzeiger' : _props$fullMediaName,
	      _props$url = props.url,
	      url = _props$url === undefined ? window.location.href : _props$url;
	  // Prepare constants for the inverted version
	
	  var invertedClass = inverted ? 'inverted' : '';
	  var invertedImgSrcName = inverted ? '-inverted' : '';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ta-masthead masthead-component ' + invertedClass },
	    _react2.default.createElement(
	      'div',
	      { className: 'ui container ' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui middle aligned grid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile only three wide column ta-logo' },
	          _react2.default.createElement(
	            'a',
	            { href: homepage },
	            ' ',
	            _react2.default.createElement('img', {
	              src: '//interaktiv.tagesanzeiger.ch/static/icons/' + mediaName + invertedImgSrcName + '.svg',
	              alt: fullMediaName,
	              className: 'ui middle aligned logo image' }),
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile hidden five wide column ta-logo' },
	          _react2.default.createElement(
	            'a',
	            { href: homepage },
	            ' ',
	            _react2.default.createElement('img', {
	              src: '//interaktiv.tagesanzeiger.ch/static/logos/' + mediaName + invertedImgSrcName + '.svg',
	              alt: fullMediaName,
	              className: 'ui middle aligned logo image' }),
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'right aligned right floated thirteen wide mobile eleven wide tablet eleven wide computer column' },
	          _react2.default.createElement(_reactShareButtons2.default, _extends({}, props, {
	            url: url,
	            clickHandler: clickHandler,
	            displayType: 'horizontal icons' }))
	        )
	      )
	    )
	  );
	}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMasthead = __webpack_require__(32);
	
	var _reactMasthead2 = _interopRequireDefault(_reactMasthead);
	
	var _d3Request = __webpack_require__(4);
	
	var _parseHostname = __webpack_require__(5);
	
	var _faviconSetter = __webpack_require__(93);
	
	var _faviconSetter2 = _interopRequireDefault(_faviconSetter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Display the masthead in standalone projects. Adapts to the mandate.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module PolymorphicMasthead
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @version 1.1
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * import Masthead from '@ta-interaktiv/react-polymorphic-masthead';
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * // more code ...
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * class YourComponent extends React.Component {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  render() {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    return (
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *      <Masthead articleID='346234' hashtags={['TAGrafik', 'DDJ']} />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    )
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Enum states for the loading process.
	 * @private
	 * @type {{LOADING: string, ERROR: string, READY: string}}
	 */
	var requestState = {
	  LOADING: 'loading',
	  ERROR: 'error',
	  READY: 'ready'
	
	  /**
	   * API endpoint subdomain for the Newsnet API
	   * @private
	   * @type {string}
	   */
	};var API_ENDPOINT = 'mobile2';
	
	/**
	 * @param {string} props.articleID The article ID of the main / link article
	 *   in the CD. Used to get the appropriate share URLs and counts.
	 * @param {boolean} [props.inverted=false] Displays the masthead transparent
	 *   with white text for dark backgrounds.
	 * @param {string[]} [props.hashtags] Hashtags as an array of strings.
	 *   Facebook will only use the first one.
	 * @param {function} [props.clickHandler=clickHandler] An
	 *   action to execute when the button is clicked. Defaults to a call to the
	 *   share button counter API endpoint.
	 * @param {number} [props.additionalFacebookShares] A number that can make
	 * up for lost Facebook shares that have been lost due to a change of the
	 * canonical URL.
	 */
	
	var PolymorphicMasthead = function (_React$PureComponent) {
	  _inherits(PolymorphicMasthead, _React$PureComponent);
	
	  function PolymorphicMasthead(props) {
	    _classCallCheck(this, PolymorphicMasthead);
	
	    var _this = _possibleConstructorReturn(this, (PolymorphicMasthead.__proto__ || Object.getPrototypeOf(PolymorphicMasthead)).call(this, props));
	
	    _this.state = {
	      loadingState: requestState.LOADING
	    };
	    return _this;
	  }
	
	  _createClass(PolymorphicMasthead, [{
	    key: 'render',
	    value: function render() {
	      if (this.state.loadingState === requestState.LOADING) {
	        // preliminarily show the masthead, so we don't get a flash of
	        // non-mastheaded content
	        var parsedHostname = (0, _parseHostname.parseHostname)();
	        return _react2.default.createElement(_reactMasthead2.default, _extends({}, this.props, { fullMediaName: '',
	          mediaName: parsedHostname.publicationName,
	          homepage: '//www.' + parsedHostname.publicationDomain,
	          url: window.location.href
	        }));
	      }
	
	      return _react2.default.createElement(_reactMasthead2.default, _extends({}, this.props, this.state));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var parsedHostname = (0, _parseHostname.parseHostname)();
	
	      // set favicon based on medium, works in Chrome, Firefox, Opera
	      (0, _faviconSetter2.default)('//www.' + parsedHostname.publicationName + '.ch/favicon.ico');
	
	      (0, _d3Request.json)('//' + API_ENDPOINT + '.' + parsedHostname.publicationDomain + '/api/articles/' + this.props.articleID + '/external_services', function (error, data) {
	        if (error) {
	          console.group('Polymorphic Masthead');
	          console.warn('Error while loading article data. Default or implied' + ' values will be used.');
	          console.groupEnd();
	
	          _this2.setState({
	            loadingState: requestState.ERROR,
	            mediaName: parsedHostname.publicationName,
	            homepage: 'https://www.' + parsedHostname.publicationDomain,
	            fullMediaName: '',
	            url: window.location.href,
	            clickHandler: function clickHandler() {} // no-op when there is an obvious problem
	          });
	          return;
	        }
	
	        _this2.setState({
	          loadingState: requestState.READY,
	          communities: data.communities,
	          mediaName: parsedHostname.publicationName,
	          fullMediaName: data.configs.name,
	          homepage: 'https://www.' + parsedHostname.publicationDomain,
	          clickHandler: _this2.props.clickHandler.bind(null, _this2.props.articleID)
	        });
	      });
	    }
	  }]);
	
	  return PolymorphicMasthead;
	}(_react2.default.PureComponent);
	
	exports.default = PolymorphicMasthead;
	
	
	PolymorphicMasthead.propTypes = {
	  inverted: _propTypes2.default.bool,
	  hashtags: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  articleID: _propTypes2.default.string.isRequired,
	  additionalFacebookShares: _propTypes2.default.number,
	  clickHandler: _propTypes2.default.func
	};
	
	PolymorphicMasthead.defaultProps = {
	  clickHandler: defaultClickHandler
	
	  /**
	   * The default click handler will call the share counting REST API upon
	   * clicking the buttons.
	   * @todo This is a pure copy from @ta-interaktiv/react-polymorphic-share-buttons
	   * and those two version should be kept in sync, in case they need to
	   * change. So maybe it would be a good idea to put it into it's own package
	   * or something?
	   * @callback clickHandler
	   * @param {string} articleID The ID of the article.
	   * @param {community} community A community object, as provided by the
	   *   Newsnet API
	   * @param {object} event The react event object.
	   */
	};function defaultClickHandler(articleID, community) {
	  var shareTypeId = community['share_type_id'];
	  (0, _d3Request.request)('//' + API_ENDPOINT + '.' + (0, _parseHostname.parseHostname)().publicationDomain + '/api/communities/' + articleID + '/counts/' + shareTypeId).post();
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Request = __webpack_require__(4);
	
	var _parseHostname = __webpack_require__(5);
	
	var _reactShareButtons = __webpack_require__(16);
	
	var _reactShareButtons2 = _interopRequireDefault(_reactShareButtons);
	
	__webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module PolymorphicShareButtons
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @description These share buttons can be provided with an article ID. They
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   will then use the Newsnet API to gather the correct links and share
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   counters.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @version 1.1
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * import PolymorphicShareButtons from
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * '@ta-interaktiv/react-polymorphic-share-buttons'
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  class YourComponent extends React.Component {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   render() {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     return (
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *       <PolymorphicShareButtons
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *           articleID='34511213'
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *           hashtags={['TAGrafik', 'ddj']}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *           displayType='horizontal icons'/>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     )
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * The community object as provided by the Newsnet API.
	 *
	 * @typedef {Object} community
	 * @property {string} type The identifier of the community (i.e. 'facebook'
	 *   or 'twitter')
	*  @property {number} count The number of shares of this type.
	 * @property {string} share_type_id A GUID that links article and community
	 *   type.
	 * @property {string} url The canonical URL of the article that should be
	 *   used for sharing this article.
	 * @property {string} [name] The front facing name of the community.
	 * @property {string} [title] The title of the article for sharing.
	 * @property {string} [description] The call to action for the community.
	 * @property {string} [facebook_id] The Facebook App ID.
	 * @property {string} [via] The via account name to use on Twitter.
	 */
	
	/**
	 * Enum states for the loading process.
	 * @type {{LOADING: string, ERROR: string, READY: string}}
	 */
	var requestStatus = {
	  LOADING: 'loading',
	  ERROR: 'error',
	  READY: 'ready'
	  /**
	   * The subdomain to use for the call to the Newsnet API.
	   * @type {string}
	   */
	};var API_SUBDOMAIN = 'mobile2';
	
	/**
	 * Share buttons that are configured using the Newsnet API, using the article ID
	 */
	
	var PolymorphicShareButtons = function (_React$Component) {
	  _inherits(PolymorphicShareButtons, _React$Component);
	
	  /**
	   * Set up share buttons.
	   *
	   * @param {string} props.articleID The article ID of the main / link article
	   *   in the CD. Used to get the appropriate share URLs and counts.
	   * @param {clickHandler} [props.clickHandler] An action to execute when
	   *   the button is clicked. Defaults to a call to the share button counter
	   *   API endpoint.
	   * @param {{VERTICAL_BUTTONS: string, HORIZONTAL_ICONS: string}}
	   *   [props.displayType=VERTICAL_BUTTONS] The display type, either
	   *   horizontally aligned icons (with share counter) or vertically stacked
	   *   buttons. Defaults to vertical buttons.
	   * @param {boolean} [props.inverted=false] Whether the list should be
	   *   displayed on a dark background.
	   * @param {string[]} [props.hashtags] A list of hashtags to tag the shared
	   *   content with. Facebook will only accept the first value, so make it
	   *   count.
	   * @param {number} [props.additionalFacebookShares] Manually add Facebook
	   * shares in case some of them got lost due to changing the canonical URL.
	   */
	  function PolymorphicShareButtons(props) {
	    _classCallCheck(this, PolymorphicShareButtons);
	
	    var _this = _possibleConstructorReturn(this, (PolymorphicShareButtons.__proto__ || Object.getPrototypeOf(PolymorphicShareButtons)).call(this, props));
	
	    _this.state = {
	      loadingState: requestStatus.LOADING
	    };
	    return _this;
	  }
	
	  // region React component overrides
	
	
	  _createClass(PolymorphicShareButtons, [{
	    key: 'render',
	    value: function render() {
	      // Don't render anything while we load data
	      if (this.state.loadingState === requestStatus.LOADING) {
	        return null;
	      }
	
	      // In case we encounter an error, we will still render the buttons. They
	      // will now use the default values, which are still somewhat decent.
	      if (this.state.loadingState === requestStatus.ERROR) {
	        return _react2.default.createElement(_reactShareButtons2.default, _extends({}, this.props, { clickHandler: this.props.clickHandler.bind(null, this.props.articleID) }));
	      }
	
	      // Otherwise
	      return _react2.default.createElement(_reactShareButtons2.default, _extends({}, this.props, { communities: this.state.communities,
	        clickHandler: this.props.clickHandler.bind(null, this.props.articleID) }));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _d3Request.json)('//' + API_SUBDOMAIN + '.' + (0, _parseHostname.parseHostname)().publicationDomain + '/api/articles/' + this.props.articleID + '/external_services', function (error, data) {
	        if (error) {
	          // Provide warning
	          console.group('Polymorphic Share Buttons');
	          console.warn('Error while loading article data. Default values' + ' will be used.');
	          console.groupEnd();
	
	          // Mark state as having an error
	          _this2.setState({
	            loadingState: requestStatus.ERROR
	          });
	
	          return;
	        }
	
	        console.log(data.communities);
	
	        _this2.setState({
	          communities: data.communities,
	          loadingState: requestStatus.READY
	        });
	      });
	    }
	
	    // endregion
	
	  }]);
	
	  return PolymorphicShareButtons;
	}(_react2.default.Component);
	
	PolymorphicShareButtons.propTypes = {
	  displayType: _propTypes2.default.oneOf([_reactShareButtons.displayTypes.HORIZONTAL_ICONS, _reactShareButtons.displayTypes.VERTICAL_BUTTONS]),
	  inverted: _propTypes2.default.bool,
	  hashtags: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  articleID: _propTypes2.default.string.isRequired,
	  clickHandler: _propTypes2.default.func,
	  additionalFacebookShares: _propTypes2.default.number
	};
	
	PolymorphicShareButtons.defaultProps = {
	  clickHandler: defaultClickHandler
	
	  /**
	   * The default click handler will call the share counting REST API upon
	   * clicking the buttons.
	   * @callback clickHandler
	   * @param {string} articleID The ID of the article.
	   * @param {community} community A community object, as provided by the
	   *   Newsnet API
	   * @param {object} event The react event object.
	   */
	};function defaultClickHandler(articleID, community) {
	  var shareTypeId = community['share_type_id'];
	  (0, _d3Request.request)('//' + API_SUBDOMAIN + '.' + (0, _parseHostname.parseHostname)().publicationDomain + '/api/communities/' + articleID + '/counts/' + shareTypeId).post();
	}
	
	exports.default = PolymorphicShareButtons;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/**
	 * Renders a collection of social sharing buttons.
	 * @module ReactShareButtons
	 * @version 1.1
	 */
	
	
	exports.ShareButtons = ShareButtons;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shareItem = __webpack_require__(36);
	
	var _shareItem2 = _interopRequireDefault(_shareItem);
	
	var _displayTypes = __webpack_require__(7);
	
	var _displayTypes2 = _interopRequireDefault(_displayTypes);
	
	var _supportedCommunities = __webpack_require__(17);
	
	var _supportedCommunities2 = _interopRequireDefault(_supportedCommunities);
	
	var _d3Collection = __webpack_require__(12);
	
	var _shareUrlFactory = __webpack_require__(37);
	
	var _shareUrlFactory2 = _interopRequireDefault(_shareUrlFactory);
	
	__webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// region CSS
	__webpack_require__(122);
	__webpack_require__(27);
	__webpack_require__(124);
	
	// endregion
	
	/**
	 * Renders social sharing buttons.
	 * @param {ShareButtonsProps} props
	 * @param [props.displayType=VERTICAL_BUTTONS] - The display
	 * type, see {@link displayTypes}
	 * @param [props.inverted=false] - For displaying the list on a dark
	 * background.
	 * @param [props.communities] - Community objects, as
	 * provided by the External Services API service by Newsnet.
	 * @param [props.hashtags] - Hashtags as an array of strings.
	 * Facebook  will only use the first one.
	 * @param [props.url=window.location.href] - The URL to share.
	 * @param [props.clickHandler=noop] - The action that should be
	 *   executed when the user clicks the link. The communities object is bound to
	 *   this action, so that the type (or other infos) can be extracted from it.
	 *   This design also means that in case of an API change the changes can be
	 *   executed on the level of the polymorphic component.
	 * @param [props.className] - Additional class names to be passed to the link
	 * group.
	 * @param [props.itemClassName] - Additional class names to be passed into
	 * individual items.
	 * @param [props.additionalFacebookShares] - In case of Facebook share loss
	 * (e.g. when the canonical URL has been changed), you can provide
	 * additional shares via this property.
	 * @constructor
	 */
	function ShareButtons(_ref) {
	  var _ref$displayType = _ref.displayType,
	      displayType = _ref$displayType === undefined ? _displayTypes2.default.VERTICAL_BUTTONS : _ref$displayType,
	      _ref$inverted = _ref.inverted,
	      inverted = _ref$inverted === undefined ? false : _ref$inverted,
	      _ref$communities = _ref.communities,
	      communities = _ref$communities === undefined ? [{
	    type: 'twitter',
	    article_id: '-1',
	    refresh: '-1',
	    share_type_id: '-1',
	    description: 'Bei Twitter veröffentlichen',
	    count: 0,
	    cache: 'false'
	  }, {
	    type: 'facebook',
	    description: 'Auf Facebook teilen',
	    facebook_id: '147124108642216',
	    count: 0,
	    article_id: '-1',
	    refresh: '-1',
	    share_type_id: '-1',
	    cache: 'false'
	  }, {
	    type: 'whatsapp',
	    description: 'Über WhatsApp texten',
	    count: 0,
	    article_id: '-1',
	    refresh: '-1',
	    share_type_id: '-1',
	    cache: 'false'
	  }, {
	    type: 'share',
	    description: 'Per Mail senden',
	    count: 0,
	    article_id: '-1',
	    refresh: '-1',
	    share_type_id: '-1',
	    cache: 'false'
	  }] : _ref$communities,
	      hashtags = _ref.hashtags,
	      _ref$url = _ref.url,
	      url = _ref$url === undefined ? window.location.href.replace(window.location.search, '').replace(window.location.hash, '') : _ref$url,
	      _ref$clickHandler = _ref.clickHandler,
	      clickHandler = _ref$clickHandler === undefined ? function () {} : _ref$clickHandler,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$itemClassName = _ref.itemClassName,
	      itemClassName = _ref$itemClassName === undefined ? '' : _ref$itemClassName,
	      _ref$additionalFacebo = _ref.additionalFacebookShares,
	      additionalFacebookShares = _ref$additionalFacebo === undefined ? 0 : _ref$additionalFacebo;
	
	  // Set up group class, depending on the desired display type.
	  var groupClass = 'ta sharing ui ' + className;
	
	  switch (displayType) {
	    case _displayTypes2.default.HORIZONTAL_ICONS:
	      groupClass += ' horizontal link list';
	      break;
	
	    case _displayTypes2.default.VERTICAL_BUTTONS:
	      groupClass += ' vertical labeled small icon buttons';
	      break;
	
	    case _displayTypes2.default.HORIZONTAL_BUTTONS:
	      groupClass += ' icon basic buttons';
	  }
	
	  // Add "inverted" if necessary
	  if (inverted) {
	    groupClass += ' inverted';
	  }
	
	  // Prepare Communities array
	  var mappedCommunities = (0, _d3Collection.map)(communities, function (d) {
	    return d.type;
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: groupClass },
	    _supportedCommunities2.default.map(function (communityType) {
	      var community = mappedCommunities.get(communityType);
	      if (community === undefined) {
	        return;
	      }
	
	      var count = community.count;
	
	      // region Special cases
	
	      // Mail has it's mail share URL already set up, so we need
	      // to take that into account. Unless it has not been set up, of course
	      var shareUrl = url;
	      if (communityType === 'share') {
	        if (community.url === undefined) {
	          shareUrl = 'mailto:?subject=' + window.document.title + '&body=' + url;
	        } else {
	          shareUrl = community.url;
	        }
	      }
	
	      if (communityType === 'facebook') {
	        count += additionalFacebookShares;
	      }
	
	      // endregion
	
	      // Create clone of the original function and bind the community
	      // object to it, so we can refer to that higher in the hierarchy.
	      var onClickHandler = clickHandler.bind(null, community);
	
	      return _react2.default.createElement(_shareItem2.default, _extends({ key: communityType
	      }, community, {
	        displayType: displayType,
	        inverted: inverted,
	        onClick: onClickHandler,
	        className: itemClassName,
	        shareUrl: _shareUrlFactory2.default[communityType](_extends({
	          hashtags: hashtags
	        }, community, {
	          url: shareUrl
	        })),
	        count: count
	      }));
	    })
	  );
	}
	
	exports.default = ShareButtons;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShareItem = ShareItem;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _displayTypes = __webpack_require__(7);
	
	var _displayTypes2 = _interopRequireDefault(_displayTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Share count number is only being shown if greater than this constant.
	 * @const {number}
	 */
	
	/**
	 * A single share button. This is usually not exposed, but is a
	 * sub-component of {@link ShareButtons}
	 * @module shareItem
	 * @version 1.1
	 */
	
	var minimumShares = 30;
	var iconReplacement = {
	  'facebook': 'facebook',
	  'twitter': 'twitter',
	  'whatsapp': 'whatsapp',
	  'share': 'mail'
	};
	
	function shareCountFormatter(count) {
	  return count >= minimumShares ? count : '';
	}
	
	/**
	 * A share item is a single sharing item, consisting of a link with an icon.
	 * Using display types, this item can be displayed in different ways, either
	 * as a list item or as a button.
	 *
	 * @param {ShareItemProps} props
	 */
	function ShareItem(_ref) {
	  var displayType = _ref.displayType,
	      _ref$inverted = _ref.inverted,
	      inverted = _ref$inverted === undefined ? false : _ref$inverted,
	      type = _ref.type,
	      count = _ref.count,
	      description = _ref.description,
	      shareUrl = _ref.shareUrl,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var itemClass = type + ' ' + (inverted ? 'inverted' : '') + ' ' + className + ' share';
	  var innerText = void 0;
	
	  switch (displayType) {
	    case _displayTypes2.default.HORIZONTAL_ICONS:
	      itemClass = itemClass + ' item';
	      innerText = shareCountFormatter(count);
	      break;
	
	    case _displayTypes2.default.VERTICAL_BUTTONS:
	      itemClass = className + ' ' + (inverted ? 'inverted' : '') + ' ui button share';
	      innerText = description;
	      break;
	
	    case _displayTypes2.default.HORIZONTAL_BUTTONS:
	      itemClass = iconReplacement[type] + ' ' + className + ' ui icon button share';
	      innerText = shareCountFormatter(count);
	      break;
	  }
	
	  return _react2.default.createElement(
	    'a',
	    { href: shareUrl,
	      title: description,
	      className: itemClass,
	      onClick: onClick,
	      target: '_top' },
	    _react2.default.createElement('i', { className: iconReplacement[type] + ' icon' }),
	    ' ',
	    innerText
	  );
	}
	
	exports.default = ShareItem;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _shareURLFactory = __webpack_require__(38);
	
	Object.defineProperty(exports, 'shareURLFactory', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shareURLFactory).default;
	  }
	});
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _shareURLFactory.shareURLFactory;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Create a URL to share an object on twitter.
	 *
	 * @param {Object} parameters
	 * @param {string} parameters.url URL to share
	 * @param {string=} parameters.title Description or title to be prefilled as
	 * text.
	 * @param {string=} parameters.via The Twitter handle that should be
	 * prefilled as «via».
	 * @param {Array.string=} parameters.hashtags The hashtags that the tweet
	 * should prefill.
	 * @returns {string} The action URL that opens the Twitter share screen.
	 * @throws {TypeError} if url is missing.
	 */
	function twitterShareUrl(parameters) {
	  var title = parameters.title,
	      url = parameters.url,
	      via = parameters.via,
	      hashtags = parameters.hashtags;
	
	
	  if (url === undefined) {
	    throw new TypeError('[Share URL Factory] URL not defined');
	  }
	
	  // Basic URL
	  var shareUrl = 'https://twitter.com/intent/tweet';
	
	  // Add URL
	  // We assume that there is always a URL present.
	  // This might bite us in our posteriors at some future time.
	  shareUrl += '?url=' + encodeURIComponent(url);
	
	  // Add title or additional text
	  if (title) {
	    shareUrl += '&text=' + encodeURIComponent(title);
	  }
	
	  // Add via
	  if (via) {
	    shareUrl += '&via=' + encodeURIComponent(via);
	  }
	
	  // Add hashtags
	  if (hashtags) {
	    shareUrl += '&hashtags=' + encodeURIComponent(hashtags.join(','));
	  }
	
	  return shareUrl;
	}
	
	/**
	 * Create an URL to share an object on Facebook.
	 *
	 * @param {Object} parameters
	 * @param {string} parameters.url The URL to be shared.
	 * @param {number} parameters.facebook_id The Facebook App ID.
	 * @param {Array.string=} parameters.hashtags The hashtags to share the
	 * content with. Similar to Twitter, but here only the first object is
	 * taken, so place your hashtags wisely!
	 * @returns {string} The URL with which the Facebook share dialog is being
	 * opened.
	 * @throws {TypeError} if url or facebook_id is undefined.
	 */
	
	/* eslint-disable camelcase */
	
	/**
	 * The default type that is being provided by the Newsnet External Services API. (Without the hashtags thing.)
	 */
	function facebookShareUrl(parameters) {
	  var url = parameters.url,
	      hashtags = parameters.hashtags,
	      facebook_id = parameters.facebook_id;
	
	
	  if (url === undefined) {
	    throw new TypeError('[Share URL Factory] URL not defined');
	  }
	
	  if (facebook_id === undefined) {
	    throw new TypeError('[Share URL Factory] Facebook ID not defined.');
	  }
	
	  var shareUrl = 'https://www.facebook.com/dialog/share';
	
	  shareUrl += '?display=popup';
	
	  shareUrl += '&app_id=' + facebook_id;
	
	  // Basic URL
	  shareUrl += '&href=' + encodeURIComponent(url);
	  shareUrl += '&redirect_uri=' + encodeURIComponent(url);
	
	  // Add hashtags
	  if (hashtags) {
	    shareUrl += '&hashtag=' + encodeURIComponent('#' + hashtags[0]);
	  }
	
	  return shareUrl;
	}
	
	/**
	 * Create a URL to share an object on WhatsApp.
	 *
	 * @param {Object} parameters
	 * @param {string} parameters.url URL to share
	 * @param {string=} parameters.title Description or title to be prefilled as
	 * text.
	 * @returns {string} The action URL that opens WhatsApp.
	 * @throws {TypeError} if url is missing.
	 */
	function whatsappShareUrl(parameters) {
	  var title = parameters.title,
	      url = parameters.url;
	
	
	  if (url === undefined) {
	    throw new TypeError('[Share URL Factory] URL not defined');
	  }
	
	  // Basic URL
	  var shareUrl = 'whatsapp://send';
	
	  // Add URL
	  shareUrl += '?text=' + encodeURIComponent(url);
	
	  // Add title or additional text
	  if (title) {
	    shareUrl += '' + encodeURIComponent(' ') + encodeURIComponent(title);
	  }
	
	  return shareUrl;
	}
	
	/**
	 * Create an URL to send a URL as e-mail.
	 * @param {Object} parameters
	 * @param {string} parameters.url In this case the actual Share URL.
	 * @return {string} The share URL.
	 */
	function shareShareUrl(parameters) {
	  var url = parameters.url;
	
	
	  if (url === undefined) {
	    throw new TypeError('[Share URL Factory] Share URL not defined');
	  }
	
	  return encodeURI(url);
	}
	
	/**
	 * The actual factory. The dictionary keys correspond to the share object type property, so it's easy to call the correct function for the specific share object
	 * @see {@link shareObject}
	 * @type {{twitter: twitterShareUrl, facebook: facebookShareUrl, whatsapp: whatsappShareUrl, share: shareShareUrl}}
	 */
	var shareURLFactory = exports.shareURLFactory = {
	  twitter: twitterShareUrl,
	  facebook: facebookShareUrl,
	  whatsapp: whatsappShareUrl,
	  share: shareShareUrl
	};
	
	exports.default = shareURLFactory;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPolymorphicMasthead = __webpack_require__(33);
	
	var _reactPolymorphicMasthead2 = _interopRequireDefault(_reactPolymorphicMasthead);
	
	var _taReactPolymorphicTracking = __webpack_require__(135);
	
	var _taReactPolymorphicTracking2 = _interopRequireDefault(_taReactPolymorphicTracking);
	
	var _reactPolymorphicShareButtons = __webpack_require__(34);
	
	var _reactPolymorphicShareButtons2 = _interopRequireDefault(_reactPolymorphicShareButtons);
	
	var _taReactPolymorphicCopyrightNotice = __webpack_require__(134);
	
	var _taReactPolymorphicCopyrightNotice2 = _interopRequireDefault(_taReactPolymorphicCopyrightNotice);
	
	var _reactWaypoint = __webpack_require__(111);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _reactArticleTeasers = __webpack_require__(31);
	
	var _reactArticleTeasers2 = _interopRequireDefault(_reactArticleTeasers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(125);
	__webpack_require__(127);
	__webpack_require__(126);
	__webpack_require__(121);
	__webpack_require__(119);
	__webpack_require__(13);
	__webpack_require__(27);
	__webpack_require__(128);
	__webpack_require__(123);
	__webpack_require__(28);
	__webpack_require__(116);
	
	var AppComponent = function (_React$Component) {
	  _inherits(AppComponent, _React$Component);
	
	  function AppComponent(props) {
	    _classCallCheck(this, AppComponent);
	
	    var _this = _possibleConstructorReturn(this, (AppComponent.__proto__ || Object.getPrototypeOf(AppComponent)).call(this, props));
	
	    _this.state = {
	      page: "",
	      counterClass: "hide"
	    };
	    return _this;
	  }
	
	  _createClass(AppComponent, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'index' },
	        _react2.default.createElement(_reactPolymorphicMasthead2.default, { articleID: '11403835', additionalFacebookShares: 387 }),
	        _react2.default.createElement(
	          'header',
	          { className: 'ui inverted vertical segment reduced-height mobile hidden',
	            style: {
	              backgroundImage: 'linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(204,205,210,0.2)), url(' + __webpack_require__(136) + ')',
	              backgroundPosition: 'center',
	              backgroundSize: 'cover'
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'header block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ui container' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'ui huge header mobile hidden' },
	                'Steckengeblieben',
	                _react2.default.createElement('br', null),
	                'im Nirgendwo'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'ta lead' },
	                'Die Menschen in der Ostukraine sind nach drei Jahren Krieg ersch\xF6pft, sie trauern um ihr zerst\xF6rtes Leben.  Unser Karikaturist Felix Schaad war vor Ort und hielt die Misere in einem Comic fest.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'header',
	          { className: 'ui inverted vertical segment reduced-height mobile only',
	            style: {
	              backgroundImage: 'linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(204,205,210,0.2)), url(' + __webpack_require__(137) + ')',
	              backgroundPosition: 'center',
	              backgroundSize: 'cover'
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'header block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ui container' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'ui large header mobile only' },
	                'Steckengeblieben',
	                _react2.default.createElement('br', null),
	                'im Nirgendwo'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'ta lead' },
	                'Die Menschen in der Ostukraine sind nach drei Jahren Krieg ersch\xF6pft, sie trauern um ihr zerst\xF6rtes Leben.  Unser Karikaturist Felix Schaad war vor Ort und hielt die Misere in einem Comic fest.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui vertical infographic segment white-bg' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui text container' },
	            _react2.default.createElement(
	              'p',
	              { className: 'ta author' },
	              'Zeichnungen Felix Schaad'
	            ),
	            _react2.default.createElement(_reactWaypoint2.default, { scrollableAncestor: window, onEnter: function onEnter(event) {
	                if (event.previousPosition === 'below') {
	                  window.dataLayer = window.dataLayer || [];
	                  window.dataLayer.push({
	                    'event': 'startReading'
	                  });
	                }
	              } }),
	            _react2.default.createElement(
	              'p',
	              { className: 'ta' },
	              '\xABDie Vergessenen\xBB, titelt TA-Karikaturist Felix Schaad seine Zeichenreportage aus der Ostukraine \xFCber die Menschen, die dort zwischen und an den Fronten gefangen sind \u2013 vergessen und verraten von den Kriegsherren, ihrer Regierung und der Welt. \xABViele sind am Ende ihrer Kr\xE4fte\xBB, sagt eine Psychologin der Hilfsorganisation M\xE9decins sans Fronti\xE8res/\xC4rzte ohne Grenzen (MSF), die Schaad in die Ukraine eingeladen hat. Die Menschen sind nach drei Jahren Krieg ersch\xF6pft, sie trauern um ihr zerst\xF6rtes Leben, um ihre H\xE4user, von denen manchen nur Bilder geblieben sind. Die medizinische Versorgung ist faktisch zusammengebrochen, weil auf alles geschossen wird, auch auf Spit\xE4ler und \xC4rzte.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'ta' },
	              'Es gebe Menschen, die seit zwei Jahren in Kellern schlafen, sagen MSF-Helfer, die in den Orten Kurachowe und Mariupol mobile Kliniken betreiben. Sie verteilen Medikamente, an welche die Patienten sonst nicht herankommen w\xFCrden und die sie gar nicht bezahlen k\xF6nnten. Auch psychologische Hilfe wird angeboten, denn viele Menschen leiden an Stress- und Angstsymptomen. Zur\xFCckgeblieben im Frontgebiet sind vor allem \xE4ltere Frauen und M\xE4nner, die nicht das Geld oder nicht die Kraft haben, sich anderswo in der Ukraine eine Wohnung zu mieten und noch einmal ganz von vorne anzufangen. Doch auch Familien sind noch dort. Die MSF-Psychologen betreuen viele traumatisierte Kinder mit Schlafst\xF6rungen und Konzentrationsschw\xE4che.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'ta' },
	              'Die Hoffnung auf den Frieden halte die Menschen aufrecht, berichtet Schaad. Ein unterzeichnetes Friedensabkommen hat das Gebiet schon lange, ebenso ungez\xE4hlte vereinbarte Waffenruhen \u2013 alle wurden gebrochen. Und statt dass es endlich besser wird, nehmen die K\xE4mpfe seit Anfang Jahr wieder zu \u2013 und damit die Not der Bev\xF6lkerung. Dabei hat nicht nur die Aufmerksamkeit, sondern auch die Hilfe massiv nachgelassen. F\xFCr das Jahr 2017 konnte die UNO bisher nur gerade 1,6 Prozent der rund 214 Millionen Franken auftreiben, die ben\xF6tigt werden f\xFCr humanit\xE4re Hilfe, auf die in der Ostukraine auf beiden Seiten der Grenze fast vier Millionen Menschen angewiesen sind. Schaad f\xE4ngt in seiner Zeichenreportage diese Welt der Vergessenen und einen Konflikt ein, der im \xABNirgendwo steckengeblieben ist\xBB, wie der Karikaturist feststellt.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'author-credit' },
	              'Zita Affentranger'
	            )
	          ),
	          _react2.default.createElement(_reactWaypoint2.default, { scrollableAncestor: window, onEnter: function onEnter(event) {
	              if (event.previousPosition === 'below') {
	                window.dataLayer = window.dataLayer || [];
	                window.dataLayer.push({
	                  'event': '20ContentRead'
	                });
	              }
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui vertical segment comics-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui container comic-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobile-only hint' },
	              _react2.default.createElement('i', { className: 'landscape icon', style: {
	                  backgroundImage: 'url(' + __webpack_require__(152) + ')',
	                  backgroundSize: '40px 40px'
	                } }),
	              'Auf dem Smartphone betrachten Sie die nachfolgenden Zeichnungen am besten im Breitformat.'
	            ),
	            _react2.default.createElement(_reactWaypoint2.default, { scrollableAncestor: window, onEnter: function onEnter(_ref) {
	                var previousPosition = _ref.previousPosition,
	                    currentPosition = _ref.currentPosition,
	                    event = _ref.event;
	
	                _this2.setState({ page: "" });
	                _this2.setState({ counterClass: "hide" });
	              } }),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref2) {
	                  var previousPosition = _ref2.previousPosition,
	                      currentPosition = _ref2.currentPosition,
	                      event = _ref2.event;
	
	                  _this2.setState({ page: "1/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(138) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref3) {
	                  var previousPosition = _ref3.previousPosition,
	                      currentPosition = _ref3.currentPosition,
	                      event = _ref3.event;
	
	                  _this2.setState({ page: "2/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(139) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref4) {
	                  var previousPosition = _ref4.previousPosition,
	                      currentPosition = _ref4.currentPosition,
	                      event = _ref4.event;
	
	                  _this2.setState({ page: "3/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(140) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref5) {
	                  var previousPosition = _ref5.previousPosition,
	                      currentPosition = _ref5.currentPosition,
	                      event = _ref5.event;
	
	                  _this2.setState({ page: "4/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(141) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref6) {
	                  var previousPosition = _ref6.previousPosition,
	                      currentPosition = _ref6.currentPosition,
	                      event = _ref6.event;
	
	                  _this2.setState({ page: "5/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(142) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref7) {
	                  var previousPosition = _ref7.previousPosition,
	                      currentPosition = _ref7.currentPosition,
	                      event = _ref7.event;
	
	                  _this2.setState({ page: "6/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(143) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref8) {
	                  var previousPosition = _ref8.previousPosition,
	                      currentPosition = _ref8.currentPosition,
	                      event = _ref8.event;
	
	                  _this2.setState({ page: "7/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(144) })
	              )
	            ),
	            _react2.default.createElement(_reactWaypoint2.default, { scrollableAncestor: window, onEnter: function onEnter(event) {
	                if (event.previousPosition === 'below') {
	                  window.dataLayer = window.dataLayer || [];
	                  window.dataLayer.push({
	                    'event': '50ContentRead'
	                  });
	                }
	              } }),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref9) {
	                  var previousPosition = _ref9.previousPosition,
	                      currentPosition = _ref9.currentPosition,
	                      event = _ref9.event;
	
	                  _this2.setState({ page: "8/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(145) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref10) {
	                  var previousPosition = _ref10.previousPosition,
	                      currentPosition = _ref10.currentPosition,
	                      event = _ref10.event;
	
	                  _this2.setState({ page: "9/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(146) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref11) {
	                  var previousPosition = _ref11.previousPosition,
	                      currentPosition = _ref11.currentPosition,
	                      event = _ref11.event;
	
	                  _this2.setState({ page: "10/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(147) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref12) {
	                  var previousPosition = _ref12.previousPosition,
	                      currentPosition = _ref12.currentPosition,
	                      event = _ref12.event;
	
	                  _this2.setState({ page: "11/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(148) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref13) {
	                  var previousPosition = _ref13.previousPosition,
	                      currentPosition = _ref13.currentPosition,
	                      event = _ref13.event;
	
	                  _this2.setState({ page: "12/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(149) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref14) {
	                  var previousPosition = _ref14.previousPosition,
	                      currentPosition = _ref14.currentPosition,
	                      event = _ref14.event;
	
	                  _this2.setState({ page: "13/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(150) })
	              )
	            ),
	            _react2.default.createElement(
	              _reactWaypoint2.default,
	              { scrollableAncestor: window, bottomOffset: '400px', onEnter: function onEnter(_ref15) {
	                  var previousPosition = _ref15.previousPosition,
	                      currentPosition = _ref15.currentPosition,
	                      event = _ref15.event;
	
	                  _this2.setState({ page: "14/14" });
	                  _this2.setState({ counterClass: "show" });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui image comic' },
	                _react2.default.createElement('img', { src: __webpack_require__(151) })
	              )
	            ),
	            _react2.default.createElement(_reactWaypoint2.default, { scrollableAncestor: window, onEnter: function onEnter(_ref16) {
	                var previousPosition = _ref16.previousPosition,
	                    currentPosition = _ref16.currentPosition,
	                    event = _ref16.event;
	
	                _this2.setState({ page: "" });
	                _this2.setState({ counterClass: "hide" });
	              } })
	          )
	        ),
	        _react2.default.createElement(_reactWaypoint2.default, { scrollableAncestor: window, onEnter: function onEnter(event) {
	            if (event.previousPosition === 'below') {
	              window.dataLayer = window.dataLayer || [];
	              window.dataLayer.push({
	                'event': '75ContentRead'
	              });
	            }
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui vertical infographic segment white-bg' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui text container' },
	            _react2.default.createElement(
	              'p',
	              { className: 'ta subheading' },
	              'Making-of'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'ta' },
	              'Etwas skeptisch seien die Helfer von M\xE9decins sans Fronti\xE8res in der Ostukraine schon gewesen, was dieser Karikaturist aus der Schweiz denn hier vorhabe. \xABDoch als sie sich das erste Mal auf den Zeichnungen gesehen haben, war das Eis gebrochen\xBB, berichtet Felix Schaad von seiner Reportage. F\xFCr den TA-Karikaturisten ist es freilich nicht die erste Reise mit Papier und Stift in ein Krisengebiet. Vor zwei Jahren zeichnete er ebenfalls f\xFCr M\xE9decins sans Fronti\xE8res in einem Camp in Sierra Leone einen Comic \xFCber Ebola.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui vertical infographic segment white-bg' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'videoWrapper' },
	              _react2.default.createElement('iframe', { className: 'externalNNIFrame', src: 'https://player.newsnetz.tv/player/iframe.php?vid=281718&channel=&adurl=0&language=de&autostart=0&poster=https://server025.newsnetz.tv/281718/frame-36-281718.jpg&video_title=Making Of: Felix Schaads Reise in der Ukraine&video_lead=&site=m&logo=1&flashactive=1&dynamicHeight=1', width: '100%', scrolling: 'no' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui vertical infographic segment' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui text container info-box' },
	            _react2.default.createElement(
	              'p',
	              { className: 'ta subheading' },
	              'Felix Schaad am Fumetto in Luzern'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'ta' },
	              'Das Luzerner Comix-Festival Fumetto zeigt Schaads Reportage aus der Ostukraine im Grossformat. R\xF6ssligasse 12 (Innenhof), Luzern.',
	              _react2.default.createElement('br', null),
	              'Eintritt frei. Bis 9. April.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'ta external-link' },
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.fumetto.ch/de', target: '_blank' },
	                _react2.default.createElement('i', { className: 'external icon' }),
	                ' www.fumetto.ch'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactWaypoint2.default, { scrollableAncestor: window, onEnter: function onEnter(event) {
	            if (event.previousPosition === 'below') {
	              window.dataLayer = window.dataLayer || [];
	              window.dataLayer.push({
	                'event': 'contentBottom'
	              });
	            }
	          } }),
	        _react2.default.createElement(
	          'aside',
	          { className: 'ui vertical segment' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui container' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'ui small infographic dividing header' },
	              'Weitere Artikel zum Thema'
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ui container' },
	            _react2.default.createElement(_reactArticleTeasers2.default, { numberOfCards: 'three', articleIds: ['26241338', '25995829'], style: { maxWidth: '100vw' } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui vertical inverted infographic segment' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ui stackable two column aligned grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column' },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'ui definition inverted very basic table' },
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Zeichnungen und Text:'
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Felix Schaad'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Digitales Konzept & Umsetzung:'
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Mathias Lutz und Interaktiv-Team'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Video:'
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Lea Koch'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      { className: 'desktop-only' },
	                      _react2.default.createElement(
	                        'td',
	                        { colSpan: '2' },
	                        _react2.default.createElement(_taReactPolymorphicCopyrightNotice2.default, { inverted: true })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column' },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'ui definition inverted very basic table' },
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('i', { className: 'comments icon' })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'content' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'header' },
	                            ' Haben Sie Anmerkungen oder einen Fehler entdeckt?'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'Wir freuen uns \xFCber Ihre '
	                            ),
	                            _react2.default.createElement(
	                              'a',
	                              { href: 'mailto:interaktiv@tages-anzeiger.ch' },
	                              'Nachricht'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              '.'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        { colSpan: '2', className: 'footer-sharing' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'spacer' },
	                          '\xA0'
	                        ),
	                        _react2.default.createElement(_reactPolymorphicShareButtons2.default, { articleID: '11403835' }),
	                        _react2.default.createElement(_taReactPolymorphicTracking2.default, { articleId: '11403835' }),
	                        _react2.default.createElement(_reactWaypoint2.default, { scrollableAncestor: window,
	                          onEnter: function onEnter(event) {
	                            if (event.previousPosition === 'below') {
	                              window.dataLayer = window.dataLayer || [];
	                              window.dataLayer.push({
	                                'event': 'pageBottom'
	                              });
	                            }
	                          } }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'spacer' },
	                          '\xA0'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_taReactPolymorphicTracking2.default, { articleId: '11403835' }),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.counterClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'page-count' },
	            _react2.default.createElement('i', { className: 'clone icon' }),
	            ' ',
	            this.state.page
	          )
	        )
	      );
	    }
	  }]);
	
	  return AppComponent;
	}(_react2.default.Component);
	
	AppComponent.defaultProps = {};
	
	var _default = AppComponent;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(AppComponent, 'AppComponent', '/Users/km/dev/ta-comic-msf/src/components/main/Main.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/km/dev/ta-comic-msf/src/components/main/Main.js');
	}();

	;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventOptionsKey = __webpack_require__(43);
	
	var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TargetEventHandlers = function () {
	  function TargetEventHandlers(target) {
	    _classCallCheck(this, TargetEventHandlers);
	
	    this.target = target;
	    this.events = {};
	  }
	
	  _createClass(TargetEventHandlers, [{
	    key: 'getEventHandlers',
	    value: function () {
	      function getEventHandlers(eventName, options) {
	        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));
	
	        if (!this.events[key]) {
	          this.events[key] = {
	            handlers: [],
	            handleEvent: undefined
	          };
	        }
	
	        return this.events[key];
	      }
	
	      return getEventHandlers;
	    }()
	  }, {
	    key: 'handleEvent',
	    value: function () {
	      function handleEvent(eventName, options, event) {
	        var _getEventHandlers = this.getEventHandlers(eventName, options),
	            handlers = _getEventHandlers.handlers;
	
	        handlers.forEach(function (handler) {
	          if (handler) {
	            // We need to check for presence here because a handler function may
	            // cause later handlers to get removed. This can happen if you for
	            // instance have a waypoint that unmounts another waypoint as part of an
	            // onEnter/onLeave handler.
	            handler(event);
	          }
	        });
	      }
	
	      return handleEvent;
	    }()
	  }, {
	    key: 'add',
	    value: function () {
	      function add(eventName, listener, options) {
	        var _this = this;
	
	        // options has already been normalized at this point.
	        var eventHandlers = this.getEventHandlers(eventName, options);
	
	        if (eventHandlers.handlers.length === 0) {
	          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	        }
	
	        eventHandlers.handlers.push(listener);
	
	        var isSubscribed = true;
	        var unsubscribe = function () {
	          function unsubscribe() {
	            if (!isSubscribed) {
	              return;
	            }
	
	            isSubscribed = false;
	
	            var index = eventHandlers.handlers.indexOf(listener);
	            eventHandlers.handlers.splice(index, 1);
	
	            if (eventHandlers.handlers.length === 0) {
	              // All event handlers have been removed, so we want to remove the event
	              // listener from the target node.
	
	              if (_this.target) {
	                // There can be a race condition where the target may no longer exist
	                // when this function is called, e.g. when a React component is
	                // unmounting. Guarding against this prevents the following error:
	                //
	                //   Cannot read property 'removeEventListener' of undefined
	                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	              }
	
	              eventHandlers.handleEvent = undefined;
	            }
	          }
	
	          return unsubscribe;
	        }();
	        return unsubscribe;
	      }
	
	      return add;
	    }()
	  }]);
	
	  return TargetEventHandlers;
	}();
	
	exports['default'] = TargetEventHandlers;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports['default'] = CAN_USE_DOM;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = canUsePassiveEventListeners;
	
	var _canUseDOM = __webpack_require__(41);
	
	var _canUseDOM2 = _interopRequireDefault(_canUseDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
	function testPassiveEventListeners() {
	  if (!_canUseDOM2['default']) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    window.addEventListener('test', null, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = eventOptionsKey;
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EVENT_HANDLERS_KEY = undefined;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	
	var _normalizeEventOptions = __webpack_require__(45);
	
	var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);
	
	var _TargetEventHandlers = __webpack_require__(40);
	
	var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Export to make testing possible.
	var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
	  }
	  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	// Deprecated
	function removeEventListener(unsubscribeFn) {
	  unsubscribeFn();
	}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = normalizeEventOptions;
	
	var _canUsePassiveEventListeners = __webpack_require__(42);
	
	var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!(0, _canUsePassiveEventListeners2['default'])()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70);
	module.exports = __webpack_require__(8).Object.assign;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(11);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(23);
	var toLength = __webpack_require__(67);
	var toAbsoluteIndex = __webpack_require__(66);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(47);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(11);
	var document = __webpack_require__(6).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var core = __webpack_require__(8);
	var hide = __webpack_require__(20);
	var redefine = __webpack_require__(63);
	var ctx = __webpack_require__(51);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(9) && !__webpack_require__(10)(function () {
	  return Object.defineProperty(__webpack_require__(52)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(60);
	var gOPS = __webpack_require__(58);
	var pIE = __webpack_require__(61);
	var toObject = __webpack_require__(68);
	var IObject = __webpack_require__(21);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(10)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(48);
	var IE8_DOM_DEFINE = __webpack_require__(55);
	var toPrimitive = __webpack_require__(69);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(9) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(19);
	var toIObject = __webpack_require__(23);
	var arrayIndexOf = __webpack_require__(49)(false);
	var IE_PROTO = __webpack_require__(64)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(59);
	var enumBugKeys = __webpack_require__(53);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var hide = __webpack_require__(20);
	var has = __webpack_require__(19);
	var SRC = __webpack_require__(24)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(8).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(65)('keys');
	var uid = __webpack_require__(24);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(22);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(22);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(18);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(11);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(54);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(56) });


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".article-teasers .article-teaser.card .extra.content{padding-top:0;font-size:.9em;margin-top:-.5em;line-height:1.2em}", ""]);
	
	// exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".masthead-component.masthead-component.masthead-component{position:absolute;border-bottom:1px solid rgba(0,0,0,.2);top:0;left:0;width:100%;z-index:100;padding:0;background-color:#fff}.masthead-component.masthead-component.masthead-component.inverted{border-bottom:none;color:#f5f5f5;background-color:transparent}.masthead-component.masthead-component.masthead-component .logo{margin:1.414ex 0;max-height:3ex;min-width:3ex;width:auto}.masthead-component.masthead-component.masthead-component .mobile.only.column .logo{max-width:3ex}.masthead-component.masthead-component+*>*>:first-child:before{content:\"\";display:block;height:80px}", ""]);
	
	// exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".inverted .ta.sharing .share:not(.inverted),.inverted .ta.sharing:not(.inverted) .share{color:#007abf}", ""]);
	
	// exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "@media only screen and (max-width:599px){[class*=\"computer only\"]:not(.mobile),[class*=\"large screen only\"]:not(.mobile),[class*=\"mobile hidden\"],[class*=\"or lower hidden\"],[class*=\"tablet only\"]:not(.mobile),[class*=\"widescreen only\"]:not(.mobile){display:none!important}}@media only screen and (min-width:600px) and (max-width:799px){[class*=\"computer only\"]:not(.tablet),[class*=\"large screen only\"]:not(.tablet),[class*=\"mobile only\"]:not(.tablet),[class*=\"or lower hidden\"]:not(.mobile),[class*=\"tablet hidden\"],[class*=\"widescreen only\"]:not(.tablet){display:none!important}}@media only screen and (min-width:800px) and (max-width:1199px){[class*=\"computer hidden\"],[class*=\"large screen only\"]:not(.computer),[class*=\"mobile only\"]:not(.computer),[class*=\"or lower hidden\"]:not(.tablet):not(.mobile),[class*=\"tablet only\"]:not(.computer),[class*=\"widescreen only\"]:not(.computer){display:none!important}}@media only screen and (min-width:1200px) and (max-width:1919px){[class*=\"computer only\"]:not([class*=\"large screen\"]),[class*=\"large screen hidden\"],[class*=\"mobile only\"]:not([class*=\"large screen\"]),[class*=\"or lower hidden\"]:not(.computer):not(.tablet):not(.mobile),[class*=\"tablet only\"]:not([class*=\"large screen\"]),[class*=\"widescreen only\"]:not([class*=\"large screen\"]){display:none!important}}@media only screen and (min-width:1920px){[class*=\"computer only\"]:not([class*=widescreen]),[class*=\"large screen only\"]:not([class*=widescreen]),[class*=\"mobile only\"]:not([class*=widescreen]),[class*=\"tablet only\"]:not([class*=widescreen]),[class*=\"widescreen hidden\"],[class*=\"widescreen or lower hidden\"]{display:none!important}}body{background-color:#f7f7f7}.index header{position:relative}.index header .header.block{position:absolute;bottom:1.5em;width:100vw}.index header.ui.inverted.segment{background-color:transparent!important}.index h1.ui.header{font-size:390%}.index .lead{font-size:1.4em}.index header.inverted{text-rendering:optimizeLegibility!important;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#ccc}.ta.interview{margin-top:0;margin-bottom:0}.ta.interview.question{margin-top:4.5ex;font-weight:700}.ta.interview.question:first-of-type{margin-top:0}.ta.author{font-style:italic}.ui.text.segment{font-size:17px;font-family:Georgia,serif;line-height:3.5ex}.ui.infographic.segment{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.ui.inverted.items>.item>.content .description,.ui.inverted.items>.item>.content .extra,.ui.inverted.items>.item>.content .header,.ui.inverted.items>.item>.content .meta{color:#fff}.ui.grid.top{margin-bottom:0;margin-top:-3rem}.ui.grid.top>.column.illu{padding:0}.ui.vertical.top.segment{padding-bottom:0}.white-bg{background:#fff!important}.ui.inverted.definition.table tr td:first-child{background:transparent;vertical-align:top}.ui.inverted.segment,.ui.primary.inverted.segment{background:#3a3a3a}div.spacer{height:1.2em;width:100%}header.reduced-height{min-height:64vh}@media screen and (max-width:599px){header.reduced-height{min-height:90vh}}h1.header{_text-shadow:1px 1px 3px #000;text-align:left!important;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}.lead,h1.header{color:#333!important;max-width:650px}.lead{_text-shadow:1px 1px 1px #000}.inverted a:hover{color:#fff}.white{color:#fff!important}.subheading{font-weight:700;margin-top:4.5ex}.half-width{display:table-cell;background-position:top;width:50%}.info-box{background-color:#e7e7e7;padding:1rem}.page-count{position:fixed;bottom:1rem;right:1rem;color:#aaa;font-size:120%}@media screen and (max-width:599px){h1.header{font-size:250%!important;padding-top:0!important}.ta.author,.ta.lead{font-size:1.2em}.ui.vertical.segment{padding-top:1.5em;padding-bottom:1.5em}}.image.comic{_border-bottom:2px solid #333;padding-bottom:2rem;height:75%;width:75%;display:block;margin:0 auto}.image.comic img{box-shadow:1px 1px 5px #aaa}.comics-wrapper{border-top:1px solid #ddd!important}.mobile-only{display:none}.hint{text-align:center;margin:2rem auto 4rem;width:80%;color:#007abf}.icon.landscape{width:40px;height:40px;display:block;margin:0 auto 1rem}.ui.two.cards>.card{width:calc(100% - 2em);margin-left:1em;margin-right:1em}.videoWrapper{position:relative;padding-bottom:56.25%;padding-top:30px;height:0;overflow:hidden}.videoWrapper iframe{position:absolute;top:0;left:0;width:100%;height:100%}iframe.externalNNIFrame{border:none}.footer-sharing{padding-left:3.5rem!important}.external-link{font-size:110%}.show{display:block}.hide{display:none}p.author-credit{font-style:italic}@media screen and (max-width:899px){.image.comic{padding-bottom:1rem;height:100%;width:100%;margin:0}.page-count{color:#888;width:20%;right:0;bottom:0;text-align:center;background-color:#fff;padding:.4rem 0 .2rem;opacity:.85;font-size:100%}}@media screen and (max-width:647px){.desktop-only{display:none!important}.mobile-only{display:block!important}.ui.header:first-child{margin-top:0}.page-count{color:#888;width:20%;right:0;bottom:0;text-align:center;background-color:#fff;padding:.4rem 0 .2rem;opacity:.85;font-size:100%}}@media screen and (max-width:599px){.ui.container.comic-container{margin-left:0!important;margin-right:0!important}.CopyrightNotice{padding-left:1em}.comments.icon{display:none!important}td{text-align:center!important}.footer-sharing{padding-left:0!important}.ui.stackable.grid>.column:not(.row){padding-top:0!important;padding-bottom:0!important}.page-count{width:25%}}", ""]);
	
	// exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".CopyrightNotice.inverted{color:hsla(0,0%,100%,.95)}", ""]);
	
	// exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Button\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.button{cursor:pointer;display:inline-block;min-height:1em;outline:none;border:none;vertical-align:baseline;background:#e0e1e2 none;color:#007abf;font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;margin:0 .25em 0 0;padding:.64705882em 1.5em;text-transform:none;text-shadow:none;font-weight:500;line-height:1em;font-style:normal;text-align:center;text-decoration:none;border-radius:.11764706rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease;will-change:\"\";-webkit-tap-highlight-color:transparent}.ui.button,.ui.button:hover{box-shadow:inset 0 0 0 1px transparent,inset 0 0 0 0 rgba(34,36,38,.15)}.ui.button:hover{background-color:#cacbcd;background-image:none;color:#00598c}.ui.button:hover .icon{opacity:.85}.ui.button:focus{background-color:#cacbcd;color:#00598c;background-image:\"\"!important;box-shadow:\"\"!important}.ui.button:focus .icon{opacity:.85}.ui.active.button:active,.ui.button:active{background-color:#babbbc;background-image:\"\";color:rgba(0,0,0,.9);box-shadow:inset 0 0 0 1px transparent,none}.ui.active.button{box-shadow:inset 0 0 0 1px transparent}.ui.active.button,.ui.active.button:hover{color:rgba(0,0,0,.95)}.ui.active.button,.ui.active.button:active,.ui.active.button:hover{background-color:#c0c1c2;background-image:none}.ui.loading.loading.loading.loading.loading.loading.button{position:relative;cursor:default;text-shadow:none!important;color:transparent!important;opacity:1;pointer-events:auto;transition:all 0s linear,opacity .1s ease}.ui.loading.button:before{border-radius:500rem;border:.2em solid rgba(0,0,0,.15)}.ui.loading.button:after,.ui.loading.button:before{position:absolute;content:\"\";top:50%;left:50%;margin:-.67647059em 0 0 -.67647059em;width:1.35294118em;height:1.35294118em}.ui.loading.button:after{-webkit-animation:button-spin .6s linear;animation:button-spin .6s linear;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;border-radius:500rem;border-color:#fff transparent transparent;border-style:solid;border-width:.2em;box-shadow:0 0 0 1px transparent}.ui.labeled.icon.loading.button .icon{background-color:transparent;box-shadow:none}@-webkit-keyframes button-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes button-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ui.basic.loading.button:not(.inverted):before{border-color:rgba(0,0,0,.1)}.ui.basic.loading.button:not(.inverted):after{border-top-color:#5a686d}.ui.button:disabled,.ui.buttons .disabled.button,.ui.disabled.active.button,.ui.disabled.button,.ui.disabled.button:hover{cursor:default;opacity:.45!important;background-image:none!important;box-shadow:none!important;pointer-events:none!important}.ui.basic.buttons .ui.disabled.button{border-color:rgba(34,36,38,.5)}.ui.animated.button{position:relative;overflow:hidden;padding-right:0!important;vertical-align:middle;z-index:1}.ui.animated.button .content{will-change:transform,opacity}.ui.animated.button .visible.content{position:relative;margin-right:1.5em}.ui.animated.button .hidden.content{position:absolute;width:100%}.ui.animated.button .hidden.content,.ui.animated.button .visible.content{transition:right .3s ease 0s}.ui.animated.button .visible.content{left:auto;right:0}.ui.animated.button .hidden.content{top:50%;left:auto;right:-100%;margin-top:-.5em}.ui.animated.button:focus .visible.content,.ui.animated.button:hover .visible.content{left:auto;right:200%}.ui.animated.button:focus .hidden.content,.ui.animated.button:hover .hidden.content{left:auto;right:0}.ui.vertical.animated.button .hidden.content,.ui.vertical.animated.button .visible.content{transition:top .3s ease,-webkit-transform .3s ease;transition:top .3s ease,transform .3s ease;transition:top .3s ease,transform .3s ease,-webkit-transform .3s ease}.ui.vertical.animated.button .visible.content{-webkit-transform:translateY(0);transform:translateY(0);right:auto}.ui.vertical.animated.button .hidden.content{top:-50%;left:0;right:auto}.ui.vertical.animated.button:focus .visible.content,.ui.vertical.animated.button:hover .visible.content{-webkit-transform:translateY(200%);transform:translateY(200%);right:auto}.ui.vertical.animated.button:focus .hidden.content,.ui.vertical.animated.button:hover .hidden.content{top:50%;right:auto}.ui.fade.animated.button .hidden.content,.ui.fade.animated.button .visible.content{transition:opacity .3s ease,-webkit-transform .3s ease;transition:opacity .3s ease,transform .3s ease;transition:opacity .3s ease,transform .3s ease,-webkit-transform .3s ease}.ui.fade.animated.button .visible.content{left:auto;right:auto;opacity:1;-webkit-transform:scale(1);transform:scale(1)}.ui.fade.animated.button .hidden.content{opacity:0;left:0;right:auto;-webkit-transform:scale(1.5);transform:scale(1.5)}.ui.fade.animated.button:focus .visible.content,.ui.fade.animated.button:hover .visible.content{left:auto;right:auto;opacity:0;-webkit-transform:scale(.75);transform:scale(.75)}.ui.fade.animated.button:focus .hidden.content,.ui.fade.animated.button:hover .hidden.content{left:0;right:auto;opacity:1;-webkit-transform:scale(1);transform:scale(1)}.ui.inverted.button{box-shadow:inset 0 0 0 0 #fff!important;background:transparent none;color:#fff;text-shadow:none!important}.ui.inverted.buttons .button{margin:0}.ui.inverted.buttons .button:first-child{margin-left:0}.ui.inverted.vertical.buttons .button{margin:0}.ui.inverted.vertical.buttons .button:first-child{margin-top:0}.ui.inverted.button.active,.ui.inverted.button:focus,.ui.inverted.button:hover{background:#fff;box-shadow:inset 0 0 0 0 #fff!important;color:#00598c}.ui.inverted.button.active:focus{background:#dcddde;box-shadow:inset 0 0 0 0 #dcddde!important;color:#00598c}.ui.labeled.button:not(.icon){display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;background:none!important;padding:0!important;border:none!important;box-shadow:none!important}.ui.labeled.button>.button{margin:0}.ui.labeled.button>.label{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0 0 0 -1px!important;padding:\"\";font-size:1em;border-color:rgba(34,36,38,.15)}.ui.labeled.button>.tag.label:before{width:1.85em;height:1.85em}.ui.labeled.button:not([class*=\"left labeled\"])>.button{border-top-right-radius:0;border-bottom-right-radius:0}.ui.labeled.button:not([class*=\"left labeled\"])>.label,.ui[class*=\"left labeled\"].button>.button{border-top-left-radius:0;border-bottom-left-radius:0}.ui[class*=\"left labeled\"].button>.label{border-top-right-radius:0;border-bottom-right-radius:0}.ui.facebook.button{background-color:#4b68b8;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.facebook.button:hover{background-color:#3d5bad;color:#fff;text-shadow:none}.ui.facebook.button:active{background-color:#3b5395;color:#fff;text-shadow:none}.ui.twitter.button{background-color:#1dadeb;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.twitter.button:hover{background-color:#09a3e5;color:#fff;text-shadow:none}.ui.twitter.button:active{background-color:#118ec4;color:#fff;text-shadow:none}.ui.google.plus.button{background-color:#dd4b39;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.google.plus.button:hover{background-color:#e0321c;color:#fff;text-shadow:none}.ui.google.plus.button:active{background-color:#c23321;color:#fff;text-shadow:none}.ui.linkedin.button{background-color:#1f88be;color:#fff;text-shadow:none}.ui.linkedin.button:hover{background-color:#147baf;color:#fff;text-shadow:none}.ui.linkedin.button:active{background-color:#186992;color:#fff;text-shadow:none}.ui.youtube.button{background-color:#cc181e;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.youtube.button:hover{background-color:#bd0d13;color:#fff;text-shadow:none}.ui.youtube.button:active{background-color:#9e1317;color:#fff;text-shadow:none}.ui.instagram.button{background-color:#49769c;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.instagram.button:hover{background-color:#3d698e;color:#fff;text-shadow:none}.ui.instagram.button:active{background-color:#395c79;color:#fff;text-shadow:none}.ui.pinterest.button{background-color:#bd081c;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.pinterest.button:hover{background-color:#ac0013;color:#fff;text-shadow:none}.ui.pinterest.button:active{background-color:#8c0615;color:#fff;text-shadow:none}.ui.vk.button{background-color:#4d7198;color:#fff;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.vk.button:hover{background-color:#41648a;color:#fff}.ui.vk.button:active{background-color:#3c5876;color:#fff}.ui.button>.icon:not(.button){height:.70588235em;opacity:.8;transition:opacity .1s ease;vertical-align:\"\";color:\"\"}.ui.button:not(.icon)>.icon:not(.button):not(.dropdown),.ui.button>.icon:not(.button){margin:0 .35294118em 0 -.17647059em}.ui.button:not(.icon)>.right.icon:not(.button):not(.dropdown){margin:0 -.17647059em 0 .35294118em}.ui[class*=\"left floated\"].button,.ui[class*=\"left floated\"].buttons{float:left;margin-left:0;margin-right:.25em}.ui[class*=\"right floated\"].button,.ui[class*=\"right floated\"].buttons{float:right;margin-right:0;margin-left:.25em}.ui.compact.button,.ui.compact.buttons .button{padding:.48529412em 1.125em}.ui.compact.icon.button,.ui.compact.icon.buttons .button{padding:.48529412em}.ui.compact.labeled.icon.button,.ui.compact.labeled.icon.buttons .button{padding:.48529412em 3.41911765em}.ui.mini.button,.ui.mini.buttons .button,.ui.mini.buttons .or{font-size:.64705882rem}.ui.tiny.button,.ui.tiny.buttons .button,.ui.tiny.buttons .or{font-size:.70588235rem}.ui.small.button,.ui.small.buttons .button,.ui.small.buttons .or{font-size:.88235294rem}.ui.button,.ui.buttons .button,.ui.buttons .or{font-size:1rem}.ui.large.button,.ui.large.buttons .button,.ui.large.buttons .or{font-size:1.17647059rem}.ui.big.button,.ui.big.buttons .button,.ui.big.buttons .or{font-size:1.35294118rem}.ui.huge.button,.ui.huge.buttons .button,.ui.huge.buttons .or{font-size:1.58823529rem}.ui.massive.button,.ui.massive.buttons .button,.ui.massive.buttons .or{font-size:1.88235294rem}.ui.icon.button,.ui.icon.buttons .button{padding:.64705882em}.ui.icon.button>.icon,.ui.icon.buttons .button>.icon{opacity:.9;margin:0!important;vertical-align:top}.ui.basic.button,.ui.basic.buttons .button{background:transparent none!important;color:#007abf!important;font-weight:500;border-radius:.11764706rem;text-transform:none;text-shadow:none!important;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.basic.buttons{box-shadow:none;border:0 solid rgba(34,36,38,.15);border-radius:.11764706rem}.ui.basic.buttons .button{border-radius:0}.ui.basic.button:focus,.ui.basic.button:hover,.ui.basic.buttons .button:focus,.ui.basic.buttons .button:hover{background:rgba(0,0,0,.05)!important;color:#00598c!important;box-shadow:none}.ui.basic.button:active,.ui.basic.buttons .button:active{background:rgba(0,0,0,.1)!important;color:rgba(0,0,0,.9)!important;box-shadow:inset 0 0 0 0 rgba(0,0,0,.15),inset 0 1px 4px 0 rgba(34,36,38,.15)}.ui.basic.active.button,.ui.basic.buttons .active.button{background:rgba(0,0,0,.05)!important;box-shadow:\"\"!important;color:rgba(0,0,0,.95)}.ui.basic.active.button:hover,.ui.basic.buttons .active.button:hover{background-color:rgba(0,0,0,.05)}.ui.basic.buttons .button:hover{box-shadow:inset none}.ui.basic.buttons .button:active{box-shadow:inset 0 0 0 0 rgba(0,0,0,.15),inset inset 0 1px 4px 0 rgba(34,36,38,.15)}.ui.basic.buttons .active.button{box-shadow:\"\"!important}.ui.basic.inverted.button,.ui.basic.inverted.buttons .button{color:#f9fafb!important}.ui.basic.inverted.button:hover,.ui.basic.inverted.buttons .button:hover{color:#fff!important;box-shadow:inset 0 0 0 0 #fff!important}.ui.basic.inverted.button:focus,.ui.basic.inverted.buttons .button:focus{box-shadow:inset 0 0 0 0 #fff!important}.ui.basic.inverted.button:active,.ui.basic.inverted.buttons .button:active{box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.9)!important}.ui.basic.inverted.active.button,.ui.basic.inverted.buttons .active.button{text-shadow:none}.ui.basic.buttons .button{border-left:0 solid rgba(34,36,38,.15);box-shadow:none}.ui.basic.vertical.buttons .button{border-left:none;border-left-width:0;border-top:0 solid rgba(34,36,38,.15)}.ui.basic.vertical.buttons .button:first-child{border-top-width:0}.ui.labeled.icon.button,.ui.labeled.icon.buttons .button{position:relative;padding-left:3.79411765em!important;padding-right:1.5em!important}.ui.labeled.icon.button>.icon,.ui.labeled.icon.buttons>.button>.icon{position:absolute;height:100%;line-height:1;border-radius:0;border-top-left-radius:inherit;border-bottom-left-radius:inherit;text-align:center;margin:0;width:2.29411765em;background-color:rgba(0,0,0,.05);color:\"\";box-shadow:inset -1px 0 0 0 transparent;top:0;left:0}.ui[class*=\"right labeled\"].icon.button{padding-right:3.79411765em!important;padding-left:1.5em!important}.ui[class*=\"right labeled\"].icon.button>.icon{left:auto;right:0;border-radius:0;border-top-right-radius:inherit;border-bottom-right-radius:inherit;box-shadow:inset 1px 0 0 0 transparent}.ui.labeled.icon.button>.icon:after,.ui.labeled.icon.button>.icon:before,.ui.labeled.icon.buttons>.button>.icon:after,.ui.labeled.icon.buttons>.button>.icon:before{display:block;position:absolute;width:100%;top:50%;text-align:center;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.ui.labeled.icon.buttons .button>.icon{border-radius:0}.ui.labeled.icon.buttons .button:first-child>.icon{border-top-left-radius:.11764706rem;border-bottom-left-radius:.11764706rem}.ui.labeled.icon.buttons .button:last-child>.icon{border-top-right-radius:.11764706rem;border-bottom-right-radius:.11764706rem}.ui.vertical.labeled.icon.buttons .button:first-child>.icon{border-radius:0;border-top-left-radius:.11764706rem}.ui.vertical.labeled.icon.buttons .button:last-child>.icon{border-radius:0;border-bottom-left-radius:.11764706rem}.ui.fluid[class*=\"left labeled\"].icon.button,.ui.fluid[class*=\"right labeled\"].icon.button{padding-left:1.5em!important;padding-right:1.5em!important}.ui.button.toggle.active,.ui.buttons .button.toggle.active,.ui.toggle.buttons .active.button{background-color:#4d9221!important;box-shadow:none!important;text-shadow:none;color:#fff!important}.ui.button.toggle.active:hover{background-color:#418217!important;text-shadow:none;color:#fff!important}.ui.circular.button{border-radius:10em}.ui.circular.button>.icon{width:1em;vertical-align:baseline}.ui.buttons .or{position:relative;width:.3em;height:2.29411765em;z-index:3}.ui.buttons .or:before{position:absolute;text-align:center;border-radius:500rem;content:\"or\";top:50%;left:50%;background-color:#fff;text-shadow:none;margin-top:-.82352941em;margin-left:-.82352941em;width:1.64705882em;height:1.64705882em;line-height:1.64705882em;color:rgba(0,0,0,.4);font-style:normal;font-weight:700;box-shadow:inset 0 0 0 1px transparent}.ui.buttons .or[data-text]:before{content:attr(data-text)}.ui.fluid.buttons .or{width:0!important}.ui.fluid.buttons .or:after{display:none}.ui.attached.button{position:relative;display:block;margin:0;border-radius:0;box-shadow:0 0 0 1px rgba(34,36,38,.15)!important}.ui.attached.top.button{border-radius:.11764706rem .11764706rem 0 0}.ui.attached.bottom.button{border-radius:0 0 .11764706rem .11764706rem}.ui.left.attached.button{display:inline-block;border-left:none;text-align:right;padding-right:.75em;border-radius:.11764706rem 0 0 .11764706rem}.ui.right.attached.button{display:inline-block;text-align:left;padding-left:.75em;border-radius:0 .11764706rem .11764706rem 0}.ui.attached.buttons{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;border-radius:0;width:auto!important;z-index:2;margin-left:-1px;margin-right:-1px}.ui.attached.buttons .button{margin:0}.ui.attached.buttons .button:first-child,.ui.attached.buttons .button:last-child{border-radius:0}.ui[class*=\"top attached\"].buttons{margin-bottom:-1px;border-radius:.11764706rem .11764706rem 0 0}.ui[class*=\"top attached\"].buttons .button:first-child{border-radius:.11764706rem 0 0 0}.ui[class*=\"top attached\"].buttons .button:last-child{border-radius:0 .11764706rem 0 0}.ui[class*=\"bottom attached\"].buttons{margin-top:-1px;border-radius:0 0 .11764706rem .11764706rem}.ui[class*=\"bottom attached\"].buttons .button:first-child{border-radius:0 0 0 .11764706rem}.ui[class*=\"bottom attached\"].buttons .button:last-child{border-radius:0 0 .11764706rem 0}.ui[class*=\"left attached\"].buttons{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-right:0;margin-left:-1px;border-radius:0 .11764706rem .11764706rem 0}.ui[class*=\"left attached\"].buttons .button:first-child{margin-left:-1px;border-radius:0 .11764706rem 0 0}.ui[class*=\"left attached\"].buttons .button:last-child{margin-left:-1px;border-radius:0 0 .11764706rem 0}.ui[class*=\"right attached\"].buttons{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:0;margin-right:-1px;border-radius:.11764706rem 0 0 .11764706rem}.ui[class*=\"right attached\"].buttons .button:first-child{margin-left:-1px;border-radius:.11764706rem 0 0 0}.ui[class*=\"right attached\"].buttons .button:last-child{margin-left:-1px;border-radius:0 0 0 .11764706rem}.ui.fluid.button,.ui.fluid.buttons{width:100%}.ui.fluid.button{display:block}.ui.two.buttons{width:100%}.ui.two.buttons>.button{width:50%}.ui.three.buttons{width:100%}.ui.three.buttons>.button{width:33.333%}.ui.four.buttons{width:100%}.ui.four.buttons>.button{width:25%}.ui.five.buttons{width:100%}.ui.five.buttons>.button{width:20%}.ui.six.buttons{width:100%}.ui.six.buttons>.button{width:16.666%}.ui.seven.buttons{width:100%}.ui.seven.buttons>.button{width:14.285%}.ui.eight.buttons{width:100%}.ui.eight.buttons>.button{width:12.5%}.ui.nine.buttons{width:100%}.ui.nine.buttons>.button{width:11.11%}.ui.ten.buttons{width:100%}.ui.ten.buttons>.button{width:10%}.ui.eleven.buttons{width:100%}.ui.eleven.buttons>.button{width:9.09%}.ui.twelve.buttons{width:100%}.ui.twelve.buttons>.button{width:8.3333%}.ui.fluid.vertical.buttons,.ui.fluid.vertical.buttons>.button{display:-webkit-box;display:-ms-flexbox;display:flex;width:auto}.ui.two.vertical.buttons>.button{height:50%}.ui.three.vertical.buttons>.button{height:33.333%}.ui.four.vertical.buttons>.button{height:25%}.ui.five.vertical.buttons>.button{height:20%}.ui.six.vertical.buttons>.button{height:16.666%}.ui.seven.vertical.buttons>.button{height:14.285%}.ui.eight.vertical.buttons>.button{height:12.5%}.ui.nine.vertical.buttons>.button{height:11.11%}.ui.ten.vertical.buttons>.button{height:10%}.ui.eleven.vertical.buttons>.button{height:9.09%}.ui.twelve.vertical.buttons>.button{height:8.3333%}.ui.black.button,.ui.black.buttons .button{text-shadow:none;background-image:none}.ui.black.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.black.button:hover,.ui.black.buttons .button:hover{background-color:#27292a;color:#fff;text-shadow:none}.ui.black.button:focus,.ui.black.buttons .button:focus{background-color:#2f3032;color:#fff;text-shadow:none}.ui.black.button:active,.ui.black.buttons .button:active{background-color:#343637;color:#fff;text-shadow:none}.ui.black.active.button,.ui.black.button .active.button:active,.ui.black.buttons .active.button,.ui.black.buttons .active.button:active{background-color:#0f0f10;color:#fff;text-shadow:none}.ui.basic.black.active.button,.ui.basic.black.button:focus,.ui.basic.black.button:hover,.ui.basic.black.buttons .active.button,.ui.basic.black.buttons .button:focus,.ui.basic.black.buttons .button:hover{background:transparent!important}.ui.inverted.black.button,.ui.inverted.black.buttons .button{background-color:transparent}.ui.inverted.black.basic.button,.ui.inverted.black.basic.buttons .button,.ui.inverted.black.buttons .basic.button{color:#fff!important}.ui.inverted.black.basic.button:focus,.ui.inverted.black.basic.buttons .button:focus{color:#545454!important}.ui.inverted.black.basic.active.button,.ui.inverted.black.basic.button:active,.ui.inverted.black.basic.buttons .active.button,.ui.inverted.black.basic.buttons .button:active,.ui.inverted.black.buttons .basic.active.button,.ui.inverted.black.buttons .basic.button:active{color:#fff!important}.ui.grey.button,.ui.grey.buttons .button{text-shadow:none;background-image:none}.ui.grey.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.grey.button:hover,.ui.grey.buttons .button:hover{background-color:#66757b;color:#fff;text-shadow:none}.ui.grey.button:focus,.ui.grey.buttons .button:focus{background-color:#6c7d83;color:#fff;text-shadow:none}.ui.grey.button:active,.ui.grey.buttons .button:active{background-color:#718389;color:#fff;text-shadow:none}.ui.grey.active.button,.ui.grey.button .active.button:active,.ui.grey.buttons .active.button,.ui.grey.buttons .active.button:active{background-color:#4e5b5f;color:#fff;text-shadow:none}.ui.basic.grey.active.button,.ui.basic.grey.button:focus,.ui.basic.grey.button:hover,.ui.basic.grey.buttons .active.button,.ui.basic.grey.buttons .button:focus,.ui.basic.grey.buttons .button:hover{background:transparent!important}.ui.inverted.grey.button,.ui.inverted.grey.buttons .button{background-color:transparent}.ui.inverted.grey.basic.button,.ui.inverted.grey.basic.buttons .button,.ui.inverted.grey.buttons .basic.button{color:#fff!important}.ui.inverted.grey.basic.button:focus,.ui.inverted.grey.basic.buttons .button:focus{color:#7f8f95!important}.ui.inverted.grey.basic.active.button,.ui.inverted.grey.basic.button:active,.ui.inverted.grey.basic.buttons .active.button,.ui.inverted.grey.basic.buttons .button:active,.ui.inverted.grey.buttons .basic.active.button,.ui.inverted.grey.buttons .basic.button:active{color:#fff!important}.ui.brown.button,.ui.brown.buttons .button{text-shadow:none;background-image:none}.ui.brown.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.brown.button:hover,.ui.brown.buttons .button:hover{background-color:#8d6700;color:#fff;text-shadow:none}.ui.brown.button:focus,.ui.brown.buttons .button:focus{background-color:#7d5c00;color:#fff;text-shadow:none}.ui.brown.button:active,.ui.brown.buttons .button:active{background-color:#735500;color:#fff;text-shadow:none}.ui.brown.active.button,.ui.brown.button .active.button:active,.ui.brown.buttons .active.button,.ui.brown.buttons .active.button:active{background-color:#8d6700;color:#fff;text-shadow:none}.ui.basic.brown.active.button,.ui.basic.brown.button:focus,.ui.basic.brown.button:hover,.ui.basic.brown.buttons .active.button,.ui.basic.brown.buttons .button:focus,.ui.basic.brown.buttons .button:hover{background:transparent!important}.ui.inverted.brown.button,.ui.inverted.brown.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #f3b200!important;color:#f3b200}.ui.inverted.brown.basic.button,.ui.inverted.brown.basic.buttons .button,.ui.inverted.brown.buttons .basic.button{color:#fff!important}.ui.inverted.brown.basic.button:focus,.ui.inverted.brown.basic.button:hover,.ui.inverted.brown.basic.buttons .button:focus,.ui.inverted.brown.basic.buttons .button:hover,.ui.inverted.brown.buttons .basic.button:hover{color:#f3b200!important}.ui.blue.button,.ui.blue.buttons .button{text-shadow:none;background-image:none}.ui.blue.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.blue.button:hover,.ui.blue.buttons .button:hover{background-color:#145171;color:#fff;text-shadow:none}.ui.blue.button:focus,.ui.blue.buttons .button:focus{background-color:#0e4968;color:#fff;text-shadow:none}.ui.blue.button:active,.ui.blue.buttons .button:active{background-color:#144158;color:#fff;text-shadow:none}.ui.blue.active.button,.ui.blue.button .active.button:active,.ui.blue.buttons .active.button,.ui.blue.buttons .active.button:active{background-color:#125274;color:#fff;text-shadow:none}.ui.basic.blue.active.button,.ui.basic.blue.button:focus,.ui.basic.blue.button:hover,.ui.basic.blue.buttons .active.button,.ui.basic.blue.buttons .button:focus,.ui.basic.blue.buttons .button:hover{background:transparent!important}.ui.inverted.blue.button,.ui.inverted.blue.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #1782bb!important;color:#1782bb}.ui.inverted.blue.basic.button,.ui.inverted.blue.basic.buttons .button,.ui.inverted.blue.buttons .basic.button{color:#fff!important}.ui.inverted.blue.basic.button:focus,.ui.inverted.blue.basic.button:hover,.ui.inverted.blue.basic.buttons .button:focus,.ui.inverted.blue.basic.buttons .button:hover,.ui.inverted.blue.buttons .basic.button:hover{color:#1782bb!important}.ui.green.button,.ui.green.buttons .button{text-shadow:none;background-image:none}.ui.green.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.green.button:hover,.ui.green.buttons .button:hover{background-color:#46a364;color:#fff;text-shadow:none}.ui.green.button:focus,.ui.green.buttons .button:focus{background-color:#3e9d5c;color:#fff;text-shadow:none}.ui.green.button:active,.ui.green.buttons .button:active{background-color:#428e5a;color:#fff;text-shadow:none}.ui.green.active.button,.ui.green.button .active.button:active,.ui.green.buttons .active.button,.ui.green.buttons .active.button:active{background-color:#44a563;color:#fff;text-shadow:none}.ui.basic.green.active.button,.ui.basic.green.button:focus,.ui.basic.green.button:hover,.ui.basic.green.buttons .active.button,.ui.basic.green.buttons .button:focus,.ui.basic.green.buttons .button:hover{background:transparent!important}.ui.inverted.green.button,.ui.inverted.green.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #68ce88!important;color:#68ce88}.ui.inverted.green.basic.button,.ui.inverted.green.basic.buttons .button,.ui.inverted.green.buttons .basic.button{color:#fff!important}.ui.inverted.green.basic.button:focus,.ui.inverted.green.basic.button:hover,.ui.inverted.green.basic.buttons .button:focus,.ui.inverted.green.basic.buttons .button:hover,.ui.inverted.green.buttons .basic.button:hover{color:#68ce88!important}.ui.orange.button,.ui.orange.buttons .button{text-shadow:none;background-image:none}.ui.orange.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.orange.button:hover,.ui.orange.buttons .button:hover{background-color:#ff6f1c;color:#fff;text-shadow:none}.ui.orange.button:focus,.ui.orange.buttons .button:focus{background-color:#ff650d;color:#fff;text-shadow:none}.ui.orange.button:active,.ui.orange.buttons .button:active{background-color:#f6610c;color:#fff;text-shadow:none}.ui.orange.active.button,.ui.orange.button .active.button:active,.ui.orange.buttons .active.button,.ui.orange.buttons .active.button:active{background-color:#ff6f1c;color:#fff;text-shadow:none}.ui.basic.orange.active.button,.ui.basic.orange.button:focus,.ui.basic.orange.button:hover,.ui.basic.orange.buttons .active.button,.ui.basic.orange.buttons .button:focus,.ui.basic.orange.buttons .button:hover{background:transparent!important}.ui.inverted.orange.button,.ui.inverted.orange.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #ff8945!important;color:#ff8945}.ui.inverted.orange.basic.button,.ui.inverted.orange.basic.buttons .button,.ui.inverted.orange.buttons .basic.button{color:#fff!important}.ui.inverted.orange.basic.button:focus,.ui.inverted.orange.basic.button:hover,.ui.inverted.orange.basic.buttons .button:focus,.ui.inverted.orange.basic.buttons .button:hover,.ui.inverted.orange.buttons .basic.button:hover{color:#ff8945!important}.ui.pink.button,.ui.pink.buttons .button{text-shadow:none;background-image:none}.ui.pink.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.pink.button:hover,.ui.pink.buttons .button:hover{background-color:#e61a8d;color:#fff;text-shadow:none}.ui.pink.button:focus,.ui.pink.buttons .button:focus{background-color:#e10f85;color:#fff;text-shadow:none}.ui.pink.button:active,.ui.pink.buttons .button:active{background-color:#c71f7e;color:#fff;text-shadow:none}.ui.pink.active.button,.ui.pink.button .active.button:active,.ui.pink.buttons .active.button,.ui.pink.buttons .active.button:active{background-color:#ea158d;color:#fff;text-shadow:none}.ui.basic.pink.active.button,.ui.basic.pink.button:focus,.ui.basic.pink.button:hover,.ui.basic.pink.buttons .active.button,.ui.basic.pink.buttons .button:focus,.ui.basic.pink.buttons .button:hover{background:transparent!important}.ui.inverted.pink.button,.ui.inverted.pink.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #f670bb!important;color:#f670bb}.ui.inverted.pink.basic.button,.ui.inverted.pink.basic.buttons .button,.ui.inverted.pink.buttons .basic.button{color:#fff!important}.ui.inverted.pink.basic.button:focus,.ui.inverted.pink.basic.button:hover,.ui.inverted.pink.basic.buttons .button:focus,.ui.inverted.pink.basic.buttons .button:hover,.ui.inverted.pink.buttons .basic.button:hover{color:#f670bb!important}.ui.violet.button,.ui.violet.buttons .button{text-shadow:none;background-image:none}.ui.violet.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.violet.button:hover,.ui.violet.buttons .button:hover{background-color:#464787;color:#fff;text-shadow:none}.ui.violet.button:focus,.ui.violet.buttons .button:focus{background-color:#3e3f7f;color:#fff;text-shadow:none}.ui.violet.button:active,.ui.violet.buttons .button:active{background-color:#404173;color:#fff;text-shadow:none}.ui.violet.active.button,.ui.violet.button .active.button:active,.ui.violet.buttons .active.button,.ui.violet.buttons .active.button:active{background-color:#454688;color:#fff;text-shadow:none}.ui.basic.violet.active.button,.ui.basic.violet.button:focus,.ui.basic.violet.button:hover,.ui.basic.violet.buttons .active.button,.ui.basic.violet.buttons .button:focus,.ui.basic.violet.buttons .button:hover{background:transparent!important}.ui.inverted.violet.button,.ui.inverted.violet.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #6d6ec6!important;color:#6d6ec6}.ui.inverted.violet.basic.button,.ui.inverted.violet.basic.buttons .button,.ui.inverted.violet.buttons .basic.button{color:#fff!important}.ui.inverted.violet.basic.button:focus,.ui.inverted.violet.basic.button:hover,.ui.inverted.violet.basic.buttons .button:focus,.ui.inverted.violet.basic.buttons .button:hover,.ui.inverted.violet.buttons .basic.button:hover{color:#6d6ec6!important}.ui.purple.button,.ui.purple.buttons .button{text-shadow:none;background-image:none}.ui.purple.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.purple.button:hover,.ui.purple.buttons .button:hover{background-color:#9f3672;color:#fff;text-shadow:none}.ui.purple.button:focus,.ui.purple.buttons .button:focus{background-color:#982e6b;color:#fff;text-shadow:none}.ui.purple.button:active,.ui.purple.buttons .button:active{background-color:#883464;color:#fff;text-shadow:none}.ui.purple.active.button,.ui.purple.button .active.button:active,.ui.purple.buttons .active.button,.ui.purple.buttons .active.button:active{background-color:#a23472;color:#fff;text-shadow:none}.ui.basic.purple.active.button,.ui.basic.purple.button:focus,.ui.basic.purple.button:hover,.ui.basic.purple.buttons .active.button,.ui.basic.purple.buttons .button:focus,.ui.basic.purple.buttons .button:hover{background:transparent!important}.ui.inverted.purple.button,.ui.inverted.purple.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #d864a6!important;color:#d864a6}.ui.inverted.purple.basic.button,.ui.inverted.purple.basic.buttons .button,.ui.inverted.purple.buttons .basic.button{color:#fff!important}.ui.inverted.purple.basic.button:focus,.ui.inverted.purple.basic.button:hover,.ui.inverted.purple.basic.buttons .button:focus,.ui.inverted.purple.basic.buttons .button:hover,.ui.inverted.purple.buttons .basic.button:hover{color:#d864a6!important}.ui.red.button,.ui.red.buttons .button{text-shadow:none;background-image:none}.ui.red.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.red.button:hover,.ui.red.buttons .button:hover{background-color:#e81d33;color:#fff;text-shadow:none}.ui.red.button:focus,.ui.red.buttons .button:focus{background-color:#e80e25;color:#fff;text-shadow:none}.ui.red.button:active,.ui.red.buttons .button:active{background-color:#cd1e31;color:#fff;text-shadow:none}.ui.red.active.button,.ui.red.button .active.button:active,.ui.red.buttons .active.button,.ui.red.buttons .active.button:active{background-color:#ed182f;color:#fff;text-shadow:none}.ui.basic.red.active.button,.ui.basic.red.button:focus,.ui.basic.red.button:hover,.ui.basic.red.buttons .active.button,.ui.basic.red.buttons .button:focus,.ui.basic.red.buttons .button:hover{background:transparent!important}.ui.inverted.red.button,.ui.inverted.red.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #f77482!important;color:#f77482}.ui.inverted.red.basic.button,.ui.inverted.red.basic.buttons .button,.ui.inverted.red.buttons .basic.button{color:#fff!important}.ui.inverted.red.basic.button:focus,.ui.inverted.red.basic.button:hover,.ui.inverted.red.basic.buttons .button:focus,.ui.inverted.red.basic.buttons .button:hover,.ui.inverted.red.buttons .basic.button:hover{color:#f77482!important}.ui.teal.button,.ui.teal.buttons .button{text-shadow:none;background-image:none}.ui.teal.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.teal.button:hover,.ui.teal.buttons .button:hover{background-color:#008db1;color:#fff;text-shadow:none}.ui.teal.button:focus,.ui.teal.buttons .button:focus{background-color:#0080a1;color:#fff;text-shadow:none}.ui.teal.button:active,.ui.teal.buttons .button:active{background-color:#007897;color:#fff;text-shadow:none}.ui.teal.active.button,.ui.teal.button .active.button:active,.ui.teal.buttons .active.button,.ui.teal.buttons .active.button:active{background-color:#008db1;color:#fff;text-shadow:none}.ui.basic.teal.active.button,.ui.basic.teal.button:focus,.ui.basic.teal.button:hover,.ui.basic.teal.buttons .active.button,.ui.basic.teal.buttons .button:focus,.ui.basic.teal.buttons .button:hover{background:transparent!important}.ui.inverted.teal.button,.ui.inverted.teal.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #00cafd!important;color:#00cafd}.ui.inverted.teal.basic.button,.ui.inverted.teal.basic.buttons .button,.ui.inverted.teal.buttons .basic.button{color:#fff!important}.ui.inverted.teal.basic.button:focus,.ui.inverted.teal.basic.button:hover,.ui.inverted.teal.basic.buttons .button:focus,.ui.inverted.teal.basic.buttons .button:hover,.ui.inverted.teal.buttons .basic.button:hover{color:#00cafd!important}.ui.olive.button,.ui.olive.buttons .button{text-shadow:none;background-image:none}.ui.olive.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.olive.button:hover,.ui.olive.buttons .button:hover{background-color:#39574b;color:#fff;text-shadow:none}.ui.olive.button:focus,.ui.olive.buttons .button:focus{background-color:#324f43;color:#fff;text-shadow:none}.ui.olive.button:active,.ui.olive.buttons .button:active{background-color:#30473e;color:#fff;text-shadow:none}.ui.olive.active.button,.ui.olive.button .active.button:active,.ui.olive.buttons .active.button,.ui.olive.buttons .active.button:active{background-color:#39584b;color:#fff;text-shadow:none}.ui.basic.olive.active.button,.ui.basic.olive.button:focus,.ui.basic.olive.button:hover,.ui.basic.olive.buttons .active.button,.ui.basic.olive.buttons .button:focus,.ui.basic.olive.buttons .button:hover{background:transparent!important}.ui.inverted.olive.button,.ui.inverted.olive.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #52a583!important;color:#52a583}.ui.inverted.olive.basic.button,.ui.inverted.olive.basic.buttons .button,.ui.inverted.olive.buttons .basic.button{color:#fff!important}.ui.inverted.olive.basic.button:focus,.ui.inverted.olive.basic.button:hover,.ui.inverted.olive.basic.buttons .button:focus,.ui.inverted.olive.basic.buttons .button:hover,.ui.inverted.olive.buttons .basic.button:hover{color:#52a583!important}.ui.yellow.button,.ui.yellow.buttons .button{text-shadow:none;background-image:none}.ui.yellow.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.yellow.button:hover,.ui.yellow.buttons .button:hover{background-color:#fec300;color:#fff;text-shadow:none}.ui.yellow.button:focus,.ui.yellow.buttons .button:focus{background-color:#eeb800;color:#fff;text-shadow:none}.ui.yellow.button:active,.ui.yellow.buttons .button:active{background-color:#e4b000;color:#fff;text-shadow:none}.ui.yellow.active.button,.ui.yellow.button .active.button:active,.ui.yellow.buttons .active.button,.ui.yellow.buttons .active.button:active{background-color:#fec300;color:#fff;text-shadow:none}.ui.basic.yellow.active.button,.ui.basic.yellow.button:focus,.ui.basic.yellow.button:hover,.ui.basic.yellow.buttons .active.button,.ui.basic.yellow.buttons .button:focus,.ui.basic.yellow.buttons .button:hover{background:transparent!important}.ui.inverted.yellow.button,.ui.inverted.yellow.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #ffca18!important;color:#ffca18}.ui.inverted.yellow.basic.button,.ui.inverted.yellow.basic.buttons .button,.ui.inverted.yellow.buttons .basic.button{color:#fff!important}.ui.inverted.yellow.basic.button:focus,.ui.inverted.yellow.basic.button:hover,.ui.inverted.yellow.basic.buttons .button:focus,.ui.inverted.yellow.basic.buttons .button:hover,.ui.inverted.yellow.buttons .basic.button:hover{color:#ffca18!important}.ui.primary.button,.ui.primary.buttons .button{text-shadow:none;background-image:none}.ui.primary.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.primary.button:hover,.ui.primary.buttons .button:hover{background-color:#006aa6;color:#fff;text-shadow:none}.ui.primary.button:focus,.ui.primary.buttons .button:focus{background-color:#006096;color:#fff;text-shadow:none}.ui.primary.button:active,.ui.primary.buttons .button:active{background-color:#00598c;color:#fff;text-shadow:none}.ui.primary.active.button,.ui.primary.button .active.button:active,.ui.primary.buttons .active.button,.ui.primary.buttons .active.button:active{background-color:#006aa6;color:#fff;text-shadow:none}.ui.basic.primary.active.button,.ui.basic.primary.button:focus,.ui.basic.primary.button:hover,.ui.basic.primary.buttons .active.button,.ui.basic.primary.buttons .button:focus,.ui.basic.primary.buttons .button:hover{background:transparent!important}.ui.secondary.button,.ui.secondary.buttons .button{text-shadow:none;background-image:none}.ui.secondary.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.secondary.button:hover,.ui.secondary.buttons .button:hover{background-color:#64767c;color:#fff;text-shadow:none}.ui.secondary.button:focus,.ui.secondary.buttons .button:focus{background-color:#6a7e86;color:#fff;text-shadow:none}.ui.secondary.button:active,.ui.secondary.buttons .button:active{background-color:#718389;color:#fff;text-shadow:none}.ui.secondary.active.button,.ui.secondary.button .active.button:active,.ui.secondary.buttons .active.button,.ui.secondary.buttons .active.button:active{background-color:#64767d;color:#fff;text-shadow:none}.ui.basic.secondary.active.button,.ui.basic.secondary.button:focus,.ui.basic.secondary.button:hover,.ui.basic.secondary.buttons .active.button,.ui.basic.secondary.buttons .button:focus,.ui.basic.secondary.buttons .button:hover{background:transparent!important}.ui.positive.button,.ui.positive.buttons .button{text-shadow:none;background-image:none}.ui.positive.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.positive.button:hover,.ui.positive.buttons .button:hover{background-color:#418217;color:#fff;text-shadow:none}.ui.positive.button:focus,.ui.positive.buttons .button:focus{background-color:#3a7911;color:#fff;text-shadow:none}.ui.positive.button:active,.ui.positive.buttons .button:active{background-color:#376818;color:#fff;text-shadow:none}.ui.positive.active.button,.ui.positive.button .active.button:active,.ui.positive.buttons .active.button,.ui.positive.buttons .active.button:active{background-color:#408415;color:#fff;text-shadow:none}.ui.basic.positive.active.button,.ui.basic.positive.button:focus,.ui.basic.positive.button:hover,.ui.basic.positive.buttons .active.button,.ui.basic.positive.buttons .button:focus,.ui.basic.positive.buttons .button:hover{background:transparent!important}.ui.negative.button,.ui.negative.buttons .button{text-shadow:none;background-image:none}.ui.negative.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.negative.button:hover,.ui.negative.buttons .button:hover{background-color:#b61070;color:#fff;text-shadow:none}.ui.negative.button:focus,.ui.negative.buttons .button:focus{background-color:#af0868;color:#fff;text-shadow:none}.ui.negative.button:active,.ui.negative.buttons .button:active{background-color:#981561;color:#fff;text-shadow:none}.ui.negative.active.button,.ui.negative.button .active.button:active,.ui.negative.buttons .active.button,.ui.negative.buttons .active.button:active{background-color:#ba0d70;color:#fff;text-shadow:none}.ui.basic.negative.active.button,.ui.basic.negative.button:focus,.ui.basic.negative.button:hover,.ui.basic.negative.buttons .active.button,.ui.basic.negative.buttons .button:focus,.ui.basic.negative.buttons .button:hover{background:transparent!important}.ui.buttons{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:0;vertical-align:baseline;margin:0 .25em 0 0}.ui.buttons:not(.basic):not(.inverted){box-shadow:none}.ui.buttons:after{content:\".\";display:block;height:0;clear:both;visibility:hidden}.ui.buttons .button{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;border-radius:0;margin:0}.ui.buttons:not(.basic):not(.inverted)>.button,.ui.buttons>.ui.button:not(.basic):not(.inverted){box-shadow:inset 0 0 0 1px transparent,inset 0 0 0 0 rgba(34,36,38,.15)}.ui.buttons .button:first-child{border-left:none;margin-left:0;border-top-left-radius:.11764706rem;border-bottom-left-radius:.11764706rem}.ui.buttons .button:last-child{border-top-right-radius:.11764706rem;border-bottom-right-radius:.11764706rem}.ui.vertical.buttons{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ui.vertical.buttons .button{display:block;float:none;width:100%;margin:0;box-shadow:none;border-radius:0}.ui.vertical.buttons .button:first-child{border-top-left-radius:.11764706rem;border-top-right-radius:.11764706rem}.ui.vertical.buttons .button:last-child{margin-bottom:0;border-bottom-left-radius:.11764706rem;border-bottom-right-radius:.11764706rem}.ui.vertical.buttons .button:only-child{border-radius:.11764706rem}.ui.inverted.button{background:hsla(0,0%,100%,.15);color:#8cd5ff}.ui.inverted.button:hover{background:hsla(0,0%,100%,.2);color:#fff}.ui.inverted.button.active,.ui.inverted.button:focus{background:hsla(0,0%,100%,.25);color:#bfe8ff}.ui.basic.inverted.button,.ui.basic.inverted.buttons .button{background-color:transparent!important;color:#26b1ff!important;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important}.ui.basic.inverted.button:hover,.ui.basic.inverted.buttons .button:hover{color:#8cd5ff!important;background-color:hsla(0,0%,100%,.15)!important}.ui.basic.inverted.button:focus,.ui.basic.inverted.buttons .button:focus{color:#fff!important;background-color:hsla(0,0%,100%,.15)!important}.ui.basic.inverted.button:active,.ui.basic.inverted.buttons .button:active{background-color:hsla(0,0%,100%,.08)!important;color:#fff!important}.ui.basic.inverted.active.button,.ui.basic.inverted.buttons .active.button{background-color:hsla(0,0%,100%,.08);color:#fff;text-shadow:\"negativeTextShadow\";box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.7)}.ui.basic.inverted.active.button:hover,.ui.basic.inverted.buttons .active.button:hover{background-color:hsla(0,0%,100%,.15);box-shadow:inset 0 0 0 0 #fff!important}.ui.red.button,.ui.red.buttons .button{background-color:#e23c4e;color:#fff}.ui.basic.red.button,.ui.basic.red.buttons .button{box-shadow:inset 0 0 0 0 #e23c4e!important;color:#e23c4e!important}.ui.basic.red.button:hover,.ui.basic.red.buttons .button:hover{background:rgba(226,60,78,.2)!important;box-shadow:inset 0 0 0 0 #e81d33!important;color:#e81d33!important}.ui.basic.red.button:focus,.ui.basic.red.buttons .button:focus{background:rgba(226,60,78,.3)!important;box-shadow:inset 0 0 0 0 #e80e25!important;color:#e81d33!important}.ui.basic.red.active.button,.ui.basic.red.buttons .active.button{background:rgba(205,30,49,.2)!important;box-shadow:inset 0 0 0 0 #ed182f!important;color:#cd1e31!important}.ui.basic.red.button:active,.ui.basic.red.buttons .button:active{box-shadow:inset 0 0 0 0 #cd1e31!important;color:#cd1e31!important}.ui.buttons:not(.vertical)>.basic.red.button:not(:first-child){margin-left:0}.ui.inverted.red.button,.ui.inverted.red.buttons .button{background-color:#e23c4e;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.red.button.active,.ui.inverted.red.button:active,.ui.inverted.red.button:focus,.ui.inverted.red.button:hover,.ui.inverted.red.buttons .button.active,.ui.inverted.red.buttons .button:active,.ui.inverted.red.buttons .button:focus,.ui.inverted.red.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.red.button:hover,.ui.inverted.red.buttons .button:hover{background-color:#fd5466}.ui.inverted.red.button:focus,.ui.inverted.red.buttons .button:focus{background-color:#ff4357}.ui.inverted.red.active.button,.ui.inverted.red.buttons .active.button{background-color:#ff5265}.ui.inverted.red.button:active,.ui.inverted.red.buttons .button:active{background-color:#f44356}.ui.inverted.red.basic.button,.ui.inverted.red.basic.buttons .button,.ui.inverted.red.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#f77482!important}.ui.inverted.red.basic.button:hover,.ui.inverted.red.basic.buttons .button:hover,.ui.inverted.red.buttons .basic.button:hover{background-color:rgba(226,60,78,.5)!important;box-shadow:inset 0 0 0 0 #fd5466!important;color:#fff!important}.ui.inverted.red.basic.button:focus,.ui.inverted.red.basic.buttons .button:focus{background-color:rgba(226,60,78,.5)!important;box-shadow:inset 0 0 0 0 #ff4357!important;color:#fff!important}.ui.inverted.red.basic.active.button,.ui.inverted.red.basic.buttons .active.button,.ui.inverted.red.buttons .basic.active.button{background-color:rgba(226,60,78,.2)!important;box-shadow:inset 0 0 0 0 #ff5265!important;color:#f77482!important}.ui.inverted.red.basic.button:active,.ui.inverted.red.basic.buttons .button:active,.ui.inverted.red.buttons .basic.button:active{background-color:rgba(226,60,78,.2)!important;box-shadow:inset 0 0 0 0 #f44356!important;color:#f77482!important}.ui.orange.button,.ui.orange.buttons .button{background-color:#f8813d;color:#fff}.ui.basic.orange.button,.ui.basic.orange.buttons .button{box-shadow:inset 0 0 0 0 #f8813d!important;color:#f8813d!important}.ui.basic.orange.button:hover,.ui.basic.orange.buttons .button:hover{background:rgba(248,129,61,.2)!important;box-shadow:inset 0 0 0 0 #ff6f1c!important;color:#ff6f1c!important}.ui.basic.orange.button:focus,.ui.basic.orange.buttons .button:focus{background:rgba(248,129,61,.3)!important;box-shadow:inset 0 0 0 0 #ff650d!important;color:#ff6f1c!important}.ui.basic.orange.active.button,.ui.basic.orange.buttons .active.button{background:rgba(246,97,12,.2)!important;box-shadow:inset 0 0 0 0 #ff6f1c!important;color:#f6610c!important}.ui.basic.orange.button:active,.ui.basic.orange.buttons .button:active{box-shadow:inset 0 0 0 0 #f6610c!important;color:#f6610c!important}.ui.buttons:not(.vertical)>.basic.orange.button:not(:first-child){margin-left:0}.ui.inverted.orange.button,.ui.inverted.orange.buttons .button{background-color:#f8813d;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.orange.button.active,.ui.inverted.orange.button:active,.ui.inverted.orange.button:focus,.ui.inverted.orange.button:hover,.ui.inverted.orange.buttons .button.active,.ui.inverted.orange.buttons .button:active,.ui.inverted.orange.buttons .button:focus,.ui.inverted.orange.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.orange.button:hover,.ui.inverted.orange.buttons .button:hover{background-color:#ff792c}.ui.inverted.orange.button:focus,.ui.inverted.orange.buttons .button:focus{background-color:#ff6f1d}.ui.inverted.orange.active.button,.ui.inverted.orange.buttons .active.button{background-color:#ff792c}.ui.inverted.orange.button:active,.ui.inverted.orange.buttons .button:active{background-color:#ff6812}.ui.inverted.orange.basic.button,.ui.inverted.orange.basic.buttons .button,.ui.inverted.orange.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#ff8945!important}.ui.inverted.orange.basic.button:hover,.ui.inverted.orange.basic.buttons .button:hover,.ui.inverted.orange.buttons .basic.button:hover{background-color:rgba(248,129,61,.5)!important;box-shadow:inset 0 0 0 0 #ff792c!important;color:#fff!important}.ui.inverted.orange.basic.button:focus,.ui.inverted.orange.basic.buttons .button:focus{background-color:rgba(248,129,61,.5)!important;box-shadow:inset 0 0 0 0 #ff6f1d!important;color:#fff!important}.ui.inverted.orange.basic.active.button,.ui.inverted.orange.basic.buttons .active.button,.ui.inverted.orange.buttons .basic.active.button{background-color:rgba(248,129,61,.2)!important;box-shadow:inset 0 0 0 0 #ff792c!important;color:#ff8945!important}.ui.inverted.orange.basic.button:active,.ui.inverted.orange.basic.buttons .button:active,.ui.inverted.orange.buttons .basic.button:active{background-color:rgba(248,129,61,.2)!important;box-shadow:inset 0 0 0 0 #ff6812!important;color:#ff8945!important}.ui.yellow.button,.ui.yellow.buttons .button{background-color:#ffca18;color:#fff}.ui.basic.yellow.button,.ui.basic.yellow.buttons .button{box-shadow:inset 0 0 0 0 #ffca18!important;color:#ffca18!important}.ui.basic.yellow.button:hover,.ui.basic.yellow.buttons .button:hover{background:rgba(255,202,24,.2)!important;box-shadow:inset 0 0 0 0 #fec300!important;color:#fec300!important}.ui.basic.yellow.button:focus,.ui.basic.yellow.buttons .button:focus{background:rgba(255,202,24,.3)!important;box-shadow:inset 0 0 0 0 #eeb800!important;color:#fec300!important}.ui.basic.yellow.active.button,.ui.basic.yellow.buttons .active.button{background:rgba(228,176,0,.2)!important;box-shadow:inset 0 0 0 0 #fec300!important;color:#e4b000!important}.ui.basic.yellow.button:active,.ui.basic.yellow.buttons .button:active{box-shadow:inset 0 0 0 0 #e4b000!important;color:#e4b000!important}.ui.buttons:not(.vertical)>.basic.yellow.button:not(:first-child){margin-left:0}.ui.inverted.yellow.button,.ui.inverted.yellow.buttons .button{background-color:#ffca18;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.yellow.button.active,.ui.inverted.yellow.button:active,.ui.inverted.yellow.button:focus,.ui.inverted.yellow.button:hover,.ui.inverted.yellow.buttons .button.active,.ui.inverted.yellow.buttons .button:active,.ui.inverted.yellow.buttons .button:focus,.ui.inverted.yellow.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.yellow.button:hover,.ui.inverted.yellow.buttons .button:hover{background-color:#fec300}.ui.inverted.yellow.button:focus,.ui.inverted.yellow.buttons .button:focus{background-color:#eeb800}.ui.inverted.yellow.active.button,.ui.inverted.yellow.buttons .active.button{background-color:#fec300}.ui.inverted.yellow.button:active,.ui.inverted.yellow.buttons .button:active{background-color:#e4b000}.ui.inverted.yellow.basic.button,.ui.inverted.yellow.basic.buttons .button,.ui.inverted.yellow.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#ffca18!important}.ui.inverted.yellow.basic.button:hover,.ui.inverted.yellow.basic.buttons .button:hover,.ui.inverted.yellow.buttons .basic.button:hover{background-color:rgba(255,202,24,.5)!important;box-shadow:inset 0 0 0 0 #fec300!important;color:#fff!important}.ui.inverted.yellow.basic.button:focus,.ui.inverted.yellow.basic.buttons .button:focus{background-color:rgba(255,202,24,.5)!important;box-shadow:inset 0 0 0 0 #eeb800!important;color:#fff!important}.ui.inverted.yellow.basic.active.button,.ui.inverted.yellow.basic.buttons .active.button,.ui.inverted.yellow.buttons .basic.active.button{background-color:rgba(255,202,24,.2)!important;box-shadow:inset 0 0 0 0 #fec300!important;color:#ffca18!important}.ui.inverted.yellow.basic.button:active,.ui.inverted.yellow.basic.buttons .button:active,.ui.inverted.yellow.buttons .basic.button:active{background-color:rgba(255,202,24,.2)!important;box-shadow:inset 0 0 0 0 #e4b000!important;color:#ffca18!important}.ui.olive.button,.ui.olive.buttons .button{background-color:#456558;color:#fff}.ui.basic.olive.button,.ui.basic.olive.buttons .button{box-shadow:inset 0 0 0 0 #456558!important;color:#456558!important}.ui.basic.olive.button:hover,.ui.basic.olive.buttons .button:hover{background:rgba(69,101,88,.2)!important;box-shadow:inset 0 0 0 0 #39574b!important;color:#39574b!important}.ui.basic.olive.button:focus,.ui.basic.olive.buttons .button:focus{background:rgba(69,101,88,.3)!important;box-shadow:inset 0 0 0 0 #324f43!important;color:#39574b!important}.ui.basic.olive.active.button,.ui.basic.olive.buttons .active.button{background:rgba(48,71,62,.2)!important;box-shadow:inset 0 0 0 0 #39584b!important;color:#30473e!important}.ui.basic.olive.button:active,.ui.basic.olive.buttons .button:active{box-shadow:inset 0 0 0 0 #30473e!important;color:#30473e!important}.ui.buttons:not(.vertical)>.basic.olive.button:not(:first-child){margin-left:0}.ui.inverted.olive.button,.ui.inverted.olive.buttons .button{background-color:#456558;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.olive.button.active,.ui.inverted.olive.button:active,.ui.inverted.olive.button:focus,.ui.inverted.olive.button:hover,.ui.inverted.olive.buttons .button.active,.ui.inverted.olive.buttons .button:active,.ui.inverted.olive.buttons .button:focus,.ui.inverted.olive.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.olive.button:hover,.ui.inverted.olive.buttons .button:hover{background-color:#459876}.ui.inverted.olive.button:focus,.ui.inverted.olive.buttons .button:focus{background-color:#3d916f}.ui.inverted.olive.active.button,.ui.inverted.olive.buttons .active.button{background-color:#497}.ui.inverted.olive.button:active,.ui.inverted.olive.buttons .button:active{background-color:#418368}.ui.inverted.olive.basic.button,.ui.inverted.olive.basic.buttons .button,.ui.inverted.olive.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#52a583!important}.ui.inverted.olive.basic.button:hover,.ui.inverted.olive.basic.buttons .button:hover,.ui.inverted.olive.buttons .basic.button:hover{background-color:rgba(69,101,88,.5)!important;box-shadow:inset 0 0 0 0 #459876!important;color:#fff!important}.ui.inverted.olive.basic.button:focus,.ui.inverted.olive.basic.buttons .button:focus{background-color:rgba(69,101,88,.5)!important;box-shadow:inset 0 0 0 0 #3d916f!important;color:#fff!important}.ui.inverted.olive.basic.active.button,.ui.inverted.olive.basic.buttons .active.button,.ui.inverted.olive.buttons .basic.active.button{background-color:rgba(69,101,88,.2)!important;box-shadow:inset 0 0 0 0 #497!important;color:#52a583!important}.ui.inverted.olive.basic.button:active,.ui.inverted.olive.basic.buttons .button:active,.ui.inverted.olive.buttons .basic.button:active{background-color:rgba(69,101,88,.2)!important;box-shadow:inset 0 0 0 0 #418368!important;color:#52a583!important}.ui.green.button,.ui.green.buttons .button{background-color:#54af71;color:#fff}.ui.basic.green.button,.ui.basic.green.buttons .button{box-shadow:inset 0 0 0 0 #54af71!important;color:#54af71!important}.ui.basic.green.button:hover,.ui.basic.green.buttons .button:hover{background:rgba(84,175,113,.2)!important;box-shadow:inset 0 0 0 0 #46a364!important;color:#46a364!important}.ui.basic.green.button:focus,.ui.basic.green.buttons .button:focus{background:rgba(84,175,113,.3)!important;box-shadow:inset 0 0 0 0 #3e9d5c!important;color:#46a364!important}.ui.basic.green.active.button,.ui.basic.green.buttons .active.button{background:rgba(66,142,90,.2)!important;box-shadow:inset 0 0 0 0 #44a563!important;color:#428e5a!important}.ui.basic.green.button:active,.ui.basic.green.buttons .button:active{box-shadow:inset 0 0 0 0 #428e5a!important;color:#428e5a!important}.ui.buttons:not(.vertical)>.basic.green.button:not(:first-child){margin-left:0}.ui.inverted.green.button,.ui.inverted.green.buttons .button{background-color:#54af71;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.green.button.active,.ui.inverted.green.button:active,.ui.inverted.green.button:focus,.ui.inverted.green.button:hover,.ui.inverted.green.buttons .button.active,.ui.inverted.green.buttons .button:active,.ui.inverted.green.buttons .button:focus,.ui.inverted.green.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.green.button:hover,.ui.inverted.green.buttons .button:hover{background-color:#4fce77}.ui.inverted.green.button:focus,.ui.inverted.green.buttons .button:focus{background-color:#3dd16c}.ui.inverted.green.active.button,.ui.inverted.green.buttons .active.button{background-color:#4cd176}.ui.inverted.green.button:active,.ui.inverted.green.buttons .button:active{background-color:#41c26a}.ui.inverted.green.basic.button,.ui.inverted.green.basic.buttons .button,.ui.inverted.green.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#68ce88!important}.ui.inverted.green.basic.button:hover,.ui.inverted.green.basic.buttons .button:hover,.ui.inverted.green.buttons .basic.button:hover{background-color:rgba(84,175,113,.5)!important;box-shadow:inset 0 0 0 0 #4fce77!important;color:#fff!important}.ui.inverted.green.basic.button:focus,.ui.inverted.green.basic.buttons .button:focus{background-color:rgba(84,175,113,.5)!important;box-shadow:inset 0 0 0 0 #3dd16c!important;color:#fff!important}.ui.inverted.green.basic.active.button,.ui.inverted.green.basic.buttons .active.button,.ui.inverted.green.buttons .basic.active.button{background-color:rgba(84,175,113,.2)!important;box-shadow:inset 0 0 0 0 #4cd176!important;color:#68ce88!important}.ui.inverted.green.basic.button:active,.ui.inverted.green.basic.buttons .button:active,.ui.inverted.green.buttons .basic.button:active{background-color:rgba(84,175,113,.2)!important;box-shadow:inset 0 0 0 0 #41c26a!important;color:#68ce88!important}.ui.teal.button,.ui.teal.buttons .button{background-color:#00a1ca;color:#fff}.ui.basic.teal.button,.ui.basic.teal.buttons .button{box-shadow:inset 0 0 0 0 #00a1ca!important;color:#00a1ca!important}.ui.basic.teal.button:hover,.ui.basic.teal.buttons .button:hover{background:rgba(0,161,202,.2)!important;box-shadow:inset 0 0 0 0 #008db1!important;color:#008db1!important}.ui.basic.teal.button:focus,.ui.basic.teal.buttons .button:focus{background:rgba(0,161,202,.3)!important;box-shadow:inset 0 0 0 0 #0080a1!important;color:#008db1!important}.ui.basic.teal.active.button,.ui.basic.teal.buttons .active.button{background:rgba(0,120,151,.2)!important;box-shadow:inset 0 0 0 0 #008db1!important;color:#007897!important}.ui.basic.teal.button:active,.ui.basic.teal.buttons .button:active{box-shadow:inset 0 0 0 0 #007897!important;color:#007897!important}.ui.buttons:not(.vertical)>.basic.teal.button:not(:first-child){margin-left:0}.ui.inverted.teal.button,.ui.inverted.teal.buttons .button{background-color:#00a1ca;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.teal.button.active,.ui.inverted.teal.button:active,.ui.inverted.teal.button:focus,.ui.inverted.teal.button:hover,.ui.inverted.teal.buttons .button.active,.ui.inverted.teal.buttons .button:active,.ui.inverted.teal.buttons .button:focus,.ui.inverted.teal.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.teal.button:hover,.ui.inverted.teal.buttons .button:hover{background-color:#00b5e4}.ui.inverted.teal.button:focus,.ui.inverted.teal.buttons .button:focus{background-color:#00a9d4}.ui.inverted.teal.active.button,.ui.inverted.teal.buttons .active.button{background-color:#00b5e4}.ui.inverted.teal.button:active,.ui.inverted.teal.buttons .button:active{background-color:#00a1ca}.ui.inverted.teal.basic.button,.ui.inverted.teal.basic.buttons .button,.ui.inverted.teal.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#00cafd!important}.ui.inverted.teal.basic.button:hover,.ui.inverted.teal.basic.buttons .button:hover,.ui.inverted.teal.buttons .basic.button:hover{background-color:rgba(0,161,202,.5)!important;box-shadow:inset 0 0 0 0 #00b5e4!important;color:#fff!important}.ui.inverted.teal.basic.button:focus,.ui.inverted.teal.basic.buttons .button:focus{background-color:rgba(0,161,202,.5)!important;box-shadow:inset 0 0 0 0 #00a9d4!important;color:#fff!important}.ui.inverted.teal.basic.active.button,.ui.inverted.teal.basic.buttons .active.button,.ui.inverted.teal.buttons .basic.active.button{background-color:rgba(0,161,202,.2)!important;box-shadow:inset 0 0 0 0 #00b5e4!important;color:#00cafd!important}.ui.inverted.teal.basic.button:active,.ui.inverted.teal.basic.buttons .button:active,.ui.inverted.teal.buttons .basic.button:active{background-color:rgba(0,161,202,.2)!important;box-shadow:inset 0 0 0 0 #00a1ca!important;color:#00cafd!important}.ui.blue.button,.ui.blue.buttons .button{background-color:#1d5f82;color:#fff}.ui.basic.blue.button,.ui.basic.blue.buttons .button{box-shadow:inset 0 0 0 0 #1d5f82!important;color:#1d5f82!important}.ui.basic.blue.button:hover,.ui.basic.blue.buttons .button:hover{background:rgba(29,95,130,.2)!important;box-shadow:inset 0 0 0 0 #145171!important;color:#145171!important}.ui.basic.blue.button:focus,.ui.basic.blue.buttons .button:focus{background:rgba(29,95,130,.3)!important;box-shadow:inset 0 0 0 0 #0e4968!important;color:#145171!important}.ui.basic.blue.active.button,.ui.basic.blue.buttons .active.button{background:rgba(20,65,88,.2)!important;box-shadow:inset 0 0 0 0 #125274!important;color:#144158!important}.ui.basic.blue.button:active,.ui.basic.blue.buttons .button:active{box-shadow:inset 0 0 0 0 #144158!important;color:#144158!important}.ui.buttons:not(.vertical)>.basic.blue.button:not(:first-child){margin-left:0}.ui.inverted.blue.button,.ui.inverted.blue.buttons .button{background-color:#1d5f82;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.blue.button.active,.ui.inverted.blue.button:active,.ui.inverted.blue.button:focus,.ui.inverted.blue.button:hover,.ui.inverted.blue.buttons .button.active,.ui.inverted.blue.buttons .button:active,.ui.inverted.blue.buttons .button:focus,.ui.inverted.blue.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.blue.button:hover,.ui.inverted.blue.buttons .button:hover{background-color:#0d75ac}.ui.inverted.blue.button:focus,.ui.inverted.blue.buttons .button:focus{background-color:#056da4}.ui.inverted.blue.active.button,.ui.inverted.blue.buttons .active.button{background-color:#0976b0}.ui.inverted.blue.button:active,.ui.inverted.blue.buttons .button:active{background-color:#11638e}.ui.inverted.blue.basic.button,.ui.inverted.blue.basic.buttons .button,.ui.inverted.blue.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#1782bb!important}.ui.inverted.blue.basic.button:hover,.ui.inverted.blue.basic.buttons .button:hover,.ui.inverted.blue.buttons .basic.button:hover{background-color:rgba(29,95,130,.5)!important;box-shadow:inset 0 0 0 0 #0d75ac!important;color:#fff!important}.ui.inverted.blue.basic.button:focus,.ui.inverted.blue.basic.buttons .button:focus{background-color:rgba(29,95,130,.5)!important;box-shadow:inset 0 0 0 0 #056da4!important;color:#fff!important}.ui.inverted.blue.basic.active.button,.ui.inverted.blue.basic.buttons .active.button,.ui.inverted.blue.buttons .basic.active.button{background-color:rgba(29,95,130,.2)!important;box-shadow:inset 0 0 0 0 #0976b0!important;color:#1782bb!important}.ui.inverted.blue.basic.button:active,.ui.inverted.blue.basic.buttons .button:active,.ui.inverted.blue.buttons .basic.button:active{background-color:rgba(29,95,130,.2)!important;box-shadow:inset 0 0 0 0 #11638e!important;color:#1782bb!important}.ui.violet.button,.ui.violet.buttons .button{background-color:#525394;color:#fff}.ui.basic.violet.button,.ui.basic.violet.buttons .button{box-shadow:inset 0 0 0 0 #525394!important;color:#525394!important}.ui.basic.violet.button:hover,.ui.basic.violet.buttons .button:hover{background:rgba(82,83,148,.2)!important;box-shadow:inset 0 0 0 0 #464787!important;color:#464787!important}.ui.basic.violet.button:focus,.ui.basic.violet.buttons .button:focus{background:rgba(82,83,148,.3)!important;box-shadow:inset 0 0 0 0 #3e3f7f!important;color:#464787!important}.ui.basic.violet.active.button,.ui.basic.violet.buttons .active.button{background:rgba(64,65,115,.2)!important;box-shadow:inset 0 0 0 0 #454688!important;color:#404173!important}.ui.basic.violet.button:active,.ui.basic.violet.buttons .button:active{box-shadow:inset 0 0 0 0 #404173!important;color:#404173!important}.ui.buttons:not(.vertical)>.basic.violet.button:not(:first-child){margin-left:0}.ui.inverted.violet.button,.ui.inverted.violet.buttons .button{background-color:#525394;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.violet.button.active,.ui.inverted.violet.button:active,.ui.inverted.violet.button:focus,.ui.inverted.violet.button:hover,.ui.inverted.violet.buttons .button.active,.ui.inverted.violet.buttons .button:active,.ui.inverted.violet.buttons .button:focus,.ui.inverted.violet.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.violet.button:hover,.ui.inverted.violet.buttons .button:hover{background-color:#5557c4}.ui.inverted.violet.button:focus,.ui.inverted.violet.buttons .button:focus{background-color:#4547c5}.ui.inverted.violet.active.button,.ui.inverted.violet.buttons .active.button{background-color:#5355c6}.ui.inverted.violet.button:active,.ui.inverted.violet.buttons .button:active{background-color:#484ab7}.ui.inverted.violet.basic.button,.ui.inverted.violet.basic.buttons .button,.ui.inverted.violet.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#6d6ec6!important}.ui.inverted.violet.basic.button:hover,.ui.inverted.violet.basic.buttons .button:hover,.ui.inverted.violet.buttons .basic.button:hover{background-color:rgba(82,83,148,.5)!important;box-shadow:inset 0 0 0 0 #5557c4!important;color:#fff!important}.ui.inverted.violet.basic.button:focus,.ui.inverted.violet.basic.buttons .button:focus{background-color:rgba(82,83,148,.5)!important;box-shadow:inset 0 0 0 0 #4547c5!important;color:#fff!important}.ui.inverted.violet.basic.active.button,.ui.inverted.violet.basic.buttons .active.button,.ui.inverted.violet.buttons .basic.active.button{background-color:rgba(82,83,148,.2)!important;box-shadow:inset 0 0 0 0 #5355c6!important;color:#6d6ec6!important}.ui.inverted.violet.basic.button:active,.ui.inverted.violet.basic.buttons .button:active,.ui.inverted.violet.buttons .basic.button:active{background-color:rgba(82,83,148,.2)!important;box-shadow:inset 0 0 0 0 #484ab7!important;color:#6d6ec6!important}.ui.purple.button,.ui.purple.buttons .button{background-color:#ad427f;color:#fff}.ui.basic.purple.button,.ui.basic.purple.buttons .button{box-shadow:inset 0 0 0 0 #ad427f!important;color:#ad427f!important}.ui.basic.purple.button:hover,.ui.basic.purple.buttons .button:hover{background:rgba(173,66,127,.2)!important;box-shadow:inset 0 0 0 0 #9f3672!important;color:#9f3672!important}.ui.basic.purple.button:focus,.ui.basic.purple.buttons .button:focus{background:rgba(173,66,127,.3)!important;box-shadow:inset 0 0 0 0 #982e6b!important;color:#9f3672!important}.ui.basic.purple.active.button,.ui.basic.purple.buttons .active.button{background:rgba(136,52,100,.2)!important;box-shadow:inset 0 0 0 0 #a23472!important;color:#883464!important}.ui.basic.purple.button:active,.ui.basic.purple.buttons .button:active{box-shadow:inset 0 0 0 0 #883464!important;color:#883464!important}.ui.buttons:not(.vertical)>.basic.purple.button:not(:first-child){margin-left:0}.ui.inverted.purple.button,.ui.inverted.purple.buttons .button{background-color:#ad427f;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.purple.button.active,.ui.inverted.purple.button:active,.ui.inverted.purple.button:focus,.ui.inverted.purple.button:hover,.ui.inverted.purple.buttons .button.active,.ui.inverted.purple.buttons .button:active,.ui.inverted.purple.buttons .button:focus,.ui.inverted.purple.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.purple.button:hover,.ui.inverted.purple.buttons .button:hover{background-color:#d9499b}.ui.inverted.purple.button:focus,.ui.inverted.purple.buttons .button:focus{background-color:#de3595}.ui.inverted.purple.active.button,.ui.inverted.purple.buttons .active.button{background-color:#dd459c}.ui.inverted.purple.button:active,.ui.inverted.purple.buttons .button:active{background-color:#ce3b8f}.ui.inverted.purple.basic.button,.ui.inverted.purple.basic.buttons .button,.ui.inverted.purple.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#d864a6!important}.ui.inverted.purple.basic.button:hover,.ui.inverted.purple.basic.buttons .button:hover,.ui.inverted.purple.buttons .basic.button:hover{background-color:rgba(173,66,127,.5)!important;box-shadow:inset 0 0 0 0 #d9499b!important;color:#fff!important}.ui.inverted.purple.basic.button:focus,.ui.inverted.purple.basic.buttons .button:focus{background-color:rgba(173,66,127,.5)!important;box-shadow:inset 0 0 0 0 #de3595!important;color:#fff!important}.ui.inverted.purple.basic.active.button,.ui.inverted.purple.basic.buttons .active.button,.ui.inverted.purple.buttons .basic.active.button{background-color:rgba(173,66,127,.2)!important;box-shadow:inset 0 0 0 0 #dd459c!important;color:#d864a6!important}.ui.inverted.purple.basic.button:active,.ui.inverted.purple.basic.buttons .button:active,.ui.inverted.purple.buttons .basic.button:active{background-color:rgba(173,66,127,.2)!important;box-shadow:inset 0 0 0 0 #ce3b8f!important;color:#d864a6!important}.ui.pink.button,.ui.pink.buttons .button{background-color:#e03997;color:#fff}.ui.basic.pink.button,.ui.basic.pink.buttons .button{box-shadow:inset 0 0 0 0 #e03997!important;color:#e03997!important}.ui.basic.pink.button:hover,.ui.basic.pink.buttons .button:hover{background:rgba(224,57,151,.2)!important;box-shadow:inset 0 0 0 0 #e61a8d!important;color:#e61a8d!important}.ui.basic.pink.button:focus,.ui.basic.pink.buttons .button:focus{background:rgba(224,57,151,.3)!important;box-shadow:inset 0 0 0 0 #e10f85!important;color:#e61a8d!important}.ui.basic.pink.active.button,.ui.basic.pink.buttons .active.button{background:rgba(199,31,126,.2)!important;box-shadow:inset 0 0 0 0 #ea158d!important;color:#c71f7e!important}.ui.basic.pink.button:active,.ui.basic.pink.buttons .button:active{box-shadow:inset 0 0 0 0 #c71f7e!important;color:#c71f7e!important}.ui.buttons:not(.vertical)>.basic.pink.button:not(:first-child){margin-left:0}.ui.inverted.pink.button,.ui.inverted.pink.buttons .button{background-color:#e03997;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.pink.button.active,.ui.inverted.pink.button:active,.ui.inverted.pink.button:focus,.ui.inverted.pink.button:hover,.ui.inverted.pink.buttons .button.active,.ui.inverted.pink.buttons .button:active,.ui.inverted.pink.buttons .button:focus,.ui.inverted.pink.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.pink.button:hover,.ui.inverted.pink.buttons .button:hover{background-color:#fc50b1}.ui.inverted.pink.button:focus,.ui.inverted.pink.buttons .button:focus{background-color:#ff3eab}.ui.inverted.pink.active.button,.ui.inverted.pink.buttons .active.button{background-color:#ff4db1}.ui.inverted.pink.button:active,.ui.inverted.pink.buttons .button:active{background-color:#f340a5}.ui.inverted.pink.basic.button,.ui.inverted.pink.basic.buttons .button,.ui.inverted.pink.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#f670bb!important}.ui.inverted.pink.basic.button:hover,.ui.inverted.pink.basic.buttons .button:hover,.ui.inverted.pink.buttons .basic.button:hover{background-color:rgba(224,57,151,.5)!important;box-shadow:inset 0 0 0 0 #fc50b1!important;color:#fff!important}.ui.inverted.pink.basic.button:focus,.ui.inverted.pink.basic.buttons .button:focus{background-color:rgba(224,57,151,.5)!important;box-shadow:inset 0 0 0 0 #ff3eab!important;color:#fff!important}.ui.inverted.pink.basic.active.button,.ui.inverted.pink.basic.buttons .active.button,.ui.inverted.pink.buttons .basic.active.button{background-color:rgba(224,57,151,.2)!important;box-shadow:inset 0 0 0 0 #ff4db1!important;color:#f670bb!important}.ui.inverted.pink.basic.button:active,.ui.inverted.pink.basic.buttons .button:active,.ui.inverted.pink.buttons .basic.button:active{background-color:rgba(224,57,151,.2)!important;box-shadow:inset 0 0 0 0 #f340a5!important;color:#f670bb!important}.ui.brown.button,.ui.brown.buttons .button{background-color:#a67a00;color:#fff}.ui.basic.brown.button,.ui.basic.brown.buttons .button{box-shadow:inset 0 0 0 0 #a67a00!important;color:#a67a00!important}.ui.basic.brown.button:hover,.ui.basic.brown.buttons .button:hover{background:rgba(166,122,0,.2)!important;box-shadow:inset 0 0 0 0 #8d6700!important;color:#8d6700!important}.ui.basic.brown.button:focus,.ui.basic.brown.buttons .button:focus{background:rgba(166,122,0,.3)!important;box-shadow:inset 0 0 0 0 #7d5c00!important;color:#8d6700!important}.ui.basic.brown.active.button,.ui.basic.brown.buttons .active.button{background:rgba(115,85,0,.2)!important;box-shadow:inset 0 0 0 0 #8d6700!important;color:#735500!important}.ui.basic.brown.button:active,.ui.basic.brown.buttons .button:active{box-shadow:inset 0 0 0 0 #735500!important;color:#735500!important}.ui.buttons:not(.vertical)>.basic.brown.button:not(:first-child){margin-left:0}.ui.inverted.brown.button,.ui.inverted.brown.buttons .button{background-color:#a67a00;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.brown.button.active,.ui.inverted.brown.button:active,.ui.inverted.brown.button:focus,.ui.inverted.brown.button:hover,.ui.inverted.brown.buttons .button.active,.ui.inverted.brown.buttons .button:active,.ui.inverted.brown.buttons .button:focus,.ui.inverted.brown.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.brown.button:hover,.ui.inverted.brown.buttons .button:hover{background-color:#d99f00}.ui.inverted.brown.button:focus,.ui.inverted.brown.buttons .button:focus{background-color:#ca9400}.ui.inverted.brown.active.button,.ui.inverted.brown.buttons .active.button{background-color:#d99f00}.ui.inverted.brown.button:active,.ui.inverted.brown.buttons .button:active{background-color:#c08d00}.ui.inverted.brown.basic.button,.ui.inverted.brown.basic.buttons .button,.ui.inverted.brown.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#f3b200!important}.ui.inverted.brown.basic.button:hover,.ui.inverted.brown.basic.buttons .button:hover,.ui.inverted.brown.buttons .basic.button:hover{background-color:rgba(166,122,0,.5)!important;box-shadow:inset 0 0 0 0 #d99f00!important;color:#fff!important}.ui.inverted.brown.basic.button:focus,.ui.inverted.brown.basic.buttons .button:focus{background-color:rgba(166,122,0,.5)!important;box-shadow:inset 0 0 0 0 #ca9400!important;color:#fff!important}.ui.inverted.brown.basic.active.button,.ui.inverted.brown.basic.buttons .active.button,.ui.inverted.brown.buttons .basic.active.button{background-color:rgba(166,122,0,.2)!important;box-shadow:inset 0 0 0 0 #d99f00!important;color:#f3b200!important}.ui.inverted.brown.basic.button:active,.ui.inverted.brown.basic.buttons .button:active,.ui.inverted.brown.buttons .basic.button:active{background-color:rgba(166,122,0,.2)!important;box-shadow:inset 0 0 0 0 #c08d00!important;color:#f3b200!important}.ui.grey.button,.ui.grey.buttons .button{background-color:#5a686d;color:#fff}.ui.basic.grey.button,.ui.basic.grey.buttons .button{box-shadow:inset 0 0 0 0 #5a686d!important;color:#5a686d!important}.ui.basic.grey.button:hover,.ui.basic.grey.buttons .button:hover{background:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #66757b!important;color:#66757b!important}.ui.basic.grey.button:focus,.ui.basic.grey.buttons .button:focus{background:rgba(90,104,109,.3)!important;box-shadow:inset 0 0 0 0 #6c7d83!important;color:#66757b!important}.ui.basic.grey.active.button,.ui.basic.grey.buttons .active.button{background:rgba(113,131,137,.2)!important;box-shadow:inset 0 0 0 0 #4e5b5f!important;color:#718389!important}.ui.basic.grey.button:active,.ui.basic.grey.buttons .button:active{box-shadow:inset 0 0 0 0 #718389!important;color:#718389!important}.ui.buttons:not(.vertical)>.basic.grey.button:not(:first-child){margin-left:0}.ui.inverted.grey.button,.ui.inverted.grey.buttons .button{background-color:#5a686d;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.grey.button.active,.ui.inverted.grey.button:active,.ui.inverted.grey.button:focus,.ui.inverted.grey.button:hover,.ui.inverted.grey.buttons .button.active,.ui.inverted.grey.buttons .button:active,.ui.inverted.grey.buttons .button:focus,.ui.inverted.grey.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.grey.button:hover,.ui.inverted.grey.buttons .button:hover{background-color:#70838a}.ui.inverted.grey.button:focus,.ui.inverted.grey.buttons .button:focus{background-color:#687c83}.ui.inverted.grey.active.button,.ui.inverted.grey.buttons .active.button{background-color:#6f848b}.ui.inverted.grey.button:active,.ui.inverted.grey.buttons .button:active{background-color:#66757b}.ui.inverted.grey.basic.button,.ui.inverted.grey.basic.buttons .button,.ui.inverted.grey.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#7f8f95!important}.ui.inverted.grey.basic.button:hover,.ui.inverted.grey.basic.buttons .button:hover,.ui.inverted.grey.buttons .basic.button:hover{background-color:rgba(90,104,109,.5)!important;box-shadow:inset 0 0 0 0 #70838a!important;color:#fff!important}.ui.inverted.grey.basic.button:focus,.ui.inverted.grey.basic.buttons .button:focus{background-color:rgba(90,104,109,.5)!important;box-shadow:inset 0 0 0 0 #687c83!important;color:#fff!important}.ui.inverted.grey.basic.active.button,.ui.inverted.grey.basic.buttons .active.button,.ui.inverted.grey.buttons .basic.active.button{background-color:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #6f848b!important;color:#7f8f95!important}.ui.inverted.grey.basic.button:active,.ui.inverted.grey.basic.buttons .button:active,.ui.inverted.grey.buttons .basic.button:active{background-color:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #66757b!important;color:#7f8f95!important}.ui.black.button,.ui.black.buttons .button{background-color:#1b1c1d;color:#fff}.ui.basic.black.button,.ui.basic.black.buttons .button{box-shadow:inset 0 0 0 0 #1b1c1d!important;color:#1b1c1d!important}.ui.basic.black.button:hover,.ui.basic.black.buttons .button:hover{background:rgba(27,28,29,.2)!important;box-shadow:inset 0 0 0 0 #27292a!important;color:#27292a!important}.ui.basic.black.button:focus,.ui.basic.black.buttons .button:focus{background:rgba(27,28,29,.3)!important;box-shadow:inset 0 0 0 0 #2f3032!important;color:#27292a!important}.ui.basic.black.active.button,.ui.basic.black.buttons .active.button{background:rgba(52,54,55,.2)!important;box-shadow:inset 0 0 0 0 #0f0f10!important;color:#343637!important}.ui.basic.black.button:active,.ui.basic.black.buttons .button:active{box-shadow:inset 0 0 0 0 #343637!important;color:#343637!important}.ui.buttons:not(.vertical)>.basic.black.button:not(:first-child){margin-left:0}.ui.inverted.black.button,.ui.inverted.black.buttons .button{background-color:#1b1c1d;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.black.button.active,.ui.inverted.black.button:active,.ui.inverted.black.button:focus,.ui.inverted.black.button:hover,.ui.inverted.black.buttons .button.active,.ui.inverted.black.buttons .button:active,.ui.inverted.black.buttons .button:focus,.ui.inverted.black.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.black.active.button,.ui.inverted.black.button:active,.ui.inverted.black.button:focus,.ui.inverted.black.button:hover,.ui.inverted.black.buttons .active.button,.ui.inverted.black.buttons .button:active,.ui.inverted.black.buttons .button:focus,.ui.inverted.black.buttons .button:hover{background-color:#000}.ui.inverted.black.basic.button,.ui.inverted.black.basic.buttons .button,.ui.inverted.black.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#545454!important}.ui.inverted.black.basic.button:focus,.ui.inverted.black.basic.button:hover,.ui.inverted.black.basic.buttons .button:focus,.ui.inverted.black.basic.buttons .button:hover,.ui.inverted.black.buttons .basic.button:hover{background-color:rgba(27,28,29,.5)!important;box-shadow:inset 0 0 0 0 #000!important;color:#fff!important}.ui.inverted.black.basic.active.button,.ui.inverted.black.basic.button:active,.ui.inverted.black.basic.buttons .active.button,.ui.inverted.black.basic.buttons .button:active,.ui.inverted.black.buttons .basic.active.button,.ui.inverted.black.buttons .basic.button:active{background-color:rgba(27,28,29,.2)!important;box-shadow:inset 0 0 0 0 #000!important;color:#545454!important}.ui.primary.button,.ui.primary.buttons .button{background-color:#007abf;color:#fff}.ui.basic.primary.button,.ui.basic.primary.buttons .button{box-shadow:inset 0 0 0 0 #007abf!important;color:#007abf!important}.ui.basic.primary.button:hover,.ui.basic.primary.buttons .button:hover{background:rgba(0,122,191,.2)!important;box-shadow:inset 0 0 0 0 #006aa6!important;color:#006aa6!important}.ui.basic.primary.button:focus,.ui.basic.primary.buttons .button:focus{background:rgba(0,122,191,.3)!important;box-shadow:inset 0 0 0 0 #006096!important;color:#006aa6!important}.ui.basic.primary.active.button,.ui.basic.primary.buttons .active.button{background:rgba(0,89,140,.2)!important;box-shadow:inset 0 0 0 0 #006aa6!important;color:#00598c!important}.ui.basic.primary.button:active,.ui.basic.primary.buttons .button:active{box-shadow:inset 0 0 0 0 #00598c!important;color:#00598c!important}.ui.buttons:not(.vertical)>.basic.primary.button:not(:first-child){margin-left:0}.ui.inverted.primary.button,.ui.inverted.primary.buttons .button{background-color:#007abf;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.primary.button.active,.ui.inverted.primary.button:active,.ui.inverted.primary.button:focus,.ui.inverted.primary.button:hover,.ui.inverted.primary.buttons .button.active,.ui.inverted.primary.buttons .button:active,.ui.inverted.primary.buttons .button:focus,.ui.inverted.primary.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.primary.button:hover,.ui.inverted.primary.buttons .button:hover{background-color:#006aa6}.ui.inverted.primary.button:focus,.ui.inverted.primary.buttons .button:focus{background-color:#006096}.ui.inverted.primary.active.button,.ui.inverted.primary.buttons .active.button{background-color:#006aa6}.ui.inverted.primary.button:active,.ui.inverted.primary.buttons .button:active{background-color:#00598c}.ui.inverted.primary.basic.button,.ui.inverted.primary.basic.buttons .button,.ui.inverted.primary.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#26b1ff!important}.ui.inverted.primary.basic.button:hover,.ui.inverted.primary.basic.buttons .button:hover,.ui.inverted.primary.buttons .basic.button:hover{background-color:rgba(0,122,191,.5)!important;box-shadow:inset 0 0 0 0 #006aa6!important;color:#fff!important}.ui.inverted.primary.basic.button:focus,.ui.inverted.primary.basic.buttons .button:focus{background-color:rgba(0,122,191,.5)!important;box-shadow:inset 0 0 0 0 #006096!important;color:#fff!important}.ui.inverted.primary.basic.active.button,.ui.inverted.primary.basic.buttons .active.button,.ui.inverted.primary.buttons .basic.active.button{background-color:rgba(0,122,191,.2)!important;box-shadow:inset 0 0 0 0 #006aa6!important;color:#26b1ff!important}.ui.inverted.primary.basic.button:active,.ui.inverted.primary.basic.buttons .button:active,.ui.inverted.primary.buttons .basic.button:active{background-color:rgba(0,122,191,.2)!important;box-shadow:inset 0 0 0 0 #00598c!important;color:#26b1ff!important}.ui.secondary.button,.ui.secondary.buttons .button{background-color:#5a686d;color:#fff}.ui.basic.secondary.button,.ui.basic.secondary.buttons .button{box-shadow:inset 0 0 0 0 #5a686d!important;color:#5a686d!important}.ui.basic.secondary.button:hover,.ui.basic.secondary.buttons .button:hover{background:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #64767c!important;color:#64767c!important}.ui.basic.secondary.button:focus,.ui.basic.secondary.buttons .button:focus{background:rgba(90,104,109,.3)!important;box-shadow:inset 0 0 0 0 #6a7e86!important;color:#64767c!important}.ui.basic.secondary.active.button,.ui.basic.secondary.buttons .active.button{background:rgba(113,131,137,.2)!important;box-shadow:inset 0 0 0 0 #64767d!important;color:#718389!important}.ui.basic.secondary.button:active,.ui.basic.secondary.buttons .button:active{box-shadow:inset 0 0 0 0 #718389!important;color:#718389!important}.ui.buttons:not(.vertical)>.basic.secondary.button:not(:first-child){margin-left:0}.ui.inverted.secondary.button,.ui.inverted.secondary.buttons .button{background-color:#5a686d;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.secondary.button.active,.ui.inverted.secondary.button:active,.ui.inverted.secondary.button:focus,.ui.inverted.secondary.button:hover,.ui.inverted.secondary.buttons .button.active,.ui.inverted.secondary.buttons .button:active,.ui.inverted.secondary.buttons .button:focus,.ui.inverted.secondary.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.secondary.button:hover,.ui.inverted.secondary.buttons .button:hover{background-color:#64767c}.ui.inverted.secondary.button:focus,.ui.inverted.secondary.buttons .button:focus{background-color:#6a7e86}.ui.inverted.secondary.active.button,.ui.inverted.secondary.buttons .active.button{background-color:#64767d}.ui.inverted.secondary.button:active,.ui.inverted.secondary.buttons .button:active{background-color:#718389}.ui.inverted.secondary.basic.button,.ui.inverted.secondary.basic.buttons .button,.ui.inverted.secondary.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#8d9ba0!important}.ui.inverted.secondary.basic.button:hover,.ui.inverted.secondary.basic.buttons .button:hover,.ui.inverted.secondary.buttons .basic.button:hover{background-color:rgba(90,104,109,.5)!important;box-shadow:inset 0 0 0 0 #64767c!important;color:#fff!important}.ui.inverted.secondary.basic.button:focus,.ui.inverted.secondary.basic.buttons .button:focus{background-color:rgba(90,104,109,.5)!important;box-shadow:inset 0 0 0 0 #6a7e86!important;color:#fff!important}.ui.inverted.secondary.basic.active.button,.ui.inverted.secondary.basic.buttons .active.button,.ui.inverted.secondary.buttons .basic.active.button{background-color:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #64767d!important;color:#8d9ba0!important}.ui.inverted.secondary.basic.button:active,.ui.inverted.secondary.basic.buttons .button:active,.ui.inverted.secondary.buttons .basic.button:active{background-color:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #718389!important;color:#8d9ba0!important}.ui.positive.button,.ui.positive.buttons .button{background-color:#4d9221;color:#fff}.ui.basic.positive.button,.ui.basic.positive.buttons .button{box-shadow:inset 0 0 0 0 #4d9221!important;color:#4d9221!important}.ui.basic.positive.button:hover,.ui.basic.positive.buttons .button:hover{background:rgba(77,146,33,.2)!important;box-shadow:inset 0 0 0 0 #418217!important;color:#418217!important}.ui.basic.positive.button:focus,.ui.basic.positive.buttons .button:focus{background:rgba(77,146,33,.3)!important;box-shadow:inset 0 0 0 0 #3a7911!important;color:#418217!important}.ui.basic.positive.active.button,.ui.basic.positive.buttons .active.button{background:rgba(55,104,24,.2)!important;box-shadow:inset 0 0 0 0 #408415!important;color:#376818!important}.ui.basic.positive.button:active,.ui.basic.positive.buttons .button:active{box-shadow:inset 0 0 0 0 #376818!important;color:#376818!important}.ui.buttons:not(.vertical)>.basic.positive.button:not(:first-child){margin-left:0}.ui.inverted.positive.button,.ui.inverted.positive.buttons .button{background-color:#4d9221;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.positive.button.active,.ui.inverted.positive.button:active,.ui.inverted.positive.button:focus,.ui.inverted.positive.button:hover,.ui.inverted.positive.buttons .button.active,.ui.inverted.positive.buttons .button:active,.ui.inverted.positive.buttons .button:focus,.ui.inverted.positive.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.positive.button:hover,.ui.inverted.positive.buttons .button:hover{background-color:#418217}.ui.inverted.positive.button:focus,.ui.inverted.positive.buttons .button:focus{background-color:#3a7911}.ui.inverted.positive.active.button,.ui.inverted.positive.buttons .active.button{background-color:#408415}.ui.inverted.positive.button:active,.ui.inverted.positive.buttons .button:active{background-color:#376818}.ui.inverted.positive.basic.button,.ui.inverted.positive.basic.buttons .button,.ui.inverted.positive.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#4d9221!important}.ui.inverted.positive.basic.button:hover,.ui.inverted.positive.basic.buttons .button:hover,.ui.inverted.positive.buttons .basic.button:hover{background-color:rgba(77,146,33,.5)!important;box-shadow:inset 0 0 0 0 #418217!important;color:#fff!important}.ui.inverted.positive.basic.button:focus,.ui.inverted.positive.basic.buttons .button:focus{background-color:rgba(77,146,33,.5)!important;box-shadow:inset 0 0 0 0 #3a7911!important;color:#fff!important}.ui.inverted.positive.basic.active.button,.ui.inverted.positive.basic.buttons .active.button,.ui.inverted.positive.buttons .basic.active.button{background-color:rgba(77,146,33,.2)!important;box-shadow:inset 0 0 0 0 #408415!important;color:#4d9221!important}.ui.inverted.positive.basic.button:active,.ui.inverted.positive.basic.buttons .button:active,.ui.inverted.positive.buttons .basic.button:active{background-color:rgba(77,146,33,.2)!important;box-shadow:inset 0 0 0 0 #376818!important;color:#4d9221!important}.ui.negative.button,.ui.negative.buttons .button{background-color:#c51b7d;color:#fff}.ui.basic.negative.button,.ui.basic.negative.buttons .button{box-shadow:inset 0 0 0 0 #c51b7d!important;color:#c51b7d!important}.ui.basic.negative.button:hover,.ui.basic.negative.buttons .button:hover{background:rgba(197,27,125,.2)!important;box-shadow:inset 0 0 0 0 #b61070!important;color:#b61070!important}.ui.basic.negative.button:focus,.ui.basic.negative.buttons .button:focus{background:rgba(197,27,125,.3)!important;box-shadow:inset 0 0 0 0 #af0868!important;color:#b61070!important}.ui.basic.negative.active.button,.ui.basic.negative.buttons .active.button{background:rgba(152,21,97,.2)!important;box-shadow:inset 0 0 0 0 #ba0d70!important;color:#981561!important}.ui.basic.negative.button:active,.ui.basic.negative.buttons .button:active{box-shadow:inset 0 0 0 0 #981561!important;color:#981561!important}.ui.buttons:not(.vertical)>.basic.negative.button:not(:first-child){margin-left:0}.ui.inverted.negative.button,.ui.inverted.negative.buttons .button{background-color:#c51b7d;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.negative.button.active,.ui.inverted.negative.button:active,.ui.inverted.negative.button:focus,.ui.inverted.negative.button:hover,.ui.inverted.negative.buttons .button.active,.ui.inverted.negative.buttons .button:active,.ui.inverted.negative.buttons .button:focus,.ui.inverted.negative.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.negative.button:hover,.ui.inverted.negative.buttons .button:hover{background-color:#b61070}.ui.inverted.negative.button:focus,.ui.inverted.negative.buttons .button:focus{background-color:#af0868}.ui.inverted.negative.active.button,.ui.inverted.negative.buttons .active.button{background-color:#ba0d70}.ui.inverted.negative.button:active,.ui.inverted.negative.buttons .button:active{background-color:#981561}.ui.inverted.negative.basic.button,.ui.inverted.negative.basic.buttons .button,.ui.inverted.negative.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#c51b7d!important}.ui.inverted.negative.basic.button:hover,.ui.inverted.negative.basic.buttons .button:hover,.ui.inverted.negative.buttons .basic.button:hover{background-color:rgba(197,27,125,.5)!important;box-shadow:inset 0 0 0 0 #b61070!important;color:#fff!important}.ui.inverted.negative.basic.button:focus,.ui.inverted.negative.basic.buttons .button:focus{background-color:rgba(197,27,125,.5)!important;box-shadow:inset 0 0 0 0 #af0868!important;color:#fff!important}.ui.inverted.negative.basic.active.button,.ui.inverted.negative.basic.buttons .active.button,.ui.inverted.negative.buttons .basic.active.button{background-color:rgba(197,27,125,.2)!important;box-shadow:inset 0 0 0 0 #ba0d70!important;color:#c51b7d!important}.ui.inverted.negative.basic.button:active,.ui.inverted.negative.basic.buttons .button:active,.ui.inverted.negative.buttons .basic.button:active{background-color:rgba(197,27,125,.2)!important;box-shadow:inset 0 0 0 0 #981561!important;color:#c51b7d!important}", ""]);
	
	// exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Item\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.card,.ui.cards>.card{max-width:100%;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:290px;min-height:0;background:hsla(0,0%,100%,.85);padding:0;border:none;border-radius:0;box-shadow:none;transition:box-shadow .1s ease,transform .1s ease;transition:box-shadow .1s ease,transform .1s ease,-webkit-transform .1s ease;z-index:\"\"}.ui.card{margin:1em 0}.ui.card a,.ui.cards>.card a{cursor:pointer}.ui.card:first-child{margin-top:0}.ui.card:last-child{margin-bottom:0}.ui.cards{margin:-.875em -.5em;-ms-flex-wrap:wrap;flex-wrap:wrap}.ui.cards,.ui.cards>.card{display:-webkit-box;display:-ms-flexbox;display:flex}.ui.cards>.card{margin:.875em .5em;float:none}.ui.card:after,.ui.cards:after{display:block;content:\" \";height:0;clear:both;overflow:hidden;visibility:hidden}.ui.cards~.ui.cards{margin-top:.875em}.ui.card>:first-child,.ui.cards>.card>:first-child{border-radius:0 0 0 0!important;border-top:none!important}.ui.card>:last-child,.ui.cards>.card>:last-child{border-radius:0 0 0 0!important}.ui.card>:only-child,.ui.cards>.card>:only-child{border-radius:0!important}.ui.card>.image,.ui.cards>.card>.image{position:relative;display:block;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding:0;background:rgba(0,0,0,.05)}.ui.card>.image>img,.ui.cards>.card>.image>img{display:block;width:100%;height:auto;border-radius:inherit}.ui.card>.image:not(.ui)>img,.ui.cards>.card>.image:not(.ui)>img{border:none}.ui.card>.content,.ui.cards>.card>.content{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;border:none;border-top:0 solid rgba(34,36,38,.1);background:none;margin:0;padding:1em;box-shadow:none;font-size:1em;border-radius:0}.ui.card>.content:after,.ui.cards>.card>.content:after{display:block;content:\" \";height:0;clear:both;overflow:hidden;visibility:hidden}.ui.card>.content>.header,.ui.cards>.card>.content>.header{display:block;margin:\"\";font-family:Publico Headline,Georgia,serif;color:rgba(0,0,0,.85)}.ui.card>.content>.header:not(.ui),.ui.cards>.card>.content>.header:not(.ui){font-weight:500;font-size:1.35294118em;margin-top:-.22em;line-height:1.05em}.ui.card>.content>.header+.description,.ui.card>.content>.meta+.description,.ui.cards>.card>.content>.header+.description,.ui.cards>.card>.content>.meta+.description{margin-top:.5em}.ui.card [class*=\"left floated\"],.ui.cards>.card [class*=\"left floated\"]{float:left}.ui.card [class*=\"right floated\"],.ui.cards>.card [class*=\"right floated\"]{float:right}.ui.card [class*=\"left aligned\"],.ui.cards>.card [class*=\"left aligned\"]{text-align:left}.ui.card [class*=\"center aligned\"],.ui.cards>.card [class*=\"center aligned\"]{text-align:center}.ui.card [class*=\"right aligned\"],.ui.cards>.card [class*=\"right aligned\"]{text-align:right}.ui.card .content img,.ui.cards>.card .content img{display:inline-block;vertical-align:middle;width:\"\"}.ui.card .avatar img,.ui.card img.avatar,.ui.cards>.card .avatar img,.ui.cards>.card img.avatar{width:2em;height:2em;border-radius:500rem}.ui.card>.content>.description,.ui.cards>.card>.content>.description{clear:both;color:rgba(0,0,0,.68)}.ui.card>.content p,.ui.cards>.card>.content p{margin:0 0 .5em}.ui.card>.content p:last-child,.ui.cards>.card>.content p:last-child{margin-bottom:0}.ui.card .meta,.ui.cards>.card .meta{font-size:1em;color:rgba(0,0,0,.4)}.ui.card .meta *,.ui.cards>.card .meta *{margin-right:.3em}.ui.card .meta :last-child,.ui.cards>.card .meta :last-child{margin-right:0}.ui.card .meta [class*=\"right floated\"],.ui.cards>.card .meta [class*=\"right floated\"]{margin-right:0;margin-left:.3em}.ui.card>.content a:not(.ui),.ui.cards>.card>.content a:not(.ui){color:\"\";transition:color .1s ease}.ui.card>.content a:not(.ui):hover,.ui.cards>.card>.content a:not(.ui):hover{color:\"\"}.ui.card>.content>a.header,.ui.cards>.card>.content>a.header{color:rgba(0,0,0,.85)}.ui.card>.content>a.header:hover,.ui.cards>.card>.content>a.header:hover{color:#00598c}.ui.card .meta>a:not(.ui),.ui.cards>.card .meta>a:not(.ui){color:rgba(0,0,0,.4)}.ui.card .meta>a:not(.ui):hover,.ui.cards>.card .meta>a:not(.ui):hover{color:rgba(0,0,0,.87)}.ui.card>.button,.ui.card>.buttons,.ui.cards>.card>.button,.ui.cards>.card>.buttons{margin:0;width:100%}.ui.card .dimmer,.ui.cards>.card .dimmer{background-color:\"\";z-index:10}.ui.card>.content .star.icon,.ui.cards>.card>.content .star.icon{cursor:pointer;opacity:.75;transition:color .1s ease}.ui.card>.content .star.icon:hover,.ui.cards>.card>.content .star.icon:hover{opacity:1;color:#ffb70a}.ui.card>.content .active.star.icon,.ui.cards>.card>.content .active.star.icon{color:#ffe623}.ui.card>.content .like.icon,.ui.cards>.card>.content .like.icon{cursor:pointer;opacity:.75;transition:color .1s ease}.ui.card>.content .like.icon:hover,.ui.cards>.card>.content .like.icon:hover{opacity:1;color:#ff2733}.ui.card>.content .active.like.icon,.ui.cards>.card>.content .active.like.icon{color:#ff2733}.ui.card>.extra,.ui.cards>.card>.extra{max-width:100%;min-height:0!important;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;border-top:none!important;position:static;background:none;width:auto;margin:0;padding:.75em 1em;top:0;left:0;color:rgba(0,0,0,.4);box-shadow:none;transition:color .1s ease}.ui.card>.extra a:not(.ui),.ui.cards>.card>.extra a:not(.ui){color:rgba(0,0,0,.4)}.ui.card>.extra a:not(.ui):hover,.ui.cards>.card>.extra a:not(.ui):hover{color:#00598c}.ui.link.cards .raised.card:hover,.ui.link.raised.card:hover,.ui.raised.cards a.card:hover,a.ui.raised.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 2px 4px 0 rgba(34,36,38,.15),0 2px 10px 0 rgba(34,36,38,.25)}.ui.raised.card,.ui.raised.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 2px 4px 0 rgba(0,0,0,.15),0 2px 10px 0 rgba(0,0,0,.1)}.ui.centered.cards{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ui.centered.card{margin-left:auto;margin-right:auto}.ui.fluid.card{width:100%;max-width:9999px}.ui.cards a.card,.ui.link.card,.ui.link.cards .card,a.ui.card{-webkit-transform:none;transform:none}.ui.cards a.card:hover,.ui.link.card:hover,.ui.link.cards .card:hover,a.ui.card:hover{cursor:pointer;z-index:5;background:\"\";border:none;box-shadow:0 1px 3px 0 rgba(0,0,0,.3),0 0 0 0 #d4d4d5;-webkit-transform:translateY(-3px);transform:translateY(-3px)}.ui.cards>.red.card,.ui.red.card,.ui.red.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #e23c4e,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.red.card:hover,.ui.red.card:hover,.ui.red.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #e81d33,0 1px 3px 0 rgba(0,0,0,.3)}.ui.cards>.orange.card,.ui.orange.card,.ui.orange.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #f8813d,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.orange.card:hover,.ui.orange.card:hover,.ui.orange.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #ff6f1c,0 1px 3px 0 rgba(0,0,0,.3)}.ui.cards>.yellow.card,.ui.yellow.card,.ui.yellow.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #ffca18,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.yellow.card:hover,.ui.yellow.card:hover,.ui.yellow.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #fec300,0 1px 3px 0 rgba(0,0,0,.3)}.ui.cards>.olive.card,.ui.olive.card,.ui.olive.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #456558,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.olive.card:hover,.ui.olive.card:hover,.ui.olive.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #39574b,0 1px 3px 0 rgba(0,0,0,.3)}.ui.cards>.green.card,.ui.green.card,.ui.green.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #54af71,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.green.card:hover,.ui.green.card:hover,.ui.green.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #46a364,0 1px 3px 0 rgba(0,0,0,.3)}.ui.cards>.teal.card,.ui.teal.card,.ui.teal.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #00a1ca,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.teal.card:hover,.ui.teal.card:hover,.ui.teal.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #008db1,0 1px 3px 0 rgba(0,0,0,.3)}.ui.blue.card,.ui.blue.cards>.card,.ui.cards>.blue.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #1d5f82,0 1px 3px 0 rgba(0,0,0,.15)}.ui.blue.card:hover,.ui.blue.cards>.card:hover,.ui.cards>.blue.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #145171,0 1px 3px 0 rgba(0,0,0,.3)}.ui.cards>.violet.card,.ui.violet.card,.ui.violet.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #525394,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.violet.card:hover,.ui.violet.card:hover,.ui.violet.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #464787,0 1px 3px 0 rgba(0,0,0,.3)}.ui.cards>.purple.card,.ui.purple.card,.ui.purple.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #ad427f,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.purple.card:hover,.ui.purple.card:hover,.ui.purple.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #9f3672,0 1px 3px 0 rgba(0,0,0,.3)}.ui.cards>.pink.card,.ui.pink.card,.ui.pink.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #e03997,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.pink.card:hover,.ui.pink.card:hover,.ui.pink.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #e61a8d,0 1px 3px 0 rgba(0,0,0,.3)}.ui.brown.card,.ui.brown.cards>.card,.ui.cards>.brown.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #a67a00,0 1px 3px 0 rgba(0,0,0,.15)}.ui.brown.card:hover,.ui.brown.cards>.card:hover,.ui.cards>.brown.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #8d6700,0 1px 3px 0 rgba(0,0,0,.3)}.ui.cards>.grey.card,.ui.grey.card,.ui.grey.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #5a686d,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.grey.card:hover,.ui.grey.card:hover,.ui.grey.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #66757b,0 1px 3px 0 rgba(0,0,0,.3)}.ui.black.card,.ui.black.cards>.card,.ui.cards>.black.card{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #1b1c1d,0 1px 3px 0 rgba(0,0,0,.15)}.ui.black.card:hover,.ui.black.cards>.card:hover,.ui.cards>.black.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 -2px 0 0 #27292a,0 1px 3px 0 rgba(0,0,0,.3)}.ui.one.cards{margin-left:0;margin-right:0}.ui.one.cards>.card{width:100%}.ui.two.cards{margin-left:-1em;margin-right:-1em}.ui.two.cards>.card{width:calc(50% - 2em);margin-left:1em;margin-right:1em}.ui.three.cards{margin-left:-1em;margin-right:-1em}.ui.three.cards>.card{width:calc(33.33333333% - 2em);margin-left:1em;margin-right:1em}.ui.four.cards{margin-left:-.75em;margin-right:-.75em}.ui.four.cards>.card{width:calc(25% - 1.5em);margin-left:.75em;margin-right:.75em}.ui.five.cards{margin-left:-.75em;margin-right:-.75em}.ui.five.cards>.card{width:calc(20% - 1.5em);margin-left:.75em;margin-right:.75em}.ui.six.cards{margin-left:-.75em;margin-right:-.75em}.ui.six.cards>.card{width:calc(16.66666667% - 1.5em);margin-left:.75em;margin-right:.75em}.ui.seven.cards{margin-left:-.5em;margin-right:-.5em}.ui.seven.cards>.card{width:calc(14.28571429% - 1em);margin-left:.5em;margin-right:.5em}.ui.eight.cards{margin-left:-.5em;margin-right:-.5em}.ui.eight.cards>.card{width:calc(12.5% - 1em);margin-left:.5em;margin-right:.5em;font-size:11px}.ui.nine.cards{margin-left:-.5em;margin-right:-.5em}.ui.nine.cards>.card{width:calc(11.11111111% - 1em);margin-left:.5em;margin-right:.5em;font-size:10px}.ui.ten.cards{margin-left:-.5em;margin-right:-.5em}.ui.ten.cards>.card{width:calc(10% - 1em);margin-left:.5em;margin-right:.5em}@media only screen and (max-width:599px){.ui.two.doubling.cards{margin-left:0;margin-right:0}.ui.two.doubling.cards>.card{width:100%;margin-left:0;margin-right:0}.ui.three.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.three.doubling.cards>.card{width:calc(50% - 2em);margin-left:1em;margin-right:1em}.ui.four.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.four.doubling.cards>.card{width:calc(50% - 2em);margin-left:1em;margin-right:1em}.ui.five.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.five.doubling.cards>.card{width:calc(50% - 2em);margin-left:1em;margin-right:1em}.ui.six.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.six.doubling.cards>.card{width:calc(50% - 2em);margin-left:1em;margin-right:1em}.ui.seven.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.seven.doubling.cards>.card{width:calc(33.33333333% - 2em);margin-left:1em;margin-right:1em}.ui.eight.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.eight.doubling.cards>.card{width:calc(33.33333333% - 2em);margin-left:1em;margin-right:1em}.ui.nine.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.nine.doubling.cards>.card{width:calc(33.33333333% - 2em);margin-left:1em;margin-right:1em}.ui.ten.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.ten.doubling.cards>.card{width:calc(33.33333333% - 2em);margin-left:1em;margin-right:1em}}@media only screen and (min-width:600px) and (max-width:899px){.ui.two.doubling.cards{margin-left:0;margin-right:0}.ui.two.doubling.cards>.card{width:100%;margin-left:0;margin-right:0}.ui.three.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.three.doubling.cards>.card{width:calc(50% - 2em);margin-left:1em;margin-right:1em}.ui.four.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.four.doubling.cards>.card{width:calc(50% - 2em);margin-left:1em;margin-right:1em}.ui.five.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.five.doubling.cards>.card{width:calc(33.33333333% - 2em);margin-left:1em;margin-right:1em}.ui.six.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.six.doubling.cards>.card{width:calc(33.33333333% - 2em);margin-left:1em;margin-right:1em}.ui.eight.doubling.cards{margin-left:-1em;margin-right:-1em}.ui.eight.doubling.cards>.card{width:calc(33.33333333% - 2em);margin-left:1em;margin-right:1em}.ui.eight.doubling.cards{margin-left:-.75em;margin-right:-.75em}.ui.eight.doubling.cards>.card{width:calc(25% - 1.5em);margin-left:.75em;margin-right:.75em}.ui.nine.doubling.cards{margin-left:-.75em;margin-right:-.75em}.ui.nine.doubling.cards>.card{width:calc(25% - 1.5em);margin-left:.75em;margin-right:.75em}.ui.ten.doubling.cards{margin-left:-.75em;margin-right:-.75em}.ui.ten.doubling.cards>.card{width:calc(20% - 1.5em);margin-left:.75em;margin-right:.75em}}@media only screen and (max-width:599px){.ui.stackable.cards{display:block!important}.ui.stackable.cards .card:first-child{margin-top:0!important}.ui.stackable.cards>.card{display:block!important;height:auto!important;margin:1em;padding:0!important;width:calc(100% - 2em)!important}}.ui.cards>.card{font-size:1em}.text .ui.card,.text .ui.cards .card,.ui.text.card,.ui.text.cards .card{font-family:Georgia,serif}.infographic .ui.card,.infographic .ui.cards .card,.ui.infographic.card,.ui.infographic.cards .card{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.infographic .ui.card>.content>.header:not(.ui),.infographic .ui.cards .card>.content>.header:not(.ui),.ui.infographic.card>.content>.header:not(.ui),.ui.infographic.cards .card>.content>.header:not(.ui){font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;font-weight:700}.ui.card .meta,.ui.card>.extra,.ui.cards>.card .meta,.ui.cards>.card>.extra{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.ui.cards>.inverted.card,.ui.inverted.card,.ui.inverted.cards>.card{background-color:rgba(0,0,0,.85);color:#fff}.ui.cards>.inverted.card>.content>.header,.ui.inverted.card>.content>.header,.ui.inverted.cards>.card>.content>.header{color:hsla(0,0%,100%,.9)}.ui.cards>.inverted.card>.content>.description,.ui.inverted.card>.content>.description,.ui.inverted.cards>.card>.content>.description{color:hsla(0,0%,100%,.8)}.ui.cards>.inverted.card>.content>a.header,.ui.inverted.card>.content>a.header,.ui.inverted.cards>.card>.content>a.header{color:hsla(0,0%,100%,.9)}.ui.cards>.inverted.card>.content>a.header:hover,.ui.inverted.card>.content>a.header:hover,.ui.inverted.cards>.card>.content>a.header:hover{color:#68c9ff}.ui.cards>.inverted.card .meta,.ui.cards>.inverted.card .meta>a:not(.ui),.ui.inverted.card .meta,.ui.inverted.card .meta>a:not(.ui),.ui.inverted.cards>.card .meta,.ui.inverted.cards>.card .meta>a:not(.ui){color:hsla(0,0%,100%,.7)}.ui.cards>.inverted.card .meta>a:not(.ui):hover,.ui.inverted.card .meta>a:not(.ui):hover,.ui.inverted.cards>.card .meta>a:not(.ui):hover{color:hsla(0,0%,100%,.9)}.ui.cards>.inverted.card>.extra,.ui.inverted.card>.extra,.ui.inverted.cards>.card>.extra{color:hsla(0,0%,100%,.7)}.ui.cards>.inverted.card>.extra a:not(.ui),.ui.inverted.card>.extra a:not(.ui),.ui.inverted.cards>.card>.extra a:not(.ui){color:hsla(0,0%,100%,.5)}.ui.cards>.inverted.card>.extra a:not(.ui):hover,.ui.inverted.card>.extra a:not(.ui):hover,.ui.inverted.cards>.card>.extra a:not(.ui):hover{color:#68c9ff}.ui.cards>.inverted.blue.card,.ui.inverted.blue.card,.ui.inverted.blue.cards>.card{background-color:#1d5f82}.ui.cards>.inverted.blue.card>.content>a.header:hover,.ui.cards>.inverted.blue.card>.extra a:not(.ui):hover,.ui.inverted.blue.card>.content>a.header:hover,.ui.inverted.blue.card>.extra a:not(.ui):hover,.ui.inverted.blue.cards>.card>.content>a.header:hover,.ui.inverted.blue.cards>.card>.extra a:not(.ui):hover{color:#c7d2df}.ui.cards>.inverted.grey.card,.ui.inverted.grey.card,.ui.inverted.grey.cards>.card{background-color:#5a686d}.ui.cards>.shadowed.card,.ui.shadowed.card,.ui.shadowed.cards>.card{box-shadow:0 0 0 0 #d4d4d5,0 1px 3px 0 rgba(0,0,0,.15)}.ui.cards>.shadowed.card:hover,.ui.shadowed.card:hover,.ui.shadowed.cards>.card:hover{box-shadow:0 0 0 0 #d4d4d5,0 1px 3px 0 rgba(0,0,0,.3)}", ""]);
	
	// exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Container\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.container{display:block;max-width:100%!important}@media only screen and (max-width:599px){.ui.container{margin-left:13px!important;margin-right:13px!important}.ui.container,.ui.grid.container,.ui.relaxed.grid.container,.ui.very.relaxed.grid.container{width:auto!important}}@media only screen and (min-width:600px) and (max-width:899px){.ui.container{width:calc(100% - 34px - 17px);margin-left:auto!important;margin-right:auto!important}.ui.grid.container{width:calc((100% - 34px - 17px) + 2rem)!important}.ui.relaxed.grid.container{width:calc((100% - 34px - 17px) + 3rem)!important}.ui.very.relaxed.grid.container{width:calc((100% - 34px - 17px) + 5rem)!important}}@media only screen and (min-width:900px) and (max-width:1199px){.ui.container{width:calc(100% - 51px - 17px);margin-left:auto!important;margin-right:auto!important}.ui.grid.container{width:calc((100% - 51px - 17px) + 2rem)!important}.ui.relaxed.grid.container{width:calc((100% - 51px - 17px) + 3rem)!important}.ui.very.relaxed.grid.container{width:calc((100% - 51px - 17px) + 5rem)!important}}@media only screen and (min-width:1200px){.ui.container{width:1115px;margin-left:auto!important;margin-right:auto!important}.ui.grid.container{width:calc(1115px + 2rem)!important}.ui.relaxed.grid.container{width:calc(1115px + 3rem)!important}.ui.very.relaxed.grid.container{width:calc(1115px + 5rem)!important}}.ui.text.container{font-family:Georgia,serif;max-width:581px!important;line-height:1.5;font-size:1rem}.ui.fluid.container{width:100%}.ui[class*=\"left aligned\"].container{text-align:left}.ui[class*=\"center aligned\"].container{text-align:center}.ui[class*=\"right aligned\"].container{text-align:right}.ui.justified.container{text-align:justify;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}.ui.infographic.infographic.container{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}@media only screen and (min-width:600px){.ui.text.container{margin-right:auto!important;margin-left:auto!important}}", ""]);
	
	// exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Divider\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.divider{margin:1rem 0;line-height:1;height:0;font-weight:700;text-transform:inherit;letter-spacing:0;color:rgba(0,0,0,.85);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.ui.divider:not(.vertical):not(.horizontal){border-top:1px solid rgba(34,36,38,.15);border-bottom:1px solid hsla(0,0%,100%,.1)}.ui.grid>.column+.divider,.ui.grid>.row>.column+.divider{left:auto}.ui.horizontal.divider{display:table;white-space:nowrap;height:auto;margin:\"\";line-height:1;text-align:center}.ui.horizontal.divider:after,.ui.horizontal.divider:before{content:\"\";display:table-cell;position:relative;top:50%;width:50%;background-repeat:no-repeat}.ui.horizontal.divider:before{background-position:right 1em top 50%}.ui.horizontal.divider:after{background-position:left 1em top 50%}.ui.vertical.divider{position:absolute;z-index:2;top:50%;left:50%;margin:0;padding:0;width:auto;height:50%;line-height:0;text-align:center;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.ui.vertical.divider:after,.ui.vertical.divider:before{position:absolute;left:50%;content:\"\";z-index:3;border-left:1px solid rgba(34,36,38,.15);border-right:1px solid hsla(0,0%,100%,.1);width:0;height:calc(100% - 1rem)}.ui.vertical.divider:before{top:-100%}.ui.vertical.divider:after{top:auto;bottom:0}@media only screen and (max-width:599px){.ui.grid .stackable.row .ui.vertical.divider,.ui.stackable.grid .ui.vertical.divider{display:table;white-space:nowrap;height:auto;margin:\"\";overflow:hidden;line-height:1;text-align:center;position:static;top:0;left:0;-webkit-transform:none;transform:none}.ui.grid .stackable.row .ui.vertical.divider:after,.ui.grid .stackable.row .ui.vertical.divider:before,.ui.stackable.grid .ui.vertical.divider:after,.ui.stackable.grid .ui.vertical.divider:before{position:static;left:0;border-left:none;border-right:none;content:\"\";display:table-cell;position:relative;top:50%;width:50%;background-repeat:no-repeat}.ui.grid .stackable.row .ui.vertical.divider:before,.ui.stackable.grid .ui.vertical.divider:before{background-position:right 1em top 50%}.ui.grid .stackable.row .ui.vertical.divider:after,.ui.stackable.grid .ui.vertical.divider:after{background-position:left 1em top 50%}}.ui.divider>.icon{margin:0;font-size:1rem;height:1em;vertical-align:middle}.ui.hidden.divider{border-color:transparent!important}.ui.hidden.divider:after,.ui.hidden.divider:before{display:none}.ui.divider.inverted,.ui.horizontal.inverted.divider,.ui.vertical.inverted.divider{color:#fff}.ui.divider.inverted,.ui.divider.inverted:after,.ui.divider.inverted:before{border-top-color:rgba(34,36,38,.15)!important;border-left-color:rgba(34,36,38,.15)!important;border-bottom-color:hsla(0,0%,100%,.15)!important;border-right-color:hsla(0,0%,100%,.15)!important}.ui.fitted.divider{margin:0}.ui.clearing.divider{clear:both}.ui.section.divider{margin-top:2rem;margin-bottom:2rem}.ui.divider{font-size:1rem}.ui.horizontal.divider:after,.ui.horizontal.divider:before{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC\")}@media only screen and (max-width:599px){.ui.grid .stackable.row .ui.vertical.divider:after,.ui.grid .stackable.row .ui.vertical.divider:before,.ui.stackable.grid .ui.vertical.divider:after,.ui.stackable.grid .ui.vertical.divider:before{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC\")}}.ui.divider.header,h1.ui.divider,h2.ui.divider,h3.ui.divider,h4.ui.divider,h5.ui.divider{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Grid\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.grid{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;padding:0;margin:-1rem}.ui.relaxed.grid{margin-left:-1.5rem;margin-right:-1.5rem}.ui[class*=\"very relaxed\"].grid{margin-left:-2.5rem;margin-right:-2.5rem}.ui.grid+.grid{margin-top:1rem}.ui.grid>.column:not(.row),.ui.grid>.row>.column{position:relative;display:inline-block;width:6.25%;padding-left:1rem;padding-right:1rem;vertical-align:top}.ui.grid>*{padding-left:1rem;padding-right:1rem}.ui.grid>.row{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:inherit;-ms-flex-pack:inherit;justify-content:inherit;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;width:100%!important;padding:0;padding-top:1rem;padding-bottom:1rem}.ui.grid>.column:not(.row){padding-top:1rem;padding-bottom:1rem}.ui.grid>.row>.column{margin-top:0;margin-bottom:0}.ui.grid>.row>.column>img,.ui.grid>.row>img{max-width:100%}.ui.grid>.ui.grid:first-child{margin-top:0}.ui.grid>.ui.grid:last-child{margin-bottom:0}.ui.aligned.grid .column>.segment:not(.compact):not(.attached),.ui.grid .aligned.row>.column>.segment:not(.compact):not(.attached){width:100%}.ui.grid .row+.ui.divider{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:1rem}.ui.grid .column+.ui.vertical.divider{height:calc(50% - 1rem)}.ui.grid>.column:last-child>.horizontal.segment,.ui.grid>.row>.column:last-child>.horizontal.segment{box-shadow:none}@media only screen and (max-width:599px){.ui.page.grid{width:auto;padding-left:0;padding-right:0;margin-left:0;margin-right:0}}@media only screen and (min-width:600px) and (max-width:899px){.ui.page.grid{width:auto;margin-left:0;margin-right:0;padding-left:2em;padding-right:2em}}@media only screen and (min-width:900px) and (max-width:1199px){.ui.page.grid{width:auto;margin-left:0;margin-right:0;padding-left:3%;padding-right:3%}}@media only screen and (min-width:1200px) and (max-width:1799px){.ui.page.grid{width:auto;margin-left:0;margin-right:0;padding-left:15%;padding-right:15%}}@media only screen and (min-width:1800px){.ui.page.grid{width:auto;margin-left:0;margin-right:0;padding-left:23%;padding-right:23%}}.ui.grid>.column:only-child,.ui.grid>.row>.column:only-child,.ui[class*=\"one column\"].grid>.column:not(.row),.ui[class*=\"one column\"].grid>.row>.column{width:100%}.ui[class*=\"two column\"].grid>.column:not(.row),.ui[class*=\"two column\"].grid>.row>.column{width:50%}.ui[class*=\"three column\"].grid>.column:not(.row),.ui[class*=\"three column\"].grid>.row>.column{width:33.33333333%}.ui[class*=\"four column\"].grid>.column:not(.row),.ui[class*=\"four column\"].grid>.row>.column{width:25%}.ui[class*=\"five column\"].grid>.column:not(.row),.ui[class*=\"five column\"].grid>.row>.column{width:20%}.ui[class*=\"six column\"].grid>.column:not(.row),.ui[class*=\"six column\"].grid>.row>.column{width:16.66666667%}.ui[class*=\"seven column\"].grid>.column:not(.row),.ui[class*=\"seven column\"].grid>.row>.column{width:14.28571429%}.ui[class*=\"eight column\"].grid>.column:not(.row),.ui[class*=\"eight column\"].grid>.row>.column{width:12.5%}.ui[class*=\"nine column\"].grid>.column:not(.row),.ui[class*=\"nine column\"].grid>.row>.column{width:11.11111111%}.ui[class*=\"ten column\"].grid>.column:not(.row),.ui[class*=\"ten column\"].grid>.row>.column{width:10%}.ui[class*=\"eleven column\"].grid>.column:not(.row),.ui[class*=\"eleven column\"].grid>.row>.column{width:9.09090909%}.ui[class*=\"twelve column\"].grid>.column:not(.row),.ui[class*=\"twelve column\"].grid>.row>.column{width:8.33333333%}.ui[class*=\"thirteen column\"].grid>.column:not(.row),.ui[class*=\"thirteen column\"].grid>.row>.column{width:7.69230769%}.ui[class*=\"fourteen column\"].grid>.column:not(.row),.ui[class*=\"fourteen column\"].grid>.row>.column{width:7.14285714%}.ui[class*=\"fifteen column\"].grid>.column:not(.row),.ui[class*=\"fifteen column\"].grid>.row>.column{width:6.66666667%}.ui[class*=\"sixteen column\"].grid>.column:not(.row),.ui[class*=\"sixteen column\"].grid>.row>.column{width:6.25%}.ui.grid>[class*=\"one column\"].row>.column{width:100%!important}.ui.grid>[class*=\"two column\"].row>.column{width:50%!important}.ui.grid>[class*=\"three column\"].row>.column{width:33.33333333%!important}.ui.grid>[class*=\"four column\"].row>.column{width:25%!important}.ui.grid>[class*=\"five column\"].row>.column{width:20%!important}.ui.grid>[class*=\"six column\"].row>.column{width:16.66666667%!important}.ui.grid>[class*=\"seven column\"].row>.column{width:14.28571429%!important}.ui.grid>[class*=\"eight column\"].row>.column{width:12.5%!important}.ui.grid>[class*=\"nine column\"].row>.column{width:11.11111111%!important}.ui.grid>[class*=\"ten column\"].row>.column{width:10%!important}.ui.grid>[class*=\"eleven column\"].row>.column{width:9.09090909%!important}.ui.grid>[class*=\"twelve column\"].row>.column{width:8.33333333%!important}.ui.grid>[class*=\"thirteen column\"].row>.column{width:7.69230769%!important}.ui.grid>[class*=\"fourteen column\"].row>.column{width:7.14285714%!important}.ui.grid>[class*=\"fifteen column\"].row>.column{width:6.66666667%!important}.ui.grid>[class*=\"sixteen column\"].row>.column{width:6.25%!important}.ui.celled.page.grid{box-shadow:none}.ui.column.grid>[class*=\"one wide\"].column,.ui.grid>.column.row>[class*=\"one wide\"].column,.ui.grid>.row>[class*=\"one wide\"].column,.ui.grid>[class*=\"one wide\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide\"].column,.ui.grid>.column.row>[class*=\"two wide\"].column,.ui.grid>.row>[class*=\"two wide\"].column,.ui.grid>[class*=\"two wide\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide\"].column,.ui.grid>.column.row>[class*=\"three wide\"].column,.ui.grid>.row>[class*=\"three wide\"].column,.ui.grid>[class*=\"three wide\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide\"].column,.ui.grid>.column.row>[class*=\"four wide\"].column,.ui.grid>.row>[class*=\"four wide\"].column,.ui.grid>[class*=\"four wide\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide\"].column,.ui.grid>.column.row>[class*=\"five wide\"].column,.ui.grid>.row>[class*=\"five wide\"].column,.ui.grid>[class*=\"five wide\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide\"].column,.ui.grid>.column.row>[class*=\"six wide\"].column,.ui.grid>.row>[class*=\"six wide\"].column,.ui.grid>[class*=\"six wide\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide\"].column,.ui.grid>.column.row>[class*=\"seven wide\"].column,.ui.grid>.row>[class*=\"seven wide\"].column,.ui.grid>[class*=\"seven wide\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide\"].column,.ui.grid>.column.row>[class*=\"eight wide\"].column,.ui.grid>.row>[class*=\"eight wide\"].column,.ui.grid>[class*=\"eight wide\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide\"].column,.ui.grid>.column.row>[class*=\"nine wide\"].column,.ui.grid>.row>[class*=\"nine wide\"].column,.ui.grid>[class*=\"nine wide\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide\"].column,.ui.grid>.column.row>[class*=\"ten wide\"].column,.ui.grid>.row>[class*=\"ten wide\"].column,.ui.grid>[class*=\"ten wide\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide\"].column,.ui.grid>.column.row>[class*=\"eleven wide\"].column,.ui.grid>.row>[class*=\"eleven wide\"].column,.ui.grid>[class*=\"eleven wide\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide\"].column,.ui.grid>.column.row>[class*=\"twelve wide\"].column,.ui.grid>.row>[class*=\"twelve wide\"].column,.ui.grid>[class*=\"twelve wide\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide\"].column,.ui.grid>.column.row>[class*=\"thirteen wide\"].column,.ui.grid>.row>[class*=\"thirteen wide\"].column,.ui.grid>[class*=\"thirteen wide\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide\"].column,.ui.grid>.column.row>[class*=\"fourteen wide\"].column,.ui.grid>.row>[class*=\"fourteen wide\"].column,.ui.grid>[class*=\"fourteen wide\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide\"].column,.ui.grid>.column.row>[class*=\"fifteen wide\"].column,.ui.grid>.row>[class*=\"fifteen wide\"].column,.ui.grid>[class*=\"fifteen wide\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide\"].column,.ui.grid>.column.row>[class*=\"sixteen wide\"].column,.ui.grid>.row>[class*=\"sixteen wide\"].column,.ui.grid>[class*=\"sixteen wide\"].column{width:100%!important}@media only screen and (min-width:320px) and (max-width:599px){.ui.column.grid>[class*=\"one wide mobile\"].column,.ui.grid>.column.row>[class*=\"one wide mobile\"].column,.ui.grid>.row>[class*=\"one wide mobile\"].column,.ui.grid>[class*=\"one wide mobile\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide mobile\"].column,.ui.grid>.column.row>[class*=\"two wide mobile\"].column,.ui.grid>.row>[class*=\"two wide mobile\"].column,.ui.grid>[class*=\"two wide mobile\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide mobile\"].column,.ui.grid>.column.row>[class*=\"three wide mobile\"].column,.ui.grid>.row>[class*=\"three wide mobile\"].column,.ui.grid>[class*=\"three wide mobile\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide mobile\"].column,.ui.grid>.column.row>[class*=\"four wide mobile\"].column,.ui.grid>.row>[class*=\"four wide mobile\"].column,.ui.grid>[class*=\"four wide mobile\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide mobile\"].column,.ui.grid>.column.row>[class*=\"five wide mobile\"].column,.ui.grid>.row>[class*=\"five wide mobile\"].column,.ui.grid>[class*=\"five wide mobile\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide mobile\"].column,.ui.grid>.column.row>[class*=\"six wide mobile\"].column,.ui.grid>.row>[class*=\"six wide mobile\"].column,.ui.grid>[class*=\"six wide mobile\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide mobile\"].column,.ui.grid>.column.row>[class*=\"seven wide mobile\"].column,.ui.grid>.row>[class*=\"seven wide mobile\"].column,.ui.grid>[class*=\"seven wide mobile\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide mobile\"].column,.ui.grid>.column.row>[class*=\"eight wide mobile\"].column,.ui.grid>.row>[class*=\"eight wide mobile\"].column,.ui.grid>[class*=\"eight wide mobile\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide mobile\"].column,.ui.grid>.column.row>[class*=\"nine wide mobile\"].column,.ui.grid>.row>[class*=\"nine wide mobile\"].column,.ui.grid>[class*=\"nine wide mobile\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide mobile\"].column,.ui.grid>.column.row>[class*=\"ten wide mobile\"].column,.ui.grid>.row>[class*=\"ten wide mobile\"].column,.ui.grid>[class*=\"ten wide mobile\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide mobile\"].column,.ui.grid>.column.row>[class*=\"eleven wide mobile\"].column,.ui.grid>.row>[class*=\"eleven wide mobile\"].column,.ui.grid>[class*=\"eleven wide mobile\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide mobile\"].column,.ui.grid>.column.row>[class*=\"twelve wide mobile\"].column,.ui.grid>.row>[class*=\"twelve wide mobile\"].column,.ui.grid>[class*=\"twelve wide mobile\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide mobile\"].column,.ui.grid>.column.row>[class*=\"thirteen wide mobile\"].column,.ui.grid>.row>[class*=\"thirteen wide mobile\"].column,.ui.grid>[class*=\"thirteen wide mobile\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide mobile\"].column,.ui.grid>.column.row>[class*=\"fourteen wide mobile\"].column,.ui.grid>.row>[class*=\"fourteen wide mobile\"].column,.ui.grid>[class*=\"fourteen wide mobile\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide mobile\"].column,.ui.grid>.column.row>[class*=\"fifteen wide mobile\"].column,.ui.grid>.row>[class*=\"fifteen wide mobile\"].column,.ui.grid>[class*=\"fifteen wide mobile\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide mobile\"].column,.ui.grid>.column.row>[class*=\"sixteen wide mobile\"].column,.ui.grid>.row>[class*=\"sixteen wide mobile\"].column,.ui.grid>[class*=\"sixteen wide mobile\"].column{width:100%!important}}@media only screen and (min-width:600px) and (max-width:899px){.ui.column.grid>[class*=\"one wide tablet\"].column,.ui.grid>.column.row>[class*=\"one wide tablet\"].column,.ui.grid>.row>[class*=\"one wide tablet\"].column,.ui.grid>[class*=\"one wide tablet\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide tablet\"].column,.ui.grid>.column.row>[class*=\"two wide tablet\"].column,.ui.grid>.row>[class*=\"two wide tablet\"].column,.ui.grid>[class*=\"two wide tablet\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide tablet\"].column,.ui.grid>.column.row>[class*=\"three wide tablet\"].column,.ui.grid>.row>[class*=\"three wide tablet\"].column,.ui.grid>[class*=\"three wide tablet\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide tablet\"].column,.ui.grid>.column.row>[class*=\"four wide tablet\"].column,.ui.grid>.row>[class*=\"four wide tablet\"].column,.ui.grid>[class*=\"four wide tablet\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide tablet\"].column,.ui.grid>.column.row>[class*=\"five wide tablet\"].column,.ui.grid>.row>[class*=\"five wide tablet\"].column,.ui.grid>[class*=\"five wide tablet\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide tablet\"].column,.ui.grid>.column.row>[class*=\"six wide tablet\"].column,.ui.grid>.row>[class*=\"six wide tablet\"].column,.ui.grid>[class*=\"six wide tablet\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide tablet\"].column,.ui.grid>.column.row>[class*=\"seven wide tablet\"].column,.ui.grid>.row>[class*=\"seven wide tablet\"].column,.ui.grid>[class*=\"seven wide tablet\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide tablet\"].column,.ui.grid>.column.row>[class*=\"eight wide tablet\"].column,.ui.grid>.row>[class*=\"eight wide tablet\"].column,.ui.grid>[class*=\"eight wide tablet\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide tablet\"].column,.ui.grid>.column.row>[class*=\"nine wide tablet\"].column,.ui.grid>.row>[class*=\"nine wide tablet\"].column,.ui.grid>[class*=\"nine wide tablet\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide tablet\"].column,.ui.grid>.column.row>[class*=\"ten wide tablet\"].column,.ui.grid>.row>[class*=\"ten wide tablet\"].column,.ui.grid>[class*=\"ten wide tablet\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide tablet\"].column,.ui.grid>.column.row>[class*=\"eleven wide tablet\"].column,.ui.grid>.row>[class*=\"eleven wide tablet\"].column,.ui.grid>[class*=\"eleven wide tablet\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide tablet\"].column,.ui.grid>.column.row>[class*=\"twelve wide tablet\"].column,.ui.grid>.row>[class*=\"twelve wide tablet\"].column,.ui.grid>[class*=\"twelve wide tablet\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide tablet\"].column,.ui.grid>.column.row>[class*=\"thirteen wide tablet\"].column,.ui.grid>.row>[class*=\"thirteen wide tablet\"].column,.ui.grid>[class*=\"thirteen wide tablet\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide tablet\"].column,.ui.grid>.column.row>[class*=\"fourteen wide tablet\"].column,.ui.grid>.row>[class*=\"fourteen wide tablet\"].column,.ui.grid>[class*=\"fourteen wide tablet\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide tablet\"].column,.ui.grid>.column.row>[class*=\"fifteen wide tablet\"].column,.ui.grid>.row>[class*=\"fifteen wide tablet\"].column,.ui.grid>[class*=\"fifteen wide tablet\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide tablet\"].column,.ui.grid>.column.row>[class*=\"sixteen wide tablet\"].column,.ui.grid>.row>[class*=\"sixteen wide tablet\"].column,.ui.grid>[class*=\"sixteen wide tablet\"].column{width:100%!important}}@media only screen and (min-width:900px){.ui.column.grid>[class*=\"one wide computer\"].column,.ui.grid>.column.row>[class*=\"one wide computer\"].column,.ui.grid>.row>[class*=\"one wide computer\"].column,.ui.grid>[class*=\"one wide computer\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide computer\"].column,.ui.grid>.column.row>[class*=\"two wide computer\"].column,.ui.grid>.row>[class*=\"two wide computer\"].column,.ui.grid>[class*=\"two wide computer\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide computer\"].column,.ui.grid>.column.row>[class*=\"three wide computer\"].column,.ui.grid>.row>[class*=\"three wide computer\"].column,.ui.grid>[class*=\"three wide computer\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide computer\"].column,.ui.grid>.column.row>[class*=\"four wide computer\"].column,.ui.grid>.row>[class*=\"four wide computer\"].column,.ui.grid>[class*=\"four wide computer\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide computer\"].column,.ui.grid>.column.row>[class*=\"five wide computer\"].column,.ui.grid>.row>[class*=\"five wide computer\"].column,.ui.grid>[class*=\"five wide computer\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide computer\"].column,.ui.grid>.column.row>[class*=\"six wide computer\"].column,.ui.grid>.row>[class*=\"six wide computer\"].column,.ui.grid>[class*=\"six wide computer\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide computer\"].column,.ui.grid>.column.row>[class*=\"seven wide computer\"].column,.ui.grid>.row>[class*=\"seven wide computer\"].column,.ui.grid>[class*=\"seven wide computer\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide computer\"].column,.ui.grid>.column.row>[class*=\"eight wide computer\"].column,.ui.grid>.row>[class*=\"eight wide computer\"].column,.ui.grid>[class*=\"eight wide computer\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide computer\"].column,.ui.grid>.column.row>[class*=\"nine wide computer\"].column,.ui.grid>.row>[class*=\"nine wide computer\"].column,.ui.grid>[class*=\"nine wide computer\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide computer\"].column,.ui.grid>.column.row>[class*=\"ten wide computer\"].column,.ui.grid>.row>[class*=\"ten wide computer\"].column,.ui.grid>[class*=\"ten wide computer\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide computer\"].column,.ui.grid>.column.row>[class*=\"eleven wide computer\"].column,.ui.grid>.row>[class*=\"eleven wide computer\"].column,.ui.grid>[class*=\"eleven wide computer\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide computer\"].column,.ui.grid>.column.row>[class*=\"twelve wide computer\"].column,.ui.grid>.row>[class*=\"twelve wide computer\"].column,.ui.grid>[class*=\"twelve wide computer\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide computer\"].column,.ui.grid>.column.row>[class*=\"thirteen wide computer\"].column,.ui.grid>.row>[class*=\"thirteen wide computer\"].column,.ui.grid>[class*=\"thirteen wide computer\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide computer\"].column,.ui.grid>.column.row>[class*=\"fourteen wide computer\"].column,.ui.grid>.row>[class*=\"fourteen wide computer\"].column,.ui.grid>[class*=\"fourteen wide computer\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide computer\"].column,.ui.grid>.column.row>[class*=\"fifteen wide computer\"].column,.ui.grid>.row>[class*=\"fifteen wide computer\"].column,.ui.grid>[class*=\"fifteen wide computer\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide computer\"].column,.ui.grid>.column.row>[class*=\"sixteen wide computer\"].column,.ui.grid>.row>[class*=\"sixteen wide computer\"].column,.ui.grid>[class*=\"sixteen wide computer\"].column{width:100%!important}}@media only screen and (min-width:1200px) and (max-width:1799px){.ui.column.grid>[class*=\"one wide large screen\"].column,.ui.grid>.column.row>[class*=\"one wide large screen\"].column,.ui.grid>.row>[class*=\"one wide large screen\"].column,.ui.grid>[class*=\"one wide large screen\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide large screen\"].column,.ui.grid>.column.row>[class*=\"two wide large screen\"].column,.ui.grid>.row>[class*=\"two wide large screen\"].column,.ui.grid>[class*=\"two wide large screen\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide large screen\"].column,.ui.grid>.column.row>[class*=\"three wide large screen\"].column,.ui.grid>.row>[class*=\"three wide large screen\"].column,.ui.grid>[class*=\"three wide large screen\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide large screen\"].column,.ui.grid>.column.row>[class*=\"four wide large screen\"].column,.ui.grid>.row>[class*=\"four wide large screen\"].column,.ui.grid>[class*=\"four wide large screen\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide large screen\"].column,.ui.grid>.column.row>[class*=\"five wide large screen\"].column,.ui.grid>.row>[class*=\"five wide large screen\"].column,.ui.grid>[class*=\"five wide large screen\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide large screen\"].column,.ui.grid>.column.row>[class*=\"six wide large screen\"].column,.ui.grid>.row>[class*=\"six wide large screen\"].column,.ui.grid>[class*=\"six wide large screen\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide large screen\"].column,.ui.grid>.column.row>[class*=\"seven wide large screen\"].column,.ui.grid>.row>[class*=\"seven wide large screen\"].column,.ui.grid>[class*=\"seven wide large screen\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide large screen\"].column,.ui.grid>.column.row>[class*=\"eight wide large screen\"].column,.ui.grid>.row>[class*=\"eight wide large screen\"].column,.ui.grid>[class*=\"eight wide large screen\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide large screen\"].column,.ui.grid>.column.row>[class*=\"nine wide large screen\"].column,.ui.grid>.row>[class*=\"nine wide large screen\"].column,.ui.grid>[class*=\"nine wide large screen\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide large screen\"].column,.ui.grid>.column.row>[class*=\"ten wide large screen\"].column,.ui.grid>.row>[class*=\"ten wide large screen\"].column,.ui.grid>[class*=\"ten wide large screen\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide large screen\"].column,.ui.grid>.column.row>[class*=\"eleven wide large screen\"].column,.ui.grid>.row>[class*=\"eleven wide large screen\"].column,.ui.grid>[class*=\"eleven wide large screen\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide large screen\"].column,.ui.grid>.column.row>[class*=\"twelve wide large screen\"].column,.ui.grid>.row>[class*=\"twelve wide large screen\"].column,.ui.grid>[class*=\"twelve wide large screen\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide large screen\"].column,.ui.grid>.column.row>[class*=\"thirteen wide large screen\"].column,.ui.grid>.row>[class*=\"thirteen wide large screen\"].column,.ui.grid>[class*=\"thirteen wide large screen\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide large screen\"].column,.ui.grid>.column.row>[class*=\"fourteen wide large screen\"].column,.ui.grid>.row>[class*=\"fourteen wide large screen\"].column,.ui.grid>[class*=\"fourteen wide large screen\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide large screen\"].column,.ui.grid>.column.row>[class*=\"fifteen wide large screen\"].column,.ui.grid>.row>[class*=\"fifteen wide large screen\"].column,.ui.grid>[class*=\"fifteen wide large screen\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide large screen\"].column,.ui.grid>.column.row>[class*=\"sixteen wide large screen\"].column,.ui.grid>.row>[class*=\"sixteen wide large screen\"].column,.ui.grid>[class*=\"sixteen wide large screen\"].column{width:100%!important}}@media only screen and (min-width:1800px){.ui.column.grid>[class*=\"one wide widescreen\"].column,.ui.grid>.column.row>[class*=\"one wide widescreen\"].column,.ui.grid>.row>[class*=\"one wide widescreen\"].column,.ui.grid>[class*=\"one wide widescreen\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide widescreen\"].column,.ui.grid>.column.row>[class*=\"two wide widescreen\"].column,.ui.grid>.row>[class*=\"two wide widescreen\"].column,.ui.grid>[class*=\"two wide widescreen\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide widescreen\"].column,.ui.grid>.column.row>[class*=\"three wide widescreen\"].column,.ui.grid>.row>[class*=\"three wide widescreen\"].column,.ui.grid>[class*=\"three wide widescreen\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide widescreen\"].column,.ui.grid>.column.row>[class*=\"four wide widescreen\"].column,.ui.grid>.row>[class*=\"four wide widescreen\"].column,.ui.grid>[class*=\"four wide widescreen\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide widescreen\"].column,.ui.grid>.column.row>[class*=\"five wide widescreen\"].column,.ui.grid>.row>[class*=\"five wide widescreen\"].column,.ui.grid>[class*=\"five wide widescreen\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide widescreen\"].column,.ui.grid>.column.row>[class*=\"six wide widescreen\"].column,.ui.grid>.row>[class*=\"six wide widescreen\"].column,.ui.grid>[class*=\"six wide widescreen\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide widescreen\"].column,.ui.grid>.column.row>[class*=\"seven wide widescreen\"].column,.ui.grid>.row>[class*=\"seven wide widescreen\"].column,.ui.grid>[class*=\"seven wide widescreen\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide widescreen\"].column,.ui.grid>.column.row>[class*=\"eight wide widescreen\"].column,.ui.grid>.row>[class*=\"eight wide widescreen\"].column,.ui.grid>[class*=\"eight wide widescreen\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide widescreen\"].column,.ui.grid>.column.row>[class*=\"nine wide widescreen\"].column,.ui.grid>.row>[class*=\"nine wide widescreen\"].column,.ui.grid>[class*=\"nine wide widescreen\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide widescreen\"].column,.ui.grid>.column.row>[class*=\"ten wide widescreen\"].column,.ui.grid>.row>[class*=\"ten wide widescreen\"].column,.ui.grid>[class*=\"ten wide widescreen\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide widescreen\"].column,.ui.grid>.column.row>[class*=\"eleven wide widescreen\"].column,.ui.grid>.row>[class*=\"eleven wide widescreen\"].column,.ui.grid>[class*=\"eleven wide widescreen\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide widescreen\"].column,.ui.grid>.column.row>[class*=\"twelve wide widescreen\"].column,.ui.grid>.row>[class*=\"twelve wide widescreen\"].column,.ui.grid>[class*=\"twelve wide widescreen\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide widescreen\"].column,.ui.grid>.column.row>[class*=\"thirteen wide widescreen\"].column,.ui.grid>.row>[class*=\"thirteen wide widescreen\"].column,.ui.grid>[class*=\"thirteen wide widescreen\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide widescreen\"].column,.ui.grid>.column.row>[class*=\"fourteen wide widescreen\"].column,.ui.grid>.row>[class*=\"fourteen wide widescreen\"].column,.ui.grid>[class*=\"fourteen wide widescreen\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide widescreen\"].column,.ui.grid>.column.row>[class*=\"fifteen wide widescreen\"].column,.ui.grid>.row>[class*=\"fifteen wide widescreen\"].column,.ui.grid>[class*=\"fifteen wide widescreen\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide widescreen\"].column,.ui.grid>.column.row>[class*=\"sixteen wide widescreen\"].column,.ui.grid>.row>[class*=\"sixteen wide widescreen\"].column,.ui.grid>[class*=\"sixteen wide widescreen\"].column{width:100%!important}}.ui.centered.grid,.ui.centered.grid>.row,.ui.grid>.centered.row{text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ui.centered.grid>.column:not(.aligned):not(.justified):not(.row),.ui.centered.grid>.row>.column:not(.aligned):not(.justified),.ui.grid .centered.row>.column:not(.aligned):not(.justified){text-align:left}.ui.grid>.centered.column,.ui.grid>.row>.centered.column{display:block;margin-left:auto;margin-right:auto}.ui.grid>.relaxed.row>.column,.ui.relaxed.grid>.column:not(.row),.ui.relaxed.grid>.row>.column{padding-left:1.5rem;padding-right:1.5rem}.ui.grid>[class*=\"very relaxed\"].row>.column,.ui[class*=\"very relaxed\"].grid>.column:not(.row),.ui[class*=\"very relaxed\"].grid>.row>.column{padding-left:2.5rem;padding-right:2.5rem}.ui.grid .relaxed.row+.ui.divider,.ui.relaxed.grid .row+.ui.divider{margin-left:1.5rem;margin-right:1.5rem}.ui.grid [class*=\"very relaxed\"].row+.ui.divider,.ui[class*=\"very relaxed\"].grid .row+.ui.divider{margin-left:2.5rem;margin-right:2.5rem}.ui.padded.grid:not(.vertically):not(.horizontally){margin:0!important}[class*=\"horizontally padded\"].ui.grid{margin-left:0!important;margin-right:0!important}[class*=\"vertically padded\"].ui.grid{margin-top:0!important;margin-bottom:0!important}.ui.grid [class*=\"left floated\"].column{margin-right:auto}.ui.grid [class*=\"right floated\"].column{margin-left:auto}.ui.divided.grid:not([class*=\"vertically divided\"])>.column:not(.row),.ui.divided.grid:not([class*=\"vertically divided\"])>.row>.column{box-shadow:-1px 0 0 0 rgba(34,36,38,.15)}.ui[class*=\"vertically divided\"].grid>.column:not(.row),.ui[class*=\"vertically divided\"].grid>.row>.column{margin-top:1rem;margin-bottom:1rem;padding-top:0;padding-bottom:0}.ui[class*=\"vertically divided\"].grid>.row{margin-top:0;margin-bottom:0}.ui.divided.grid:not([class*=\"vertically divided\"])>.column:first-child,.ui.divided.grid:not([class*=\"vertically divided\"])>.row>.column:first-child{box-shadow:none}.ui[class*=\"vertically divided\"].grid>.row:first-child>.column{margin-top:0}.ui.grid>.divided.row>.column{box-shadow:-1px 0 0 0 rgba(34,36,38,.15)}.ui.grid>.divided.row>.column:first-child{box-shadow:none}.ui[class*=\"vertically divided\"].grid>.row{position:relative}.ui[class*=\"vertically divided\"].grid>.row:before{position:absolute;content:\"\";top:0;left:0;width:calc(100% - 2rem);height:1px;margin:0 1rem;box-shadow:0 -1px 0 0 rgba(34,36,38,.15)}.ui.padded.divided.grid:not(.vertically):not(.horizontally),[class*=\"horizontally padded\"].ui.divided.grid{width:100%}.ui[class*=\"vertically divided\"].grid>.row:first-child:before{box-shadow:none}.ui.inverted.divided.grid:not([class*=\"vertically divided\"])>.column:not(.row),.ui.inverted.divided.grid:not([class*=\"vertically divided\"])>.row>.column{box-shadow:-1px 0 0 0 hsla(0,0%,100%,.1)}.ui.inverted.divided.grid:not([class*=\"vertically divided\"])>.column:not(.row):first-child,.ui.inverted.divided.grid:not([class*=\"vertically divided\"])>.row>.column:first-child{box-shadow:none}.ui.inverted[class*=\"vertically divided\"].grid>.row:before{box-shadow:0 -1px 0 0 hsla(0,0%,100%,.1)}.ui.relaxed[class*=\"vertically divided\"].grid>.row:before{margin-left:1.5rem;margin-right:1.5rem;width:calc(100% - 3rem)}.ui[class*=\"very relaxed\"][class*=\"vertically divided\"].grid>.row:before{margin-left:5rem;margin-right:5rem;width:calc(100% - 5rem)}.ui.celled.grid{width:100%;margin:1em 0;box-shadow:0 0 0 1px #d4d4d5}.ui.celled.grid>.row{width:100%!important;margin:0;padding:0;box-shadow:0 -1px 0 0 #d4d4d5}.ui.celled.grid>.column:not(.row),.ui.celled.grid>.row>.column{box-shadow:-1px 0 0 0 #d4d4d5}.ui.celled.grid>.column:first-child,.ui.celled.grid>.row>.column:first-child{box-shadow:none}.ui.celled.grid>.column:not(.row),.ui.celled.grid>.row>.column{padding:1em}.ui.relaxed.celled.grid>.column:not(.row),.ui.relaxed.celled.grid>.row>.column{padding:1.5em}.ui[class*=\"very relaxed\"].celled.grid>.column:not(.row),.ui[class*=\"very relaxed\"].celled.grid>.row>.column{padding:2em}.ui[class*=\"internally celled\"].grid{box-shadow:none;margin:0}.ui[class*=\"internally celled\"].grid>.row:first-child,.ui[class*=\"internally celled\"].grid>.row>.column:first-child{box-shadow:none}.ui.grid>.row>[class*=\"top aligned\"].column,.ui.grid>[class*=\"top aligned\"].column:not(.row),.ui.grid>[class*=\"top aligned\"].row>.column,.ui[class*=\"top aligned\"].grid>.column:not(.row),.ui[class*=\"top aligned\"].grid>.row>.column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;vertical-align:top;-ms-flex-item-align:start!important;align-self:flex-start!important}.ui.grid>.row>[class*=\"middle aligned\"].column,.ui.grid>[class*=\"middle aligned\"].column:not(.row),.ui.grid>[class*=\"middle aligned\"].row>.column,.ui[class*=\"middle aligned\"].grid>.column:not(.row),.ui[class*=\"middle aligned\"].grid>.row>.column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;vertical-align:middle;-ms-flex-item-align:center!important;align-self:center!important}.ui.grid>.row>[class*=\"bottom aligned\"].column,.ui.grid>[class*=\"bottom aligned\"].column:not(.row),.ui.grid>[class*=\"bottom aligned\"].row>.column,.ui[class*=\"bottom aligned\"].grid>.column:not(.row),.ui[class*=\"bottom aligned\"].grid>.row>.column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;vertical-align:bottom;-ms-flex-item-align:end!important;align-self:flex-end!important}.ui.grid>.row>.stretched.column,.ui.grid>.stretched.column:not(.row),.ui.grid>.stretched.row>.column,.ui.stretched.grid>.column,.ui.stretched.grid>.row>.column{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important;-ms-flex-item-align:stretch;align-self:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ui.grid>.row>.stretched.column>*,.ui.grid>.stretched.column:not(.row)>*,.ui.grid>.stretched.row>.column>*,.ui.stretched.grid>.column>*,.ui.stretched.grid>.row>.column>*{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.ui.grid>.row>[class*=\"left aligned\"].column.column,.ui.grid>[class*=\"left aligned\"].column.column,.ui.grid>[class*=\"left aligned\"].row>.column,.ui[class*=\"left aligned\"].grid>.column,.ui[class*=\"left aligned\"].grid>.row>.column{text-align:left;-ms-flex-item-align:inherit;align-self:inherit}.ui.grid>.row>[class*=\"center aligned\"].column.column,.ui.grid>[class*=\"center aligned\"].column.column,.ui.grid>[class*=\"center aligned\"].row>.column,.ui[class*=\"center aligned\"].grid>.column,.ui[class*=\"center aligned\"].grid>.row>.column{text-align:center;-ms-flex-item-align:inherit;align-self:inherit}.ui[class*=\"center aligned\"].grid{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ui.grid>.row>[class*=\"right aligned\"].column.column,.ui.grid>[class*=\"right aligned\"].column.column,.ui.grid>[class*=\"right aligned\"].row>.column,.ui[class*=\"right aligned\"].grid>.column,.ui[class*=\"right aligned\"].grid>.row>.column{text-align:right;-ms-flex-item-align:inherit;align-self:inherit}.ui.grid>.justified.column.column,.ui.grid>.justified.row>.column,.ui.grid>.row>.justified.column.column,.ui.justified.grid>.column,.ui.justified.grid>.row>.column{text-align:justify;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}.ui.grid>.row>.black.column,.ui.grid>.row>.blue.column,.ui.grid>.row>.brown.column,.ui.grid>.row>.green.column,.ui.grid>.row>.grey.column,.ui.grid>.row>.olive.column,.ui.grid>.row>.orange.column,.ui.grid>.row>.pink.column,.ui.grid>.row>.purple.column,.ui.grid>.row>.red.column,.ui.grid>.row>.teal.column,.ui.grid>.row>.violet.column,.ui.grid>.row>.yellow.column{margin-top:-1rem;margin-bottom:-1rem;padding-top:1rem;padding-bottom:1rem}.ui.grid>.red.column,.ui.grid>.red.row,.ui.grid>.row>.red.column{background-color:#e23c4e!important;color:#fff}.ui.grid>.orange.column,.ui.grid>.orange.row,.ui.grid>.row>.orange.column{background-color:#f8813d!important;color:#fff}.ui.grid>.row>.yellow.column,.ui.grid>.yellow.column,.ui.grid>.yellow.row{background-color:#ffca18!important;color:#fff}.ui.grid>.olive.column,.ui.grid>.olive.row,.ui.grid>.row>.olive.column{background-color:#456558!important;color:#fff}.ui.grid>.green.column,.ui.grid>.green.row,.ui.grid>.row>.green.column{background-color:#54af71!important;color:#fff}.ui.grid>.row>.teal.column,.ui.grid>.teal.column,.ui.grid>.teal.row{background-color:#00a1ca!important;color:#fff}.ui.grid>.blue.column,.ui.grid>.blue.row,.ui.grid>.row>.blue.column{background-color:#1d5f82!important;color:#fff}.ui.grid>.row>.violet.column,.ui.grid>.violet.column,.ui.grid>.violet.row{background-color:#525394!important;color:#fff}.ui.grid>.purple.column,.ui.grid>.purple.row,.ui.grid>.row>.purple.column{background-color:#ad427f!important;color:#fff}.ui.grid>.pink.column,.ui.grid>.pink.row,.ui.grid>.row>.pink.column{background-color:#e03997!important;color:#fff}.ui.grid>.brown.column,.ui.grid>.brown.row,.ui.grid>.row>.brown.column{background-color:#a67a00!important;color:#fff}.ui.grid>.grey.column,.ui.grid>.grey.row,.ui.grid>.row>.grey.column{background-color:#5a686d!important;color:#fff}.ui.grid>.black.column,.ui.grid>.black.row,.ui.grid>.row>.black.column{background-color:#1b1c1d!important;color:#fff}.ui.grid>[class*=\"equal width\"].row>.column,.ui[class*=\"equal width\"].grid>.column:not(.row),.ui[class*=\"equal width\"].grid>.row>.column{display:inline-block;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.ui.grid>[class*=\"equal width\"].row>.wide.column,.ui[class*=\"equal width\"].grid>.row>.wide.column,.ui[class*=\"equal width\"].grid>.wide.column{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}@media only screen and (max-width:599px){.ui.grid>[class*=\"mobile reversed\"].row,.ui[class*=\"mobile reversed\"].grid,.ui[class*=\"mobile reversed\"].grid>.row{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.ui.stackable[class*=\"mobile reversed\"],.ui[class*=\"mobile vertically reversed\"].grid{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:first-child,.ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:first-child{box-shadow:-1px 0 0 0 rgba(34,36,38,.15)}.ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:last-child,.ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:last-child{box-shadow:none}.ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"]>.row:first-child:before{box-shadow:0 -1px 0 0 rgba(34,36,38,.15)}.ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"]>.row:last-child:before{box-shadow:none}.ui[class*=\"mobile reversed\"].celled.grid>.row>.column:first-child{box-shadow:-1px 0 0 0 #d4d4d5}.ui[class*=\"mobile reversed\"].celled.grid>.row>.column:last-child{box-shadow:none}}@media only screen and (min-width:600px) and (max-width:899px){.ui.grid>[class*=\"tablet reversed\"].row,.ui[class*=\"tablet reversed\"].grid,.ui[class*=\"tablet reversed\"].grid>.row{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.ui[class*=\"tablet vertically reversed\"].grid{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:first-child,.ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:first-child{box-shadow:-1px 0 0 0 rgba(34,36,38,.15)}.ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:last-child,.ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:last-child{box-shadow:none}.ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"]>.row:first-child:before{box-shadow:0 -1px 0 0 rgba(34,36,38,.15)}.ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"]>.row:last-child:before{box-shadow:none}.ui[class*=\"tablet reversed\"].celled.grid>.row>.column:first-child{box-shadow:-1px 0 0 0 #d4d4d5}.ui[class*=\"tablet reversed\"].celled.grid>.row>.column:last-child{box-shadow:none}}@media only screen and (min-width:900px){.ui.grid>[class*=\"computer reversed\"].row,.ui[class*=\"computer reversed\"].grid,.ui[class*=\"computer reversed\"].grid>.row{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.ui[class*=\"computer vertically reversed\"].grid{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:first-child,.ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:first-child{box-shadow:-1px 0 0 0 rgba(34,36,38,.15)}.ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:last-child,.ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:last-child{box-shadow:none}.ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"]>.row:first-child:before{box-shadow:0 -1px 0 0 rgba(34,36,38,.15)}.ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"]>.row:last-child:before{box-shadow:none}.ui[class*=\"computer reversed\"].celled.grid>.row>.column:first-child{box-shadow:-1px 0 0 0 #d4d4d5}.ui[class*=\"computer reversed\"].celled.grid>.row>.column:last-child{box-shadow:none}}@media only screen and (min-width:600px) and (max-width:899px){.ui.doubling.grid{width:auto}.ui.doubling.grid>.row,.ui.grid>.doubling.row{margin:0!important;padding:0!important}.ui.doubling.grid>.row>.column,.ui.grid>.doubling.row>.column{display:inline-block!important;padding-top:1rem!important;padding-bottom:1rem!important;box-shadow:none!important;margin:0}.ui.grid>[class*=\"two column\"].doubling.row.row>.column,.ui[class*=\"two column\"].doubling.grid>.column:not(.row),.ui[class*=\"two column\"].doubling.grid>.row>.column{width:100%!important}.ui.grid>[class*=\"four column\"].doubling.row.row>.column,.ui.grid>[class*=\"three column\"].doubling.row.row>.column,.ui[class*=\"four column\"].doubling.grid>.column:not(.row),.ui[class*=\"four column\"].doubling.grid>.row>.column,.ui[class*=\"three column\"].doubling.grid>.column:not(.row),.ui[class*=\"three column\"].doubling.grid>.row>.column{width:50%!important}.ui.grid>[class*=\"five column\"].doubling.row.row>.column,.ui.grid>[class*=\"seven column\"].doubling.row.row>.column,.ui.grid>[class*=\"six column\"].doubling.row.row>.column,.ui[class*=\"five column\"].doubling.grid>.column:not(.row),.ui[class*=\"five column\"].doubling.grid>.row>.column,.ui[class*=\"seven column\"].doubling.grid>.column:not(.row),.ui[class*=\"seven column\"].doubling.grid>.row>.column,.ui[class*=\"six column\"].doubling.grid>.column:not(.row),.ui[class*=\"six column\"].doubling.grid>.row>.column{width:33.33333333%!important}.ui.grid>[class*=\"eight column\"].doubling.row.row>.column,.ui.grid>[class*=\"nine column\"].doubling.row.row>.column,.ui[class*=\"eight column\"].doubling.grid>.column:not(.row),.ui[class*=\"eight column\"].doubling.grid>.row>.column,.ui[class*=\"nine column\"].doubling.grid>.column:not(.row),.ui[class*=\"nine column\"].doubling.grid>.row>.column{width:25%!important}.ui.grid>[class*=\"eleven column\"].doubling.row.row>.column,.ui.grid>[class*=\"ten column\"].doubling.row.row>.column,.ui[class*=\"eleven column\"].doubling.grid>.column:not(.row),.ui[class*=\"eleven column\"].doubling.grid>.row>.column,.ui[class*=\"ten column\"].doubling.grid>.column:not(.row),.ui[class*=\"ten column\"].doubling.grid>.row>.column{width:20%!important}.ui.grid>[class*=\"thirteen column\"].doubling.row.row>.column,.ui.grid>[class*=\"twelve column\"].doubling.row.row>.column,.ui[class*=\"thirteen column\"].doubling.grid>.column:not(.row),.ui[class*=\"thirteen column\"].doubling.grid>.row>.column,.ui[class*=\"twelve column\"].doubling.grid>.column:not(.row),.ui[class*=\"twelve column\"].doubling.grid>.row>.column{width:16.66666667%!important}.ui.grid>[class*=\"fifteen column\"].doubling.row.row>.column,.ui.grid>[class*=\"fourteen column\"].doubling.row.row>.column,.ui[class*=\"fifteen column\"].doubling.grid>.column:not(.row),.ui[class*=\"fifteen column\"].doubling.grid>.row>.column,.ui[class*=\"fourteen column\"].doubling.grid>.column:not(.row),.ui[class*=\"fourteen column\"].doubling.grid>.row>.column{width:14.28571429%!important}.ui.grid>[class*=\"sixteen column\"].doubling.row.row>.column,.ui[class*=\"sixteen column\"].doubling.grid>.column:not(.row),.ui[class*=\"sixteen column\"].doubling.grid>.row>.column{width:12.5%!important}}@media only screen and (max-width:599px){.ui.doubling.grid>.row,.ui.grid>.doubling.row{margin:0!important;padding:0!important}.ui.doubling.grid>.row>.column,.ui.grid>.doubling.row>.column{padding-top:1rem!important;padding-bottom:1rem!important;margin:0!important;box-shadow:none!important}.ui.grid>[class*=\"two column\"].doubling:not(.stackable).row.row>.column,.ui[class*=\"two column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"two column\"].doubling:not(.stackable).grid>.row>.column{width:100%!important}.ui.grid>[class*=\"eight column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"five column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"four column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"seven column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"six column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"three column\"].doubling:not(.stackable).row.row>.column,.ui[class*=\"eight column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"eight column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"five column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"five column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"four column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"four column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"seven column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"seven column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"six column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"six column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"three column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"three column\"].doubling:not(.stackable).grid>.row>.column{width:50%!important}.ui.grid>[class*=\"eleven column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"nine column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"ten column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"thirteen column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"twelve column\"].doubling:not(.stackable).row.row>.column,.ui[class*=\"eleven column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"eleven column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"nine column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"nine column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"ten column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"ten column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"thirteen column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"thirteen column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"twelve column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"twelve column\"].doubling:not(.stackable).grid>.row>.column{width:33.33333333%!important}.ui.grid>[class*=\"fifteen column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"fourteen column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"sixteen column\"].doubling:not(.stackable).row.row>.column,.ui[class*=\"fifteen column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"fifteen column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"fourteen column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"fourteen column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"sixteen column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"sixteen column\"].doubling:not(.stackable).grid>.row>.column{width:25%!important}}@media only screen and (max-width:599px){.ui.stackable.grid{width:auto;margin-left:0!important;margin-right:0!important}.ui.grid>.stackable.stackable.row>.column,.ui.stackable.grid>.column.grid>.column,.ui.stackable.grid>.column.row>.column,.ui.stackable.grid>.column:not(.row),.ui.stackable.grid>.row>.column,.ui.stackable.grid>.row>.wide.column,.ui.stackable.grid>.wide.column{width:100%!important;margin:0!important;box-shadow:none!important;padding:1rem!important}.ui.stackable.grid:not(.vertically)>.row{margin:0;padding:0}.ui.container>.ui.stackable.grid>.column,.ui.container>.ui.stackable.grid>.row>.column{padding-left:0!important;padding-right:0!important}.ui.grid .ui.stackable.grid,.ui.segment:not(.vertical) .ui.stackable.page.grid{margin-left:-1rem!important;margin-right:-1rem!important}.ui.stackable.celled.grid>.column:not(.row):first-child,.ui.stackable.celled.grid>.row:first-child>.column:first-child,.ui.stackable.divided.grid>.column:not(.row):first-child,.ui.stackable.divided.grid>.row:first-child>.column:first-child{border-top:none!important}.ui.inverted.stackable.celled.grid>.column:not(.row),.ui.inverted.stackable.celled.grid>.row>.column,.ui.inverted.stackable.divided.grid>.column:not(.row),.ui.inverted.stackable.divided.grid>.row>.column{border-top:1px solid hsla(0,0%,100%,.1)}.ui.stackable.celled.grid>.column:not(.row),.ui.stackable.celled.grid>.row>.column,.ui.stackable.divided:not(.vertically).grid>.column:not(.row),.ui.stackable.divided:not(.vertically).grid>.row>.column{border-top:1px solid rgba(34,36,38,.15);box-shadow:none!important;padding-top:2rem!important;padding-bottom:2rem!important}.ui.stackable.celled.grid>.row{box-shadow:none!important}.ui.stackable.divided:not(.vertically).grid>.column:not(.row),.ui.stackable.divided:not(.vertically).grid>.row>.column{padding-left:0!important;padding-right:0!important}}@media only screen and (max-width:599px){.ui.grid.grid.grid>.row>[class*=\"computer only\"].column:not(.mobile),.ui.grid.grid.grid>.row>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>.row>[class*=\"tablet only\"].column:not(.mobile),.ui.grid.grid.grid>.row>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"computer only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"computer only\"].row:not(.mobile),.ui.grid.grid.grid>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"large screen only\"].row:not(.mobile),.ui.grid.grid.grid>[class*=\"tablet only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"tablet only\"].row:not(.mobile),.ui.grid.grid.grid>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"widescreen only\"].row:not(.mobile),.ui[class*=\"computer only\"].grid.grid.grid:not(.mobile),.ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),.ui[class*=\"tablet only\"].grid.grid.grid:not(.mobile),.ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile){display:none!important}}@media only screen and (min-width:600px) and (max-width:899px){.ui.grid.grid.grid>.row>[class*=\"computer only\"].column:not(.tablet),.ui.grid.grid.grid>.row>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>.row>[class*=\"mobile only\"].column:not(.tablet),.ui.grid.grid.grid>.row>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"computer only\"].column:not(.tablet),.ui.grid.grid.grid>[class*=\"computer only\"].row:not(.tablet),.ui.grid.grid.grid>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"large screen only\"].row:not(.mobile),.ui.grid.grid.grid>[class*=\"mobile only\"].column:not(.tablet),.ui.grid.grid.grid>[class*=\"mobile only\"].row:not(.tablet),.ui.grid.grid.grid>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"widescreen only\"].row:not(.mobile),.ui[class*=\"computer only\"].grid.grid.grid:not(.tablet),.ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),.ui[class*=\"mobile only\"].grid.grid.grid:not(.tablet),.ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile){display:none!important}}@media only screen and (min-width:900px) and (max-width:1199px){.ui.grid.grid.grid>.row>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>.row>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>.row>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>.row>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"large screen only\"].row:not(.mobile),.ui.grid.grid.grid>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"mobile only\"].row:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].row:not(.computer),.ui.grid.grid.grid>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"widescreen only\"].row:not(.mobile),.ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),.ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),.ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),.ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile){display:none!important}}@media only screen and (min-width:1200px) and (max-width:1799px){.ui.grid.grid.grid>.row>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>.row>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>.row>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"mobile only\"].row:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].row:not(.computer),.ui.grid.grid.grid>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"widescreen only\"].row:not(.mobile),.ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),.ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),.ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile){display:none!important}}@media only screen and (min-width:1800px){.ui.grid.grid.grid>.row>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>.row>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"mobile only\"].row:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].row:not(.computer),.ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),.ui[class*=\"tablet only\"].grid.grid.grid:not(.computer){display:none!important}}.ui.grid{max-width:100vw}", ""]);
	
	// exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Header\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.header{border:none;margin:calc(2rem - .025em) 0 1rem;padding:0;font-family:Publico Headline,Georgia,serif;font-weight:500;line-height:1.05em;text-transform:none;color:rgba(0,0,0,.87)}.ui.header:first-child{margin-top:-.025em}.ui.header:last-child{margin-bottom:0}.ui.header .sub.header{display:block;font-weight:400;padding:0;margin:0;line-height:1.2em;color:rgba(0,0,0,.6)}.ui.header>.icon{display:table-cell;opacity:1;font-size:1.5em;padding-top:.025em;vertical-align:middle}.ui.header .icon:only-child{display:inline-block;padding:0;margin-right:.75rem}.ui.header>.image:not(.icon),.ui.header>img{display:inline-block;margin-top:.025em;width:2.5em;height:auto;vertical-align:middle}.ui.header>.image:not(.icon):only-child,.ui.header>img:only-child{margin-right:.75rem}.ui.header .content{display:inline-block;vertical-align:top}.ui.header>.icon+.content,.ui.header>.image+.content,.ui.header>img+.content{padding-left:.75rem;vertical-align:middle}.ui.header>.icon+.content{display:table-cell}.ui.header .ui.label{font-size:\"\";margin-left:.5rem;vertical-align:middle}.ui.header+p{margin-top:0}h1.ui.header{font-size:4.24rem}h2.ui.header{font-size:2.955rem}h3.ui.header{font-size:2.059rem}h4.ui.header{font-size:1.435rem}h5.ui.header{font-size:1rem}h1.ui.header .sub.header{font-size:1.88235294rem}h2.ui.header .sub.header{font-size:1.58823529rem}h3.ui.header .sub.header{font-size:1.35294118rem}h4.ui.header .sub.header{font-size:1rem}h5.ui.header .sub.header{font-size:.88235294rem}.ui.huge.header{min-height:1em;font-size:4.24em}.ui.large.header{font-size:2.955em}.ui.medium.header{font-size:2.059em}.ui.small.header{font-size:1.435em}.ui.tiny.header{font-size:1em}.ui.huge.header .sub.header,.ui.large.header .sub.header{font-size:1.88235294rem}.ui.header .sub.header{font-size:1.35294118rem}.ui.small.header .sub.header{font-size:1rem}.ui.tiny.header .sub.header{font-size:.88235294rem}.ui.sub.header{padding:0;margin-bottom:.11764706rem;font-weight:700;text-transform:uppercase;color:\"\"}.ui.small.sub.header{font-size:.64705882em}.ui.sub.header{font-size:.70588235em}.ui.large.sub.header{font-size:.88235294em}.ui.huge.sub.header{font-size:1em}.ui.icon.header{display:inline-block;text-align:center;margin:2rem 0 1rem}.ui.icon.header:after{content:\"\";display:block;height:0;clear:both;visibility:hidden}.ui.icon.header:first-child{margin-top:0}.ui.icon.header .icon{float:none;width:auto;height:auto;line-height:1;font-size:3em;margin:0 auto .5rem;opacity:1}.ui.icon.header .content,.ui.icon.header .icon{display:block;padding:0}.ui.icon.header .circular.icon,.ui.icon.header .square.icon{font-size:2em}.ui.block.icon.header .icon{margin-bottom:0}.ui.icon.header.aligned{margin-left:auto;margin-right:auto;display:block}.ui.disabled.header{opacity:.45}.ui.inverted.header{color:#fff}.ui.inverted.header .sub.header{color:hsla(0,0%,100%,.8)}.ui.inverted.attached.header{border-color:transparent}.ui.inverted.attached.header,.ui.inverted.block.header{background:#545454 linear-gradient(transparent,rgba(0,0,0,.05));box-shadow:none}.ui.inverted.block.header{border-bottom:none}.ui.red.header{color:#e23c4e!important}a.ui.red.header:hover{color:#e81d33!important}.ui.red.dividing.header{border-bottom:0 solid #e23c4e}.ui.inverted.red.header{color:#f77482!important}a.ui.inverted.red.header:hover{color:#fd5466!important}.ui.orange.header{color:#f8813d!important}a.ui.orange.header:hover{color:#ff6f1c!important}.ui.orange.dividing.header{border-bottom:0 solid #f8813d}.ui.inverted.orange.header{color:#ff8945!important}a.ui.inverted.orange.header:hover{color:#ff792c!important}.ui.olive.header{color:#456558!important}a.ui.olive.header:hover{color:#39574b!important}.ui.olive.dividing.header{border-bottom:0 solid #456558}.ui.inverted.olive.header{color:#52a583!important}a.ui.inverted.olive.header:hover{color:#459876!important}.ui.yellow.header{color:#ffca18!important}a.ui.yellow.header:hover{color:#fec300!important}.ui.yellow.dividing.header{border-bottom:0 solid #ffca18}.ui.inverted.yellow.header{color:#ffca18!important}a.ui.inverted.yellow.header:hover{color:#fec300!important}.ui.green.header{color:#54af71!important}a.ui.green.header:hover{color:#46a364!important}.ui.green.dividing.header{border-bottom:0 solid #54af71}.ui.inverted.green.header{color:#68ce88!important}a.ui.inverted.green.header:hover{color:#4fce77!important}.ui.teal.header{color:#00a1ca!important}a.ui.teal.header:hover{color:#008db1!important}.ui.teal.dividing.header{border-bottom:0 solid #00a1ca}.ui.inverted.teal.header{color:#00cafd!important}a.ui.inverted.teal.header:hover{color:#00b5e4!important}.ui.blue.header{color:#1d5f82!important}a.ui.blue.header:hover{color:#145171!important}.ui.blue.dividing.header{border-bottom:0 solid #1d5f82}.ui.inverted.blue.header{color:#1782bb!important}a.ui.inverted.blue.header:hover{color:#0d75ac!important}.ui.violet.header{color:#525394!important}a.ui.violet.header:hover{color:#464787!important}.ui.violet.dividing.header{border-bottom:0 solid #525394}.ui.inverted.violet.header{color:#6d6ec6!important}a.ui.inverted.violet.header:hover{color:#5557c4!important}.ui.purple.header{color:#ad427f!important}a.ui.purple.header:hover{color:#9f3672!important}.ui.purple.dividing.header{border-bottom:0 solid #ad427f}.ui.inverted.purple.header{color:#d864a6!important}a.ui.inverted.purple.header:hover{color:#d9499b!important}.ui.pink.header{color:#e03997!important}a.ui.pink.header:hover{color:#e61a8d!important}.ui.pink.dividing.header{border-bottom:0 solid #e03997}.ui.inverted.pink.header{color:#f670bb!important}a.ui.inverted.pink.header:hover{color:#fc50b1!important}.ui.brown.header{color:#a67a00!important}a.ui.brown.header:hover{color:#8d6700!important}.ui.brown.dividing.header{border-bottom:0 solid #a67a00}.ui.inverted.brown.header{color:#f3b200!important}a.ui.inverted.brown.header:hover{color:#d99f00!important}.ui.grey.header{color:#5a686d!important}a.ui.grey.header:hover{color:#66757b!important}.ui.grey.dividing.header{border-bottom:0 solid #5a686d}.ui.inverted.grey.header{color:#7f8f95!important}a.ui.inverted.grey.header:hover{color:#70838a!important}.ui.left.aligned.header{text-align:left}.ui.right.aligned.header{text-align:right}.ui.center.aligned.header,.ui.centered.header{text-align:center}.ui.justified.header{text-align:justify}.ui.justified.header:after{display:inline-block;content:\"\";width:100%}.ui.floated.header,.ui[class*=\"left floated\"].header{float:left;margin-top:0;margin-right:.5em}.ui[class*=\"right floated\"].header{float:right;margin-top:0;margin-left:.5em}.ui.fitted.header{padding:0}.ui.dividing.header{border-bottom:1px solid}.ui.dividing.header,.ui.dividing.header .sub.header{padding-bottom:.17647059rem}.ui.inverted.dividing.header{border-bottom-color:currentColor}.ui.block.header{background:rgba(0,0,0,.1);padding:.64705882rem 1rem;box-shadow:none;border:0 solid #d4d4d5;border-radius:.11764706rem}.ui.tiny.block.header{font-size:.70588235rem}.ui.small.block.header{font-size:.88235294rem}.ui.block.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6){font-size:1rem}.ui.large.block.header{font-size:1.17647059rem}.ui.huge.block.header{font-size:1.58823529rem}.ui.attached.header{padding:.64705882rem 1rem;margin-left:0;margin-right:0;box-shadow:none;border:1px solid #d4d4d5}.ui.attached.block.header,.ui.attached.header{background:rgba(0,0,0,.1)}.ui.attached:not(.top):not(.bottom).header{margin-top:0;margin-bottom:0;border-top:none;border-radius:0}.ui.top.attached.header{margin-bottom:0;border-radius:.11764706rem .11764706rem 0 0}.ui.bottom.attached.header{margin-top:0;border-top:none;border-radius:0 0 .11764706rem .11764706rem}.ui.tiny.attached.header{font-size:.70588235em}.ui.small.attached.header{font-size:.88235294em}.ui.attached.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6){font-size:1em}.ui.large.attached.header{font-size:1.17647059em}.ui.huge.attached.header{font-size:1.58823529em}.ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6){font-size:2.059em}.ui.header .sub.header{font-family:Georgia,serif;font-weight:500;line-height:1.25em}.ui.header .sub.header.meta{color:rgba(0,0,0,.4);font-weight:500}.infographic .ui.header,.ui.infographic.header{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;font-weight:700}.infographic .ui.header.huge,.infographic .ui.header.large,.ui.infographic.header.huge,.ui.infographic.header.large{font-weight:200}.infographic .ui.header .sub.header,.ui.infographic.header .sub.header{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.ui.sub.header{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.ui.dividing.header{padding-bottom:0;padding-top:.17647059rem;border-top:1px solid;border-bottom:none}.ui.dividing.header .sub.header{padding-bottom:0}.ui.dividing.header .icon{margin-bottom:0}.ui.dividing.header.inverted{border-bottom-color:transparent;border-top-color:currentColor}@media (max-width:600px){.ui.header .sub.header{line-height:1.2em}h1.ui.header{font-size:2.005rem}h1.ui.header .sub.header{font-size:1.17647059rem}h2.ui.header{font-size:1.685rem}h2.ui.header .sub.header{font-size:1.17647059rem}h3.ui.header{font-size:1.416rem}h3.ui.header .sub.header{font-size:1.17647059rem}h4.ui.header{font-size:1.19rem}h5.ui.header{font-size:1rem}}.ui.attached.header{border:none;border-top:1px solid #d4d4d5}.ui.top.attached.header{border-top:none}.ui.blue.segment .ui.attached.header:not(.inverted),.ui.brown.segment .ui.attached.header:not(.inverted),.ui.green.segment .ui.attached.header:not(.inverted),.ui.grey.segment .ui.attached.header:not(.inverted),.ui.olive.segment .ui.attached.header:not(.inverted),.ui.orange.segment .ui.attached.header:not(.inverted),.ui.pink.segment .ui.attached.header:not(.inverted),.ui.purple.segment .ui.attached.header:not(.inverted),.ui.red.segment .ui.attached.header:not(.inverted),.ui.teal.segment .ui.attached.header:not(.inverted),.ui.violet.segment .ui.attached.header:not(.inverted),.ui.yellow.segment .ui.attached.header:not(.inverted){background-color:hsla(0,0%,100%,.85);border-top:none;margin-top:1px}.ui.inverted.segment .ui.attached.header:not(.inverted){color:rgba(0,0,0,.87)}", ""]);
	
	// exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Icon\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */@font-face{font-family:Icons;src:url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.eot\");src:url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.eot?#iefix\") format(\"embedded-opentype\"),url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.woff2\") format(\"woff2\"),url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.woff\") format(\"woff\"),url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.ttf\") format(\"truetype\"),url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.svg#icons\") format(\"svg\");font-style:normal;font-weight:400;font-variant:normal;text-decoration:inherit;text-transform:none}i.icon{display:inline-block;opacity:1;margin:0 .25rem 0 0;width:1.18em;height:1em;font-family:Icons;font-style:normal;font-weight:400;text-decoration:inherit;text-align:center;speak:none;font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;-webkit-backface-visibility:hidden;backface-visibility:hidden}i.icon:before{background:none!important}i.icon.loading{height:1em;line-height:1;-webkit-animation:icon-loading 2s linear infinite;animation:icon-loading 2s linear infinite}@-webkit-keyframes icon-loading{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes icon-loading{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}i.emphasized.icon,i.icon.active,i.icon.hover{opacity:1!important}i.disabled.icon{opacity:.45!important}i.fitted.icon{width:auto;margin:0}i.link.icon,i.link.icons{cursor:pointer;opacity:.8;transition:opacity .1s ease}i.link.icon:hover,i.link.icons:hover{opacity:1!important}i.circular.icon{border-radius:500em!important;line-height:1!important;padding:.5em!important;box-shadow:inset 0 0 0 .1em rgba(0,0,0,.1);width:2em!important;height:2em!important}i.circular.inverted.icon{border:none;box-shadow:none}i.flipped.icon,i.horizontally.flipped.icon{-webkit-transform:scaleX(-1);transform:scaleX(-1)}i.vertically.flipped.icon{-webkit-transform:scaleY(-1);transform:scaleY(-1)}i.clockwise.rotated.icon,i.right.rotated.icon,i.rotated.icon{-webkit-transform:rotate(90deg);transform:rotate(90deg)}i.counterclockwise.rotated.icon,i.left.rotated.icon{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}i.bordered.icon{line-height:1;vertical-align:baseline;width:2em;height:2em;padding:.5em .41em!important;box-shadow:inset 0 0 0 .1em rgba(0,0,0,.1)}i.bordered.inverted.icon{border:none;box-shadow:none}i.inverted.bordered.icon,i.inverted.circular.icon{background-color:#1b1c1d!important;color:#fff!important}i.inverted.icon{color:#fff}i.red.icon{color:#e23c4e!important}i.inverted.red.icon{color:#f77482!important}i.inverted.bordered.red.icon,i.inverted.circular.red.icon{background-color:#e23c4e!important;color:#fff!important}i.orange.icon{color:#f8813d!important}i.inverted.orange.icon{color:#ff8945!important}i.inverted.bordered.orange.icon,i.inverted.circular.orange.icon{background-color:#f8813d!important;color:#fff!important}i.inverted.yellow.icon,i.yellow.icon{color:#ffca18!important}i.inverted.bordered.yellow.icon,i.inverted.circular.yellow.icon{background-color:#ffca18!important;color:#fff!important}i.olive.icon{color:#456558!important}i.inverted.olive.icon{color:#52a583!important}i.inverted.bordered.olive.icon,i.inverted.circular.olive.icon{background-color:#456558!important;color:#fff!important}i.green.icon{color:#54af71!important}i.inverted.green.icon{color:#68ce88!important}i.inverted.bordered.green.icon,i.inverted.circular.green.icon{background-color:#54af71!important;color:#fff!important}i.teal.icon{color:#00a1ca!important}i.inverted.teal.icon{color:#00cafd!important}i.inverted.bordered.teal.icon,i.inverted.circular.teal.icon{background-color:#00a1ca!important;color:#fff!important}i.blue.icon{color:#1d5f82!important}i.inverted.blue.icon{color:#1782bb!important}i.inverted.bordered.blue.icon,i.inverted.circular.blue.icon{background-color:#1d5f82!important;color:#fff!important}i.violet.icon{color:#525394!important}i.inverted.violet.icon{color:#6d6ec6!important}i.inverted.bordered.violet.icon,i.inverted.circular.violet.icon{background-color:#525394!important;color:#fff!important}i.purple.icon{color:#ad427f!important}i.inverted.purple.icon{color:#d864a6!important}i.inverted.bordered.purple.icon,i.inverted.circular.purple.icon{background-color:#ad427f!important;color:#fff!important}i.pink.icon{color:#e03997!important}i.inverted.pink.icon{color:#f670bb!important}i.inverted.bordered.pink.icon,i.inverted.circular.pink.icon{background-color:#e03997!important;color:#fff!important}i.brown.icon{color:#a67a00!important}i.inverted.brown.icon{color:#f3b200!important}i.inverted.bordered.brown.icon,i.inverted.circular.brown.icon{background-color:#a67a00!important;color:#fff!important}i.grey.icon{color:#5a686d!important}i.inverted.grey.icon{color:#7f8f95!important}i.inverted.bordered.grey.icon,i.inverted.circular.grey.icon{background-color:#5a686d!important;color:#fff!important}i.black.icon{color:#1b1c1d!important}i.inverted.black.icon{color:#545454!important}i.inverted.bordered.black.icon,i.inverted.circular.black.icon{background-color:#1b1c1d!important;color:#fff!important}i.mini.icon,i.mini.icons{line-height:1;font-size:.4em}i.tiny.icon,i.tiny.icons{line-height:1;font-size:.5em}i.small.icon,i.small.icons{line-height:1;font-size:.75em}i.icon,i.icons{font-size:1em}i.large.icon,i.large.icons{line-height:1;vertical-align:middle;font-size:1.5em}i.big.icon,i.big.icons{line-height:1;vertical-align:middle;font-size:2em}i.huge.icon,i.huge.icons{line-height:1;vertical-align:middle;font-size:4em}i.massive.icon,i.massive.icons{line-height:1;vertical-align:middle;font-size:8em}i.icons{display:inline-block;position:relative;line-height:1}i.icons .icon{position:absolute;top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);margin:0}i.icons .icon:first-child{position:static;width:auto;height:auto;vertical-align:top;-webkit-transform:none;transform:none;margin-right:.25rem}i.icons .corner.icon{top:auto;left:auto;right:0;bottom:0;-webkit-transform:none;transform:none;font-size:.45em;text-shadow:-1px -1px 0 #fff,1px -1px 0 #fff,-1px 1px 0 #fff,1px 1px 0 #fff}i.icons .top.right.corner.icon{top:0;left:auto;right:0;bottom:auto}i.icons .top.left.corner.icon{top:0;left:0;right:auto;bottom:auto}i.icons .bottom.left.corner.icon{top:auto;left:0;right:auto;bottom:0}i.icons .bottom.right.corner.icon{top:auto;left:auto;right:0;bottom:0}i.icons .inverted.corner.icon{text-shadow:-1px -1px 0 #1b1c1d,1px -1px 0 #1b1c1d,-1px 1px 0 #1b1c1d,1px 1px 0 #1b1c1d}i.icon.search:before{content:\"\\F002\"}i.icon.mail.outline:before{content:\"\\F003\"}i.icon.signal:before{content:\"\\F012\"}i.icon.setting:before{content:\"\\F013\"}i.icon.home:before{content:\"\\F015\"}i.icon.inbox:before{content:\"\\F01C\"}i.icon.browser:before{content:\"\\F022\"}i.icon.tag:before{content:\"\\F02B\"}i.icon.tags:before{content:\"\\F02C\"}i.icon.image:before{content:\"\\F03E\"}i.icon.calendar:before{content:\"\\F073\"}i.icon.comment:before{content:\"\\F075\"}i.icon.shop:before{content:\"\\F07A\"}i.icon.privacy:before{content:\"\\F084\"}i.icon.settings:before{content:\"\\F085\"}i.icon.comments:before{content:\"\\F086\"}i.icon.external:before{content:\"\\F08E\"}i.icon.trophy:before{content:\"\\F091\"}i.icon.payment:before{content:\"\\F09D\"}i.icon.feed:before{content:\"\\F09E\"}i.icon.alarm.outline:before{content:\"\\F0A2\"}i.icon.tasks:before{content:\"\\F0AE\"}i.icon.cloud:before{content:\"\\F0C2\"}i.icon.lab:before{content:\"\\F0C3\"}i.icon.mail:before{content:\"\\F0E0\"}i.icon.dashboard:before{content:\"\\F0E4\"}i.icon.comment.outline:before{content:\"\\F0E5\"}i.icon.comments.outline:before{content:\"\\F0E6\"}i.icon.sitemap:before{content:\"\\F0E8\"}i.icon.idea:before{content:\"\\F0EB\"}i.icon.alarm:before{content:\"\\F0F3\"}i.icon.terminal:before{content:\"\\F120\"}i.icon.code:before{content:\"\\F121\"}i.icon.protect:before{content:\"\\F132\"}i.icon.calendar.outline:before{content:\"\\F133\"}i.icon.ticket:before{content:\"\\F145\"}i.icon.external.square:before{content:\"\\F14C\"}i.icon.bug:before{content:\"\\F188\"}i.icon.mail.square:before{content:\"\\F199\"}i.icon.history:before{content:\"\\F1DA\"}i.icon.options:before{content:\"\\F1DE\"}i.icon.text.telephone:before{content:\"\\F1E4\"}i.icon.find:before{content:\"\\F1E5\"}i.icon.alarm.mute:before{content:\"\\F1F6\"}i.icon.alarm.mute.outline:before{content:\"\\F1F7\"}i.icon.copyright:before{content:\"\\F1F9\"}i.icon.at:before{content:\"\\F1FA\"}i.icon.eyedropper:before{content:\"\\F1FB\"}i.icon.paint.brush:before{content:\"\\F1FC\"}i.icon.heartbeat:before{content:\"\\F21E\"}i.icon.mouse.pointer:before{content:\"\\F245\"}i.icon.hourglass.empty:before{content:\"\\F250\"}i.icon.hourglass.start:before{content:\"\\F251\"}i.icon.hourglass.half:before{content:\"\\F252\"}i.icon.hourglass.end:before{content:\"\\F253\"}i.icon.hourglass.full:before{content:\"\\F254\"}i.icon.hand.pointer:before{content:\"\\F25A\"}i.icon.trademark:before{content:\"\\F25C\"}i.icon.registered:before{content:\"\\F25D\"}i.icon.creative.commons:before{content:\"\\F25E\"}i.icon.add.to.calendar:before{content:\"\\F271\"}i.icon.remove.from.calendar:before{content:\"\\F272\"}i.icon.delete.calendar:before{content:\"\\F273\"}i.icon.checked.calendar:before{content:\"\\F274\"}i.icon.industry:before{content:\"\\F275\"}i.icon.shopping.bag:before{content:\"\\F290\"}i.icon.shopping.basket:before{content:\"\\F291\"}i.icon.hashtag:before{content:\"\\F292\"}i.icon.percent:before{content:\"\\F295\"}i.icon.handshake:before{content:\"\\F2B5\"}i.icon.open.envelope:before{content:\"\\F2B6\"}i.icon.open.envelope.outline:before{content:\"\\F2B7\"}i.icon.address.book:before{content:\"\\F2B9\"}i.icon.address.book.outline:before{content:\"\\F2BA\"}i.icon.address.card:before{content:\"\\F2BB\"}i.icon.address.card.outline:before{content:\"\\F2BC\"}i.icon.id.badge:before{content:\"\\F2C1\"}i.icon.id.card:before{content:\"\\F2C2\"}i.icon.id.card.outline:before{content:\"\\F2C3\"}i.icon.podcast:before{content:\"\\F2CE\"}i.icon.window.maximize:before{content:\"\\F2D0\"}i.icon.window.minimize:before{content:\"\\F2D1\"}i.icon.window.restore:before{content:\"\\F2D2\"}i.icon.window.close:before{content:\"\\F2D3\"}i.icon.window.close.outline:before{content:\"\\F2D4\"}i.icon.wait:before{content:\"\\F017\"}i.icon.download:before{content:\"\\F019\"}i.icon.repeat:before{content:\"\\F01E\"}i.icon.refresh:before{content:\"\\F021\"}i.icon.lock:before{content:\"\\F023\"}i.icon.bookmark:before{content:\"\\F02E\"}i.icon.print:before{content:\"\\F02F\"}i.icon.write:before{content:\"\\F040\"}i.icon.adjust:before{content:\"\\F042\"}i.icon.theme:before{content:\"\\F043\"}i.icon.edit:before{content:\"\\F044\"}i.icon.external.share:before{content:\"\\F045\"}i.icon.ban:before{content:\"\\F05E\"}i.icon.mail.forward:before,i.icon.share:before{content:\"\\F064\"}i.icon.expand:before{content:\"\\F065\"}i.icon.compress:before{content:\"\\F066\"}i.icon.unhide:before{content:\"\\F06E\"}i.icon.hide:before{content:\"\\F070\"}i.icon.random:before{content:\"\\F074\"}i.icon.retweet:before{content:\"\\F079\"}i.icon.sign.out:before{content:\"\\F08B\"}i.icon.pin:before{content:\"\\F08D\"}i.icon.sign.in:before{content:\"\\F090\"}i.icon.upload:before{content:\"\\F093\"}i.icon.call:before{content:\"\\F095\"}i.icon.remove.bookmark:before{content:\"\\F097\"}i.icon.call.square:before{content:\"\\F098\"}i.icon.unlock:before{content:\"\\F09C\"}i.icon.configure:before{content:\"\\F0AD\"}i.icon.filter:before{content:\"\\F0B0\"}i.icon.wizard:before{content:\"\\F0D0\"}i.icon.undo:before{content:\"\\F0E2\"}i.icon.exchange:before{content:\"\\F0EC\"}i.icon.cloud.download:before{content:\"\\F0ED\"}i.icon.cloud.upload:before{content:\"\\F0EE\"}i.icon.reply:before{content:\"\\F112\"}i.icon.reply.all:before{content:\"\\F122\"}i.icon.erase:before{content:\"\\F12D\"}i.icon.unlock.alternate:before{content:\"\\F13E\"}i.icon.write.square:before{content:\"\\F14B\"}i.icon.share.square:before{content:\"\\F14D\"}i.icon.archive:before{content:\"\\F187\"}i.icon.translate:before{content:\"\\F1AB\"}i.icon.recycle:before{content:\"\\F1B8\"}i.icon.send:before{content:\"\\F1D8\"}i.icon.send.outline:before{content:\"\\F1D9\"}i.icon.share.alternate:before{content:\"\\F1E0\"}i.icon.share.alternate.square:before{content:\"\\F1E1\"}i.icon.add.to.cart:before{content:\"\\F217\"}i.icon.in.cart:before{content:\"\\F218\"}i.icon.add.user:before{content:\"\\F234\"}i.icon.remove.user:before{content:\"\\F235\"}i.icon.object.group:before{content:\"\\F247\"}i.icon.object.ungroup:before{content:\"\\F248\"}i.icon.clone:before{content:\"\\F24D\"}i.icon.talk:before{content:\"\\F27A\"}i.icon.talk.outline:before{content:\"\\F27B\"}i.icon.help.circle:before{content:\"\\F059\"}i.icon.info.circle:before{content:\"\\F05A\"}i.icon.warning.circle:before{content:\"\\F06A\"}i.icon.warning.sign:before{content:\"\\F071\"}i.icon.announcement:before{content:\"\\F0A1\"}i.icon.help:before{content:\"\\F128\"}i.icon.info:before{content:\"\\F129\"}i.icon.warning:before{content:\"\\F12A\"}i.icon.birthday:before{content:\"\\F1FD\"}i.icon.help.circle.outline:before{content:\"\\F29C\"}i.icon.user:before{content:\"\\F007\"}i.icon.users:before{content:\"\\F0C0\"}i.icon.doctor:before{content:\"\\F0F0\"}i.icon.handicap:before{content:\"\\F193\"}i.icon.student:before{content:\"\\F19D\"}i.icon.child:before{content:\"\\F1AE\"}i.icon.spy:before{content:\"\\F21B\"}i.icon.user.circle:before{content:\"\\F2BD\"}i.icon.user.circle.outline:before{content:\"\\F2BE\"}i.icon.user.outline:before{content:\"\\F2C0\"}i.icon.female:before{content:\"\\F182\"}i.icon.male:before{content:\"\\F183\"}i.icon.woman:before{content:\"\\F221\"}i.icon.man:before{content:\"\\F222\"}i.icon.non.binary.transgender:before{content:\"\\F223\"}i.icon.intergender:before{content:\"\\F224\"}i.icon.transgender:before{content:\"\\F225\"}i.icon.lesbian:before{content:\"\\F226\"}i.icon.gay:before{content:\"\\F227\"}i.icon.heterosexual:before{content:\"\\F228\"}i.icon.other.gender:before{content:\"\\F229\"}i.icon.other.gender.vertical:before{content:\"\\F22A\"}i.icon.other.gender.horizontal:before{content:\"\\F22B\"}i.icon.neuter:before{content:\"\\F22C\"}i.icon.genderless:before{content:\"\\F22D\"}i.icon.universal.access:before{content:\"\\F29A\"}i.icon.wheelchair:before{content:\"\\F29B\"}i.icon.blind:before{content:\"\\F29D\"}i.icon.audio.description:before{content:\"\\F29E\"}i.icon.volume.control.phone:before{content:\"\\F2A0\"}i.icon.braille:before{content:\"\\F2A1\"}i.icon.asl:before{content:\"\\F2A3\"}i.icon.assistive.listening.systems:before{content:\"\\F2A2\"}i.icon.deafness:before{content:\"\\F2A4\"}i.icon.sign.language:before{content:\"\\F2A7\"}i.icon.low.vision:before{content:\"\\F2A8\"}i.icon.block.layout:before{content:\"\\F009\"}i.icon.grid.layout:before{content:\"\\F00A\"}i.icon.list.layout:before{content:\"\\F00B\"}i.icon.zoom:before{content:\"\\F00E\"}i.icon.zoom.out:before{content:\"\\F010\"}i.icon.resize.vertical:before{content:\"\\F07D\"}i.icon.resize.horizontal:before{content:\"\\F07E\"}i.icon.maximize:before{content:\"\\F0B2\"}i.icon.crop:before{content:\"\\F125\"}i.icon.cocktail:before{content:\"\\F000\"}i.icon.road:before{content:\"\\F018\"}i.icon.flag:before{content:\"\\F024\"}i.icon.book:before{content:\"\\F02D\"}i.icon.gift:before{content:\"\\F06B\"}i.icon.leaf:before{content:\"\\F06C\"}i.icon.fire:before{content:\"\\F06D\"}i.icon.plane:before{content:\"\\F072\"}i.icon.magnet:before{content:\"\\F076\"}i.icon.lemon:before{content:\"\\F094\"}i.icon.world:before{content:\"\\F0AC\"}i.icon.travel:before{content:\"\\F0B1\"}i.icon.shipping:before{content:\"\\F0D1\"}i.icon.money:before{content:\"\\F0D6\"}i.icon.legal:before{content:\"\\F0E3\"}i.icon.lightning:before{content:\"\\F0E7\"}i.icon.umbrella:before{content:\"\\F0E9\"}i.icon.treatment:before{content:\"\\F0F1\"}i.icon.suitcase:before{content:\"\\F0F2\"}i.icon.bar:before{content:\"\\F0FC\"}i.icon.flag.outline:before{content:\"\\F11D\"}i.icon.flag.checkered:before{content:\"\\F11E\"}i.icon.puzzle:before{content:\"\\F12E\"}i.icon.fire.extinguisher:before{content:\"\\F134\"}i.icon.rocket:before{content:\"\\F135\"}i.icon.anchor:before{content:\"\\F13D\"}i.icon.bullseye:before{content:\"\\F140\"}i.icon.sun:before{content:\"\\F185\"}i.icon.moon:before{content:\"\\F186\"}i.icon.fax:before{content:\"\\F1AC\"}i.icon.life.ring:before{content:\"\\F1CD\"}i.icon.bomb:before{content:\"\\F1E2\"}i.icon.soccer:before{content:\"\\F1E3\"}i.icon.calculator:before{content:\"\\F1EC\"}i.icon.diamond:before{content:\"\\F219\"}i.icon.sticky.note:before{content:\"\\F249\"}i.icon.sticky.note.outline:before{content:\"\\F24A\"}i.icon.law:before{content:\"\\F24E\"}i.icon.hand.peace:before{content:\"\\F25B\"}i.icon.hand.rock:before{content:\"\\F255\"}i.icon.hand.paper:before{content:\"\\F256\"}i.icon.hand.scissors:before{content:\"\\F257\"}i.icon.hand.lizard:before{content:\"\\F258\"}i.icon.hand.spock:before{content:\"\\F259\"}i.icon.tv:before{content:\"\\F26C\"}i.icon.thermometer.full:before{content:\"\\F2C7\"}i.icon.thermometer.three.quarters:before{content:\"\\F2C8\"}i.icon.thermometer.half:before{content:\"\\F2C9\"}i.icon.thermometer.quarter:before{content:\"\\F2CA\"}i.icon.thermometer.empty:before{content:\"\\F2CB\"}i.icon.shower:before{content:\"\\F2CC\"}i.icon.bathtub:before{content:\"\\F2CD\"}i.icon.snowflake:before{content:\"\\F2DC\"}i.icon.crosshairs:before{content:\"\\F05B\"}i.icon.asterisk:before{content:\"\\F069\"}i.icon.square.outline:before{content:\"\\F096\"}i.icon.certificate:before{content:\"\\F0A3\"}i.icon.square:before{content:\"\\F0C8\"}i.icon.quote.left:before{content:\"\\F10D\"}i.icon.quote.right:before{content:\"\\F10E\"}i.icon.spinner:before{content:\"\\F110\"}i.icon.circle:before{content:\"\\F111\"}i.icon.ellipsis.horizontal:before{content:\"\\F141\"}i.icon.ellipsis.vertical:before{content:\"\\F142\"}i.icon.cube:before{content:\"\\F1B2\"}i.icon.cubes:before{content:\"\\F1B3\"}i.icon.circle.notched:before{content:\"\\F1CE\"}i.icon.circle.thin:before{content:\"\\F1DB\"}i.icon.checkmark:before{content:\"\\F00C\"}i.icon.remove:before{content:\"\\F00D\"}i.icon.checkmark.box:before{content:\"\\F046\"}i.icon.move:before{content:\"\\F047\"}i.icon.add.circle:before{content:\"\\F055\"}i.icon.minus.circle:before{content:\"\\F056\"}i.icon.remove.circle:before{content:\"\\F057\"}i.icon.check.circle:before{content:\"\\F058\"}i.icon.remove.circle.outline:before{content:\"\\F05C\"}i.icon.check.circle.outline:before{content:\"\\F05D\"}i.icon.plus:before{content:\"\\F067\"}i.icon.minus:before{content:\"\\F068\"}i.icon.add.square:before{content:\"\\F0FE\"}i.icon.radio:before{content:\"\\F10C\"}i.icon.minus.square:before{content:\"\\F146\"}i.icon.minus.square.outline:before{content:\"\\F147\"}i.icon.check.square:before{content:\"\\F14A\"}i.icon.selected.radio:before{content:\"\\F192\"}i.icon.plus.square.outline:before{content:\"\\F196\"}i.icon.toggle.off:before{content:\"\\F204\"}i.icon.toggle.on:before{content:\"\\F205\"}i.icon.film:before{content:\"\\F008\"}i.icon.sound:before{content:\"\\F025\"}i.icon.photo:before{content:\"\\F030\"}i.icon.bar.chart:before{content:\"\\F080\"}i.icon.camera.retro:before{content:\"\\F083\"}i.icon.newspaper:before{content:\"\\F1EA\"}i.icon.area.chart:before{content:\"\\F1FE\"}i.icon.pie.chart:before{content:\"\\F200\"}i.icon.line.chart:before{content:\"\\F201\"}i.icon.arrow.circle.outline.down:before{content:\"\\F01A\"}i.icon.arrow.circle.outline.up:before{content:\"\\F01B\"}i.icon.chevron.left:before{content:\"\\F053\"}i.icon.chevron.right:before{content:\"\\F054\"}i.icon.arrow.left:before{content:\"\\F060\"}i.icon.arrow.right:before{content:\"\\F061\"}i.icon.arrow.up:before{content:\"\\F062\"}i.icon.arrow.down:before{content:\"\\F063\"}i.icon.chevron.up:before{content:\"\\F077\"}i.icon.chevron.down:before{content:\"\\F078\"}i.icon.pointing.right:before{content:\"\\F0A4\"}i.icon.pointing.left:before{content:\"\\F0A5\"}i.icon.pointing.up:before{content:\"\\F0A6\"}i.icon.pointing.down:before{content:\"\\F0A7\"}i.icon.arrow.circle.left:before{content:\"\\F0A8\"}i.icon.arrow.circle.right:before{content:\"\\F0A9\"}i.icon.arrow.circle.up:before{content:\"\\F0AA\"}i.icon.arrow.circle.down:before{content:\"\\F0AB\"}i.icon.caret.down:before{content:\"\\F0D7\"}i.icon.caret.up:before{content:\"\\F0D8\"}i.icon.caret.left:before{content:\"\\F0D9\"}i.icon.caret.right:before{content:\"\\F0DA\"}i.icon.angle.double.left:before{content:\"\\F100\"}i.icon.angle.double.right:before{content:\"\\F101\"}i.icon.angle.double.up:before{content:\"\\F102\"}i.icon.angle.double.down:before{content:\"\\F103\"}i.icon.angle.left:before{content:\"\\F104\"}i.icon.angle.right:before{content:\"\\F105\"}i.icon.angle.up:before{content:\"\\F106\"}i.icon.angle.down:before{content:\"\\F107\"}i.icon.chevron.circle.left:before{content:\"\\F137\"}i.icon.chevron.circle.right:before{content:\"\\F138\"}i.icon.chevron.circle.up:before{content:\"\\F139\"}i.icon.chevron.circle.down:before{content:\"\\F13A\"}i.icon.toggle.down:before{content:\"\\F150\"}i.icon.toggle.up:before{content:\"\\F151\"}i.icon.toggle.right:before{content:\"\\F152\"}i.icon.long.arrow.down:before{content:\"\\F175\"}i.icon.long.arrow.up:before{content:\"\\F176\"}i.icon.long.arrow.left:before{content:\"\\F177\"}i.icon.long.arrow.right:before{content:\"\\F178\"}i.icon.arrow.circle.outline.right:before{content:\"\\F18E\"}i.icon.arrow.circle.outline.left:before{content:\"\\F190\"}i.icon.toggle.left:before{content:\"\\F191\"}i.icon.tablet:before{content:\"\\F10A\"}i.icon.mobile:before{content:\"\\F10B\"}i.icon.battery.full:before{content:\"\\F240\"}i.icon.battery.high:before{content:\"\\F241\"}i.icon.battery.medium:before{content:\"\\F242\"}i.icon.battery.low:before{content:\"\\F243\"}i.icon.battery.empty:before{content:\"\\F244\"}i.icon.power:before{content:\"\\F011\"}i.icon.trash.outline:before{content:\"\\F014\"}i.icon.disk.outline:before{content:\"\\F0A0\"}i.icon.desktop:before{content:\"\\F108\"}i.icon.laptop:before{content:\"\\F109\"}i.icon.game:before{content:\"\\F11B\"}i.icon.keyboard:before{content:\"\\F11C\"}i.icon.plug:before{content:\"\\F1E6\"}i.icon.trash:before{content:\"\\F1F8\"}i.icon.file.outline:before{content:\"\\F016\"}i.icon.folder:before{content:\"\\F07B\"}i.icon.folder.open:before{content:\"\\F07C\"}i.icon.file.text.outline:before{content:\"\\F0F6\"}i.icon.folder.outline:before{content:\"\\F114\"}i.icon.folder.open.outline:before{content:\"\\F115\"}i.icon.level.up:before{content:\"\\F148\"}i.icon.level.down:before{content:\"\\F149\"}i.icon.file:before{content:\"\\F15B\"}i.icon.file.text:before{content:\"\\F15C\"}i.icon.file.pdf.outline:before{content:\"\\F1C1\"}i.icon.file.word.outline:before{content:\"\\F1C2\"}i.icon.file.excel.outline:before{content:\"\\F1C3\"}i.icon.file.powerpoint.outline:before{content:\"\\F1C4\"}i.icon.file.image.outline:before{content:\"\\F1C5\"}i.icon.file.archive.outline:before{content:\"\\F1C6\"}i.icon.file.audio.outline:before{content:\"\\F1C7\"}i.icon.file.video.outline:before{content:\"\\F1C8\"}i.icon.file.code.outline:before{content:\"\\F1C9\"}i.icon.qrcode:before{content:\"\\F029\"}i.icon.barcode:before{content:\"\\F02A\"}i.icon.rss:before{content:\"\\F09E\"}i.icon.fork:before{content:\"\\F126\"}i.icon.html5:before{content:\"\\F13B\"}i.icon.css3:before{content:\"\\F13C\"}i.icon.rss.square:before{content:\"\\F143\"}i.icon.openid:before{content:\"\\F19B\"}i.icon.database:before{content:\"\\F1C0\"}i.icon.wifi:before{content:\"\\F1EB\"}i.icon.server:before{content:\"\\F233\"}i.icon.usb:before{content:\"\\F287\"}i.icon.bluetooth:before{content:\"\\F293\"}i.icon.bluetooth.alternative:before{content:\"\\F294\"}i.icon.microchip:before{content:\"\\F2DB\"}i.icon.heart:before{content:\"\\F004\"}i.icon.star:before{content:\"\\F005\"}i.icon.empty.star:before{content:\"\\F006\"}i.icon.thumbs.outline.up:before{content:\"\\F087\"}i.icon.thumbs.outline.down:before{content:\"\\F088\"}i.icon.star.half:before{content:\"\\F089\"}i.icon.empty.heart:before{content:\"\\F08A\"}i.icon.smile:before{content:\"\\F118\"}i.icon.frown:before{content:\"\\F119\"}i.icon.meh:before{content:\"\\F11A\"}i.icon.star.half.empty:before{content:\"\\F123\"}i.icon.thumbs.up:before{content:\"\\F164\"}i.icon.thumbs.down:before{content:\"\\F165\"}i.icon.music:before{content:\"\\F001\"}i.icon.video.play.outline:before{content:\"\\F01D\"}i.icon.volume.off:before{content:\"\\F026\"}i.icon.volume.down:before{content:\"\\F027\"}i.icon.volume.up:before{content:\"\\F028\"}i.icon.record:before{content:\"\\F03D\"}i.icon.step.backward:before{content:\"\\F048\"}i.icon.fast.backward:before{content:\"\\F049\"}i.icon.backward:before{content:\"\\F04A\"}i.icon.play:before{content:\"\\F04B\"}i.icon.pause:before{content:\"\\F04C\"}i.icon.stop:before{content:\"\\F04D\"}i.icon.forward:before{content:\"\\F04E\"}i.icon.fast.forward:before{content:\"\\F050\"}i.icon.step.forward:before{content:\"\\F051\"}i.icon.eject:before{content:\"\\F052\"}i.icon.unmute:before{content:\"\\F130\"}i.icon.mute:before{content:\"\\F131\"}i.icon.video.play:before{content:\"\\F144\"}i.icon.closed.captioning:before{content:\"\\F20A\"}i.icon.pause.circle:before{content:\"\\F28B\"}i.icon.pause.circle.outline:before{content:\"\\F28C\"}i.icon.stop.circle:before{content:\"\\F28D\"}i.icon.stop.circle.outline:before{content:\"\\F28E\"}i.icon.marker:before{content:\"\\F041\"}i.icon.coffee:before{content:\"\\F0F4\"}i.icon.food:before{content:\"\\F0F5\"}i.icon.building.outline:before{content:\"\\F0F7\"}i.icon.hospital:before{content:\"\\F0F8\"}i.icon.emergency:before{content:\"\\F0F9\"}i.icon.first.aid:before{content:\"\\F0FA\"}i.icon.military:before{content:\"\\F0FB\"}i.icon.h:before{content:\"\\F0FD\"}i.icon.location.arrow:before{content:\"\\F124\"}i.icon.compass:before{content:\"\\F14E\"}i.icon.space.shuttle:before{content:\"\\F197\"}i.icon.university:before{content:\"\\F19C\"}i.icon.building:before{content:\"\\F1AD\"}i.icon.paw:before{content:\"\\F1B0\"}i.icon.spoon:before{content:\"\\F1B1\"}i.icon.car:before{content:\"\\F1B9\"}i.icon.taxi:before{content:\"\\F1BA\"}i.icon.tree:before{content:\"\\F1BB\"}i.icon.bicycle:before{content:\"\\F206\"}i.icon.bus:before{content:\"\\F207\"}i.icon.ship:before{content:\"\\F21A\"}i.icon.motorcycle:before{content:\"\\F21C\"}i.icon.street.view:before{content:\"\\F21D\"}i.icon.hotel:before{content:\"\\F236\"}i.icon.train:before{content:\"\\F238\"}i.icon.subway:before{content:\"\\F239\"}i.icon.map.pin:before{content:\"\\F276\"}i.icon.map.signs:before{content:\"\\F277\"}i.icon.map.outline:before{content:\"\\F278\"}i.icon.map:before{content:\"\\F279\"}i.icon.table:before{content:\"\\F0CE\"}i.icon.columns:before{content:\"\\F0DB\"}i.icon.sort:before{content:\"\\F0DC\"}i.icon.sort.descending:before{content:\"\\F0DD\"}i.icon.sort.ascending:before{content:\"\\F0DE\"}i.icon.sort.alphabet.ascending:before{content:\"\\F15D\"}i.icon.sort.alphabet.descending:before{content:\"\\F15E\"}i.icon.sort.content.ascending:before{content:\"\\F160\"}i.icon.sort.content.descending:before{content:\"\\F161\"}i.icon.sort.numeric.ascending:before{content:\"\\F162\"}i.icon.sort.numeric.descending:before{content:\"\\F163\"}i.icon.font:before{content:\"\\F031\"}i.icon.bold:before{content:\"\\F032\"}i.icon.italic:before{content:\"\\F033\"}i.icon.text.height:before{content:\"\\F034\"}i.icon.text.width:before{content:\"\\F035\"}i.icon.align.left:before{content:\"\\F036\"}i.icon.align.center:before{content:\"\\F037\"}i.icon.align.right:before{content:\"\\F038\"}i.icon.align.justify:before{content:\"\\F039\"}i.icon.list:before{content:\"\\F03A\"}i.icon.outdent:before{content:\"\\F03B\"}i.icon.indent:before{content:\"\\F03C\"}i.icon.cut:before{content:\"\\F0C4\"}i.icon.copy:before{content:\"\\F0C5\"}i.icon.attach:before{content:\"\\F0C6\"}i.icon.save:before{content:\"\\F0C7\"}i.icon.content:before{content:\"\\F0C9\"}i.icon.unordered.list:before{content:\"\\F0CA\"}i.icon.ordered.list:before{content:\"\\F0CB\"}i.icon.strikethrough:before{content:\"\\F0CC\"}i.icon.underline:before{content:\"\\F0CD\"}i.icon.paste:before{content:\"\\F0EA\"}i.icon.unlinkify:before{content:\"\\F127\"}i.icon.superscript:before{content:\"\\F12B\"}i.icon.subscript:before{content:\"\\F12C\"}i.icon.header:before{content:\"\\F1DC\"}i.icon.paragraph:before{content:\"\\F1DD\"}i.icon.text.cursor:before{content:\"\\F246\"}i.icon.euro:before{content:\"\\F153\"}i.icon.pound:before{content:\"\\F154\"}i.icon.dollar:before{content:\"\\F155\"}i.icon.rupee:before{content:\"\\F156\"}i.icon.yen:before{content:\"\\F157\"}i.icon.ruble:before{content:\"\\F158\"}i.icon.won:before{content:\"\\F159\"}i.icon.bitcoin:before{content:\"\\F15A\"}i.icon.lira:before{content:\"\\F195\"}i.icon.shekel:before{content:\"\\F20B\"}i.icon.paypal:before{content:\"\\F1ED\"}i.icon.google.wallet:before{content:\"\\F1EE\"}i.icon.visa:before{content:\"\\F1F0\"}i.icon.mastercard:before{content:\"\\F1F1\"}i.icon.discover:before{content:\"\\F1F2\"}i.icon.american.express:before{content:\"\\F1F3\"}i.icon.paypal.card:before{content:\"\\F1F4\"}i.icon.stripe:before{content:\"\\F1F5\"}i.icon.japan.credit.bureau:before{content:\"\\F24B\"}i.icon.diners.club:before{content:\"\\F24C\"}i.icon.credit.card.alternative:before{content:\"\\F283\"}i.icon.twitter.square:before{content:\"\\F081\"}i.icon.facebook.square:before{content:\"\\F082\"}i.icon.linkedin.square:before{content:\"\\F08C\"}i.icon.github.square:before{content:\"\\F092\"}i.icon.twitter:before{content:\"\\F099\"}i.icon.facebook.f:before{content:\"\\F09A\"}i.icon.github:before{content:\"\\F09B\"}i.icon.pinterest:before{content:\"\\F0D2\"}i.icon.pinterest.square:before{content:\"\\F0D3\"}i.icon.google.plus.square:before{content:\"\\F0D4\"}i.icon.google.plus:before{content:\"\\F0D5\"}i.icon.linkedin:before{content:\"\\F0E1\"}i.icon.github.alternate:before{content:\"\\F113\"}i.icon.maxcdn:before{content:\"\\F136\"}i.icon.youtube.square:before{content:\"\\F166\"}i.icon.youtube:before{content:\"\\F167\"}i.icon.xing:before{content:\"\\F168\"}i.icon.xing.square:before{content:\"\\F169\"}i.icon.youtube.play:before{content:\"\\F16A\"}i.icon.dropbox:before{content:\"\\F16B\"}i.icon.stack.overflow:before{content:\"\\F16C\"}i.icon.instagram:before{content:\"\\F16D\"}i.icon.flickr:before{content:\"\\F16E\"}i.icon.adn:before{content:\"\\F170\"}i.icon.bitbucket:before{content:\"\\F171\"}i.icon.bitbucket.square:before{content:\"\\F172\"}i.icon.tumblr:before{content:\"\\F173\"}i.icon.tumblr.square:before{content:\"\\F174\"}i.icon.apple:before{content:\"\\F179\"}i.icon.windows:before{content:\"\\F17A\"}i.icon.android:before{content:\"\\F17B\"}i.icon.linux:before{content:\"\\F17C\"}i.icon.dribble:before{content:\"\\F17D\"}i.icon.skype:before{content:\"\\F17E\"}i.icon.foursquare:before{content:\"\\F180\"}i.icon.trello:before{content:\"\\F181\"}i.icon.gittip:before{content:\"\\F184\"}i.icon.vk:before{content:\"\\F189\"}i.icon.weibo:before{content:\"\\F18A\"}i.icon.renren:before{content:\"\\F18B\"}i.icon.pagelines:before{content:\"\\F18C\"}i.icon.stack.exchange:before{content:\"\\F18D\"}i.icon.vimeo.square:before{content:\"\\F194\"}i.icon.slack:before{content:\"\\F198\"}i.icon.wordpress:before{content:\"\\F19A\"}i.icon.yahoo:before{content:\"\\F19E\"}i.icon.google:before{content:\"\\F1A0\"}i.icon.reddit:before{content:\"\\F1A1\"}i.icon.reddit.square:before{content:\"\\F1A2\"}i.icon.stumbleupon.circle:before{content:\"\\F1A3\"}i.icon.stumbleupon:before{content:\"\\F1A4\"}i.icon.delicious:before{content:\"\\F1A5\"}i.icon.digg:before{content:\"\\F1A6\"}i.icon.pied.piper:before{content:\"\\F1A7\"}i.icon.pied.piper.alternate:before{content:\"\\F1A8\"}i.icon.drupal:before{content:\"\\F1A9\"}i.icon.joomla:before{content:\"\\F1AA\"}i.icon.behance:before{content:\"\\F1B4\"}i.icon.behance.square:before{content:\"\\F1B5\"}i.icon.steam:before{content:\"\\F1B6\"}i.icon.steam.square:before{content:\"\\F1B7\"}i.icon.spotify:before{content:\"\\F1BC\"}i.icon.deviantart:before{content:\"\\F1BD\"}i.icon.soundcloud:before{content:\"\\F1BE\"}i.icon.vine:before{content:\"\\F1CA\"}i.icon.codepen:before{content:\"\\F1CB\"}i.icon.jsfiddle:before{content:\"\\F1CC\"}i.icon.rebel:before{content:\"\\F1D0\"}i.icon.empire:before{content:\"\\F1D1\"}i.icon.git.square:before{content:\"\\F1D2\"}i.icon.git:before{content:\"\\F1D3\"}i.icon.hacker.news:before{content:\"\\F1D4\"}i.icon.tencent.weibo:before{content:\"\\F1D5\"}i.icon.qq:before{content:\"\\F1D6\"}i.icon.wechat:before{content:\"\\F1D7\"}i.icon.slideshare:before{content:\"\\F1E7\"}i.icon.twitch:before{content:\"\\F1E8\"}i.icon.yelp:before{content:\"\\F1E9\"}i.icon.lastfm:before{content:\"\\F202\"}i.icon.lastfm.square:before{content:\"\\F203\"}i.icon.ioxhost:before{content:\"\\F208\"}i.icon.angellist:before{content:\"\\F209\"}i.icon.meanpath:before{content:\"\\F20C\"}i.icon.buysellads:before{content:\"\\F20D\"}i.icon.connectdevelop:before{content:\"\\F20E\"}i.icon.dashcube:before{content:\"\\F210\"}i.icon.forumbee:before{content:\"\\F211\"}i.icon.leanpub:before{content:\"\\F212\"}i.icon.sellsy:before{content:\"\\F213\"}i.icon.shirtsinbulk:before{content:\"\\F214\"}i.icon.simplybuilt:before{content:\"\\F215\"}i.icon.skyatlas:before{content:\"\\F216\"}i.icon.facebook:before{content:\"\\F230\"}i.icon.pinterest:before{content:\"\\F231\"}i.icon.whatsapp:before{content:\"\\F232\"}i.icon.viacoin:before{content:\"\\F237\"}i.icon.medium:before{content:\"\\F23A\"}i.icon.y.combinator:before{content:\"\\F23B\"}i.icon.optinmonster:before{content:\"\\F23C\"}i.icon.opencart:before{content:\"\\F23D\"}i.icon.expeditedssl:before{content:\"\\F23E\"}i.icon.gg:before{content:\"\\F260\"}i.icon.gg.circle:before{content:\"\\F261\"}i.icon.tripadvisor:before{content:\"\\F262\"}i.icon.odnoklassniki:before{content:\"\\F263\"}i.icon.odnoklassniki.square:before{content:\"\\F264\"}i.icon.pocket:before{content:\"\\F265\"}i.icon.wikipedia:before{content:\"\\F266\"}i.icon.safari:before{content:\"\\F267\"}i.icon.chrome:before{content:\"\\F268\"}i.icon.firefox:before{content:\"\\F269\"}i.icon.opera:before{content:\"\\F26A\"}i.icon.internet.explorer:before{content:\"\\F26B\"}i.icon.contao:before{content:\"\\F26D\"}i.icon.\\35 00px:before{content:\"\\F26E\"}i.icon.amazon:before{content:\"\\F270\"}i.icon.houzz:before{content:\"\\F27C\"}i.icon.vimeo:before{content:\"\\F27D\"}i.icon.black.tie:before{content:\"\\F27E\"}i.icon.fonticons:before{content:\"\\F280\"}i.icon.reddit.alien:before{content:\"\\F281\"}i.icon.microsoft.edge:before{content:\"\\F282\"}i.icon.codiepie:before{content:\"\\F284\"}i.icon.modx:before{content:\"\\F285\"}i.icon.fort.awesome:before{content:\"\\F286\"}i.icon.product.hunt:before{content:\"\\F288\"}i.icon.mixcloud:before{content:\"\\F289\"}i.icon.scribd:before{content:\"\\F28A\"}i.icon.gitlab:before{content:\"\\F296\"}i.icon.wpbeginner:before{content:\"\\F297\"}i.icon.wpforms:before{content:\"\\F298\"}i.icon.envira.gallery:before{content:\"\\F299\"}i.icon.glide:before{content:\"\\F2A5\"}i.icon.glide.g:before{content:\"\\F2A6\"}i.icon.viadeo:before{content:\"\\F2A9\"}i.icon.viadeo.square:before{content:\"\\F2AA\"}i.icon.snapchat:before{content:\"\\F2AB\"}i.icon.snapchat.ghost:before{content:\"\\F2AC\"}i.icon.snapchat.square:before{content:\"\\F2AD\"}i.icon.pied.piper.hat:before{content:\"\\F2AE\"}i.icon.first.order:before{content:\"\\F2B0\"}i.icon.yoast:before{content:\"\\F2B1\"}i.icon.themeisle:before{content:\"\\F2B2\"}i.icon.google.plus.circle:before{content:\"\\F2B3\"}i.icon.font.awesome:before{content:\"\\F2B4\"}i.icon.linode:before{content:\"\\F2B8\"}i.icon.quora:before{content:\"\\F2C4\"}i.icon.free.code.camp:before{content:\"\\F2C5\"}i.icon.telegram:before{content:\"\\F2C6\"}i.icon.bandcamp:before{content:\"\\F2D5\"}i.icon.grav:before{content:\"\\F2D6\"}i.icon.etsy:before{content:\"\\F2D7\"}i.icon.imdb:before{content:\"\\F2D8\"}i.icon.ravelry:before{content:\"\\F2D9\"}i.icon.eercast:before{content:\"\\F2DA\"}i.icon.superpowers:before{content:\"\\F2DD\"}i.icon.wpexplorer:before{content:\"\\F2DE\"}i.icon.meetup:before{content:\"\\F2E0\"}i.icon.like:before{content:\"\\F004\"}i.icon.favorite:before{content:\"\\F005\"}i.icon.video:before{content:\"\\F008\"}i.icon.check:before{content:\"\\F00C\"}i.icon.cancel:before,i.icon.close:before,i.icon.delete:before,i.icon.x:before{content:\"\\F00D\"}i.icon.magnify:before,i.icon.zoom.in:before{content:\"\\F00E\"}i.icon.shutdown:before{content:\"\\F011\"}i.icon.clock:before,i.icon.time:before{content:\"\\F017\"}i.icon.play.circle.outline:before{content:\"\\F01D\"}i.icon.headphone:before{content:\"\\F025\"}i.icon.camera:before{content:\"\\F030\"}i.icon.video.camera:before{content:\"\\F03D\"}i.icon.picture:before{content:\"\\F03E\"}i.icon.compose:before,i.icon.pencil:before{content:\"\\F040\"}i.icon.point:before{content:\"\\F041\"}i.icon.tint:before{content:\"\\F043\"}i.icon.signup:before{content:\"\\F044\"}i.icon.plus.circle:before{content:\"\\F055\"}i.icon.question.circle:before{content:\"\\F059\"}i.icon.dont:before{content:\"\\F05E\"}i.icon.minimize:before{content:\"\\F066\"}i.icon.add:before{content:\"\\F067\"}i.icon.attention:before,i.icon.exclamation.circle:before{content:\"\\F06A\"}i.icon.eye:before{content:\"\\F06E\"}i.icon.exclamation.triangle:before{content:\"\\F071\"}i.icon.shuffle:before{content:\"\\F074\"}i.icon.chat:before{content:\"\\F075\"}i.icon.cart:before,i.icon.shopping.cart:before{content:\"\\F07A\"}i.icon.bar.graph:before{content:\"\\F080\"}i.icon.key:before{content:\"\\F084\"}i.icon.cogs:before{content:\"\\F085\"}i.icon.discussions:before{content:\"\\F086\"}i.icon.like.outline:before{content:\"\\F087\"}i.icon.dislike.outline:before{content:\"\\F088\"}i.icon.heart.outline:before{content:\"\\F08A\"}i.icon.log.out:before{content:\"\\F08B\"}i.icon.thumb.tack:before{content:\"\\F08D\"}i.icon.winner:before{content:\"\\F091\"}i.icon.phone:before{content:\"\\F095\"}i.icon.bookmark.outline:before{content:\"\\F097\"}i.icon.phone.square:before{content:\"\\F098\"}i.icon.credit.card:before{content:\"\\F09D\"}i.icon.hdd.outline:before{content:\"\\F0A0\"}i.icon.bullhorn:before{content:\"\\F0A1\"}i.icon.bell.outline:before{content:\"\\F0A2\"}i.icon.hand.outline.right:before{content:\"\\F0A4\"}i.icon.hand.outline.left:before{content:\"\\F0A5\"}i.icon.hand.outline.up:before{content:\"\\F0A6\"}i.icon.hand.outline.down:before{content:\"\\F0A7\"}i.icon.globe:before{content:\"\\F0AC\"}i.icon.wrench:before{content:\"\\F0AD\"}i.icon.briefcase:before{content:\"\\F0B1\"}i.icon.group:before{content:\"\\F0C0\"}i.icon.chain:before,i.icon.linkify:before{content:\"\\F0C1\"}i.icon.flask:before{content:\"\\F0C3\"}i.icon.bars:before,i.icon.sidebar:before{content:\"\\F0C9\"}i.icon.list.ul:before{content:\"\\F0CA\"}i.icon.list.ol:before,i.icon.numbered.list:before{content:\"\\F0CB\"}i.icon.magic:before{content:\"\\F0D0\"}i.icon.truck:before{content:\"\\F0D1\"}i.icon.currency:before{content:\"\\F0D6\"}i.icon.dropdown:before,i.icon.triangle.down:before{content:\"\\F0D7\"}i.icon.triangle.up:before{content:\"\\F0D8\"}i.icon.triangle.left:before{content:\"\\F0D9\"}i.icon.triangle.right:before{content:\"\\F0DA\"}i.icon.envelope:before{content:\"\\F0E0\"}i.icon.conversation:before{content:\"\\F0E6\"}i.icon.rain:before{content:\"\\F0E9\"}i.icon.clipboard:before{content:\"\\F0EA\"}i.icon.lightbulb:before{content:\"\\F0EB\"}i.icon.bell:before{content:\"\\F0F3\"}i.icon.ambulance:before{content:\"\\F0F9\"}i.icon.medkit:before{content:\"\\F0FA\"}i.icon.fighter.jet:before{content:\"\\F0FB\"}i.icon.beer:before{content:\"\\F0FC\"}i.icon.plus.square:before{content:\"\\F0FE\"}i.icon.computer:before{content:\"\\F108\"}i.icon.circle.outline:before{content:\"\\F10C\"}i.icon.gamepad:before{content:\"\\F11B\"}i.icon.star.half.full:before{content:\"\\F123\"}i.icon.broken.chain:before{content:\"\\F127\"}i.icon.question:before{content:\"\\F128\"}i.icon.exclamation:before{content:\"\\F12A\"}i.icon.eraser:before{content:\"\\F12D\"}i.icon.microphone:before{content:\"\\F130\"}i.icon.microphone.slash:before{content:\"\\F131\"}i.icon.shield:before{content:\"\\F132\"}i.icon.target:before{content:\"\\F140\"}i.icon.play.circle:before{content:\"\\F144\"}i.icon.pencil.square:before{content:\"\\F14B\"}i.icon.eur:before{content:\"\\F153\"}i.icon.gbp:before{content:\"\\F154\"}i.icon.usd:before{content:\"\\F155\"}i.icon.inr:before{content:\"\\F156\"}i.icon.cny:before,i.icon.jpy:before,i.icon.rmb:before{content:\"\\F157\"}i.icon.rouble:before,i.icon.rub:before{content:\"\\F158\"}i.icon.krw:before{content:\"\\F159\"}i.icon.btc:before{content:\"\\F15A\"}i.icon.gratipay:before{content:\"\\F184\"}i.icon.zip:before{content:\"\\F187\"}i.icon.dot.circle.outline:before{content:\"\\F192\"}i.icon.try:before{content:\"\\F195\"}i.icon.graduation:before{content:\"\\F19D\"}i.icon.circle.outline:before{content:\"\\F1DB\"}i.icon.sliders:before{content:\"\\F1DE\"}i.icon.weixin:before{content:\"\\F1D7\"}i.icon.teletype:before,i.icon.tty:before{content:\"\\F1E4\"}i.icon.binoculars:before{content:\"\\F1E5\"}i.icon.power.cord:before{content:\"\\F1E6\"}i.icon.wi-fi:before{content:\"\\F1EB\"}i.icon.visa.card:before{content:\"\\F1F0\"}i.icon.mastercard.card:before{content:\"\\F1F1\"}i.icon.discover.card:before{content:\"\\F1F2\"}i.icon.american.express.card:before,i.icon.amex:before{content:\"\\F1F3\"}i.icon.stripe.card:before{content:\"\\F1F5\"}i.icon.bell.slash:before{content:\"\\F1F6\"}i.icon.bell.slash.outline:before{content:\"\\F1F7\"}i.icon.area.graph:before{content:\"\\F1FE\"}i.icon.pie.graph:before{content:\"\\F200\"}i.icon.line.graph:before{content:\"\\F201\"}i.icon.cc:before{content:\"\\F20A\"}i.icon.ils:before,i.icon.sheqel:before{content:\"\\F20B\"}i.icon.plus.cart:before{content:\"\\F217\"}i.icon.arrow.down.cart:before{content:\"\\F218\"}i.icon.detective:before{content:\"\\F21B\"}i.icon.venus:before{content:\"\\F221\"}i.icon.mars:before{content:\"\\F222\"}i.icon.mercury:before{content:\"\\F223\"}i.icon.intersex:before{content:\"\\F224\"}i.icon.female.homosexual:before,i.icon.venus.double:before{content:\"\\F226\"}i.icon.male.homosexual:before,i.icon.mars.double:before{content:\"\\F227\"}i.icon.venus.mars:before{content:\"\\F228\"}i.icon.mars.alternate:before,i.icon.mars.stroke:before{content:\"\\F229\"}i.icon.mars.stroke.vertical:before,i.icon.mars.vertical:before{content:\"\\F22A\"}i.icon.mars.horizontal:before,i.icon.mars.stroke.horizontal:before{content:\"\\F22B\"}i.icon.asexual:before{content:\"\\F22D\"}i.icon.facebook.official:before{content:\"\\F230\"}i.icon.user.plus:before{content:\"\\F234\"}i.icon.user.cancel:before,i.icon.user.close:before,i.icon.user.delete:before,i.icon.user.times:before,i.icon.user.x:before{content:\"\\F235\"}i.icon.bed:before{content:\"\\F236\"}i.icon.yc:before,i.icon.ycombinator:before{content:\"\\F23B\"}i.icon.battery.four:before{content:\"\\F240\"}i.icon.battery.three.quarters:before,i.icon.battery.three:before{content:\"\\F241\"}i.icon.battery.half:before,i.icon.battery.two:before{content:\"\\F242\"}i.icon.battery.one:before,i.icon.battery.quarter:before{content:\"\\F243\"}i.icon.battery.zero:before{content:\"\\F244\"}i.icon.i.cursor:before{content:\"\\F246\"}i.icon.japan.credit.bureau.card:before,i.icon.jcb:before{content:\"\\F24B\"}i.icon.diners.club.card:before{content:\"\\F24C\"}i.icon.balance:before{content:\"\\F24E\"}i.icon.hourglass.outline:before,i.icon.hourglass.zero:before{content:\"\\F250\"}i.icon.hourglass.one:before{content:\"\\F251\"}i.icon.hourglass.two:before{content:\"\\F252\"}i.icon.hourglass.three:before{content:\"\\F253\"}i.icon.hourglass.four:before{content:\"\\F254\"}i.icon.grab:before{content:\"\\F255\"}i.icon.hand.victory:before{content:\"\\F25B\"}i.icon.tm:before{content:\"\\F25C\"}i.icon.r.circle:before{content:\"\\F25D\"}i.icon.television:before{content:\"\\F26C\"}i.icon.five.hundred.pixels:before{content:\"\\F26E\"}i.icon.calendar.plus:before{content:\"\\F271\"}i.icon.calendar.minus:before{content:\"\\F272\"}i.icon.calendar.times:before{content:\"\\F273\"}i.icon.calendar.check:before{content:\"\\F274\"}i.icon.factory:before{content:\"\\F275\"}i.icon.commenting:before{content:\"\\F27A\"}i.icon.commenting.outline:before{content:\"\\F27B\"}i.icon.edge:before,i.icon.ms.edge:before{content:\"\\F282\"}i.icon.wordpress.beginner:before{content:\"\\F297\"}i.icon.wordpress.forms:before{content:\"\\F298\"}i.icon.envira:before{content:\"\\F299\"}i.icon.question.circle.outline:before{content:\"\\F29C\"}i.icon.ald:before,i.icon.als:before,i.icon.assistive.listening.devices:before{content:\"\\F2A2\"}i.icon.asl.interpreting:before{content:\"\\F2A3\"}i.icon.deaf:before{content:\"\\F2A4\"}i.icon.american.sign.language.interpreting:before{content:\"\\F2A3\"}i.icon.hard.of.hearing:before{content:\"\\F2A4\"}i.icon.signing:before{content:\"\\F2A7\"}i.icon.new.pied.piper:before{content:\"\\F2AE\"}i.icon.theme.isle:before{content:\"\\F2B2\"}i.icon.google.plus.official:before{content:\"\\F2B3\"}i.icon.fa:before{content:\"\\F2B4\"}i.icon.vcard:before{content:\"\\F2BB\"}i.icon.vcard.outline:before{content:\"\\F2BC\"}i.icon.drivers.license:before{content:\"\\F2C2\"}i.icon.drivers.license.outline:before{content:\"\\F2C3\"}i.icon.thermometer:before{content:\"\\F2C7\"}i.icon.bath:before,i.icon.s15:before{content:\"\\F2CD\"}i.icon.times.rectangle:before{content:\"\\F2D3\"}i.icon.times.rectangle.outline:before{content:\"\\F2D4\"}", ""]);
	
	// exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Image\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.image{position:relative;display:inline-block;vertical-align:middle;max-width:100%;background-color:transparent}img.ui.image{display:block}.ui.image img,.ui.image svg{display:block;max-width:100%;height:auto}.ui.hidden.image,.ui.hidden.images{display:none}.ui.hidden.transition.image,.ui.hidden.transition.images{display:block;visibility:hidden}.ui.disabled.image,.ui.disabled.images{cursor:default;opacity:.45}.ui.inline.image,.ui.inline.image img,.ui.inline.image svg{display:inline-block}.ui.top.aligned.image,.ui.top.aligned.image img,.ui.top.aligned.images .image,.ui.top.aligned.image svg{display:inline-block;vertical-align:top}.ui.middle.aligned.image,.ui.middle.aligned.image img,.ui.middle.aligned.images .image,.ui.middle.aligned.image svg{display:inline-block;vertical-align:middle}.ui.bottom.aligned.image,.ui.bottom.aligned.image img,.ui.bottom.aligned.images .image,.ui.bottom.aligned.image svg{display:inline-block;vertical-align:bottom}.ui.rounded.image,.ui.rounded.image>*,.ui.rounded.images .image,.ui.rounded.images .image>*{border-radius:.3125em}.ui.bordered.image img,.ui.bordered.images .image,.ui.bordered.images img,.ui.bordered.images svg,.ui.bordered.image svg,img.ui.bordered.image{border:1px solid rgba(0,0,0,.1)}.ui.circular.image,.ui.circular.images{overflow:hidden}.ui.circular.image,.ui.circular.image>*,.ui.circular.images .image,.ui.circular.images .image>*{border-radius:500rem}.ui.fluid.image,.ui.fluid.image img,.ui.fluid.images,.ui.fluid.images img,.ui.fluid.images svg,.ui.fluid.image svg{display:block;width:100%;height:auto}.ui.avatar.image,.ui.avatar.image img,.ui.avatar.images .image,.ui.avatar.images img,.ui.avatar.images svg,.ui.avatar.image svg{margin-right:.25em;display:inline-block;width:2em;height:2em;border-radius:500rem}.ui.spaced.image{display:inline-block!important;margin-left:.5em;margin-right:.5em}.ui[class*=\"left spaced\"].image{margin-left:.5em;margin-right:0}.ui[class*=\"right spaced\"].image{margin-left:0;margin-right:.5em}.ui.floated.image,.ui.floated.images{float:left;margin-right:1em;margin-bottom:1em}.ui.right.floated.image,.ui.right.floated.images{float:right;margin-right:0;margin-bottom:1em;margin-left:1em}.ui.floated.image:last-child,.ui.floated.images:last-child{margin-bottom:0}.ui.centered.image,.ui.centered.images{margin-left:auto;margin-right:auto}.ui.mini.image,.ui.mini.images .image,.ui.mini.images img,.ui.mini.images svg{width:35px;height:auto;font-size:.64705882rem}.ui.tiny.image,.ui.tiny.images .image,.ui.tiny.images img,.ui.tiny.images svg{width:80px;height:auto;font-size:.70588235rem}.ui.small.image,.ui.small.images .image,.ui.small.images img,.ui.small.images svg{width:150px;height:auto;font-size:.88235294rem}.ui.medium.image,.ui.medium.images .image,.ui.medium.images img,.ui.medium.images svg{width:300px;height:auto;font-size:1rem}.ui.large.image,.ui.large.images .image,.ui.large.images img,.ui.large.images svg{width:450px;height:auto;font-size:1.17647059rem}.ui.big.image,.ui.big.images .image,.ui.big.images img,.ui.big.images svg{width:600px;height:auto;font-size:1.35294118rem}.ui.huge.image,.ui.huge.images .image,.ui.huge.images img,.ui.huge.images svg{width:800px;height:auto;font-size:1.58823529rem}.ui.massive.image,.ui.massive.images .image,.ui.massive.images img,.ui.massive.images svg{width:960px;height:auto;font-size:1.88235294rem}.ui.images{font-size:0;margin:0 -.25rem}.ui.images .image,.ui.images img,.ui.images svg{display:inline-block;margin:0 .25rem .5rem}", ""]);
	
	// exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Item\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.items>.item{display:-webkit-box;display:-ms-flexbox;display:flex;margin:1em 0;width:100%;min-height:0;background:transparent;padding:0;border:none;border-radius:0;box-shadow:none;transition:box-shadow .1s ease;z-index:\"\"}.ui.items>.item a{cursor:pointer}.ui.items{margin:1.5em 0}.ui.items:first-child{margin-top:0!important}.ui.items:last-child{margin-bottom:0!important}.ui.items>.item:after{display:block;content:\" \";height:0;clear:both;overflow:hidden;visibility:hidden}.ui.items>.item:first-child{margin-top:0}.ui.items>.item:last-child{margin-bottom:0}.ui.items>.item>.image{position:relative;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;display:block;float:none;margin:0;padding:0;max-height:\"\";-ms-flex-item-align:top;align-self:top}.ui.items>.item>.image>img{display:block;width:100%;height:auto;border-radius:.125rem;border:none}.ui.items>.item>.image:only-child>img{border-radius:0}.ui.items>.item>.content{display:block;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;background:none;margin:0;padding:0;box-shadow:none;font-size:1em;border:none;border-radius:0}.ui.items>.item>.content:after{display:block;content:\" \";height:0;clear:both;overflow:hidden;visibility:hidden}.ui.items>.item>.image+.content{min-width:0;width:auto;display:block;margin-left:0;-ms-flex-item-align:top;align-self:top;padding-left:1.5em}.ui.items>.item>.content>.header{display:inline-block;margin:-.22em 0 0;font-family:Publico Headline,Georgia,serif;font-weight:700;color:rgba(0,0,0,.85)}.ui.items>.item>.content>.header:not(.ui){font-size:1.35294118em}.ui.items>.item [class*=\"left floated\"]{float:left}.ui.items>.item [class*=\"right floated\"]{float:right}.ui.items>.item .content img{-ms-flex-item-align:middle;align-self:middle;width:\"\"}.ui.items>.item .avatar img,.ui.items>.item img.avatar{width:\"\";height:\"\";border-radius:500rem}.ui.items>.item>.content>.description{margin-top:.6em;max-width:auto;font-size:1em;line-height:1.44em;color:rgba(0,0,0,.87)}.ui.items>.item>.content p{margin:0 0 .5em}.ui.items>.item>.content p:last-child{margin-bottom:0}.ui.items>.item .meta{margin:.5em 0;font-size:1em;line-height:1em;color:rgba(0,0,0,.6)}.ui.items>.item .meta *{margin-right:.3em}.ui.items>.item .meta :last-child{margin-right:0}.ui.items>.item .meta [class*=\"right floated\"]{margin-right:0;margin-left:.3em}.ui.items>.item>.content a:not(.ui){color:\"\";transition:color .1s ease}.ui.items>.item>.content a:not(.ui):hover{color:\"\"}.ui.items>.item>.content>a.header{color:rgba(0,0,0,.85)}.ui.items>.item>.content>a.header:hover{color:#00598c}.ui.items>.item .meta>a:not(.ui){color:rgba(0,0,0,.4)}.ui.items>.item .meta>a:not(.ui):hover{color:rgba(0,0,0,.87)}.ui.items>.item>.content .favorite.icon{cursor:pointer;opacity:.75;transition:color .1s ease}.ui.items>.item>.content .favorite.icon:hover{opacity:1;color:#ffb70a}.ui.items>.item>.content .active.favorite.icon{color:#ffe623}.ui.items>.item>.content .like.icon{cursor:pointer;opacity:.75;transition:color .1s ease}.ui.items>.item>.content .like.icon:hover{opacity:1;color:#ff2733}.ui.items>.item>.content .active.like.icon{color:#ff2733}.ui.items>.item .extra{display:block;position:relative;background:none;margin:.5rem 0 0;width:100%;padding:0;top:0;left:0;color:rgba(0,0,0,.4);box-shadow:none;transition:color .1s ease;border-top:none}.ui.items>.item .extra>*{margin:.25rem .5rem .25rem 0}.ui.items>.item .extra>[class*=\"right floated\"]{margin:.25rem 0 .25rem .5rem}.ui.items>.item .extra:after{display:block;content:\" \";height:0;clear:both;overflow:hidden;visibility:hidden}.ui.items>.item>.image:not(.ui){width:175px}@media only screen and (min-width:600px) and (max-width:899px){.ui.items>.item{margin:1em 0}.ui.items>.item>.image:not(.ui){width:150px}.ui.items>.item>.image+.content{display:block;padding:0 0 0 1em}}@media only screen and (max-width:599px){.ui.items:not(.unstackable)>.item{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:2em 0}.ui.items:not(.unstackable)>.item>.image{display:block;margin-left:auto;margin-right:auto}.ui.items:not(.unstackable)>.item>.image,.ui.items:not(.unstackable)>.item>.image>img{max-width:100%!important;width:auto!important;max-height:250px!important}.ui.items:not(.unstackable)>.item>.image+.content{display:block;padding:1.5em 0 0}}.ui.items>.item>.image+[class*=\"top aligned\"].content{-ms-flex-item-align:start;align-self:flex-start}.ui.items>.item>.image+[class*=\"middle aligned\"].content{-ms-flex-item-align:center;align-self:center}.ui.items>.item>.image+[class*=\"bottom aligned\"].content{-ms-flex-item-align:end;align-self:flex-end}.ui.relaxed.items>.item{margin:1.5em 0}.ui[class*=\"very relaxed\"].items>.item{margin:2em 0}.ui.divided.items>.item{border-top:1px solid rgba(34,36,38,.15);margin:0;padding:1em 0}.ui.divided.items>.item:first-child{border-top:none;margin-top:0!important;padding-top:0!important}.ui.divided.items>.item:last-child{margin-bottom:0!important;padding-bottom:0!important}.ui.relaxed.divided.items>.item{margin:0;padding:1.5em 0}.ui[class*=\"very relaxed\"].divided.items>.item{margin:0;padding:2em 0}.ui.items a.item:hover,.ui.link.items>.item:hover{cursor:pointer}.ui.items a.item:hover .content .header,.ui.link.items>.item:hover .content .header{color:#00598c}.ui.items>.item{font-size:1em}@media only screen and (max-width:599px){.ui.unstackable.items>.item>.image,.ui.unstackable.items>.item>.image>img{width:125px!important}}", ""]);
	
	// exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - List\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.list,ol.ui.list,ul.ui.list{list-style-type:none;margin:1em 0;padding:0}.ui.list:first-child,ol.ui.list:first-child,ul.ui.list:first-child{margin-top:0;padding-top:0}.ui.list:last-child,ol.ui.list:last-child,ul.ui.list:last-child{margin-bottom:0;padding-bottom:0}.ui.list .list>.item,.ui.list>.item,ol.ui.list li,ul.ui.list li{display:list-item;table-layout:fixed;list-style-type:none;list-style-position:outside;padding:.17647059em 0;line-height:1.17647059em}.ui.list>.item:after,.ui.list>.list>.item,ol.ui.list>li:first-child:after,ul.ui.list>li:first-child:after{content:\"\";display:block;height:0;clear:both;visibility:hidden}.ui.list .list>.item:first-child,.ui.list>.item:first-child,ol.ui.list li:first-child,ul.ui.list li:first-child{padding-top:0}.ui.list .list>.item:last-child,.ui.list>.item:last-child,ol.ui.list li:last-child,ul.ui.list li:last-child{padding-bottom:0}.ui.list .list,ol.ui.list ol,ul.ui.list ul{clear:both;margin:0;padding:.75em 0 .25em .5em}.ui.list .list>.item,ol.ui.list ol li,ul.ui.list ul li{padding:.11764706em 0;line-height:inherit}.ui.list .list>.item>i.icon,.ui.list>.item>i.icon{display:table-cell;margin:0;padding-top:.08823529em;padding-right:.23529412em;vertical-align:top;transition:color .1s ease}.ui.list .list>.item>i.icon:only-child,.ui.list>.item>i.icon:only-child{display:inline-block;vertical-align:top}.ui.list .list>.item>.image,.ui.list>.item>.image{display:table-cell;background-color:transparent;margin:0;vertical-align:top}.ui.list .list>.item>.image:not(:only-child):not(img),.ui.list>.item>.image:not(:only-child):not(img){padding-right:.5em}.ui.list .list>.item>.image img,.ui.list>.item>.image img{vertical-align:top}.ui.list .list>.item>.image:only-child,.ui.list .list>.item>img.image,.ui.list>.item>.image:only-child,.ui.list>.item>img.image{display:inline-block}.ui.list .list>.item>.content,.ui.list>.item>.content{line-height:1.17647059em}.ui.list .list>.item>.icon+.content,.ui.list .list>.item>.image+.content,.ui.list>.item>.icon+.content,.ui.list>.item>.image+.content{display:table-cell;padding:0 0 0 .5em;vertical-align:top}.ui.list .list>.item>img.image+.content,.ui.list>.item>img.image+.content{display:inline-block}.ui.list .list>.item>.content>.list,.ui.list>.item>.content>.list{margin-left:0;padding-left:0}.ui.list .list>.item .header,.ui.list>.item .header{display:block;margin:0;font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;font-weight:700;color:rgba(0,0,0,.87)}.ui.list .list>.item .description,.ui.list>.item .description{display:block;color:rgba(0,0,0,.7)}.ui.list .list>.item a,.ui.list>.item a{cursor:pointer}.ui.list .list>a.item,.ui.list>a.item{cursor:pointer;color:#007abf}.ui.list .list>a.item:hover,.ui.list>a.item:hover{color:#00598c}.ui.list .list>a.item i.icon,.ui.list>a.item i.icon{color:rgba(0,0,0,.4)}.ui.list .list>.item a.header,.ui.list>.item a.header{cursor:pointer;color:#007abf!important}.ui.list .list>.item a.header:hover,.ui.list>.item a.header:hover{color:#00598c!important}.ui[class*=\"left floated\"].list{float:left}.ui[class*=\"right floated\"].list{float:right}.ui.list .list>.item [class*=\"left floated\"],.ui.list>.item [class*=\"left floated\"]{float:left;margin:0 1em 0 0}.ui.list .list>.item [class*=\"right floated\"],.ui.list>.item [class*=\"right floated\"]{float:right;margin:0 0 0 1em}.ui.menu .ui.list .list>.item,.ui.menu .ui.list>.item{display:list-item;table-layout:fixed;background-color:transparent;list-style-type:none;list-style-position:outside;padding:.17647059em 0;line-height:1.17647059em}.ui.menu .ui.list .list>.item:before,.ui.menu .ui.list>.item:before{border:none;background:none}.ui.menu .ui.list .list>.item:first-child,.ui.menu .ui.list>.item:first-child{padding-top:0}.ui.menu .ui.list .list>.item:last-child,.ui.menu .ui.list>.item:last-child{padding-bottom:0}.ui.horizontal.list{display:inline-block;font-size:0}.ui.horizontal.list>.item{display:inline-block;margin-left:1em;font-size:1rem}.ui.horizontal.list:not(.celled)>.item:first-child{margin-left:0!important;padding-left:0!important}.ui.horizontal.list .list{padding-left:0;padding-bottom:0}.ui.horizontal.list .list>.item>.content,.ui.horizontal.list .list>.item>.icon,.ui.horizontal.list .list>.item>.image,.ui.horizontal.list>.item>.content,.ui.horizontal.list>.item>.icon,.ui.horizontal.list>.item>.image{vertical-align:middle}.ui.horizontal.list>.item:first-child,.ui.horizontal.list>.item:last-child{padding-top:.17647059em;padding-bottom:.17647059em}.ui.horizontal.list>.item>i.icon{margin:0;padding:0 .25em 0 0}.ui.horizontal.list>.item>.icon,.ui.horizontal.list>.item>.icon+.content{float:none;display:inline-block}.ui.list .list>.disabled.item,.ui.list>.disabled.item{pointer-events:none;color:rgba(40,40,40,.3)!important}.ui.inverted.list .list>.disabled.item,.ui.inverted.list>.disabled.item{color:hsla(0,0%,88%,.3)!important}.ui.list .list>a.item:hover .icon,.ui.list>a.item:hover .icon{color:rgba(0,0,0,.87)}.ui.inverted.list .list>a.item>.icon,.ui.inverted.list>a.item>.icon{color:hsla(0,0%,100%,.7)}.ui.inverted.list .list>.item .header,.ui.inverted.list>.item .header{color:hsla(0,0%,100%,.9)}.ui.inverted.list .list>.item .description,.ui.inverted.list>.item .description{color:hsla(0,0%,100%,.7)}.ui.inverted.list .list>a.item,.ui.inverted.list>a.item{cursor:pointer;color:hsla(0,0%,100%,.9)}.ui.inverted.list .list>a.item:hover,.ui.inverted.list>a.item:hover{color:#00598c}.ui.inverted.list .item a:not(.ui){color:hsla(0,0%,100%,.9)!important}.ui.inverted.list .item a:not(.ui):hover{color:#00598c!important}.ui.list [class*=\"top aligned\"],.ui.list[class*=\"top aligned\"] .content,.ui.list[class*=\"top aligned\"] .image{vertical-align:top!important}.ui.list [class*=\"middle aligned\"],.ui.list[class*=\"middle aligned\"] .content,.ui.list[class*=\"middle aligned\"] .image{vertical-align:middle!important}.ui.list [class*=\"bottom aligned\"],.ui.list[class*=\"bottom aligned\"] .content,.ui.list[class*=\"bottom aligned\"] .image{vertical-align:bottom!important}.ui.link.list .item,.ui.link.list .item a:not(.ui),.ui.link.list a.item{color:rgba(0,0,0,.4);transition:color .1s ease}.ui.link.list .item a:not(.ui):hover,.ui.link.list a.item:hover{color:rgba(0,0,0,.8)}.ui.link.list .item a:not(.ui):active,.ui.link.list a.item:active{color:rgba(0,0,0,.9)}.ui.link.list .active.item,.ui.link.list .active.item a:not(.ui){color:rgba(0,0,0,.95)}.ui.inverted.link.list .item,.ui.inverted.link.list .item a:not(.ui),.ui.inverted.link.list a.item{color:hsla(0,0%,100%,.5)}.ui.inverted.link.list .active.item a:not(.ui),.ui.inverted.link.list .item a:not(.ui):active,.ui.inverted.link.list .item a:not(.ui):hover,.ui.inverted.link.list a.active.item,.ui.inverted.link.list a.item:active,.ui.inverted.link.list a.item:hover{color:#fff}.ui.selection.list .list>.item,.ui.selection.list>.item{cursor:pointer;background:transparent;padding:.5em;margin:0;color:rgba(0,0,0,.4);border-radius:.5em;transition:color .1s ease,padding-left .1s ease,background-color .1s ease}.ui.selection.list .list>.item:last-child,.ui.selection.list>.item:last-child{margin-bottom:0}.ui.selection.list.list>.item:hover,.ui.selection.list>.item:hover{background:rgba(0,0,0,.03);color:rgba(0,0,0,.8)}.ui.selection.list .list>.item:active,.ui.selection.list>.item:active{background:rgba(0,0,0,.05);color:rgba(0,0,0,.9)}.ui.selection.list .list>.item.active,.ui.selection.list>.item.active{background:rgba(0,0,0,.05);color:rgba(0,0,0,.95)}.ui.inverted.selection.list>.item{background:transparent;color:hsla(0,0%,100%,.5)}.ui.inverted.selection.list>.item:hover{background:hsla(0,0%,100%,.02);color:#fff}.ui.inverted.selection.list>.item.active,.ui.inverted.selection.list>.item:active{background:hsla(0,0%,100%,.08);color:#fff}.ui.celled.selection.list .list>.item,.ui.celled.selection.list>.item,.ui.divided.selection.list .list>.item,.ui.divided.selection.list>.item{border-radius:0}.ui.animated.list>.item{transition:color .25s ease .1s,padding-left .25s ease .1s,background-color .25s ease .1s}.ui.animated.list:not(.horizontal)>.item:hover{padding-left:1em}.ui.fitted.list:not(.selection) .list>.item,.ui.fitted.list:not(.selection)>.item{padding-left:0;padding-right:0}.ui.fitted.selection.list .list>.item,.ui.fitted.selection.list>.item{margin-left:-.5em;margin-right:-.5em}.ui.bulleted.list,ul.ui.list{margin-left:1.25rem}.ui.bulleted.list .list>.item,.ui.bulleted.list>.item,ul.ui.list li{position:relative}.ui.bulleted.list .list>.item:before,.ui.bulleted.list>.item:before,ul.ui.list li:before{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;position:absolute;top:auto;left:auto;font-weight:400;margin-left:-1.25rem;content:\"\\2022\";opacity:1;color:inherit;vertical-align:top}.ui.bulleted.list .list>a.item:before,.ui.bulleted.list>a.item:before,ul.ui.list li:before{color:rgba(0,0,0,.87)}.ui.bulleted.list .list,ul.ui.list ul{padding-left:1.25rem}.ui.horizontal.bulleted.list,ul.ui.horizontal.bulleted.list{margin-left:0}.ui.horizontal.bulleted.list>.item,ul.ui.horizontal.bulleted.list li{margin-left:1.75rem}.ui.horizontal.bulleted.list>.item:first-child,ul.ui.horizontal.bulleted.list li:first-child{margin-left:0}.ui.horizontal.bulleted.list>.item:before,ul.ui.horizontal.bulleted.list li:before{color:rgba(0,0,0,.87)}.ui.horizontal.bulleted.list>.item:first-child:before,ul.ui.horizontal.bulleted.list li:first-child:before{display:none}.ui.ordered.list,.ui.ordered.list .list,ol.ui.list,ol.ui.list ol{counter-reset:ordered;margin-left:1.25rem;list-style-type:none}.ui.ordered.list .list>.item,.ui.ordered.list>.item,ol.ui.list li{list-style-type:none;position:relative}.ui.ordered.list .list>.item:before,.ui.ordered.list>.item:before,ol.ui.list li:before{position:absolute;top:auto;left:auto;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;margin-left:-1.25rem;counter-increment:ordered;content:counters(ordered,\".\") \" \";text-align:right;color:rgba(0,0,0,.87);vertical-align:middle;opacity:.8}.ui.ordered.inverted.list .list>.item:before,.ui.ordered.inverted.list>.item:before,ol.ui.inverted.list li:before{color:hsla(0,0%,100%,.7)}.ui.ordered.list>.item[data-value],.ui.ordered.list>.list>.item[data-value]{content:attr(data-value)}ol.ui.list li[value]:before{content:attr(value)}.ui.ordered.list .list,ol.ui.list ol{margin-left:1em}.ui.ordered.list .list>.item:before,ol.ui.list ol li:before{margin-left:-2em}.ui.ordered.horizontal.list,ol.ui.horizontal.list{margin-left:0}.ui.ordered.horizontal.list .list>.item:before,.ui.ordered.horizontal.list>.item:before,ol.ui.horizontal.list li:before{position:static;margin:0 .5em 0 0}.ui.divided.list>.item{border-top:1px solid rgba(34,36,38,.15)}.ui.divided.list .item .list>.item,.ui.divided.list .list>.item,.ui.divided.list .list>.item:first-child,.ui.divided.list>.item:first-child{border-top:none}.ui.divided.list:not(.horizontal) .list>.item:first-child{border-top-width:1px}.ui.divided.bulleted.list .list,.ui.divided.bulleted.list:not(.horizontal){margin-left:0;padding-left:0}.ui.divided.bulleted.list>.item:not(.horizontal){padding-left:1.25rem}.ui.divided.ordered.list{margin-left:0}.ui.divided.ordered.list .list>.item,.ui.divided.ordered.list>.item{padding-left:1.25rem}.ui.divided.ordered.list .item .list{margin-left:0;margin-right:0;padding-bottom:.17647059em}.ui.divided.ordered.list .item .list>.item{padding-left:1em}.ui.divided.selection.list .list>.item,.ui.divided.selection.list>.item{margin:0;border-radius:0}.ui.divided.horizontal.list{margin-left:0}.ui.divided.horizontal.list>.item:not(:first-child){padding-left:.5em}.ui.divided.horizontal.list>.item:not(:last-child){padding-right:.5em}.ui.divided.horizontal.list>.item{border-top:none;border-left:1px solid rgba(34,36,38,.15);margin:0;line-height:.6}.ui.horizontal.divided.list>.item:first-child{border-left:none}.ui.divided.inverted.horizontal.list>.item,.ui.divided.inverted.list>.item,.ui.divided.inverted.list>.list{border-color:hsla(0,0%,100%,.1)}.ui.celled.list>.item,.ui.celled.list>.list{border-top:1px solid rgba(34,36,38,.15);padding-left:.5em;padding-right:.5em}.ui.celled.list>.item:last-child{border-bottom:1px solid rgba(34,36,38,.15)}.ui.celled.list>.item:first-child,.ui.celled.list>.item:last-child{padding-top:.17647059em;padding-bottom:.17647059em}.ui.celled.list .item .list>.item{border-width:0}.ui.celled.list .list>.item:first-child{border-top-width:0}.ui.celled.bulleted.list{margin-left:0}.ui.celled.bulleted.list .list>.item,.ui.celled.bulleted.list>.item{padding-left:1.25rem}.ui.celled.bulleted.list .item .list{margin-left:-1.25rem;margin-right:-1.25rem;padding-bottom:.17647059em}.ui.celled.ordered.list{margin-left:0}.ui.celled.ordered.list .list>.item,.ui.celled.ordered.list>.item{padding-left:1.25rem}.ui.celled.ordered.list .item .list{margin-left:0;margin-right:0;padding-bottom:.17647059em}.ui.celled.ordered.list .list>.item{padding-left:1em}.ui.horizontal.celled.list{margin-left:0}.ui.horizontal.celled.list .list>.item,.ui.horizontal.celled.list>.item{border-top:none;border-left:1px solid rgba(34,36,38,.15);margin:0;padding-left:.5em;padding-right:.5em;line-height:.6}.ui.horizontal.celled.list .list>.item:last-child,.ui.horizontal.celled.list>.item:last-child{border-bottom:none;border-right:1px solid rgba(34,36,38,.15)}.ui.celled.inverted.horizontal.list .list>.item,.ui.celled.inverted.horizontal.list>.item,.ui.celled.inverted.list>.item,.ui.celled.inverted.list>.list{border-color:1px solid hsla(0,0%,100%,.1)}.ui.relaxed.list:not(.horizontal)>.item:not(:first-child){padding-top:.35294118em}.ui.relaxed.list:not(.horizontal)>.item:not(:last-child){padding-bottom:.35294118em}.ui.horizontal.relaxed.list .list>.item:not(:first-child),.ui.horizontal.relaxed.list>.item:not(:first-child){padding-left:1rem}.ui.horizontal.relaxed.list .list>.item:not(:last-child),.ui.horizontal.relaxed.list>.item:not(:last-child){padding-right:1rem}.ui[class*=\"very relaxed\"].list:not(.horizontal)>.item:not(:first-child){padding-top:.70588235em}.ui[class*=\"very relaxed\"].list:not(.horizontal)>.item:not(:last-child){padding-bottom:.70588235em}.ui.horizontal[class*=\"very relaxed\"].list .list>.item:not(:first-child),.ui.horizontal[class*=\"very relaxed\"].list>.item:not(:first-child){padding-left:1.5rem}.ui.horizontal[class*=\"very relaxed\"].list .list>.item:not(:last-child),.ui.horizontal[class*=\"very relaxed\"].list>.item:not(:last-child){padding-right:1.5rem}.ui.mini.list{font-size:.64705882em}.ui.tiny.list{font-size:.70588235em}.ui.small.list{font-size:.88235294em}.ui.list{font-size:1em}.ui.large.list{font-size:1.17647059em}.ui.big.list{font-size:1.35294118em}.ui.huge.list{font-size:1.58823529em}.ui.massive.list{font-size:1.88235294em}.ui.mini.horizontal.list .list>.item,.ui.mini.horizontal.list>.item{font-size:.64705882rem}.ui.tiny.horizontal.list .list>.item,.ui.tiny.horizontal.list>.item{font-size:.70588235rem}.ui.small.horizontal.list .list>.item,.ui.small.horizontal.list>.item{font-size:.88235294rem}.ui.horizontal.list .list>.item,.ui.horizontal.list>.item{font-size:1rem}.ui.large.horizontal.list .list>.item,.ui.large.horizontal.list>.item{font-size:1.17647059rem}.ui.big.horizontal.list .list>.item,.ui.big.horizontal.list>.item{font-size:1.35294118rem}.ui.huge.horizontal.list .list>.item,.ui.huge.horizontal.list>.item{font-size:1.58823529rem}.ui.massive.horizontal.list .list>.item,.ui.massive.horizontal.list>.item{font-size:1.88235294rem}.ui.list,ol.ui.list,ul.ui.list{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.ui.list.infographic,ol.ui.list.infographic,ul.ui.list.infographic{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.ui.list.text,ol.ui.list.text,ul.ui.list.text{font-family:Georgia,serif}.ui.list.caption,ol.ui.list.caption,ul.ui.list.caption{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.infographic .ui.list,.infographic ol.ui.list,.infographic ul.ui.list{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.text .ui.list,.text ol.ui.list,.text ul.ui.list{font-family:Georgia,serif}.infographic .list>.item .header,.ui.infographic.list>.item .header{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}", ""]);
	
	// exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Reset\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */*,:after,:before{box-sizing:inherit}html{box-sizing:border-box}input[type=email],input[type=password],input[type=search],input[type=text]{-webkit-appearance:none;-moz-appearance:none}\n/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}", ""]);
	
	// exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Segment\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.segment{position:relative;background:hsla(0,0%,100%,.85);box-shadow:none;margin:1rem 0;padding:1em;border-radius:0;border:0 solid rgba(34,36,38,.15)}.ui.segment:first-child{margin-top:0}.ui.segment:last-child{margin-bottom:0}.ui.vertical.segment{margin:0;padding-left:0;padding-right:0;background:none transparent;border-radius:0;box-shadow:none;border:none;border-bottom:0 solid rgba(34,36,38,.15)}.ui.vertical.segment:last-child{border-bottom:none}.ui.inverted.segment>.ui.header{color:#fff}.ui[class*=\"bottom attached\"].segment>[class*=\"top attached\"].label{border-top-left-radius:0;border-top-right-radius:0}.ui[class*=\"top attached\"].segment>[class*=\"bottom attached\"].label{border-bottom-left-radius:0;border-bottom-right-radius:0}.ui.attached.segment:not(.top):not(.bottom)>[class*=\"top attached\"].label{border-top-left-radius:0;border-top-right-radius:0}.ui.attached.segment:not(.top):not(.bottom)>[class*=\"bottom attached\"].label{border-bottom-left-radius:0;border-bottom-right-radius:0}.ui.grid>.row>.ui.segment.column,.ui.grid>.ui.segment.column,.ui.page.grid.segment{padding-top:2em;padding-bottom:2em}.ui.grid.segment{margin:1rem 0;border-radius:0}.ui.basic.table.segment{background:hsla(0,0%,100%,.85);border:0 solid rgba(34,36,38,.15);box-shadow:none}.ui[class*=\"very basic\"].table.segment{padding:1em}.ui.piled.segment,.ui.piled.segments{margin:3em 0;box-shadow:\"\";z-index:auto}.ui.piled.segment:first-child{margin-top:0}.ui.piled.segment:last-child{margin-bottom:0}.ui.piled.segment:after,.ui.piled.segment:before,.ui.piled.segments:after,.ui.piled.segments:before{background-color:#fff;visibility:visible;content:\"\";display:block;height:100%;left:0;position:absolute;width:100%;border:1px solid rgba(34,36,38,.15);box-shadow:\"\"}.ui.piled.segment:before,.ui.piled.segments:before{-webkit-transform:rotate(-1.2deg);transform:rotate(-1.2deg);top:0;z-index:-2}.ui.piled.segment:after,.ui.piled.segments:after{-webkit-transform:rotate(1.2deg);transform:rotate(1.2deg);top:0;z-index:-1}.ui[class*=\"top attached\"].piled.segment{margin-top:3em;margin-bottom:0}.ui.piled.segment[class*=\"top attached\"]:first-child{margin-top:0}.ui.piled.segment[class*=\"bottom attached\"]{margin-top:0;margin-bottom:3em}.ui.piled.segment[class*=\"bottom attached\"]:last-child{margin-bottom:0}.ui.stacked.segment{padding-bottom:1.4em}.ui.stacked.segment:after,.ui.stacked.segment:before,.ui.stacked.segments:after,.ui.stacked.segments:before{content:\"\";position:absolute;bottom:-3px;left:0;border-top:1px solid rgba(34,36,38,.15);background:rgba(0,0,0,.03);width:100%;height:6px;visibility:visible}.ui.stacked.segment:before,.ui.stacked.segments:before{display:none}.ui.tall.stacked.segment:before,.ui.tall.stacked.segments:before{display:block;bottom:0}.ui.stacked.inverted.segment:after,.ui.stacked.inverted.segment:before,.ui.stacked.inverted.segments:after,.ui.stacked.inverted.segments:before{background-color:rgba(0,0,0,.03);border-top:1px solid rgba(34,36,38,.35)}.ui.padded.segment{padding:1.5em}.ui[class*=\"very padded\"].segment{padding:3em}.ui.padded.segment.vertical.segment,.ui[class*=\"very padded\"].vertical.segment{padding-left:0;padding-right:0}.ui.compact.segment{display:table}.ui.compact.segments{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.ui.compact.segments .segment,.ui.segments .compact.segment{display:block;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.ui.circular.segment{display:table-cell;padding:2em;text-align:center;vertical-align:middle;border-radius:500em}.ui.raised.segment,.ui.raised.segments{box-shadow:0 2px 4px 0 rgba(0,0,0,.15),0 2px 10px 0 rgba(0,0,0,.1)}.ui.segments{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;margin:1rem 0;border:0 solid rgba(34,36,38,.15);box-shadow:none;border-radius:0}.ui.segments:first-child{margin-top:0}.ui.segments:last-child{margin-bottom:0}.ui.segments>.segment{top:0;bottom:0;border-radius:0;margin:0;width:auto;box-shadow:none;border:none;border-top:0 solid rgba(34,36,38,.15)}.ui.segments:not(.horizontal)>.segment:first-child{border-top:none;margin-top:0;bottom:0;margin-bottom:0;top:0;border-radius:0 0 0 0}.ui.segments:not(.horizontal)>.segment:last-child{top:0;bottom:0;margin-top:0;margin-bottom:0;box-shadow:none,none;border-radius:0 0 0 0}.ui.segments:not(.horizontal)>.segment:only-child{border-radius:0}.ui.segments>.ui.segments{border-top:0 solid rgba(34,36,38,.15);margin:1rem}.ui.segments>.segments:first-child{border-top:none}.ui.segments>.segment+.segments:not(.horizontal){margin-top:0}.ui.horizontal.segments{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;background-color:transparent;padding:0;background-color:hsla(0,0%,100%,.85);box-shadow:none;margin:1rem 0;border-radius:0;border:0 solid rgba(34,36,38,.15)}.ui.segments>.horizontal.segments{margin:0;background-color:transparent;border-radius:0;border:none;box-shadow:none;border-top:0 solid rgba(34,36,38,.15)}.ui.horizontal.segments>.segment{-webkit-box-flex:1;flex:1 1 auto;-ms-flex:1 1 0px;margin:0;min-width:0;background-color:transparent;border-radius:0;border:none;box-shadow:none;border-left:0 solid rgba(34,36,38,.15)}.ui.segments>.horizontal.segments:first-child{border-top:none}.ui.horizontal.segments>.segment:first-child{border-left:none}.ui.disabled.segment{opacity:.45;color:rgba(40,40,40,.3)}.ui.loading.segment{position:relative;cursor:default;pointer-events:none;text-shadow:none!important;color:transparent!important;transition:all 0s linear}.ui.loading.segment:before{position:absolute;content:\"\";top:0;left:0;background:hsla(0,0%,100%,.8);width:100%;height:100%;border-radius:0;z-index:100}.ui.loading.segment:after{position:absolute;content:\"\";top:50%;left:50%;margin:-1.5em 0 0 -1.5em;width:3em;height:3em;-webkit-animation:segment-spin .6s linear;animation:segment-spin .6s linear;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;border-radius:500rem;border-color:#5a686d rgba(0,0,0,.1) rgba(0,0,0,.1);border-style:solid;border-width:.2em;box-shadow:0 0 0 1px transparent;visibility:visible;z-index:101}@-webkit-keyframes segment-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes segment-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ui.basic.segment{background:none transparent;box-shadow:none;border:none;border-radius:0}.ui.clearing.segment:after{content:\".\";display:block;height:0;clear:both;visibility:hidden}.ui.red.segment:not(.inverted){border-top:1px solid #e23c4e!important}.ui.inverted.red.segment{background-color:#e23c4e!important;color:#fff!important}.ui.orange.segment:not(.inverted){border-top:1px solid #f8813d!important}.ui.inverted.orange.segment{background-color:#f8813d!important;color:#fff!important}.ui.yellow.segment:not(.inverted){border-top:1px solid #ffca18!important}.ui.inverted.yellow.segment{background-color:#ffca18!important;color:#fff!important}.ui.olive.segment:not(.inverted){border-top:1px solid #456558!important}.ui.inverted.olive.segment{background-color:#456558!important;color:#fff!important}.ui.green.segment:not(.inverted){border-top:1px solid #54af71!important}.ui.inverted.green.segment{background-color:#54af71!important;color:#fff!important}.ui.teal.segment:not(.inverted){border-top:1px solid #00a1ca!important}.ui.inverted.teal.segment{background-color:#00a1ca!important;color:#fff!important}.ui.blue.segment:not(.inverted){border-top:1px solid #1d5f82!important}.ui.inverted.blue.segment{background-color:#1d5f82!important;color:#fff!important}.ui.violet.segment:not(.inverted){border-top:1px solid #525394!important}.ui.inverted.violet.segment{background-color:#525394!important;color:#fff!important}.ui.purple.segment:not(.inverted){border-top:1px solid #ad427f!important}.ui.inverted.purple.segment{background-color:#ad427f!important;color:#fff!important}.ui.pink.segment:not(.inverted){border-top:1px solid #e03997!important}.ui.inverted.pink.segment{background-color:#e03997!important;color:#fff!important}.ui.brown.segment:not(.inverted){border-top:1px solid #a67a00!important}.ui.inverted.brown.segment{background-color:#a67a00!important;color:#fff!important}.ui.grey.segment:not(.inverted){border-top:1px solid #5a686d!important}.ui.inverted.grey.segment{background-color:#5a686d!important;color:#fff!important}.ui.black.segment:not(.inverted){border-top:1px solid #1b1c1d!important}.ui.inverted.black.segment{background-color:#1b1c1d!important;color:#fff!important}.ui[class*=\"left aligned\"].segment{text-align:left}.ui[class*=\"right aligned\"].segment{text-align:right}.ui[class*=\"center aligned\"].segment{text-align:center}.ui.floated.segment,.ui[class*=\"left floated\"].segment{float:left;margin-right:1em}.ui[class*=\"right floated\"].segment{float:right;margin-left:1em}.ui.inverted.segment{border:none;box-shadow:none}.ui.inverted.segment,.ui.primary.inverted.segment{background:rgba(0,0,0,.85);color:hsla(0,0%,100%,.9)}.ui.inverted.segment .segment{color:rgba(0,0,0,.87)}.ui.inverted.segment .inverted.segment{color:hsla(0,0%,100%,.9)}.ui.inverted.attached.segment{border-color:#555}.ui.secondary.segment{background:hsla(0,0%,100%,.15);color:rgba(0,0,0,.6)}.ui.secondary.inverted.segment{background:rgba(0,0,0,.85);color:hsla(0,0%,100%,.8)}.ui.tertiary.segment{background:transparent;color:rgba(0,0,0,.4)}.ui.tertiary.inverted.segment{background:rgba(0,0,0,.85);color:hsla(0,0%,100%,.8)}.ui.attached.segment{top:0;bottom:0;border-radius:0;margin:0;width:100%;max-width:100%;box-shadow:none;border:none}.ui.attached:not(.message)+.ui.attached.segment:not(.top){border-top:none}.ui[class*=\"top attached\"].segment{bottom:0;margin-bottom:0;top:0;margin-top:1rem;border-radius:0 0 0 0}.ui.segment[class*=\"top attached\"]:first-child{margin-top:0}.ui.segment[class*=\"bottom attached\"]{bottom:0;margin-top:0;top:0;margin-bottom:1rem;box-shadow:none,none;border-radius:0 0 0 0}.ui.segment[class*=\"bottom attached\"]:last-child{margin-bottom:0}.ui.mini.segment,.ui.mini.segments .segment{font-size:.64705882rem}.ui.tiny.segment,.ui.tiny.segments .segment{font-size:.70588235rem}.ui.small.segment,.ui.small.segments .segment{font-size:.88235294rem}.ui.segment,.ui.segments .segment{font-size:1rem}.ui.large.segment,.ui.large.segments .segment{font-size:1.17647059rem}.ui.big.segment,.ui.big.segments .segment{font-size:1.35294118rem}.ui.huge.segment,.ui.huge.segments .segment{font-size:1.58823529rem}.ui.massive.segment,.ui.massive.segments .segment{font-size:1.88235294rem}.ui.segment:not(.stacked):not(.piled):not(.attached){border:none}.ui.segments.segments .ui.segment{border-top:0 solid rgba(34,36,38,.15)}.ui.segments.segments .ui.segment:first-child{border-top:none}.ui.vertical.segment{padding-top:3em;padding-bottom:3em}.ui.vertical.segment.padded,.ui.vertical.segment.relaxed{padding:6em 0}.ui.vertical.segment[class*=\"very padded\"],.ui.vertical.segment[class*=\"very relaxed\"]{padding:12em 0}.ui.vertical.segment.fitted{padding:1.5em 0}.ui.vertical.segment[class*=\"very fitted\"]{padding:1em 0}.ui.basic.basic.basic.basic.segment{background:none transparent;box-shadow:none;border:none;border-radius:0}.ui.secondary.inverted.segment{opacity:.8}.ui.tertiary.inverted.segment{opacity:.5}.ui.red.segment:not(.inverted){background-color:#fbcecd;border-top:none}.ui.orange.segment:not(.inverted){background-color:#ffe2c7;border-top:none}.ui.yellow.segment:not(.inverted){background-color:#fff1bd;border-top:none}.ui.olive.segment:not(.inverted){background-color:#d7ebda;border-top:none}.ui.green.segment:not(.inverted){background-color:#d0dad6;border-top:none}.ui.teal.segment:not(.inverted){background-color:#cae8f4;border-top:none}.ui.blue.segment:not(.inverted){background-color:#c7d2df;border-top:none}.ui.violet.segment:not(.inverted){background-color:#dbd8ea;border-top:none}.ui.purple.segment:not(.inverted){background-color:#eed0e1;border-top:none}.ui.pink.segment:not(.inverted){background-color:#ffe3fb;border-top:none}.ui.brown.segment:not(.inverted){background-color:#f1e2d3;border-top:none}.ui.grey.segment:not(.inverted){background-color:#cdd2d3;border-top:none}.ui.black.segment:not(.inverted){background-color:#545454;color:hsla(0,0%,100%,.85)!important}.ui.attached.segment{background-color:rgba(0,0,0,.05);border-bottom:1px solid rgba(0,0,0,.15)}.ui[class*=\"top attached\"].segment{border-radius:.11764706rem .11764706rem 0 0}.ui[class*=\"bottom attached\"].segment{border-radius:0 0 .11764706rem .11764706rem;border-bottom:none}.ui.blue.segment .ui.attached.segment:not(.inverted),.ui.brown.segment .ui.attached.segment:not(.inverted),.ui.green.segment .ui.attached.segment:not(.inverted),.ui.grey.segment .ui.attached.segment:not(.inverted),.ui.olive.segment .ui.attached.segment:not(.inverted),.ui.orange.segment .ui.attached.segment:not(.inverted),.ui.pink.segment .ui.attached.segment:not(.inverted),.ui.purple.segment .ui.attached.segment:not(.inverted),.ui.red.segment .ui.attached.segment:not(.inverted),.ui.teal.segment .ui.attached.segment:not(.inverted),.ui.violet.segment .ui.attached.segment:not(.inverted),.ui.yellow.segment .ui.attached.segment:not(.inverted){background-color:#fff;border-bottom:1px solid rgba(0,0,0,.03)}.ui.piled.segment,.ui.piled.segments{border:1px solid rgba(34,36,38,.15);background-color:#fff}.ui.text.segment{font-family:Georgia,serif}.ui.infographic.segment{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}", ""]);
	
	// exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700&subset=latin);", ""]);
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Site\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */body,html{height:100%}body,html{font-size:17px}body{margin:0;padding:0;overflow-x:hidden;min-width:auto;background:#fff;font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;line-height:1.44em;color:rgba(0,0,0,.87);font-smoothing:antialiased}h1,h2,h3,h4,h5{font-family:Publico Headline,Georgia,serif;line-height:1.05em;margin:calc(2rem - .025em) 0 1rem;font-weight:500;padding:0}h1{min-height:1rem;font-size:4.24rem}h2{font-size:2.955rem}h3{font-size:2.059rem}h4{font-size:1.435rem}h5{font-size:1rem}h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child{margin-top:0}h1:last-child,h2:last-child,h3:last-child,h4:last-child,h5:last-child{margin-bottom:0}p{margin:0 0 1em;line-height:1.44em}p:first-child{margin-top:0}p:last-child{margin-bottom:0}a{color:#007abf}a,a:hover{text-decoration:none}a:hover{color:#00598c}::-webkit-selection{background-color:#cce2ff;color:rgba(0,0,0,.87)}::-moz-selection{background-color:#cce2ff;color:rgba(0,0,0,.87)}::selection{background-color:#cce2ff;color:rgba(0,0,0,.87)}input::-webkit-selection,textarea::-webkit-selection{background-color:hsla(0,0%,39%,.4);color:rgba(0,0,0,.87)}input::-moz-selection,textarea::-moz-selection{background-color:hsla(0,0%,39%,.4);color:rgba(0,0,0,.87)}input::selection,textarea::selection{background-color:hsla(0,0%,39%,.4);color:rgba(0,0,0,.87)}body ::-webkit-scrollbar{-webkit-appearance:none;width:10px}body ::-webkit-scrollbar-track{background:rgba(0,0,0,.1);border-radius:0}body ::-webkit-scrollbar-thumb{cursor:pointer;border-radius:5px;background:rgba(0,0,0,.25);transition:color .2s ease}body ::-webkit-scrollbar-thumb:window-inactive{background:rgba(0,0,0,.15)}body ::-webkit-scrollbar-thumb:hover{background:hsla(202,5%,52%,.8)}body .ui.inverted::-webkit-scrollbar-track{background:hsla(0,0%,100%,.1)}body .ui.inverted::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.25)}body .ui.inverted::-webkit-scrollbar-thumb:window-inactive{background:hsla(0,0%,100%,.15)}body .ui.inverted::-webkit-scrollbar-thumb:hover{background:hsla(0,0%,100%,.35)}@font-face{font-family:Benton Sans Cond;src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/3d37dcaf-9dfb-45f0-bd8f-a635fea92d0b-2.eot\");src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/3d37dcaf-9dfb-45f0-bd8f-a635fea92d0b-2.eot?\") format(\"embedded-opentype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/3d37dcaf-9dfb-45f0-bd8f-a635fea92d0b-3.woff\") format(\"woff\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/3d37dcaf-9dfb-45f0-bd8f-a635fea92d0b-1.ttf\") format(\"truetype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/3d37dcaf-9dfb-45f0-bd8f-a635fea92d0b-4.svg#web\") format(\"svg\");font-style:normal;font-weight:900}@font-face{font-family:Benton Sans Cond;src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/2e86b3e0-b624-4270-befe-3f44606d827a-2.eot\");src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/2e86b3e0-b624-4270-befe-3f44606d827a-2.eot?\") format(\"embedded-opentype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/2e86b3e0-b624-4270-befe-3f44606d827a-3.woff\") format(\"woff\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/2e86b3e0-b624-4270-befe-3f44606d827a-1.ttf\") format(\"truetype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/2e86b3e0-b624-4270-befe-3f44606d827a-4.svg#web\") format(\"svg\");font-style:normal;font-weight:300}@font-face{font-family:Benton Sans Cond;src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/7bb9e5d1-f5d9-4a09-8b5d-770aa2f4228e-2.eot\");src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/7bb9e5d1-f5d9-4a09-8b5d-770aa2f4228e-2.eot?\") format(\"embedded-opentype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/7bb9e5d1-f5d9-4a09-8b5d-770aa2f4228e-3.woff\") format(\"woff\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/7bb9e5d1-f5d9-4a09-8b5d-770aa2f4228e-1.ttf\") format(\"truetype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/7bb9e5d1-f5d9-4a09-8b5d-770aa2f4228e-4.svg#web\") format(\"svg\");font-style:normal;font-weight:500}@font-face{font-family:Publico Headline;src:url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Medium-Web.eot\");src:url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Medium-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Medium-Web.woff\") format(\"woff\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Medium-Web.ttf\") format(\"truetype\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Medium-Web.svg\") format(\"svg\");font-weight:500;font-style:normal}@font-face{font-family:Publico Headline;src:url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Bold-Web.eot\");src:url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Bold-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Bold-Web.woff\") format(\"woff\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Bold-Web.ttf\") format(\"truetype\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Bold-Web.svg\") format(\"svg\");font-weight:700;font-style:normal}@media only screen and (max-width:599px){[class*=\"computer only\"]:not(.mobile),[class*=\"large screen only\"]:not(.mobile),[class*=\"mobile hidden\"],[class*=\"or lower hidden\"],[class*=\"tablet only\"]:not(.mobile),[class*=\"widescreen only\"]:not(.mobile){display:none!important}}@media only screen and (min-width:600px) and (max-width:899px){[class*=\"computer only\"]:not(.tablet),[class*=\"large screen only\"]:not(.tablet),[class*=\"mobile only\"]:not(.tablet),[class*=\"or lower hidden\"]:not(.mobile),[class*=\"tablet hidden\"],[class*=\"widescreen only\"]:not(.tablet){display:none!important}}@media only screen and (min-width:900px) and (max-width:1199px){[class*=\"computer hidden\"],[class*=\"large screen only\"]:not(.computer),[class*=\"mobile only\"]:not(.computer),[class*=\"or lower hidden\"]:not(.tablet):not(.mobile),[class*=\"tablet only\"]:not(.computer),[class*=\"widescreen only\"]:not(.computer){display:none!important}}@media only screen and (min-width:1200px) and (max-width:1799px){[class*=\"computer only\"]:not([class*=\"large screen\"]),[class*=\"large screen hidden\"],[class*=\"mobile only\"]:not([class*=\"large screen\"]),[class*=\"or lower hidden\"]:not(.computer):not(.tablet):not(.mobile),[class*=\"tablet only\"]:not([class*=\"large screen\"]),[class*=\"widescreen only\"]:not([class*=\"large screen\"]){display:none!important}}@media only screen and (min-width:1800px){[class*=\"computer only\"]:not([class*=widescreen]),[class*=\"large screen only\"]:not([class*=widescreen]),[class*=\"mobile only\"]:not([class*=widescreen]),[class*=\"tablet only\"]:not([class*=widescreen]),[class*=\"widescreen hidden\"],[class*=\"widescreen or lower hidden\"]{display:none!important}}.ta.lead{font-size:120%}.ta.author{font-style:italic}.ta.interview p{margin-top:0;margin-bottom:0}.ta.interview.question{margin-top:4.5ex;font-weight:700}.ta.interview.question:first-of-type{margin-top:0}body.inverted{background-color:#1b1c1d}body .inverted{text-rendering:optimizeLegibility!important;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body .inverted a[href],body .inverted a[href]:hover{color:#68c9ff}.ta.caption.caption.caption{font-size:90%;font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;line-height:1.25}.ta.caption.caption.caption.small.small.small{font-size:75%;font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.ta.caption.caption.caption.secondary{opacity:.66}.ta.caption.caption.caption.tertiary{opacity:.33}.ui.image+.ta.caption,img+.ta.caption{margin-top:.5ex}", ""]);
	
	// exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.11 - Table\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.table{width:100%;background:transparent;margin:1em 0;border:1px solid rgba(34,36,38,.15);box-shadow:none;border-radius:.11764706rem;text-align:left;color:rgba(0,0,0,.87);border-collapse:separate;border-spacing:0}.ui.table:first-child{margin-top:0}.ui.table:last-child{margin-bottom:0}.ui.table td,.ui.table th{transition:background .1s ease,color .1s ease}.ui.table thead{box-shadow:none}.ui.table thead th{cursor:auto;background:rgba(0,0,0,.05);text-align:inherit;color:rgba(0,0,0,.87);padding:.88235294em .64705882em;vertical-align:inherit;font-style:none;font-weight:700;text-transform:none;border-bottom:2px solid rgba(34,36,38,.1);border-left:none}.ui.table thead tr>th:first-child{border-left:none}.ui.table thead tr:first-child>th:first-child{border-radius:.11764706rem 0 0 0}.ui.table thead tr:first-child>th:last-child{border-radius:0 .11764706rem 0 0}.ui.table thead tr:first-child>th:only-child{border-radius:.11764706rem .11764706rem 0 0}.ui.table tfoot{box-shadow:none}.ui.table tfoot th{cursor:auto;border-top:1px solid rgba(34,36,38,.15);background:rgba(0,0,0,.05);text-align:inherit;color:rgba(0,0,0,.87);padding:.64705882em;vertical-align:middle;font-style:normal;font-weight:400;text-transform:none}.ui.table tfoot tr>th:first-child{border-left:none}.ui.table tfoot tr:first-child>th:first-child{border-radius:0 0 0 .11764706rem}.ui.table tfoot tr:first-child>th:last-child{border-radius:0 0 .11764706rem 0}.ui.table tfoot tr:first-child>th:only-child{border-radius:0 0 .11764706rem .11764706rem}.ui.table tr td{border-top:1px solid rgba(34,36,38,.1)}.ui.table tr:first-child td{border-top:none}.ui.table td{padding:.64705882em;text-align:inherit}.ui.table>.icon{vertical-align:baseline}.ui.table>.icon:only-child{margin:0}.ui.table.segment{padding:0}.ui.table.segment:after{display:none}.ui.table.segment.stacked:after{display:block}@media only screen and (max-width:599px){.ui.table:not(.unstackable){width:100%}.ui.table:not(.unstackable) tbody,.ui.table:not(.unstackable) tr,.ui.table:not(.unstackable) tr>td,.ui.table:not(.unstackable) tr>th{width:auto!important;display:block!important}.ui.table:not(.unstackable){padding:0}.ui.table:not(.unstackable) tfoot,.ui.table:not(.unstackable) thead{display:block}.ui.table:not(.unstackable) tr{padding-top:1em;padding-bottom:1em;box-shadow:inset 0 -1px 0 0 rgba(0,0,0,.1)!important}.ui.table:not(.unstackable) tr>td,.ui.table:not(.unstackable) tr>th{background:none;border:none!important;padding:.25em 0!important;box-shadow:none!important}.ui.table:not(.unstackable) td:first-child,.ui.table:not(.unstackable) th:first-child{font-weight:700}.ui.definition.table:not(.unstackable) thead th:first-child{box-shadow:none!important}}.ui.table td .image,.ui.table td .image img,.ui.table th .image,.ui.table th .image img{max-width:none}.ui.structured.table{border-collapse:collapse}.ui.structured.table thead th{border-left:none;border-right:none}.ui.structured.sortable.table thead th{border-left:1px solid rgba(34,36,38,.15);border-right:1px solid rgba(34,36,38,.15)}.ui.structured.basic.table th{border-left:none;border-right:none}.ui.structured.celled.table tr td,.ui.structured.celled.table tr th{border-left:1px solid rgba(34,36,38,.1);border-right:1px solid rgba(34,36,38,.1)}.ui.definition.table thead:not(.full-width) th:first-child{pointer-events:none;background:transparent;font-weight:400;color:rgba(0,0,0,.4);box-shadow:-1px -1px 0 1px transparent}.ui.definition.table tfoot:not(.full-width) th:first-child{pointer-events:none;background:transparent;font-weight:rgba(0,0,0,.4);color:normal;box-shadow:1px 1px 0 1px transparent}.ui.celled.definition.table thead:not(.full-width) th:first-child{box-shadow:0 -1px 0 1px transparent}.ui.celled.definition.table tfoot:not(.full-width) th:first-child{box-shadow:0 1px 0 1px transparent}.ui.definition.table tr td.definition,.ui.definition.table tr td:first-child:not(.ignored){background:transparent;font-weight:700;color:rgba(0,0,0,.95);text-transform:\"\";box-shadow:\"\";text-align:\"\";font-size:1em;padding-left:\"\";padding-right:\"\"}.ui.definition.table td:nth-child(2),.ui.definition.table tfoot:not(.full-width) th:nth-child(2),.ui.definition.table thead:not(.full-width) th:nth-child(2){border-left:1px solid rgba(34,36,38,.15)}.ui.table td.positive,.ui.table tr.positive{box-shadow:inset 0 0 0 #b8e186;background:#e6f5d0!important;color:#276419!important}.ui.table td.negative,.ui.table tr.negative{box-shadow:inset 0 0 0 #f1b6da;background:#fde0ef!important;color:#8e0152!important}.ui.table td.error,.ui.table tr.error{box-shadow:inset 0 0 0 #f1b6da;background:#fde0ef!important;color:#8e0152!important}.ui.table td.warning,.ui.table tr.warning{box-shadow:inset 0 0 0 #ecc353;background:#fff1bd!important;color:#735500!important}.ui.table td.active,.ui.table tr.active{box-shadow:inset 0 0 0 rgba(0,0,0,.87);background:#e0e0e0!important;color:rgba(0,0,0,.87)!important}.ui.table tr.disabled:hover,.ui.table tr.disabled td,.ui.table tr:hover td.disabled,.ui.table tr td.disabled{pointer-events:none;color:rgba(40,40,40,.3)}@media only screen and (max-width:899px){.ui[class*=\"tablet stackable\"].table,.ui[class*=\"tablet stackable\"].table tbody,.ui[class*=\"tablet stackable\"].table tr,.ui[class*=\"tablet stackable\"].table tr>td,.ui[class*=\"tablet stackable\"].table tr>th{width:100%!important;display:block!important}.ui[class*=\"tablet stackable\"].table{padding:0}.ui[class*=\"tablet stackable\"].table tfoot,.ui[class*=\"tablet stackable\"].table thead{display:block}.ui[class*=\"tablet stackable\"].table tr{padding-top:1em;padding-bottom:1em;box-shadow:inset 0 -1px 0 0 rgba(0,0,0,.1)!important}.ui[class*=\"tablet stackable\"].table tr>td,.ui[class*=\"tablet stackable\"].table tr>th{background:none;border:none!important;padding:.25em 0;box-shadow:none!important}.ui.definition[class*=\"tablet stackable\"].table thead th:first-child{box-shadow:none!important}}.ui.table[class*=\"left aligned\"],.ui.table [class*=\"left aligned\"]{text-align:left}.ui.table[class*=\"center aligned\"],.ui.table [class*=\"center aligned\"]{text-align:center}.ui.table[class*=\"right aligned\"],.ui.table [class*=\"right aligned\"]{text-align:right}.ui.table[class*=\"top aligned\"],.ui.table [class*=\"top aligned\"]{vertical-align:top}.ui.table[class*=\"middle aligned\"],.ui.table [class*=\"middle aligned\"]{vertical-align:middle}.ui.table[class*=\"bottom aligned\"],.ui.table [class*=\"bottom aligned\"]{vertical-align:bottom}.ui.table td.collapsing,.ui.table th.collapsing{width:1px;white-space:nowrap}.ui.fixed.table{table-layout:fixed}.ui.fixed.table td,.ui.fixed.table th{overflow:hidden;text-overflow:ellipsis}.ui.selectable.table tbody tr:hover,.ui.table tbody tr td.selectable:hover{background:rgba(0,0,0,.05)!important;color:rgba(0,0,0,.95)!important}.ui.inverted.table tbody tr td.selectable:hover,.ui.selectable.inverted.table tbody tr:hover{background:hsla(0,0%,100%,.08)!important;color:#fff!important}.ui.table tbody tr td.selectable{padding:0}.ui.table tbody tr td.selectable>a:not(.ui){display:block;color:inherit;padding:.64705882em}.ui.selectable.table tr.error:hover,.ui.selectable.table tr:hover td.error,.ui.table tr td.selectable.error:hover{background:#fcd2e8!important;color:#7f0149!important}.ui.selectable.table tr.warning:hover,.ui.selectable.table tr:hover td.warning,.ui.table tr td.selectable.warning:hover{background:#ffeeae!important;color:#644900!important}.ui.selectable.table tr.active:hover,.ui.selectable.table tr:hover td.active,.ui.table tr td.selectable.active:hover{background:#e0e0e0!important;color:rgba(0,0,0,.87)!important}.ui.selectable.table tr.positive:hover,.ui.selectable.table tr:hover td.positive,.ui.table tr td.selectable.positive:hover{background:#dff2c3!important;color:#225816!important}.ui.selectable.table tr.negative:hover,.ui.selectable.table tr:hover td.negative,.ui.table tr td.selectable.negative:hover{background:#fcd2e8!important;color:#7f0149!important}.ui.attached.table{top:0;bottom:0;border-radius:0;margin:0 -1px;width:calc(100% + 2px);max-width:calc(100% + 2px);box-shadow:none;border:1px solid #d4d4d5}.ui.attached+.ui.attached.table:not(.top){border-top:none}.ui[class*=\"top attached\"].table{bottom:0;margin-bottom:0;top:0;margin-top:1em;border-radius:.11764706rem .11764706rem 0 0}.ui.table[class*=\"top attached\"]:first-child{margin-top:0}.ui[class*=\"bottom attached\"].table{bottom:0;margin-top:0;top:0;margin-bottom:1em;box-shadow:none,none;border-radius:0 0 .11764706rem .11764706rem}.ui[class*=\"bottom attached\"].table:last-child{margin-bottom:0}.ui.striped.table>tr:nth-child(2n),.ui.striped.table tbody tr:nth-child(2n){background-color:rgba(0,0,50,.02)}.ui.inverted.striped.table>tr:nth-child(2n),.ui.inverted.striped.table tbody tr:nth-child(2n){background-color:hsla(0,0%,100%,.05)}.ui.striped.selectable.selectable.selectable.table tbody tr.active:hover{background:#efefef!important;color:rgba(0,0,0,.95)!important}.ui.table[class*=\"single line\"],.ui.table [class*=\"single line\"]{white-space:nowrap}.ui.red.table{border-top:.2em solid #e23c4e}.ui.inverted.red.table{background-color:#e23c4e!important;color:#fff!important}.ui.orange.table{border-top:.2em solid #f8813d}.ui.inverted.orange.table{background-color:#f8813d!important;color:#fff!important}.ui.yellow.table{border-top:.2em solid #ffca18}.ui.inverted.yellow.table{background-color:#ffca18!important;color:#fff!important}.ui.olive.table{border-top:.2em solid #456558}.ui.inverted.olive.table{background-color:#456558!important;color:#fff!important}.ui.green.table{border-top:.2em solid #54af71}.ui.inverted.green.table{background-color:#54af71!important;color:#fff!important}.ui.teal.table{border-top:.2em solid #00a1ca}.ui.inverted.teal.table{background-color:#00a1ca!important;color:#fff!important}.ui.blue.table{border-top:.2em solid #1d5f82}.ui.inverted.blue.table{background-color:#1d5f82!important;color:#fff!important}.ui.violet.table{border-top:.2em solid #525394}.ui.inverted.violet.table{background-color:#525394!important;color:#fff!important}.ui.purple.table{border-top:.2em solid #ad427f}.ui.inverted.purple.table{background-color:#ad427f!important;color:#fff!important}.ui.pink.table{border-top:.2em solid #e03997}.ui.inverted.pink.table{background-color:#e03997!important;color:#fff!important}.ui.brown.table{border-top:.2em solid #a67a00}.ui.inverted.brown.table{background-color:#a67a00!important;color:#fff!important}.ui.grey.table{border-top:.2em solid #5a686d}.ui.inverted.grey.table{background-color:#5a686d!important;color:#fff!important}.ui.black.table{border-top:.2em solid #1b1c1d}.ui.inverted.black.table{background-color:#1b1c1d!important;color:#fff!important}.ui.one.column.table td{width:100%}.ui.two.column.table td{width:50%}.ui.three.column.table td{width:33.33333333%}.ui.four.column.table td{width:25%}.ui.five.column.table td{width:20%}.ui.six.column.table td{width:16.66666667%}.ui.seven.column.table td{width:14.28571429%}.ui.eight.column.table td{width:12.5%}.ui.nine.column.table td{width:11.11111111%}.ui.ten.column.table td{width:10%}.ui.eleven.column.table td{width:9.09090909%}.ui.twelve.column.table td{width:8.33333333%}.ui.thirteen.column.table td{width:7.69230769%}.ui.fourteen.column.table td{width:7.14285714%}.ui.fifteen.column.table td{width:6.66666667%}.ui.sixteen.column.table td,.ui.table td.one.wide,.ui.table th.one.wide{width:6.25%}.ui.table td.two.wide,.ui.table th.two.wide{width:12.5%}.ui.table td.three.wide,.ui.table th.three.wide{width:18.75%}.ui.table td.four.wide,.ui.table th.four.wide{width:25%}.ui.table td.five.wide,.ui.table th.five.wide{width:31.25%}.ui.table td.six.wide,.ui.table th.six.wide{width:37.5%}.ui.table td.seven.wide,.ui.table th.seven.wide{width:43.75%}.ui.table td.eight.wide,.ui.table th.eight.wide{width:50%}.ui.table td.nine.wide,.ui.table th.nine.wide{width:56.25%}.ui.table td.ten.wide,.ui.table th.ten.wide{width:62.5%}.ui.table td.eleven.wide,.ui.table th.eleven.wide{width:68.75%}.ui.table td.twelve.wide,.ui.table th.twelve.wide{width:75%}.ui.table td.thirteen.wide,.ui.table th.thirteen.wide{width:81.25%}.ui.table td.fourteen.wide,.ui.table th.fourteen.wide{width:87.5%}.ui.table td.fifteen.wide,.ui.table th.fifteen.wide{width:93.75%}.ui.table td.sixteen.wide,.ui.table th.sixteen.wide{width:100%}.ui.sortable.table thead th{cursor:pointer;white-space:nowrap;border-left:1px solid rgba(34,36,38,.15);color:rgba(0,0,0,.87)}.ui.sortable.table thead th:first-child{border-left:none}.ui.sortable.table thead th.sorted,.ui.sortable.table thead th.sorted:hover{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ui.sortable.table thead th:after{display:none;font-style:normal;font-weight:400;text-decoration:inherit;content:\"\";height:1em;width:auto;opacity:.8;margin:0 0 0 .5em;font-family:Icons}.ui.sortable.table thead th.ascending:after{content:\"\\F0D8\"}.ui.sortable.table thead th.descending:after{content:\"\\F0D7\"}.ui.sortable.table th.disabled:hover{cursor:auto;color:rgba(40,40,40,.3)}.ui.sortable.table thead th:hover{background:rgba(0,0,0,.05);color:rgba(0,0,0,.8)}.ui.sortable.table thead th.sorted{background:rgba(0,0,0,.05);color:rgba(0,0,0,.95)}.ui.sortable.table thead th.sorted:after{display:inline-block}.ui.sortable.table thead th.sorted:hover{background:rgba(0,0,0,.05);color:rgba(0,0,0,.95)}.ui.inverted.sortable.table thead th.sorted{background:hsla(0,0%,100%,.15) linear-gradient(transparent,rgba(0,0,0,.05));color:#fff}.ui.inverted.sortable.table thead th:hover{background:hsla(0,0%,100%,.08) linear-gradient(transparent,rgba(0,0,0,.05));color:#fff}.ui.inverted.sortable.table thead th{border-left-color:transparent;border-right-color:transparent}.ui.inverted.table{background:#333;color:hsla(0,0%,100%,.9);border:none}.ui.inverted.table th{background-color:rgba(0,0,0,.15);color:hsla(0,0%,100%,.9)!important}.ui.inverted.table th,.ui.inverted.table tr td{border-color:hsla(0,0%,100%,.1)!important}.ui.inverted.table tr.disabled:hover td,.ui.inverted.table tr.disabled td,.ui.inverted.table tr:hover td.disabled,.ui.inverted.table tr td.disabled{pointer-events:none;color:hsla(0,0%,88%,.3)}.ui.inverted.definition.table tfoot:not(.full-width) th:first-child,.ui.inverted.definition.table thead:not(.full-width) th:first-child{background:transparent}.ui.inverted.definition.table tr td:first-child{background:transparent;color:#fff}.ui.collapsing.table{width:auto}.ui.basic.table{background:transparent;border:1px solid rgba(34,36,38,.15);box-shadow:none}.ui.basic.table tfoot,.ui.basic.table thead{box-shadow:none}.ui.basic.table th{background:transparent;border-left:none}.ui.basic.table tbody tr{border-bottom:1px solid rgba(0,0,0,.1)}.ui.basic.table td{background:transparent}.ui.basic.striped.table tbody tr:nth-child(2n){background-color:rgba(0,0,0,.05)!important}.ui[class*=\"very basic\"].table{border:none}.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td,.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th{padding:\"\"}.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td:first-child,.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th:first-child{padding-left:0}.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td:last-child,.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th:last-child{padding-right:0}.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) thead tr:first-child th{padding-top:0}.ui.celled.table tr td,.ui.celled.table tr th{border-left:1px solid rgba(34,36,38,.1)}.ui.celled.table tr td:first-child,.ui.celled.table tr th:first-child{border-left:none}.ui.padded.table th{padding-left:1em;padding-right:1em}.ui.padded.table td,.ui.padded.table th{padding:1em}.ui[class*=\"very padded\"].table th{padding-left:1.5em;padding-right:1.5em}.ui[class*=\"very padded\"].table td{padding:1.5em}.ui.compact.table th{padding-left:.7em;padding-right:.7em}.ui.compact.table td{padding:.5em .7em}.ui[class*=\"very compact\"].table th{padding-left:.6em;padding-right:.6em}.ui[class*=\"very compact\"].table td{padding:.4em .6em}.ui.small.table{font-size:.9em}.ui.table{font-size:1em}.ui.large.table{font-size:1.1em}.ui.table{border-style:none none solid}.caption .ui.table,.ui.caption.table,.ui.table{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.infographic .ui.table,.ui.infographic.table{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.text .ui.table,.ui.text.table{font-family:Georgia,serif}.text .ui.table thead th,.ui.text.table thead th{font-family:Publico Headline,Georgia,serif}.ui.definition.table:not(.celled) td:nth-child(2),.ui.definition.table:not(.celled) tfoot:not(.full-width) th:nth-child(2),.ui.definition.table:not(.celled) thead:not(.full-width) th:nth-child(2){border-left:none}", ""]);
	
	// exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dispatch/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var noop = {value: function() {}};
	
	function dispatch() {
	  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	    _[t] = [];
	  }
	  return new Dispatch(_);
	}
	
	function Dispatch(_) {
	  this._ = _;
	}
	
	function parseTypenames(typenames, types) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	    return {type: t, name: name};
	  });
	}
	
	Dispatch.prototype = dispatch.prototype = {
	  constructor: Dispatch,
	  on: function(typename, callback) {
	    var _ = this._,
	        T = parseTypenames(typename + "", _),
	        t,
	        i = -1,
	        n = T.length;
	
	    // If no callback was specified, return the callback of the given type and name.
	    if (arguments.length < 2) {
	      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	      return;
	    }
	
	    // If a type was specified, set the callback for the given type and name.
	    // Otherwise, if a null callback was specified, remove callbacks of the given name.
	    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    while (++i < n) {
	      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
	      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
	    }
	
	    return this;
	  },
	  copy: function() {
	    var copy = {}, _ = this._;
	    for (var t in _) copy[t] = _[t].slice();
	    return new Dispatch(copy);
	  },
	  call: function(type, that) {
	    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  },
	  apply: function(type, that, args) {
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  }
	};
	
	function get(type, name) {
	  for (var i = 0, n = type.length, c; i < n; ++i) {
	    if ((c = type[i]).name === name) {
	      return c.value;
	    }
	  }
	}
	
	function set(type, name, callback) {
	  for (var i = 0, n = type.length; i < n; ++i) {
	    if (type[i].name === name) {
	      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	      break;
	    }
	  }
	  if (callback != null) type.push({name: name, value: callback});
	  return type;
	}
	
	exports.dispatch = dispatch;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dsv/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function(name, i) {
	    return JSON.stringify(name) + ": d[" + i + "]";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function(row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function(row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}
	
	var dsv = function(delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
	      delimiterCode = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert, columns, rows = parseRows(text, function(row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns;
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var EOL = {}, // sentinel value for end-of-line
	        EOF = {}, // sentinel value for end-of-file
	        rows = [], // output rows
	        N = text.length,
	        I = 0, // current character index
	        n = 0, // the current line number
	        t, // the current token
	        eol; // is the current token followed by EOL?
	
	    function token() {
	      if (I >= N) return EOF; // special case: end of file
	      if (eol) return eol = false, EOL; // special case: end of line
	
	      // special case: quotes
	      var j = I, c;
	      if (text.charCodeAt(j) === 34) {
	        var i = j;
	        while (i++ < N) {
	          if (text.charCodeAt(i) === 34) {
	            if (text.charCodeAt(i + 1) !== 34) break;
	            ++i;
	          }
	        }
	        I = i + 2;
	        c = text.charCodeAt(i + 1);
	        if (c === 13) {
	          eol = true;
	          if (text.charCodeAt(i + 2) === 10) ++I;
	        } else if (c === 10) {
	          eol = true;
	        }
	        return text.slice(j + 1, i).replace(/""/g, "\"");
	      }
	
	      // common case: find next delimiter or newline
	      while (I < N) {
	        var k = 1;
	        c = text.charCodeAt(I++);
	        if (c === 10) eol = true; // \n
	        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
	        else if (c !== delimiterCode) continue;
	        return text.slice(j, I - k);
	      }
	
	      // special case: last token before EOF
	      return text.slice(j);
	    }
	
	    while ((t = token()) !== EOF) {
	      var a = [];
	      while (t !== EOL && t !== EOF) {
	        a.push(t);
	        t = token();
	      }
	      if (f && (a = f(a, n++)) == null) continue;
	      rows.push(a);
	    }
	
	    return rows;
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
	      return columns.map(function(column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    })).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(text) {
	    return text == null ? ""
	        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
	        : text;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatRows: formatRows
	  };
	};
	
	var csv = dsv(",");
	
	var csvParse = csv.parse;
	var csvParseRows = csv.parseRows;
	var csvFormat = csv.format;
	var csvFormatRows = csv.formatRows;
	
	var tsv = dsv("\t");
	
	var tsvParse = tsv.parse;
	var tsvParseRows = tsv.parseRows;
	var tsvFormat = tsv.format;
	var tsvFormatRows = tsv.formatRows;
	
	exports.dsvFormat = dsv;
	exports.csvParse = csvParse;
	exports.csvParseRows = csvParseRows;
	exports.csvFormat = csvFormat;
	exports.csvFormatRows = csvFormatRows;
	exports.tsvParse = tsvParse;
	exports.tsvParseRows = tsvParseRows;
	exports.tsvFormat = tsvFormat;
	exports.tsvFormatRows = tsvFormatRows;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// follow @HenrikJoreteg and @andyet if you like this ;)
	// props to @mathias for this https://gist.github.com/428626 which served as starting point
	// for this code.
	(function () {
	    function setFavicon(href) {
	        var head = (document.head = document.getElementsByTagName('head')[0]);
	        var faviconId = 'favicon';
	        var link = document.createElement('link');
	        var oldLink = document.getElementById(faviconId);
	        link.id = faviconId;
	        link.rel = 'shortcut icon';
	        link.href = href;
	        if (oldLink) {
	            head.removeChild(oldLink);
	        }
	        head.appendChild(link);
	
	        return this;
	    };
	
	    // export for various systems
	    if (true) {
	        module.exports = setFavicon;
	    } else if (typeof $ !== 'undefined') {
	        $.setFavicon = setFavicon;
	    } else {
	        window.setFavicon = setFavicon;
	    }
	})();


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(94);
	var invariant = __webpack_require__(95);
	var ReactPropTypesSecret = __webpack_require__(97);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(101);


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable global-require */
	
	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(100);
	} else {
	  module.exports = require('./AppContainer.dev');
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable react/prop-types */
	
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(3);
	var Component = React.Component;
	
	var AppContainer = function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    _classCallCheck(this, AppContainer);
	
	    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppContainer, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.component) {
	        return React.createElement(this.props.component, this.props.props);
	      }
	
	      return React.Children.only(this.props.children);
	    }
	  }]);
	
	  return AppContainer;
	}(Component);
	
	module.exports = AppContainer;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable global-require */
	
	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(102);
	} else {
	  module.exports = require('./index.dev');
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.AppContainer = __webpack_require__(99);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = computeOffsetPixels;
	
	var _parseOffsetAsPercentage = __webpack_require__(108);
	
	var _parseOffsetAsPercentage2 = _interopRequireDefault(_parseOffsetAsPercentage);
	
	var _parseOffsetAsPixels = __webpack_require__(109);
	
	var _parseOffsetAsPixels2 = _interopRequireDefault(_parseOffsetAsPixels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @param {string|number} offset
	 * @param {number} contextHeight
	 * @return {number} A number representing `offset` converted into pixels.
	 */
	function computeOffsetPixels(offset, contextHeight) {
	  var pixelOffset = (0, _parseOffsetAsPixels2.default)(offset);
	
	  if (typeof pixelOffset === 'number') {
	    return pixelOffset;
	  }
	
	  var percentOffset = (0, _parseOffsetAsPercentage2.default)(offset);
	  if (typeof percentOffset === 'number') {
	    return percentOffset * contextHeight;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debugLog;
	function debugLog() {
	  if (false) {
	    console.log(arguments); // eslint-disable-line no-console
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ensureChildrenIsSingleDOMElement;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isDOMElement = __webpack_require__(107);
	
	var _isDOMElement2 = _interopRequireDefault(_isDOMElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Raise an error if "children" isn't a single DOM Element
	 *
	 * @param {React.element|null} children
	 * @return {undefined}
	 */
	function ensureChildrenIsSingleDOMElement(children) {
	  if (children) {
	    _react2.default.Children.only(children);
	
	    if (!(0, _isDOMElement2.default)(children)) {
	      throw new Error('You must wrap any Component Elements passed to Waypoint in a DOM Element (eg; a <div>).');
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getCurrentPosition;
	
	var _constants = __webpack_require__(26);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @param {object} bounds An object with bounds data for the waypoint and
	 *   scrollable parent
	 * @return {string} The current position of the waypoint in relation to the
	 *   visible portion of the scrollable parent. One of `constants.above`,
	 *   `constants.below`, or `constants.inside`.
	 */
	function getCurrentPosition(bounds) {
	  if (bounds.viewportBottom - bounds.viewportTop === 0) {
	    return _constants2.default.invisible;
	  }
	
	  // top is within the viewport
	  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
	    return _constants2.default.inside;
	  }
	
	  // bottom is within the viewport
	  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
	    return _constants2.default.inside;
	  }
	
	  // top is above the viewport and bottom is below the viewport
	  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
	    return _constants2.default.inside;
	  }
	
	  if (bounds.viewportBottom < bounds.waypointTop) {
	    return _constants2.default.below;
	  }
	
	  if (bounds.waypointTop < bounds.viewportTop) {
	    return _constants2.default.above;
	  }
	
	  return _constants2.default.invisible;
	}
	module.exports = exports['default'];

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDOMElement;
	/**
	 * When an element's type is a string, it represents a DOM node with that tag name
	 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
	 *
	 * @param {React.element} Component
	 * @return {bool} Whether the component is a DOM Element
	 */
	function isDOMElement(Component) {
	  return typeof Component.type === 'string';
	}
	module.exports = exports['default'];

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseOffsetAsPercentage;
	/**
	 * Attempts to parse the offset provided as a prop as a percentage. For
	 * instance, if the component has been provided with the string "20%" as
	 * a value of one of the offset props. If the value matches, then it returns
	 * a numeric version of the prop. For instance, "20%" would become `0.2`.
	 * If `str` isn't a percentage, then `undefined` will be returned.
	 *
	 * @param {string} str The value of an offset prop to be converted to a
	 *   number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was not a percentage.
	 */
	function parseOffsetAsPercentage(str) {
	  if (str.slice(-1) === '%') {
	    return parseFloat(str.slice(0, -1)) / 100;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseOffsetAsPixels;
	/**
	 * Attempts to parse the offset provided as a prop as a pixel value. If
	 * parsing fails, then `undefined` is returned. Three examples of values that
	 * will be successfully parsed are:
	 * `20`
	 * "20px"
	 * "20"
	 *
	 * @param {string|number} str A string of the form "{number}" or "{number}px",
	 *   or just a number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was neither a number nor string ending in "px".
	 */
	function parseOffsetAsPixels(str) {
	  if (!isNaN(parseFloat(str)) && isFinite(str)) {
	    return parseFloat(str);
	  } else if (str.slice(-2) === 'px') {
	    return parseFloat(str.slice(0, -2));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = resolveScrollableAncestorProp;
	function resolveScrollableAncestorProp(scrollableAncestor) {
	  // When Waypoint is rendered on the server, `window` is not available.
	  // To make Waypoint easier to work with, we allow this to be specified in
	  // string form and safely convert to `window` here.
	  if (scrollableAncestor === 'window') {
	    return global.window;
	  }
	
	  return scrollableAncestor;
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _consolidatedEvents = __webpack_require__(44);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _computeOffsetPixels = __webpack_require__(103);
	
	var _computeOffsetPixels2 = _interopRequireDefault(_computeOffsetPixels);
	
	var _constants = __webpack_require__(26);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _debugLog = __webpack_require__(104);
	
	var _debugLog2 = _interopRequireDefault(_debugLog);
	
	var _ensureChildrenIsSingleDOMElement = __webpack_require__(105);
	
	var _ensureChildrenIsSingleDOMElement2 = _interopRequireDefault(_ensureChildrenIsSingleDOMElement);
	
	var _getCurrentPosition = __webpack_require__(106);
	
	var _getCurrentPosition2 = _interopRequireDefault(_getCurrentPosition);
	
	var _resolveScrollableAncestorProp = __webpack_require__(110);
	
	var _resolveScrollableAncestorProp2 = _interopRequireDefault(_resolveScrollableAncestorProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  topOffset: '0px',
	  bottomOffset: '0px',
	  horizontal: false,
	  onEnter: function onEnter() {},
	  onLeave: function onLeave() {},
	  onPositionChange: function onPositionChange() {},
	
	  fireOnRapidScroll: true
	};
	
	/**
	 * Calls a function when you scroll to the element.
	 */
	
	var Waypoint = function (_React$Component) {
	  _inherits(Waypoint, _React$Component);
	
	  function Waypoint(props) {
	    _classCallCheck(this, Waypoint);
	
	    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));
	
	    _this.refElement = function (e) {
	      return _this._ref = e;
	    };
	    return _this;
	  }
	
	  _createClass(Waypoint, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      (0, _ensureChildrenIsSingleDOMElement2.default)(this.props.children);
	
	      if (this.props.scrollableParent) {
	        // eslint-disable-line react/prop-types
	        throw new Error('The `scrollableParent` prop has changed name to `scrollableAncestor`.');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!Waypoint.getWindow()) {
	        return;
	      }
	
	      this._handleScroll = this._handleScroll.bind(this);
	      this.scrollableAncestor = this._findScrollableAncestor();
	
	      if (false) {
	        (0, _debugLog2.default)('scrollableAncestor', this.scrollableAncestor);
	      }
	
	      this.scrollEventListenerHandle = (0, _consolidatedEvents.addEventListener)(this.scrollableAncestor, 'scroll', this._handleScroll, { passive: true });
	
	      this.resizeEventListenerHandle = (0, _consolidatedEvents.addEventListener)(window, 'resize', this._handleScroll, { passive: true });
	
	      // this._ref may occasionally not be set at this time. To help ensure that
	      // this works smoothly, we want to delay the initial execution until the
	      // next tick.
	      this.initialTimeout = setTimeout(function () {
	        _this2.initialTimeout = null;
	        _this2._handleScroll(null);
	      }, 0);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _ensureChildrenIsSingleDOMElement2.default)(nextProps.children);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!Waypoint.getWindow()) {
	        return;
	      }
	
	      // The element may have moved.
	      this._handleScroll(null);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!Waypoint.getWindow()) {
	        return;
	      }
	
	      (0, _consolidatedEvents.removeEventListener)(this.scrollEventListenerHandle);
	      (0, _consolidatedEvents.removeEventListener)(this.resizeEventListenerHandle);
	
	      if (this.initialTimeout) {
	        clearTimeout(this.initialTimeout);
	      }
	    }
	
	    /**
	     * Traverses up the DOM to find an ancestor container which has an overflow
	     * style that allows for scrolling.
	     *
	     * @return {Object} the closest ancestor element with an overflow style that
	     *   allows for scrolling. If none is found, the `window` object is returned
	     *   as a fallback.
	     */
	
	  }, {
	    key: '_findScrollableAncestor',
	    value: function _findScrollableAncestor() {
	      var _props = this.props,
	          horizontal = _props.horizontal,
	          scrollableAncestor = _props.scrollableAncestor;
	
	
	      if (scrollableAncestor) {
	        return (0, _resolveScrollableAncestorProp2.default)(scrollableAncestor);
	      }
	
	      var node = this._ref;
	
	      while (node.parentNode) {
	        node = node.parentNode;
	
	        if (node === document) {
	          // This particular node does not have a computed style.
	          continue;
	        }
	
	        if (node === document.documentElement) {
	          // This particular node does not have a scroll bar, it uses the window.
	          continue;
	        }
	
	        var style = window.getComputedStyle(node);
	        var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
	        var overflow = overflowDirec || style.getPropertyValue('overflow');
	
	        if (overflow === 'auto' || overflow === 'scroll') {
	          return node;
	        }
	      }
	
	      // A scrollable ancestor element was not found, which means that we need to
	      // do stuff on window.
	      return window;
	    }
	
	    /**
	     * @param {Object} event the native scroll event coming from the scrollable
	     *   ancestor, or resize event coming from the window. Will be undefined if
	     *   called by a React lifecyle method
	     */
	
	  }, {
	    key: '_handleScroll',
	    value: function _handleScroll(event) {
	      if (!this._ref) {
	        // There's a chance we end up here after the component has been unmounted.
	        return;
	      }
	
	      var bounds = this._getBounds();
	      var currentPosition = (0, _getCurrentPosition2.default)(bounds);
	      var previousPosition = this._previousPosition;
	
	      if (false) {
	        (0, _debugLog2.default)('currentPosition', currentPosition);
	        (0, _debugLog2.default)('previousPosition', previousPosition);
	      }
	
	      // Save previous position as early as possible to prevent cycles
	      this._previousPosition = currentPosition;
	
	      if (previousPosition === currentPosition) {
	        // No change since last trigger
	        return;
	      }
	
	      var callbackArg = {
	        currentPosition: currentPosition,
	        previousPosition: previousPosition,
	        event: event,
	        waypointTop: bounds.waypointTop,
	        waypointBottom: bounds.waypointBottom,
	        viewportTop: bounds.viewportTop,
	        viewportBottom: bounds.viewportBottom
	      };
	      this.props.onPositionChange.call(this, callbackArg);
	
	      if (currentPosition === _constants2.default.inside) {
	        this.props.onEnter.call(this, callbackArg);
	      } else if (previousPosition === _constants2.default.inside) {
	        this.props.onLeave.call(this, callbackArg);
	      }
	
	      var isRapidScrollDown = previousPosition === _constants2.default.below && currentPosition === _constants2.default.above;
	      var isRapidScrollUp = previousPosition === _constants2.default.above && currentPosition === _constants2.default.below;
	
	      if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
	        // If the scroll event isn't fired often enough to occur while the
	        // waypoint was visible, we trigger both callbacks anyway.
	        this.props.onEnter.call(this, {
	          currentPosition: _constants2.default.inside,
	          previousPosition: previousPosition,
	          event: event,
	          waypointTop: bounds.waypointTop,
	          waypointBottom: bounds.waypointBottom,
	          viewportTop: bounds.viewportTop,
	          viewportBottom: bounds.viewportBottom
	        });
	        this.props.onLeave.call(this, {
	          currentPosition: currentPosition,
	          previousPosition: _constants2.default.inside,
	          event: event,
	          waypointTop: bounds.waypointTop,
	          waypointBottom: bounds.waypointBottom,
	          viewportTop: bounds.viewportTop,
	          viewportBottom: bounds.viewportBottom
	        });
	      }
	    }
	  }, {
	    key: '_getBounds',
	    value: function _getBounds() {
	      var horizontal = this.props.horizontal;
	
	      var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
	          left = _ref$getBoundingClien.left,
	          top = _ref$getBoundingClien.top,
	          right = _ref$getBoundingClien.right,
	          bottom = _ref$getBoundingClien.bottom;
	
	      var waypointTop = horizontal ? left : top;
	      var waypointBottom = horizontal ? right : bottom;
	
	      var contextHeight = void 0;
	      var contextScrollTop = void 0;
	      if (this.scrollableAncestor === window) {
	        contextHeight = horizontal ? window.innerWidth : window.innerHeight;
	        contextScrollTop = 0;
	      } else {
	        contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
	        contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
	      }
	
	      if (false) {
	        (0, _debugLog2.default)('waypoint top', waypointTop);
	        (0, _debugLog2.default)('waypoint bottom', waypointBottom);
	        (0, _debugLog2.default)('scrollableAncestor height', contextHeight);
	        (0, _debugLog2.default)('scrollableAncestor scrollTop', contextScrollTop);
	      }
	
	      var _props2 = this.props,
	          bottomOffset = _props2.bottomOffset,
	          topOffset = _props2.topOffset;
	
	      var topOffsetPx = (0, _computeOffsetPixels2.default)(topOffset, contextHeight);
	      var bottomOffsetPx = (0, _computeOffsetPixels2.default)(bottomOffset, contextHeight);
	      var contextBottom = contextScrollTop + contextHeight;
	
	      return {
	        waypointTop: waypointTop,
	        waypointBottom: waypointBottom,
	        viewportTop: contextScrollTop + topOffsetPx,
	        viewportBottom: contextBottom - bottomOffsetPx
	      };
	    }
	
	    /**
	     * @return {Object}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var children = this.props.children;
	
	
	      if (!children) {
	        // We need an element that we can locate in the DOM to determine where it is
	        // rendered relative to the top of its context.
	        return _react2.default.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
	      }
	
	      var ref = function ref(node) {
	        _this3.refElement(node);
	        if (children.ref) {
	          children.ref(node);
	        }
	      };
	
	      return _react2.default.cloneElement(children, { ref: ref });
	    }
	  }]);
	
	  return Waypoint;
	}(_react2.default.Component);
	
	exports.default = Waypoint;
	
	
	Waypoint.propTypes = {
	  children: _react.PropTypes.element,
	  debug: _react.PropTypes.bool,
	  onEnter: _react.PropTypes.func,
	  onLeave: _react.PropTypes.func,
	  onPositionChange: _react.PropTypes.func,
	  fireOnRapidScroll: _react.PropTypes.bool,
	  scrollableAncestor: _react.PropTypes.any,
	  horizontal: _react.PropTypes.bool,
	
	  // `topOffset` can either be a number, in which case its a distance from the
	  // top of the container in pixels, or a string value. Valid string values are
	  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
	  // as a percentage of the height of the containing element.
	  // For instance, if you pass "-20%", and the containing element is 100px tall,
	  // then the waypoint will be triggered when it has been scrolled 20px beyond
	  // the top of the containing element.
	  topOffset: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
	  bottomOffset: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
	};
	
	Waypoint.above = _constants2.default.above;
	Waypoint.below = _constants2.default.below;
	Waypoint.inside = _constants2.default.inside;
	Waypoint.invisible = _constants2.default.invisible;
	Waypoint.getWindow = function () {
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	};
	Waypoint.defaultProps = defaultProps;
	Waypoint.displayName = 'Waypoint';
	module.exports = exports['default'];

/***/ }),
/* 112 */
[153, 71],
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(72);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Masthead.css", function() {
				var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Masthead.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 114 */
[153, 73],
/* 115 */
[153, 74],
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(75);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?outputStyle=expanded!./App.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?outputStyle=expanded!./App.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(76);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/index.js!./CopyrightNotice.css", function() {
				var newContent = require("!!../../css-loader/index.js!../../postcss-loader/index.js!./CopyrightNotice.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(79);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./container.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./container.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(80);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./divider.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./divider.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(81);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./grid.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./grid.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(82);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./header.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./header.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(83);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./icon.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./icon.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(85);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./item.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./item.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(86);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./list.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./list.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(87);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./reset.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./reset.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(88);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./segment.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./segment.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(89);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./site.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./site.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(90);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./table.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/index.js!./table.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parseHostname = __webpack_require__(130);
	
	Object.defineProperty(exports, 'parseHostname', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_parseHostname).default;
	  }
	});
	
	var _shareActionFactory = __webpack_require__(131);
	
	Object.defineProperty(exports, 'shareActionFactory', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shareActionFactory).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @module parseHostname
	 *
	 * @desc Extracts the projectDomain of the location, and provides the default
	 * publicationName if none is supplied.
	 */
	
	/**
	 * @typedef {Object} Hostname
	 * @property {string} projectDomain Full host name, like
	 * "interaktiv.tagesanzeiger.ch".
	 * @property {string} publicationDomain Last two parts of the project
	 * domain, like "tagesanzeiger.ch".
	 * @property {string} publicationName Just the media name, like "tagesanzeiger".
	 */
	
	/**
	 * @param host {string} A window.location.projectDomain, in case it differs
	 * from the current location.
	 *
	 * @returns {Hostname}
	 */
	function parseHostname() {
	  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
	
	  // get the full host name.
	  var projectDomain = host;
	
	  /** Create an array with the projectDomain parts */
	  var hostnameArray = projectDomain.split('.');
	
	  /**
	   * Domain without any sub domains = last two parts of the projectDomain
	   */
	  var publicationDomain = hostnameArray.slice(-2).join('.');
	
	  /**
	   * Media Name: Domain without top level domain.
	   */
	  var publicationName = hostnameArray[hostnameArray.length - 2];
	
	  return {
	    projectDomain: projectDomain,
	    publicationDomain: publicationDomain,
	    publicationName: publicationName
	  };
	}
	
	exports.default = parseHostname;

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @file Provides a object with functions to create a share for various
	 * social services.
	 * @module shareActionFactory
	 *
	 * @author Kaspar Manz <kaspar.manz@tages-anzeiger.ch>
	 */
	
	/**
	 * Create a URL to share an object on twitter.
	 *
	 * @param {Object} parameters
	 * @param {string} parameters.url URL to share
	 * @param {string=} parameters.title Description or title to be prefilled as
	 * text.
	 * @param {string=} parameters.via The Twitter handle that should be
	 * prefilled as «via».
	 * @param {Array.string=} parameters.hashtags The hashtags that the tweet
	 * should prefill.
	 * @returns {string} The action URL that opens the Twitter share screen.
	 * @throws {TypeError} if url is missing.
	 */
	function twitterShareUrl(parameters) {
	  var title = parameters.title,
	      url = parameters.url,
	      via = parameters.via,
	      hashtags = parameters.hashtags;
	
	
	  if (url === undefined) {
	    throw new TypeError('[Share URL Factory] URL not defined');
	  }
	
	  // Basic URL
	  var shareUrl = 'https://twitter.com/intent/tweet';
	
	  // Add URL
	  // We assume that there is always a URL present.
	  // This might bite us in our posteriors at some future time.
	  shareUrl += '?url=' + encodeURIComponent(url);
	
	  // Add title or additional text
	  if (title) {
	    shareUrl += '&text=' + encodeURIComponent(title);
	  }
	
	  // Add via
	  if (via) {
	    shareUrl += '&via=' + encodeURIComponent(via);
	  }
	
	  // Add hashtags
	  if (hashtags) {
	    shareUrl += '&hashtags=' + encodeURIComponent(hashtags.join(','));
	  }
	
	  return shareUrl;
	}
	
	/**
	 * Create an URL to share an object on Facebook.
	 *
	 * @param {Object} parameters
	 * @param {string} parameters.url The URL to be shared.
	 * @param {number} parameters.facebook_id The Facebook App ID.
	 * @param {Array.string=} parameters.hashtags The hashtags to share the
	 * content with. Similar to Twitter, but here only the first object is
	 * taken, so place your hashtags wisely!
	 * @returns {string} The URL with which the Facebook share dialog is being
	 * opened.
	 * @throws {TypeError} if url or facebook_id is undefined.
	 */
	function facebookShareUrl(parameters) {
	  var url = parameters.url,
	      hashtags = parameters.hashtags,
	      facebook_id = parameters.facebook_id;
	
	
	  if (url === undefined) {
	    throw new TypeError('[Share URL Factory] URL not defined');
	  }
	
	  if (facebook_id === undefined) {
	    throw new TypeError('[Share URL Factory] Facebook ID not defined.');
	  }
	
	  var shareUrl = 'https://www.facebook.com/dialog/share';
	
	  shareUrl += '?display=popup';
	
	  shareUrl += '&app_id=' + facebook_id;
	
	  // Basic URL
	  shareUrl += '&href=' + encodeURIComponent(url);
	  shareUrl += '&redirect_uri=' + encodeURIComponent(url);
	
	  // Add hashtags
	  if (hashtags) {
	    shareUrl += '&hashtag=' + encodeURIComponent('#' + hashtags[0]);
	  }
	
	  return shareUrl;
	}
	
	exports.default = {
	  /**
	   * @function twitter
	   * @public
	   */
	  twitter: twitterShareUrl,
	  /**
	   * @function facebook
	   * @public
	   */
	  facebook: facebookShareUrl
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(13);
	
	__webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CopyrightNotice = function CopyrightNotice(props) {
	  return _react2.default.createElement(
	    'a',
	    { href: '//www.' + props.secondLevelDomainName + '.ch/',
	      className: 'CopyrightNotice ' + (props.inverted ? 'inverted' : '') },
	    ' ',
	    _react2.default.createElement('img', {
	      src: '//interaktiv.tagesanzeiger.ch/static/icons/' + props.secondLevelDomainName + (props.inverted ? '-inverted' : '') + '.svg',
	      alt: '',
	      className: 'ui mini middle aligned right spaced image' }),
	    _react2.default.createElement(
	      'small',
	      null,
	      '\xA9 ',
	      props.year,
	      ' ',
	      props.name
	    )
	  );
	};
	
	CopyrightNotice.propTypes = {
	  secondLevelDomainName: _react2.default.PropTypes.string,
	  year: _react2.default.PropTypes.number,
	  inverted: _react2.default.PropTypes.bool,
	  name: _react2.default.PropTypes.string
	};
	
	CopyrightNotice.defaultProps = {
	  secondLevelDomainName: 'tagesanzeiger',
	  year: function () {
	    return new Date(Date.now()).getFullYear();
	  }(),
	  inverted: false,
	  name: 'Tages-Anzeiger'
	};
	
	exports.default = CopyrightNotice;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Component to use Google Tag Manager on the page. This component should
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * only be mounted when the GMT ID has be defined.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module GoogleTagManager
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @version 2.1
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Set up the GTM tracking. Apart from a `noscript` fallback, this pretty
	 * much doesn't render anything, but sets up the GTM dataLayer in the
	 * constructor, loads the GTM.js script by Google while mounting and pushes
	 * a pageview event into the dataLayer, using the passed-in props.
	 *
	 * Apart from props.gtmId, all props are part of the statistics object
	 * provided by the Newsnet API.
	 *
	 * As this class extends `PureComponent`, it shouldn't be rerendered all the
	 * time.
	 *
	 * @param {string} props.gtmId The GTM ID to use.
	 * @param {string} props.pagetype The pagetype (e.g. 'article').
	 * @param {string} props.category The category of the article.
	 * @param {string=} props.subcategory The subcategory of the article.
	 * @param {number=} props.article_id The legacy article ID.
	 * @param {bool=} props.premium Whether this is a premium article.
	 * @extends React.PureComponent
	 */
	var GoogleTagManager = function (_React$PureComponent) {
	  _inherits(GoogleTagManager, _React$PureComponent);
	
	  function GoogleTagManager(props) {
	    _classCallCheck(this, GoogleTagManager);
	
	    // Setup the data layer used by the tag manager.
	    var _this = _possibleConstructorReturn(this, (GoogleTagManager.__proto__ || Object.getPrototypeOf(GoogleTagManager)).call(this, props));
	
	    window.dataLayer = window.dataLayer || [];
	    return _this;
	  }
	
	  /**
	   * Renders the noscript fallback.
	   *
	   * Does rendering something using a noscript tag make much sense? Not at
	   * first, but according to
	   * https://twitter.com/bockph/status/793399813089923072 it can be useful
	   * in isomorphic environments (where parts of the code is rendered on the
	   * server).
	   *
	   * @private
	   * @returns {null | XML}
	   */
	
	
	  _createClass(GoogleTagManager, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'noscript',
	        null,
	        _react2.default.createElement('iframe', {
	          src: '//www.googletagmanager.com/ns.html?id=' + this.props.gtmId,
	          height: '0', width: '0',
	          style: {
	            display: 'none',
	            visibility: 'hidden',
	            position: 'absolute'
	          } })
	      );
	    }
	
	    /**
	     * Once the component mounts, the setup script by google is called. This
	     * will download the additional gtm.js script from Google's server. This
	     * should only happen once.
	     *
	     * @private
	     */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      //region Code Snippet from Google
	      (function (w, d, s, l, i) {
	        w[l] = w[l] || [];
	        w[l].push({
	          'gtm.start': new Date().getTime(),
	          event: 'gtm.js'
	        });
	        var f = d.getElementsByTagName(s)[0],
	            j = d.createElement(s),
	            dl = l != 'dataLayer' ? '&l=' + l : '';
	        j.async = true;
	        j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
	        f.parentNode.insertBefore(j, f);
	      })(window, document, 'script', 'dataLayer', this.props.gtmId);
	      //endregion
	
	      // Push page view event to the data layer
	      // Why is this happening here?
	      // 1. We know the dataLayer exists (it has been set up in the constructor)
	      // 2. componentDidMount will only be called once, as opposed to other
	      // lifecycle events, so the pageview event should only be triggered once.
	      window.dataLayer.push({
	        'event': 'pageview',
	        'pagetype': this.props.pagetype,
	        'category': this.props.category,
	        'subcategory': this.props.subcategory || '',
	        'article_id': this.props.article_id || '',
	        'premium': this.props.premium ? 1 : 0
	      });
	    }
	  }]);
	
	  return GoogleTagManager;
	}(_react2.default.PureComponent);
	
	exports.default = GoogleTagManager;
	
	
	GoogleTagManager.propTypes = {
	  gtmId: _react2.default.PropTypes.string.isRequired,
	  pagetype: _react2.default.PropTypes.string.isRequired,
	  category: _react2.default.PropTypes.string.isRequired,
	  subcategory: _react2.default.PropTypes.string,
	  article_id: _react2.default.PropTypes.number,
	  premium: _react2.default.PropTypes.bool
	};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taReactCopyrightNotice = __webpack_require__(132);
	
	var _taReactCopyrightNotice2 = _interopRequireDefault(_taReactCopyrightNotice);
	
	var _parseHostname = __webpack_require__(5);
	
	var _d3Request = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The subdomain under which to find the API.
	 * @type {string}
	 */
	var apiSubdomain = 'mobile2';
	
	/**
	 * The endpoint where the media information is stored.
	 * @type {string}
	 */
	var apiEndpoint = '/api/external_services';
	
	/**
	 * Enums that represent different loading states.
	 * @type {string}
	 */
	var LOADING_STATE = 'loading';
	var ERROR_STATE = 'error';
	var READY_STATE = 'ready';
	
	var PolymorphicCopyrightNotice = function (_React$Component) {
	  _inherits(PolymorphicCopyrightNotice, _React$Component);
	
	  function PolymorphicCopyrightNotice(props) {
	    _classCallCheck(this, PolymorphicCopyrightNotice);
	
	    var _this = _possibleConstructorReturn(this, (PolymorphicCopyrightNotice.__proto__ || Object.getPrototypeOf(PolymorphicCopyrightNotice)).call(this, props));
	
	    _this.state = {
	      retrieval: LOADING_STATE
	    };
	    return _this;
	  }
	
	  _createClass(PolymorphicCopyrightNotice, [{
	    key: 'render',
	    value: function render() {
	      // Don't show anything while we load data or an error occurred
	      if (this.state.retrieval === LOADING_STATE || this.state.retrieval === ERROR_STATE) {
	        return null;
	      }
	
	      // Otherwise display a copyright notice with the correct configurations
	      return _react2.default.createElement(_taReactCopyrightNotice2.default, _extends({}, this.state.mediaConfigs, this.props));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // handle development
	      if (false) {
	        // no point in doing the round trip to the external services API
	        this.setState({
	          mediaConfigs: {
	            name: 'Local Host',
	            secondLevelDomainName: 'localhost'
	          },
	          retrieval: READY_STATE
	        });
	        return;
	      }
	
	      // parse the current location so we know our second level domain name
	      var parsedHostname = (0, _parseHostname.parseHostname)();
	
	      (0, _d3Request.json)('//' + apiSubdomain + '.' + parsedHostname.publicationDomain + apiEndpoint, function (error, externalServicesInformation) {
	        // region Error handling
	        if (error) {
	          console.group('Polymorphic Copyright Notice');
	          console.warn('The external services endpoint could not be reached (or threw up for some other reason).');
	          console.groupEnd();
	          _this2.setState({
	            retrieval: ERROR_STATE
	          });
	          return;
	        }
	        // endregion
	
	        _this2.setState({
	          mediaConfigs: _extends({}, externalServicesInformation.configs, {
	            secondLevelDomainName: parsedHostname.publicationName
	          }),
	          retrieval: READY_STATE
	        });
	      });
	    }
	  }]);
	
	  return PolymorphicCopyrightNotice;
	}(_react2.default.Component);
	
	PolymorphicCopyrightNotice.propTypes = {
	  year: _react2.default.PropTypes.number,
	  inverted: _react2.default.PropTypes.bool
	};
	
	PolymorphicCopyrightNotice.defaultProps = {
	  year: function () {
	    return new Date(Date.now()).getFullYear();
	  }(),
	  inverted: false
	};
	
	exports.default = PolymorphicCopyrightNotice;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taJsToolbox = __webpack_require__(129);
	
	var _d3Request = __webpack_require__(4);
	
	var _d3Collection = __webpack_require__(12);
	
	var _taReactGtm = __webpack_require__(133);
	
	var _taReactGtm2 = _interopRequireDefault(_taReactGtm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Component to track visits to a website, accessing the Newsnet API for all
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * tracking information. Currently supports GTM, WEMF and Webseismo.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Additional Providers need to be added separately.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module Polymorphic Tracking
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @version 1.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Loading states.
	 *
	 * @enum
	 * @type {string}
	 * @private
	 */
	var LOADING = 'loading',
	    ERROR = 'error',
	    READY = 'ready';
	
	/**
	 * @param {string=} props.articleId The article ID of the link article in
	 * the CD. If not available will assume that content is being loaded in an
	 * iframe.
	 * @extends React.PureComponent
	 */
	
	var PolymorphicTracking = function (_React$PureComponent) {
	  _inherits(PolymorphicTracking, _React$PureComponent);
	
	  function PolymorphicTracking(props) {
	    _classCallCheck(this, PolymorphicTracking);
	
	    /**
	     * The timestamp for cache-busting the tracking pixels.
	     * @type {number}
	     * @private
	     */
	    var _this = _possibleConstructorReturn(this, (PolymorphicTracking.__proto__ || Object.getPrototypeOf(PolymorphicTracking)).call(this, props));
	
	    _this.loadTimestamp = Date.now();
	
	    /**
	     * Component state
	     * @type {object}
	     * @private
	     */
	    _this.state = {
	      loadingState: LOADING
	    };
	    return _this;
	  }
	
	  _createClass(PolymorphicTracking, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.state.loadingState === LOADING || this.state.loadingState === ERROR) {
	        return null;
	      }
	
	      if (this.state.loadingState === READY) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'tracking' },
	          this.state.gtmArticleData.map(function (tracker, index) {
	            return _react2.default.createElement(_taReactGtm2.default, _extends({ gtmId: _this2.state.gtmId }, tracker, { key: index }));
	          })
	        );
	      }
	    }
	
	    /**
	     * Called after component has been mounted. This should only be called
	     * once within the component lifecycle, even with state and props changing.
	     */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var hostdomain = (0, _taJsToolbox.parseHostname)().publicationDomain;
	
	      if (hostdomain === 'localhost') {
	        hostdomain = 'tagesanzeiger.ch';
	      }
	
	      var articleIdFragment = '';
	      if (this.props.articleId) {
	        articleIdFragment += '/articles/' + this.props.articleId;
	      }
	
	      (0, _d3Request.json)('//mobile2.' + hostdomain + '/api' + articleIdFragment + '/external_services', function (error, data) {
	        //region Error Handling
	        if (error) {
	          console.group('Polymorphic Tracking');
	          console.warn('Data could not be loaded from the Newsnet API.');
	          console.groupEnd();
	          _this3.setState({
	            loadingState: ERROR
	          });
	          return;
	        }
	        //endregion
	
	        // Do something with the data
	        var nestedTrackers = (0, _d3Collection.nest)().key(function (d) {
	          return d.provider;
	        }).map(data.statistics);
	
	        //region WEMF (tracking pixels)
	        if (_this3.props.articleId && nestedTrackers.has('wemf')) {
	          nestedTrackers.get('wemf').map(function (tracker) {
	            // Default tracking URL – mobile version
	            var baseTrackerUrl = tracker.url;
	            var contentWidth = window.innerWidth;
	            // Adapt to content width.
	            // This is obviously not entirely side-effect free, but we will
	            // assume that a user typically doesn't resize their browser
	            // window.
	            if (contentWidth > 600) {
	              baseTrackerUrl = tracker.ipad_url;
	            }
	            if (contentWidth > 900) {
	              baseTrackerUrl = tracker.desktop_url;
	            }
	
	            var completeUrl = baseTrackerUrl + '?r=' + encodeURIComponent(document.referrer) + '&d=' + _this3.loadTimestamp;
	            PolymorphicTracking.trackWithImage(completeUrl);
	          });
	        }
	        //endregion
	
	        //region Webseismo (tracking pixels)
	        if (_this3.props.articleId && nestedTrackers.has('webseismo')) {
	          nestedTrackers.get('webseismo').map(function (tracker) {
	            var baseTrackerUrl = tracker.url_webapp;
	
	            var contentWidth = window.innerWidth;
	
	            if (contentWidth > 600) {
	              baseTrackerUrl = tracker.url_tablet;
	            }
	
	            if (contentWidth > 900) {
	              baseTrackerUrl = tracker.url_desktop;
	            }
	
	            var completeUrl = baseTrackerUrl + '?nocache=' + _this3.loadTimestamp;
	            PolymorphicTracking.trackWithImage(completeUrl);
	          });
	        }
	        //endregion
	
	        //region GTM
	        // This always tracks.
	        _this3.setState({
	          loadingState: READY,
	          gtmArticleData: nestedTrackers.get('gtm') || [{
	            pagetype: 'embedded content',
	            category: 'interactive'
	          }],
	          gtmId: data.configs.gtm_id
	        });
	        //endregion
	      });
	    }
	
	    /**
	     * Track a visit using an image.
	     *
	     * @param {string} src The URL of the tracking pixel to use as the image
	     * source.
	     */
	
	  }], [{
	    key: 'trackWithImage',
	    value: function trackWithImage(src) {
	      // Load the image source URL without actually creating a image DOM element
	      // (which, since it's invisible, isn't necessary anyway).
	      var image = new Image();
	      image.src = src;
	    }
	  }]);
	
	  return PolymorphicTracking;
	}(_react2.default.PureComponent);
	
	exports.default = PolymorphicTracking;
	
	
	PolymorphicTracking.propTypes = {
	  articleId: _react2.default.PropTypes.string
	};
	
	PolymorphicTracking.defaultProps = {};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8e573dbe1c8722f2f616934f442b4150.jpg";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e616ec2953c1ac22142f6b3084a799fe.jpg";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a019310c72e2c10b843fbe357af56e94.jpg";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "25a9a7f1f3612b12b5bdce03e243794d.jpg";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "56ec72c020920fc12b364a7ab0381661.jpg";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "04a1f800fb294aea81f4a3583623e10b.jpg";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8893c86b21cbb00eca3f3d248d7915f0.jpg";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eb7c37bc7d3bb7ace532062f5265ffa6.jpg";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cc77a258d228943c948e3d6ca5e958f3.jpg";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "770b6ac40a029dbe76fee132c942e015.jpg";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5e1e7d629442bf6b739b25a6e651df83.jpg";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dd8f7f8631d7739edfffeba814695e22.jpg";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ae00f913ec39c075a1c9ecb6e369b29.jpg";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "92ef53798dbe57484428910a5992ef71.jpg";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a09c84d48655c5d2f2bc50a37c62bd82.jpg";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3a0787e38e83216a5972c86c97e0103d.jpg";

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./styles.css", function() {
				var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./styles.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// app.040eec6ed87db3bcbe95.js